// generated with @7nohe/openapi-react-query-codegen@1.6.1

import {
  type QueryClient,
  useQuery,
  useSuspenseQuery,
  useMutation,
  UseQueryResult,
  UseQueryOptions,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import {
  UserControllerService,
  EmployeeUploadControllerService,
  StripeControllerService,
  ScriptSureControllerService,
  SavedCardControllerService,
  SavedBankControllerService,
  SalesTaxProfileControllerService,
  SalesTaxJurisdictionControllerService,
  RolesAndPermissionControllerService,
  RoleTypeManagementControllerService,
  RoleTypeFeatureManagementControllerService,
  ProviderControllerService,
  PlanControllerService,
  PaymentTransactionControllerService,
  PatientControllerService,
  PatientModuleControllerService,
  PatientModuleAccessControllerService,
  PatientInformationControllerService,
  NurseStaffProviderControllerService,
  LeadControllerService,
  InvoiceSettingControllerService,
  FeatureManagementControllerService,
  FaxControllerService,
  FaceSheetLayoutControllerService,
  EmployerControllerService,
  EmployerPageControllerService,
  EmployerDivisionControllerService,
  EmployerAdministratorControllerService,
  CreditControllerService,
  CoverageRuleControllerService,
  CoveragePlanControllerService,
  CouponControllerService,
  ChargeItemControllerService,
  ChargeCategoryControllerService,
  CancellationControllerService,
  BrokerControllerService,
  BreakGlassControllerService,
  AncillaryServiceChargesControllerService,
  AgentFirmControllerService,
  AgentDealControllerService,
  AffiliateGroupControllerService,
  AdminUserControllerService,
  SupervisingProviderRequestControllerService,
  ShareCardControllerService,
  ShareBankControllerService,
  ProviderCoverageControllerService,
  PdfControllerService,
  AgentPayoutService,
  InventoryOrderControllerService,
  GoogleMapsControllerService,
  FutureBillingControllerService,
  CsvControllerService,
  CartControllerService,
  MobileAuthControllerService,
  VideoControllerService,
  SpecialityControllerService,
  PhysicianAccountTypeControllerService,
  EmailHistoryControllerService,
  DashboardControllerService,
  WorkNoteControllerService,
  VitalControllerService,
  VaccineControllerService,
  TaskControllerService,
  StatusConfigurationControllerService,
  SocialHistoryControllerService,
  SoapNoteControllerService,
  SoapNoteTemplateControllerService,
  ScreenHistoryControllerService,
  ReviewOfSystemTemplateControllerService,
  ReviewOfSystemControllerService,
  ReferralControllerService,
  ProviderDirectoryControllerService,
  PointsOfCareLabControllerService,
  PocLabTestControllerService,
  PocLabResultControllerService,
  PhysicalExamTemplateControllerService,
  PhysicalExamControllerService,
  PharmacyControllerService,
  PatientVaccinationControllerService,
  PatientFlagControllerService,
  PastSurgicalHistoryControllerService,
  PastMedicalHistoryControllerService,
  NoteControllerService,
  MedicationControllerService,
  MacroControllerService,
  LocationControllerService,
  LocationShareableSettingControllerService,
  LocationGroupControllerService,
  LocationAvailabilityControllerService,
  PatientLinkPharmacyControllerService,
  LabTestControllerService,
  LabResultControllerService,
  LabOrderControllerService,
  LabOrderSetControllerService,
  InvoiceControllerService,
  InsuranceControllerService,
  ImagingResultControllerService,
  ImagingOrderControllerService,
  IcdCodeControllerService,
  HAndPNoteControllerService,
  HabitsControllerService,
  GlobalHolidayControllerService,
  FormTemplateControllerService,
  FdbMedicationsControllerService,
  FamilyHistoryControllerService,
  EducationalMaterialControllerService,
  DrugIntoleranceControllerService,
  DocumentTypeControllerService,
  DiagnosisControllerService,
  CptCodeControllerService,
  CommentControllerService,
  CarePlanControllerService,
  AvailabilityControllerService,
  AppointmentControllerService,
  AppointmentTypeControllerService,
  AnnotableImageControllerService,
  AnnotableImageTemplateControllerService,
  AnnotableImagePinControllerService,
  AllergyControllerService,
  QuestionnaireControllerService,
  QuestResultPushControllerService,
  QuestControllerService,
  Hl7ControllerService,
  PatientFormControllerService,
  DocumentControllerService,
  ContactDirectoryControllerService,
  AwsControllerService,
  AgreementControllerService,
  TribleLabControllerService,
  TaskCategoryControllerService,
  ProcedureCodeControllerService,
  PlaceholderControllerService,
  OrderStudyControllerService,
  GrowthChartControllerService,
  DynamicMappingControllerService,
  AuditHistoryControllerService,
  NotificationControllerService,
  NotificationPreferenceControllerService,
  EmployerManagementNotificationSettingControllerService,
  PushNotificationControllerService,
  NotificationSettingControllerService,
  SnsWebHookControllerService,
  EmployerNotificationSettingControllerService,
  EmailControllerService,
  StripControllerService,
  TicketControllerService,
  TicketTaskControllerService,
  TicketNotesControllerService,
  TicketAttachmentControllerService,
  CrmTemplateControllerService,
  CrmTaskControllerService,
  TaskLogControllerService,
  CrmNewsletterControllerService,
  CrmCampaignControllerService,
  CallLogsControllerService,
  TicketMergeControllerService,
  TicketLinkedControllerService,
  TicketConversationControllerService,
  MessageControllerService,
  VideoCallControllerService,
  TwilioVoiceWebhookControllerService,
  TwilioVoiceControllerService,
  TwilioControllerService,
  ThreadControllerService,
  RealtimeControllerService,
  BookmarkControllerService,
} from "../requests/services.gen";
import {
  Response,
  code,
  ScriptSurePatientDto,
  AllergyDto,
  type,
  severity,
  adverseEventCode,
  ReactionDto,
  reaction,
  CardUpdateRequest,
  SalesTaxProfileRequest,
  SalesTaxJurisdictionRequest,
  RoleFeatureRequest,
  RoleRequest,
  RoleTypeRequest,
  RoleTypeFeatureRequest,
  AddressDto,
  EducationResponse,
  LocationResponseDto,
  NurseStaffProviderRequestDto,
  phoneType,
  gender,
  PhysicianAccountTypeResponse,
  ProviderRequestDto,
  acceptingEnrollmentFrom,
  honorific,
  ProviderResponse,
  RoleLocationMappingRequest,
  RoleLocationMappingResponse,
  SpecialityDto,
  StateLicenseRequest,
  AssignedProviderDto,
  PlanDto,
  planType,
  AdvancePaymentOptions,
  defaultBillingPeriod,
  AdvancePricingRuleDto,
  contractEndBehaviour,
  effectiveTime,
  BasicPlanDetails,
  planStatus,
  CoveragePlanEmployerDto,
  IndividualMemberShipRateDto,
  IndividualMembershipFeeDto,
  relationShip,
  PlanDetailsDto,
  RegistrationFeeDto,
  SpecialRateDto,
  PaymentTransactionRequestDto,
  customerType,
  paymentMethod,
  paymentStatus,
  EmergencyContactDto,
  PatientRequestDto,
  sex,
  preferredLocation,
  relationshipToYou,
  UnEnrollDto,
  PatientModuleRequest,
  PatientModuleAccessRequest,
  PatientInformationRequest,
  LeadResponseDto,
  contactStatus,
  contactPriority,
  InvoiceSettingDto,
  FeatureRequest,
  FaxDocumentsRequest,
  FaxSharingDocument,
  referenceType,
  FaceSheetLayoutRequestDto,
  WidgetPositionDto,
  EmployerDto,
  CoveragePlanResponse,
  EmployerDivisionDto,
  EmployerPricingDto,
  EnrollmentAndTerminationDto,
  sendEmployeeInvitation,
  PlanChangeDto,
  AffiliateGroupDto,
  status,
  EmployerOnlineSignUpDto,
  providerInformationCollection,
  ssnCollection,
  EmployerPageDto,
  LocationGroupRequest,
  ProviderDetailDto,
  User,
  roleType,
  AgentDealDto,
  account,
  rateType,
  commissionType,
  status2,
  ContactDto,
  contactCategory,
  EmployerAccountDto,
  EmployerAdministratorDto,
  contactType,
  CreditDto,
  CoverageRuleDto,
  appliesTo,
  amountDuePaidBy,
  CoveragePlanDto,
  CouponRequestDto,
  couponApplyTo,
  status3,
  HolidayDto,
  source,
  LocationAvailabilityDto,
  dayOfWeek,
  LocationRequestDto,
  timeZone,
  ChargeItemRequest,
  unitOfMeasure,
  ChargeCategoryRequest,
  CancellationRequest,
  BrokerDto,
  BreakGlassRequest,
  UpdateAncillaryServiceChargesRequest,
  userTypes,
  MiscellaneousServiceChargeRequest,
  month,
  AgentFirmDto,
  agentFirmType,
  AdminUserRequest,
  SupervisingRequestCreateDto,
  StripeSubscriptionRequest,
  CompleteSubscriptionRequest,
  StripeCustomerRequest,
  SaveCardRequest,
  AncillaryServiceChargesWithUUIDAndQtyRequest,
  StripeRefundRequest,
  PromotionalCodeDto,
  CreateProductRequest,
  CreateProductPriceRequest,
  FlexiblePaymentRequest,
  paymentType,
  StripeProductPaymentRequest,
  StripePaymentRequest,
  CreateCouponDto,
  stripeCouponDuration,
  ShareCardRequest,
  ShareWithUser,
  ShareBankRequest,
  IcdCodeDescriptionRequestDto,
  MedicationRequest,
  durationUnit,
  ScriptSureDrugDto,
  PrescriptionDiagnosesDto,
  PrescriptionDrug,
  PrescriptionScriptDto,
  PrescriptionSig,
  PrescriptionStatusDto,
  ScriptSureMedicationPrescriptionDto,
  ScriptSurePharmacyDto,
  ScriptSurePharmacyInfoDto,
  ScriptSureAllergyDto,
  CoverageRequestDto,
  LocalTime,
  LabOrderPdfDto,
  SpecimenLabelDto,
  TestLine,
  LabResultPdfDto,
  MakePayoutRequest,
  AddPayoutBankAccountRequest,
  VerifyPayoutBankAccountRequest,
  PatientChartItemsDto,
  PatientDetailsRequestDto,
  CancelPlanChangeDto,
  AddMemberShipDto,
  AddInventoryRequest,
  LocationInventoryTransferRequest,
  LocationInventoryWithQuantity,
  FaxStatusRequest,
  QueueFaxRequest,
  LabResultFaxDto,
  ChartItemAttachmentDto,
  ContactDirectoryResponse,
  referralType,
  source2,
  CptCodeResponse,
  DocumentResponse,
  status4,
  DocumentTypeResponse,
  IcdCodeResponse,
  type2,
  ImagingResultFileRequest,
  OrderStudyResponse,
  PatientBasicDetailsDto,
  primaryProviderHonorific,
  ProcedureCodeResponse,
  ReferralFaxDto,
  ReferralResponse,
  responseStatus,
  UserDto,
  QuestionnaireFaxDto,
  LabOrderFaxDto,
  ImagingFaxDto,
  EmployerInvoiceSettingRequest,
  createdInvoiceMonth,
  issueInvoiceMonth,
  autopayInvoiceMonth,
  dueDateMonth,
  ScheduledPaymentDetails,
  ScheduledPaymentRequest,
  MakePaymentRequest,
  CreateChargeItemAndInvoiceRequest,
  AncillaryServiceChargesRequest,
  CheckChargeCoverageRequest,
  ChangeInvoiceStatusRequest,
  invoiceStatus,
  RegisterUserRequest,
  RefreshTokenRequest,
  ConfirmEnrollmentRequest,
  LogoutRequest,
  MobileLoginRequest,
  appType,
  VerifyOtpRequest,
  ForgotPasswordRequest,
  UpdateSavedBankRequest,
  UrgentMessageAlertDto,
  DependentRelationDto,
  UpdateLocationInventoryRequest,
  UpdateGoogleMapsShareLinkRequest,
  EmployerPlanChangeDto,
  WorkNoteRequestDto,
  VitalDto,
  VaccineDto,
  type3,
  TaskRequestDto,
  priority,
  StatusConfigurationDto,
  SocialHistoryDto,
  AnnotableImageDto,
  AnnotableImagePinDto,
  CptCodeDescriptionRequestDto,
  PhysicalExamDto,
  ReferralRequest,
  ReviewOfSystemDto,
  SoapNoteRequestDto,
  AnnotableImageTemplateDto,
  CarePlanResponse,
  CptCodeDescriptionDto,
  CptCodeDto,
  GoalResponse,
  IcdCodeDescriptionDto,
  IcdCodeDto,
  PhysicalExamTemplateDto,
  PlanItemResponse,
  ReviewOfSystemTemplateDto,
  SoapNoteTemplateDto,
  noteType,
  ScreenHistoryDto,
  ProviderDirectoryRequest,
  LabTestDto,
  LabTestTitleDto,
  PointOfCareLabDto,
  PocLabTestFieldDto,
  pocTestStatus,
  PocLabTestRequestDto,
  LabResultDetail,
  PocLabResultRequestDto,
  PharmacyDto,
  pharmacyType,
  PatientVaccinationDto,
  status5,
  PatientFlagDto,
  PastSurgicalHistoryDto,
  PastMedicalHistoryDto,
  NoteRequest,
  documentNote,
  MacroDto,
  AoeQuestionsRequestDto,
  LabOrderDto,
  status6,
  providerHonorific,
  LabTestOrderDto,
  OrderedTestDto,
  LabOrderSetDto,
  InvoiceRequest,
  invoiceChargeType,
  InsuranceDetailsDto,
  insuranceType,
  ImagingResultRequest,
  imagingResultInterpretation,
  ImagingOrderRequest,
  imagingOrderStatus,
  HAndPNoteRequestDto,
  HabitsDto,
  GlobalHolidayDto,
  FormTemplateRequest,
  formBuilderType,
  FdbMedicationsDto,
  FamilyHistoryDto,
  CancellationResponse,
  EducationalMaterialDto,
  PatientAssignmentDto,
  PatientDetailsDto,
  patientStatus,
  effectiveStatus,
  DrugIntoleranceDto,
  status7,
  UpdateDocumentTypeRequest,
  DiagnosisDto,
  type4,
  CommentRequestDto,
  UpdateCarePlanRequest,
  UpdateGoalRequest,
  UpdatePlanItemRequest,
  AvailabilityDto,
  minimumSchedulingNotice,
  timezone,
  BlockDayDto,
  DaySlotDto,
  dayOfWeek2,
  appointmentMode,
  AppointmentDto,
  appointmentRoom,
  AppointmentTypeDto,
  appointmentDuration,
  appointmentType,
  DependentAppointment,
  FormTemplateInfo,
  DeleteAppointmentRequestDto,
  deleteMode,
  UploadFormPdfRequest,
  PatientLinkedPharmacyDto,
  LabResultDto,
  ObservationResultDto,
  ExternalLabResultDto,
  TestNamesDto,
  InvoiceStatementRequest,
  DocumentTypeRequest,
  DocumentRequest,
  ContactDirectoryRequest,
  CarePlanRequest,
  GoalRequest,
  PlanItemRequest,
  AppointmentBlockTimeDto,
  Pageable,
  PageTribleTestCodesDto,
  PageableObject,
  SortObject,
  TribleTestCodesDto,
  ColumnChange,
  GenericAuditLogResponse,
  PageGenericAuditLogResponse,
  NotificationPreferenceUpdateRequest,
  JsonNode,
  NotificationDto,
  notificationType,
  NotificationSettingEnableRequest,
  UserInvitationDto,
  PatientPaymentInfoRequest,
  RefundDto,
  InvoiceEntity,
  PatientInvoiceEmailRequest,
  billingPeriod,
  PatientBasicPaymentDetailsDto,
  ApprovePatientRequest,
  MultipleFormsEmailDto,
  QuestionnaireEmailDto,
  EmployerInvoiceNotificationRequest,
  PaymentReceivedDto,
  EmployerAutopayNotificationRequest,
  ChargePaidNotificationRequest,
  ShareCardNotificationDto,
  CallInvitationDto,
  AppointmentInfo,
  reminderEventType,
  FormLinkDto,
  AffiliateAgreementNotificationDto,
  NotificationPreferenceDto,
  ReferralEmailDto,
  ProviderReassignmentEmailDto,
  SendEmailDto,
  BulkUserCredentialDto,
  Response1,
  code2,
  CouponRequestDto1,
  LocationRequestDto1,
  phoneType2,
  PromotionalCodeDto1,
  AddMetadataRequest,
  TicketAttachmentDto,
  TicketDto,
  ticketPriority,
  ticketStatus,
  Response2,
  code3,
  TicketTaskDto,
  priority2,
  TicketNotesDto,
  CrmTemplateDto,
  templateCategory,
  taskType,
  CrmTaskDto,
  creationCategory,
  TaskLogsDto,
  CrmNewsletterDto,
  newsLetterType,
  CrmCampaignDto,
  audienceType,
  templateType,
  CallLogsDto,
  TicketMergeDto,
  TicketLinkedDto,
  TicketConversationDto,
  AttachmentDto,
  MessageDto,
  type5,
  VideoCallStartRequest,
  PlaceCallRequest,
  LocationRequest,
  SendSMSPatientRequest,
  SendSMSProviderRequest,
  SendSMSRequest,
  smsType,
  GenericSMSRequest,
  ThreadDto,
  status8,
  OpenThreadRequest,
  RealtimeEventDto,
  entity,
  action,
  UpdateUserArchiveStatusData,
  UpdateUserArchiveStatusResponse,
  BulkUpdateUserStatusData,
  BulkUpdateUserStatusResponse,
  UpdateUserData,
  UpdateUserResponse,
  AddUserData,
  AddUserResponse,
  UpdateUserStatusData,
  UpdateUserStatusResponse,
  SyncDeviceTokenData,
  SyncDeviceTokenResponse,
  RevokeDeviceTokenData,
  RevokeDeviceTokenResponse,
  ResetPasswordData,
  ResetPasswordResponse,
  SwitchLastLoggedInLocationData,
  SwitchLastLoggedInLocationResponse,
  GetProfileResponse,
  UpdateProfileDetailsOfUserData,
  UpdateProfileDetailsOfUserResponse,
  CheckUsernameData,
  CheckUsernameResponse,
  HandleStripeWebhookResponse,
  RegisterUsersOnKeycloakData,
  RegisterUsersOnKeycloakResponse,
  SendInviteData,
  SendInviteResponse,
  RegisterUserWithUuidData,
  RegisterUserWithUuidResponse,
  GetAllUsersData,
  GetAllUsersResponse,
  GetAllProviderAndStaffUserData,
  GetAllProviderAndStaffUserResponse,
  GetClinicalStaffData,
  GetClinicalStaffResponse,
  GetUsersByRoleTypeData,
  GetUsersByRoleTypeResponse,
  GetUserData,
  GetUserResponse,
  GetUserFromIamidData,
  GetUserFromIamidResponse,
  CheckResponse,
  CheckUserRegistrationData,
  CheckUserRegistrationResponse,
  GetAssignedLocationsData,
  GetAssignedLocationsResponse,
  GetUsersData,
  GetUsersResponse,
  ProcessUploadData,
  ProcessUploadResponse,
  UploadFileData,
  UploadFileResponse,
  SetReviewedData,
  SetReviewedResponse,
  UpdateMuteStatusData,
  UpdateMuteStatusResponse,
  GetUploadDetailsByUploadUuidData,
  GetUploadDetailsByUploadUuidResponse,
  GetRowFromCsvData,
  GetRowFromCsvResponse,
  ExportRowsData,
  ExportRowsResponse,
  DownloadFileData,
  DownloadFileResponse,
  GetAllUploadsData,
  GetAllUploadsResponse,
  GetAllUploadDetailsByUploadUuidData,
  GetAllUploadDetailsByUploadUuidResponse,
  GetSubscriptionData,
  GetSubscriptionResponse,
  UpdateSubscriptionData,
  UpdateSubscriptionResponse,
  CancelSubscriptionData,
  CancelSubscriptionResponse,
  ChangePlanData,
  ChangePlanResponse,
  ChangePlanWithProrationData,
  ChangePlanWithProrationResponse,
  UpdatePromotionalCouponData,
  UpdatePromotionalCouponResponse,
  CreatePromotionalCouponData,
  CreatePromotionalCouponResponse,
  HandleStripeWebhook1Response,
  CreateSubscriptionData,
  CreateSubscriptionResponse,
  CreateSubscriptionWithPaymentData,
  CreateSubscriptionWithPaymentResponse,
  CompleteSubscriptionData,
  CompleteSubscriptionResponse,
  CreateSetupIntentData,
  CreateSetupIntentResponse,
  CreateSetupIntentWithCustomerData,
  CreateSetupIntentWithCustomerResponse,
  SetDefaultPaymentMethodData,
  SetDefaultPaymentMethodResponse,
  SaveCardToCustomerWithChargingData,
  SaveCardToCustomerWithChargingResponse,
  SaveCardToCustomerData,
  SaveCardToCustomerResponse,
  RefundAmountData,
  RefundAmountResponse,
  CreateProductData,
  CreateProductResponse,
  CreatePriceForProductData,
  CreatePriceForProductResponse,
  CreateProductAndPriceData,
  CreateProductAndPriceResponse,
  CreateFlexiblePaymentData,
  CreateFlexiblePaymentResponse,
  CreatePaymentIntentWithProductPriceData,
  CreatePaymentIntentWithProductPriceResponse,
  CreatePaymentIntentData,
  CreatePaymentIntentResponse,
  CreateCustomerData,
  CreateCustomerResponse,
  CreateCoupon1Data,
  CreateCoupon1Response,
  AddSaveCardToCustomerData,
  AddSaveCardToCustomerResponse,
  GetPhpUserResponse,
  GetStripeConfigResponse,
  CheckServicesOfUserData,
  CheckServicesOfUserResponse,
  UpdateScriptSurePatientData,
  UpdateScriptSurePatientResponse,
  CreateScriptSurePatientData,
  CreateScriptSurePatientResponse,
  DeleteScriptSurePatientData,
  DeleteScriptSurePatientResponse,
  UpdateAllergyData,
  UpdateAllergyResponse,
  ArchiveAllergyData,
  ArchiveAllergyResponse,
  VendorLoginData,
  VendorLoginResponse,
  RegisterProviderToScriptSureData,
  RegisterProviderToScriptSureResponse,
  RegisterNurseStaffToScriptSureData,
  RegisterNurseStaffToScriptSureResponse,
  RegisterLocationToScriptSureData,
  RegisterLocationToScriptSureResponse,
  SaveMedicationPrescriptionData,
  SaveMedicationPrescriptionResponse,
  GetPatientMedicationsData,
  GetPatientMedicationsResponse,
  GetPatientPharmacyData,
  GetPatientPharmacyResponse,
  SaveAllergyData,
  SaveAllergyResponse,
  SaveNoKnownAllergyData,
  SaveNoKnownAllergyResponse,
  GetPatientAllergiesData,
  GetPatientAllergiesResponse,
  GetPrescriptionIframeData,
  GetPrescriptionIframeResponse,
  GetMessageCountData,
  GetMessageCountResponse,
  GetMedCartIframeData,
  GetMedCartIframeResponse,
  SearchDrugsData,
  SearchDrugsResponse,
  GetDrugDosesData,
  GetDrugDosesResponse,
  GetDrugHistoryIframeData,
  GetDrugHistoryIframeResponse,
  GetCpoeIframeResponse,
  SearchAllergiesData,
  SearchAllergiesResponse,
  GetAllergyIframeData,
  GetAllergyIframeResponse,
  DeletePreferredPharmacyData,
  DeletePreferredPharmacyResponse,
  UpdateSavedCardByUuidData,
  UpdateSavedCardByUuidResponse,
  DeleteSavedCardByUuidData,
  DeleteSavedCardByUuidResponse,
  SetAutopaySavedCardByUuidData,
  SetAutopaySavedCardByUuidResponse,
  SetDefaultSavedCardByUuidData,
  SetDefaultSavedCardByUuidResponse,
  GetAllSavedCardsData,
  GetAllSavedCardsResponse,
  GetAllSavedCards1Data,
  GetAllSavedCards1Response,
  SetAutopaySavedBankByUuidData,
  SetAutopaySavedBankByUuidResponse,
  SetDefaultSavedBankByUuidData,
  SetDefaultSavedBankByUuidResponse,
  CreateSetupIntent1Data,
  CreateSetupIntent1Response,
  ConfirmBankAccountData,
  ConfirmBankAccountResponse,
  UpdateAutopaySavedBankData,
  UpdateAutopaySavedBankResponse,
  GetAllSavedBanksData,
  GetAllSavedBanksResponse,
  DeleteSavedBankByUuidData,
  DeleteSavedBankByUuidResponse,
  CreateSetupIntent11Data,
  CreateSetupIntent11Response,
  ConfirmBankAccount1Data,
  ConfirmBankAccount1Response,
  GetAllSavedBanks1Data,
  GetAllSavedBanks1Response,
  GetSalesTaxProfileByUuidData,
  GetSalesTaxProfileByUuidResponse,
  UpdateSalesTaxProfileByUuidData,
  UpdateSalesTaxProfileByUuidResponse,
  DeleteSalesTaxProfileByUuidData,
  DeleteSalesTaxProfileByUuidResponse,
  SaveSalesTaxProfileData,
  SaveSalesTaxProfileResponse,
  GetAllSalesTaxProfilesData,
  GetAllSalesTaxProfilesResponse,
  GetSalesTaxJurisdictionByUuidData,
  GetSalesTaxJurisdictionByUuidResponse,
  UpdateSalesTaxJurisdictionByUuidData,
  UpdateSalesTaxJurisdictionByUuidResponse,
  DeleteSalesTaxJurisdictionByUuidData,
  DeleteSalesTaxJurisdictionByUuidResponse,
  SaveSalesTaxJurisdictionData,
  SaveSalesTaxJurisdictionResponse,
  GetAllSalesTaxJurisdictionsData,
  GetAllSalesTaxJurisdictionsResponse,
  UpdatePermissionsOfRoleData,
  UpdatePermissionsOfRoleResponse,
  CreateRoleData,
  CreateRoleResponse,
  UpdateRoleNameData,
  UpdateRoleNameResponse,
  GetRoleTypesResponse,
  GetRolesByRoleTypeData,
  GetRolesByRoleTypeResponse,
  GetFeaturesByRoleAndRoleTypeData,
  GetFeaturesByRoleAndRoleTypeResponse,
  GetRoleTypeByUuidData,
  GetRoleTypeByUuidResponse,
  UpdateRoleTypeData,
  UpdateRoleTypeResponse,
  DeleteRoleTypeData,
  DeleteRoleTypeResponse,
  GetAllRoleTypesResponse,
  CreateRoleTypeData,
  CreateRoleTypeResponse,
  GetRoleTypeFeatureByUuidData,
  GetRoleTypeFeatureByUuidResponse,
  UpdateRoleTypeFeatureData,
  UpdateRoleTypeFeatureResponse,
  DeleteRoleTypeFeatureData,
  DeleteRoleTypeFeatureResponse,
  GetAllRoleTypeFeaturesResponse,
  CreateRoleTypeFeatureData,
  CreateRoleTypeFeatureResponse,
  GetRoleTypeFeaturesByRoleTypeData,
  GetRoleTypeFeaturesByRoleTypeResponse,
  GetRoleTypeFeatureByRoleTypeAndFeatureData,
  GetRoleTypeFeatureByRoleTypeAndFeatureResponse,
  GetRoleTypeFeaturesByFeatureData,
  GetRoleTypeFeaturesByFeatureResponse,
  UpdateProviderData,
  UpdateProviderResponse,
  AddProviderData,
  AddProviderResponse,
  AssignedNewProviderData,
  AssignedNewProviderResponse,
  UpdatePatientEntrollmentByProviderUuidData,
  UpdatePatientEntrollmentByProviderUuidResponse,
  UpdateProviderStatusData,
  UpdateProviderStatusResponse,
  GetProviderByUuidData,
  GetProviderByUuidResponse,
  DeleteProviderByUuidData,
  DeleteProviderByUuidResponse,
  IsProviderWithUrgentMessageAlertsData,
  IsProviderWithUrgentMessageAlertsResponse,
  GetCoveringProvidersForUrgentAlertsData,
  GetCoveringProvidersForUrgentAlertsResponse,
  GetProviderProfileData,
  GetProviderProfileResponse,
  GetAllProvidersData,
  GetAllProvidersResponse,
  GetAllProvidersByIsAffiliateData,
  GetAllProvidersByIsAffiliateResponse,
  ExportAffiliateProvidersCsvData,
  ExportAffiliateProvidersCsvResponse,
  UpdatePlanData,
  UpdatePlanResponse,
  UpdatePlanDetailsData,
  UpdatePlanDetailsResponse,
  CreatePlanData,
  CreatePlanResponse,
  GetPlanAmountData,
  GetPlanAmountResponse,
  GetPlanByUuidData,
  GetPlanByUuidResponse,
  DeletePlanByUuidData,
  DeletePlanByUuidResponse,
  GetPlanDetailsByUuidData,
  GetPlanDetailsByUuidResponse,
  GetPlanStatusData,
  GetPlanStatusResponse,
  CheckMyPlanData,
  CheckMyPlanResponse,
  GetAllPlanData,
  GetAllPlanResponse,
  UpdatePaymentTransactionData,
  UpdatePaymentTransactionResponse,
  CreatePaymentTransactionData,
  CreatePaymentTransactionResponse,
  GetPaymentTransactionByUuidData,
  GetPaymentTransactionByUuidResponse,
  DeletePaymentTransactionData,
  DeletePaymentTransactionResponse,
  GetAllPaymentTransactionsData,
  GetAllPaymentTransactionsResponse,
  UpdatePatientData,
  UpdatePatientResponse,
  AddPatientData,
  AddPatientResponse,
  UnEnrollPatientData,
  UnEnrollPatientResponse,
  PatientCreateUpdateData,
  PatientCreateUpdateResponse,
  EndMembershipForPatientAndDependentsData,
  EndMembershipForPatientAndDependentsResponse,
  EditDependentMembershipDetailsData,
  EditDependentMembershipDetailsResponse,
  CreateUpdatePatientData,
  CreateUpdatePatientResponse,
  MarkPatientViewedData,
  MarkPatientViewedResponse,
  SyncPatientWithScriptSureData,
  SyncPatientWithScriptSureResponse,
  SendNotificationMailForBasicPaymentDetailsData,
  SendNotificationMailForBasicPaymentDetailsResponse,
  GeneratePatientChartPdfData,
  GeneratePatientChartPdfResponse,
  UpdateEngagedPatientEmployerMembershipInvoiceData,
  UpdateEngagedPatientEmployerMembershipInvoiceResponse,
  CheckPatientCredentialsData,
  CheckPatientCredentialsResponse,
  CancelPlanChangeData,
  CancelPlanChangeResponse,
  EvictPatientCachesResponse,
  UpdateEngagedPatientBrokerFirmMembershipInvoiceData,
  UpdateEngagedPatientBrokerFirmMembershipInvoiceResponse,
  UpdateEngagedPatientAffiliateFirmMembershipInvoiceData,
  UpdateEngagedPatientAffiliateFirmMembershipInvoiceResponse,
  AddPatientToStripeData,
  AddPatientToStripeResponse,
  AddMembershipData,
  AddMembershipResponse,
  GetPatientByUuidData,
  GetPatientByUuidResponse,
  SetPatientPortalAccessData,
  SetPatientPortalAccessResponse,
  UpdatePatientStatusData,
  UpdatePatientStatusResponse,
  MakePrimaryData,
  MakePrimaryResponse,
  SetPatientPrimaryProviderData,
  SetPatientPrimaryProviderResponse,
  SetSendSmsData,
  SetSendSmsResponse,
  RemovePreEngageData,
  RemovePreEngageResponse,
  SetReEnrollmentData,
  SetReEnrollmentResponse,
  AddExistingPatientAsDependentData,
  AddExistingPatientAsDependentResponse,
  ChangeBillingDateData,
  ChangeBillingDateResponse,
  GetPatientLocationWithSalesTaxData,
  GetPatientLocationWithSalesTaxResponse,
  GetLabPayerDefaultsData,
  GetLabPayerDefaultsResponse,
  GetRecentlyViewedPatientsData,
  GetRecentlyViewedPatientsResponse,
  GetProfile1Response,
  GetPatientPlanDetailsData,
  GetPatientPlanDetailsResponse,
  GetPatientOverviewData,
  GetPatientOverviewResponse,
  GetPatientMemberShipData,
  GetPatientMemberShipResponse,
  GetPatientEmployeeMembershipDetailsData,
  GetPatientEmployeeMembershipDetailsResponse,
  GetPatientDropDownData,
  GetPatientDropDownResponse,
  GetPatientWithDependentsData,
  GetPatientWithDependentsResponse,
  ExportPatientsByAffiliateGroupData,
  ExportPatientsByAffiliateGroupResponse,
  GetDependentsData,
  GetDependentsResponse,
  GetAllPatientData,
  GetAllPatientResponse,
  DeletePatientByUuidData,
  DeletePatientByUuidResponse,
  UpdateData,
  UpdateResponse,
  CreateData,
  CreateResponse,
  GetByUuid1Data,
  GetByUuid1Response,
  GetAllResponse,
  Delete1Data,
  Delete1Response,
  Update1Data,
  Update1Response,
  Create1Data,
  Create1Response,
  GetByUuid2Data,
  GetByUuid2Response,
  GetAllByGranteeData,
  GetAllByGranteeResponse,
  GetAllByOwnerAndGranteeData,
  GetAllByOwnerAndGranteeResponse,
  Delete2Data,
  Delete2Response,
  GetByUuidData,
  GetByUuidResponse,
  Update2Data,
  Update2Response,
  DeleteData,
  DeleteResponse,
  Create2Data,
  Create2Response,
  GetAllByPatientUuidData,
  GetAllByPatientUuidResponse,
  UpdateNurseStaffProviderData,
  UpdateNurseStaffProviderResponse,
  AddNurseStaffProviderData,
  AddNurseStaffProviderResponse,
  UpdateNurseStaffProviderStatusData,
  UpdateNurseStaffProviderStatusResponse,
  GetNurseStaffProviderByUuidData,
  GetNurseStaffProviderByUuidResponse,
  DeleteNurseStaffProviderData,
  DeleteNurseStaffProviderResponse,
  GetAllNurseStaffProvidersData,
  GetAllNurseStaffProvidersResponse,
  UpdateLeadData,
  UpdateLeadResponse,
  CreateLeadData,
  CreateLeadResponse,
  CreateUpdateLeadData,
  CreateUpdateLeadResponse,
  CreateSubscriptionAfterPaymentData,
  CreateSubscriptionAfterPaymentResponse,
  GetLeadByUuidData,
  GetLeadByUuidResponse,
  DeleteLeadByUuidData,
  DeleteLeadByUuidResponse,
  ValidateCouponCodeData,
  ValidateCouponCodeResponse,
  GetLeadFullInfoData,
  GetLeadFullInfoResponse,
  GetAllLeadData,
  GetAllLeadResponse,
  GetInvoiceSettingByUuidData,
  GetInvoiceSettingByUuidResponse,
  UpdateInvoiceSettingData,
  UpdateInvoiceSettingResponse,
  DeleteInvoiceSettingByUuidData,
  DeleteInvoiceSettingByUuidResponse,
  ToggleEmailNotificationData,
  ToggleEmailNotificationResponse,
  CreateInvoiceSettingData,
  CreateInvoiceSettingResponse,
  GetAllInvoiceSettingsData,
  GetAllInvoiceSettingsResponse,
  GetFeatureByUuidData,
  GetFeatureByUuidResponse,
  UpdateFeatureData,
  UpdateFeatureResponse,
  DeleteFeatureData,
  DeleteFeatureResponse,
  GetAllFeaturesResponse,
  CreateFeatureData,
  CreateFeatureResponse,
  UpdateFaxDocumentData,
  UpdateFaxDocumentResponse,
  UpdateFaxStatusData,
  UpdateFaxStatusResponse,
  SendFaxData,
  SendFaxResponse,
  SendWorkNoteByFaxData,
  SendWorkNoteByFaxResponse,
  SendWorkNoteByEmailData,
  SendWorkNoteByEmailResponse,
  SendSoapNoteByFaxData,
  SendSoapNoteByFaxResponse,
  SendSoapNoteByEmailData,
  SendSoapNoteByEmailResponse,
  SendReferralByFaxData,
  SendReferralByFaxResponse,
  SendReferralByEmailData,
  SendReferralByEmailResponse,
  SendPocByFaxData,
  SendPocByFaxResponse,
  SendPocByEmailData,
  SendPocByEmailResponse,
  SendPatientInformationByFaxData,
  SendPatientInformationByFaxResponse,
  SendPatientInformationByEmailData,
  SendPatientInformationByEmailResponse,
  SendLabResultBySmsData,
  SendLabResultBySmsResponse,
  GetFaxDetailServiceData,
  GetFaxDetailServiceResponse,
  SendImagingByFaxData,
  SendImagingByFaxResponse,
  SendImagingByEmailData,
  SendImagingByEmailResponse,
  SendHandpNoteByFaxData,
  SendHandpNoteByFaxResponse,
  SendHandpNoteByEmailData,
  SendHandpNoteByEmailResponse,
  SendDocumentByFaxData,
  SendDocumentByFaxResponse,
  SendDocumentByEmailData,
  SendDocumentByEmailResponse,
  SendFaxToRefferalData,
  SendFaxToRefferalResponse,
  SendQuestionnaireFaxData,
  SendQuestionnaireFaxResponse,
  SendFaxToLabOrderData,
  SendFaxToLabOrderResponse,
  SendFaxToImagingData,
  SendFaxToImagingResponse,
  SendFaxToLabOrder1Data,
  SendFaxToLabOrder1Response,
  CancelEfaxFaxData,
  CancelEfaxFaxResponse,
  AttachDocumentData,
  AttachDocumentResponse,
  FetchSentFaxesByLocationData,
  FetchSentFaxesByLocationResponse,
  RetrieveFaxData,
  RetrieveFaxResponse,
  GetImagingResultPdfData,
  GetImagingResultPdfResponse,
  GetLabOrderPdfData,
  GetLabOrderPdfResponse,
  FetchOutboxFaxesData,
  FetchOutboxFaxesResponse,
  FetchInboxFaxesData,
  FetchInboxFaxesResponse,
  FetchInboxWithSubUsersResponse,
  FetchSentFaxesFromEfaxData,
  FetchSentFaxesFromEfaxResponse,
  FetchReceivedFaxesFromEfaxData,
  FetchReceivedFaxesFromEfaxResponse,
  FetchEfaxFaxPagesData,
  FetchEfaxFaxPagesResponse,
  FetchEfaxOutboundFaxMetadataData,
  FetchEfaxOutboundFaxMetadataResponse,
  FetchEfaxFaxMetadataData,
  FetchEfaxFaxMetadataResponse,
  DeleteEfaxFaxData,
  DeleteEfaxFaxResponse,
  DeleteFaxData,
  DeleteFaxResponse,
  GetLayoutResponse,
  SaveLayoutData,
  SaveLayoutResponse,
  ResetLayoutResponse,
  UpdateEmployerData,
  UpdateEmployerResponse,
  DeleteEmployerData,
  DeleteEmployerResponse,
  GetPricingDetailsData,
  GetPricingDetailsResponse,
  SavePricingDetailsData,
  SavePricingDetailsResponse,
  GetOnlineSignUpData,
  GetOnlineSignUpResponse,
  SaveOnlineSignUpData,
  SaveOnlineSignUpResponse,
  GetAccountDetailsData,
  GetAccountDetailsResponse,
  SaveAccountDetailsData,
  SaveAccountDetailsResponse,
  AddEmployerData,
  AddEmployerResponse,
  GetInvoiceSettingData,
  GetInvoiceSettingResponse,
  UpdateInvoiceSetting1Data,
  UpdateInvoiceSetting1Response,
  UpdateEmployerStatusData,
  UpdateEmployerStatusResponse,
  GetAllEmployerTotalCountData,
  GetAllEmployerTotalCountResponse,
  GetEmployerMemberShipData,
  GetEmployerMemberShipResponse,
  GetMembershipDetailsData,
  GetMembershipDetailsResponse,
  GetEmployerByUuidData,
  GetEmployerByUuidResponse,
  GetEmployerCustomLogoByUuidData,
  GetEmployerCustomLogoByUuidResponse,
  GetEmployerCoveragePlansData,
  GetEmployerCoveragePlansResponse,
  GetBasicDetailsByPatientUuidData,
  GetBasicDetailsByPatientUuidResponse,
  GetAllEmployersData,
  GetAllEmployersResponse,
  ArchiveEmployerPlanData,
  ArchiveEmployerPlanResponse,
  UpdateEmployerPageData,
  UpdateEmployerPageResponse,
  CreateEmployerPageData,
  CreateEmployerPageResponse,
  GetEmployerPageByUuidData,
  GetEmployerPageByUuidResponse,
  DeleteEmployerPageByUuidData,
  DeleteEmployerPageByUuidResponse,
  IsLinkActiveData,
  IsLinkActiveResponse,
  GetAllEmployerPagesData,
  GetAllEmployerPagesResponse,
  UpdateEmployerDivisionData,
  UpdateEmployerDivisionResponse,
  CreateEmployerDivisionData,
  CreateEmployerDivisionResponse,
  GetEmployerDivisionByUuidData,
  GetEmployerDivisionByUuidResponse,
  DeleteEmployerDivisionByUuidData,
  DeleteEmployerDivisionByUuidResponse,
  GetAllEmployerDivisionsData,
  GetAllEmployerDivisionsResponse,
  UpdateEmployerAdministratorData,
  UpdateEmployerAdministratorResponse,
  CreateEmployerAdministratorData,
  CreateEmployerAdministratorResponse,
  GetEmployerAdministratorByUuidData,
  GetEmployerAdministratorByUuidResponse,
  DeleteEmployerAdministratorByUuidData,
  DeleteEmployerAdministratorByUuidResponse,
  GetAllEmployerAdministratorsData,
  GetAllEmployerAdministratorsResponse,
  GetCreditByUuidData,
  GetCreditByUuidResponse,
  UpdateCreditData,
  UpdateCreditResponse,
  DeleteCreditData,
  DeleteCreditResponse,
  AddCreditData,
  AddCreditResponse,
  GetTotalCreditByUuidData,
  GetTotalCreditByUuidResponse,
  GetAllCreditsData,
  GetAllCreditsResponse,
  UpdateCoverageRuleData,
  UpdateCoverageRuleResponse,
  CreateCoverageRuleData,
  CreateCoverageRuleResponse,
  GetCoverageRuleByUuidData,
  GetCoverageRuleByUuidResponse,
  DeleteCoverageRuleByUuidData,
  DeleteCoverageRuleByUuidResponse,
  GetAllCoverageRuleData,
  GetAllCoverageRuleResponse,
  UpdateCoveragePlanData,
  UpdateCoveragePlanResponse,
  CreateCoveragePlanData,
  CreateCoveragePlanResponse,
  GetCoveragePlanByUuidData,
  GetCoveragePlanByUuidResponse,
  DeleteCoveragePlanByUuidData,
  DeleteCoveragePlanByUuidResponse,
  GetAllCoveragePlanData,
  GetAllCoveragePlanResponse,
  DeleteCoveragePlanEmployerByUuidData,
  DeleteCoveragePlanEmployerByUuidResponse,
  UpdateCouponData,
  UpdateCouponResponse,
  CreateCouponData,
  CreateCouponResponse,
  GetCouponByUuidData,
  GetCouponByUuidResponse,
  DeleteCouponByUuidData,
  DeleteCouponByUuidResponse,
  GetAllCouponsData,
  GetAllCouponsResponse,
  GetChargeItemByUuidData,
  GetChargeItemByUuidResponse,
  UpdateChargeItemByUuidData,
  UpdateChargeItemByUuidResponse,
  DeleteChargeItemByUuidData,
  DeleteChargeItemByUuidResponse,
  UploadCsvData,
  UploadCsvResponse,
  UpdatePricesFromCsvData,
  UpdatePricesFromCsvResponse,
  SaveChargeItemData,
  SaveChargeItemResponse,
  GetChargeItemTaxMappingData,
  GetChargeItemTaxMappingResponse,
  DownloadPriceUpdateCsvTemplateResponse,
  ExportCsvData,
  ExportCsvResponse,
  DownloadCsvTemplate1Response,
  GetChargeItemsByChargeCategoryUuidData,
  GetChargeItemsByChargeCategoryUuidResponse,
  SearchAndFilterChargeItemsData,
  SearchAndFilterChargeItemsResponse,
  DeleteChargeItemsByUuidsData,
  DeleteChargeItemsByUuidsResponse,
  GetChargeCategoryByUuidData,
  GetChargeCategoryByUuidResponse,
  UpdateChargeCategoryByUuidData,
  UpdateChargeCategoryByUuidResponse,
  DeleteChargeCategoryByUuidData,
  DeleteChargeCategoryByUuidResponse,
  SaveChargeCategoryData,
  SaveChargeCategoryResponse,
  GetChargeCategoryByCoveragePlanUuidData,
  GetChargeCategoryByCoveragePlanUuidResponse,
  GetAllChargeCategoriesData,
  GetAllChargeCategoriesResponse,
  GetCancellationByUuidData,
  GetCancellationByUuidResponse,
  UpdateCancellationData,
  UpdateCancellationResponse,
  DeleteCancellationByUuidData,
  DeleteCancellationByUuidResponse,
  ArchiveAndUnarchiveCancellationByUuidData,
  ArchiveAndUnarchiveCancellationByUuidResponse,
  SaveCancellationData,
  SaveCancellationResponse,
  GetAllCancellationsData,
  GetAllCancellationsResponse,
  UpdateBrokerData,
  UpdateBrokerResponse,
  CreateBrokerData,
  CreateBrokerResponse,
  UpdateBrokerStatusData,
  UpdateBrokerStatusResponse,
  GetBrokerByUuidData,
  GetBrokerByUuidResponse,
  DeleteBrokerByUuidData,
  DeleteBrokerByUuidResponse,
  GetAllBrokersData,
  GetAllBrokersResponse,
  Update3Data,
  Update3Response,
  Create3Data,
  Create3Response,
  GetByUuid3Data,
  GetByUuid3Response,
  GetAllBreakGlassData,
  GetAllBreakGlassResponse,
  Delete3Data,
  Delete3Response,
  UpdateAncillaryServiceChargesData,
  UpdateAncillaryServiceChargesResponse,
  GetMiscellaneousServiceChargeByUuidData,
  GetMiscellaneousServiceChargeByUuidResponse,
  UpdateMiscellaneousServiceChargeByUuidData,
  UpdateMiscellaneousServiceChargeByUuidResponse,
  DeleteMiscellaneousServiceChargeByUuidData,
  DeleteMiscellaneousServiceChargeByUuidResponse,
  UpdatePlanRenewalDatesForActiveRetailPatientsResponse,
  SyncEmployerInvoiceData,
  SyncEmployerInvoiceResponse,
  ScheduledPaymentProcessingResponse,
  ScheduledPaymentData,
  ScheduledPaymentResponse,
  UpdateExistingRetailPatientMembershipInvoiceData,
  UpdateExistingRetailPatientMembershipInvoiceResponse,
  RefundAmount1Data,
  RefundAmount1Response,
  ReactiveEmployerMembershipData,
  ReactiveEmployerMembershipResponse,
  ProcessOverdueInvoicesAndGeneratePdfsResponse,
  SaveMiscellaneousServiceChargeData,
  SaveMiscellaneousServiceChargeResponse,
  MakePaymentData,
  MakePaymentResponse,
  LinkChargeItemsToPatientData,
  LinkChargeItemsToPatientResponse,
  MarkLabOrderAsDrawnData,
  MarkLabOrderAsDrawnResponse,
  InvoiceLabOrderNowData,
  InvoiceLabOrderNowResponse,
  SendLabInvoicePaymentRemindersResponse,
  LabInvoiceAutopayProcessingResponse,
  CreateRetailMembershipInvoiceData,
  CreateRetailMembershipInvoiceResponse,
  RetailPatientAutopayProcessingResponse,
  GenerateMonthlyEmployerInvoicesResponse,
  GenerateMonthlyBrokerFirmInvoicesResponse,
  GenerateMonthlyAffiliateFirmInvoicesResponse,
  GenerateLabOrderInvoicesResponse,
  GenerateInvoiceOfAncillaryForUserData,
  GenerateInvoiceOfAncillaryForUserResponse,
  GenerateInvoiceEmployerMembershipData,
  GenerateInvoiceEmployerMembershipResponse,
  EmployerInvoiceSettingResponse,
  DeactivateRetailPatientsWithUnpaidInvoicesResponse,
  ProcessEmployerDeactivationResponse,
  CreateChargeItemAndInvoiceData,
  CreateChargeItemAndInvoiceResponse,
  SaveAncillaryServiceChargesData,
  SaveAncillaryServiceChargesResponse,
  ConvertPatientMembershipResponse,
  CheckChargeCoverageData,
  CheckChargeCoverageResponse,
  ChangeInvoiceStatusData,
  ChangeInvoiceStatusResponse,
  UpdateExistingAffiliateFirmMembershipInvoiceData,
  UpdateExistingAffiliateFirmMembershipInvoiceResponse,
  UpdateExistingBrokerFirmMembershipInvoiceData,
  UpdateExistingBrokerFirmMembershipInvoiceResponse,
  ActivatePendingEmployeePatientsResponse,
  GetAncillaryServiceChargesUuidData,
  GetAncillaryServiceChargesUuidResponse,
  TransactionDetailsData,
  TransactionDetailsResponse,
  InvoiceTransactionDetailsData,
  InvoiceTransactionDetailsResponse,
  GetInvoiceStatementData,
  GetInvoiceStatementResponse,
  GetAllScheduledPaymentData,
  GetAllScheduledPaymentResponse,
  PaymentHistoryData,
  PaymentHistoryResponse,
  GetAllMiscellaneousServiceChargesData,
  GetAllMiscellaneousServiceChargesResponse,
  GenerateRetailPatientInvoicesResponse,
  GetInvoiceStatusData,
  GetInvoiceStatusResponse,
  InvoiceDetailsData,
  InvoiceDetailsResponse,
  EmployerEmployeesDetailsData,
  EmployerEmployeesDetailsResponse,
  GetChargeItemNamesByInvoiceData,
  GetChargeItemNamesByInvoiceResponse,
  AmountDetailsData,
  AmountDetailsResponse,
  GetAllAncillaryServiceChargesData,
  GetAllAncillaryServiceChargesResponse,
  AffiliateFirmEmployeesDetailsData,
  AffiliateFirmEmployeesDetailsResponse,
  EmployerDetailsMonthWiseData,
  EmployerDetailsMonthWiseResponse,
  GetAllAffiliateBrokerServiceChargesData,
  GetAllAffiliateBrokerServiceChargesResponse,
  AffiliateProviderEmployeeDetailsData,
  AffiliateProviderEmployeeDetailsResponse,
  DeleteAncillaryServiceChargesByUuidData,
  DeleteAncillaryServiceChargesByUuidResponse,
  UpdateAgentFirmData,
  UpdateAgentFirmResponse,
  CreateAgentFirmData,
  CreateAgentFirmResponse,
  GetAgentFirmByUuidData,
  GetAgentFirmByUuidResponse,
  DeleteAgentFirmByUuidData,
  DeleteAgentFirmByUuidResponse,
  GetEmployersUnderAgentFirmData,
  GetEmployersUnderAgentFirmResponse,
  GetAllAgentFirmsData,
  GetAllAgentFirmsResponse,
  UpdateAgentDealData,
  UpdateAgentDealResponse,
  CreateAgentDealData,
  CreateAgentDealResponse,
  EndAgentDealData,
  EndAgentDealResponse,
  EndAllDealsByAgentFirmData,
  EndAllDealsByAgentFirmResponse,
  GetAgentDealByUuidData,
  GetAgentDealByUuidResponse,
  DeleteAgentDealByUuidData,
  DeleteAgentDealByUuidResponse,
  GetEmployersUnderBrokerData,
  GetEmployersUnderBrokerResponse,
  GetAgentDealsByAgentFirmUuidData,
  GetAgentDealsByAgentFirmUuidResponse,
  GetAllAgentDealsData,
  GetAllAgentDealsResponse,
  GetAffiliateGropByUuidData,
  GetAffiliateGropByUuidResponse,
  UpdateAffiliateData,
  UpdateAffiliateResponse,
  DeleteAffiliateData,
  DeleteAffiliateResponse,
  UpdateAffiliateUserData,
  UpdateAffiliateUserResponse,
  MarkAffiliateUserAsPrimaryData,
  MarkAffiliateUserAsPrimaryResponse,
  AddAffiliateData,
  AddAffiliateResponse,
  GetAffiliateUsersByAffiliateGroupUuidData,
  GetAffiliateUsersByAffiliateGroupUuidResponse,
  AddAffiliateUserData,
  AddAffiliateUserResponse,
  DownloadAffiliateDataExcelData,
  DownloadAffiliateDataExcelResponse,
  GetAffiliateUserByUuidData,
  GetAffiliateUserByUuidResponse,
  ExportCsvForAffiliateData,
  ExportCsvForAffiliateResponse,
  GetAllAffiliatesData,
  GetAllAffiliatesResponse,
  GetAdminUserByUuidData,
  GetAdminUserByUuidResponse,
  UpdateAdminUserByUuidData,
  UpdateAdminUserByUuidResponse,
  DeleteAdminUserByUuidData,
  DeleteAdminUserByUuidResponse,
  ActiveAdminUserByUuidData,
  ActiveAdminUserByUuidResponse,
  ResetUserMfaData,
  ResetUserMfaResponse,
  GenerateGuestTokenData,
  GenerateGuestTokenResponse,
  ResendLinkData,
  ResendLinkResponse,
  SaveAdminUserData,
  SaveAdminUserResponse,
  GetSupersetDashBoardIdData,
  GetSupersetDashBoardIdResponse,
  GetUserDetailsData,
  GetUserDetailsResponse,
  GetProfile2Response,
  GetAllAdminUsersData,
  GetAllAdminUsersResponse,
  SendRequestsData,
  SendRequestsResponse,
  DenyData,
  DenyResponse,
  ApproveData,
  ApproveResponse,
  GetIncomingRequestsData,
  GetIncomingRequestsResponse,
  GetApprovedProvidersData,
  GetApprovedProvidersResponse,
  ShareCardData,
  ShareCardResponse,
  GetSharedCardsByUserData,
  GetSharedCardsByUserResponse,
  GetSharedCardCustomersData,
  GetSharedCardCustomersResponse,
  DeleteShareCardData,
  DeleteShareCardResponse,
  ShareCard1Data,
  ShareCard1Response,
  AddMetadataData,
  AddMetadataResponse,
  GetSharedCardsByUser1Data,
  GetSharedCardsByUser1Response,
  ShareBankData,
  ShareBankResponse,
  GetSharedBanksByUserData,
  GetSharedBanksByUserResponse,
  GetSharedBankCustomersData,
  GetSharedBankCustomersResponse,
  DeleteSharedBankAccountData,
  DeleteSharedBankAccountResponse,
  GetCoveragesData,
  GetCoveragesResponse,
  CreateRequestData,
  CreateRequestResponse,
  ResyncScriptSureData,
  ResyncScriptSureResponse,
  RevokeData,
  RevokeResponse,
  Deny1Data,
  Deny1Response,
  Approve1Data,
  Approve1Response,
  GetUrgentMessageAlertResponse,
  UpdateUrgentMessageAlertData,
  UpdateUrgentMessageAlertResponse,
  ExpireEndedCoveragesResponse,
  GetCoverageByUuidData,
  GetCoverageByUuidResponse,
  GetActiveCoverageResponse,
  UploadSoapNotePdfData,
  UploadSoapNotePdfResponse,
  UploadSingleLabOrderPdfData,
  UploadSingleLabOrderPdfResponse,
  UploadPocPdfData,
  UploadPocPdfResponse,
  UploadPatientInformationPdfData,
  UploadPatientInformationPdfResponse,
  UploadLabResultPdfData,
  UploadLabResultPdfResponse,
  UploadImagingResultPdfData,
  UploadImagingResultPdfResponse,
  UploadHandpNotePdfData,
  UploadHandpNotePdfResponse,
  SignExistingPdfData,
  SignExistingPdfResponse,
  GeneratePdfData,
  GeneratePdfResponse,
  GenerateWorkNotePdfData,
  GenerateWorkNotePdfResponse,
  GenerateExportStatementPdfData,
  GenerateExportStatementPdfResponse,
  GenerateSpecimenLabelData,
  GenerateSpecimenLabelResponse,
  GenerateSoapNotePdfData,
  GenerateSoapNotePdfResponse,
  GenerateSingleLabOrderPdfData,
  GenerateSingleLabOrderPdfResponse,
  GenerateReturnLetterPdfData,
  GenerateReturnLetterPdfResponse,
  GenerateReferralPdfData,
  GenerateReferralPdfResponse,
  GenerateProviderAppointmentsPdfData,
  GenerateProviderAppointmentsPdfResponse,
  GeneratePocPdfData,
  GeneratePocPdfResponse,
  GeneratePatientInformationPdfData,
  GeneratePatientInformationPdfResponse,
  GenerateMedicationsPdfData,
  GenerateMedicationsPdfResponse,
  GenerateLabResultPdfData,
  GenerateLabResultPdfResponse,
  GenerateLabResultPdfByUuidData,
  GenerateLabResultPdfByUuidResponse,
  GenerateLabOrdersPdfData,
  GenerateLabOrdersPdfResponse,
  GenerateInventoryOrderPdfData,
  GenerateInventoryOrderPdfResponse,
  GenerateInventoryDetailPdfData,
  GenerateInventoryDetailPdfResponse,
  GenerateImmunizationsPdfData,
  GenerateImmunizationsPdfResponse,
  GenerateImagingResultPdfData,
  GenerateImagingResultPdfResponse,
  GenerateHandpNotePdfData,
  GenerateHandpNotePdfResponse,
  GenerateFacesheetPdfData,
  GenerateFacesheetPdfResponse,
  GenerateDiagnosisPdfData,
  GenerateDiagnosisPdfResponse,
  GenerateAuditLogPdfData,
  GenerateAuditLogPdfResponse,
  GetLabPdfByPatientData,
  GetLabPdfByPatientResponse,
  MakePayoutData,
  MakePayoutResponse,
  AddPayoutBankAccountData,
  AddPayoutBankAccountResponse,
  VerifyPayoutBankAccountData,
  VerifyPayoutBankAccountResponse,
  GetPayoutBankAccountsData,
  GetPayoutBankAccountsResponse,
  AddToInventoryData,
  AddToInventoryResponse,
  PollShipmentsResponse,
  PlaceOrderOnNorthWindData,
  PlaceOrderOnNorthWindResponse,
  TransferInventoryData,
  TransferInventoryResponse,
  AddInventoryQuantityData,
  AddInventoryQuantityResponse,
  UpdateInventoryData,
  UpdateInventoryResponse,
  UpdateFormularyData,
  UpdateFormularyResponse,
  UpdateAutoShipData,
  UpdateAutoShipResponse,
  GetAllInventoryData,
  GetAllInventoryResponse,
  LocationBasedFormularyData,
  LocationBasedFormularyResponse,
  ExportLocationBasedInventoryCsvResponse,
  ExportInventoryCsvData,
  ExportInventoryCsvResponse,
  GetAllShipmentMedicationByInvoiceNumberData,
  GetAllShipmentMedicationByInvoiceNumberResponse,
  GetAllShipmentData,
  GetAllShipmentResponse,
  GetAllOrderData,
  GetAllOrderResponse,
  UploadPatientAddressesCsvData,
  UploadPatientAddressesCsvResponse,
  GenerateShareLinkData,
  GenerateShareLinkResponse,
  DeleteShareLinkData,
  DeleteShareLinkResponse,
  UpdateShareLinkData,
  UpdateShareLinkResponse,
  GetAllShareLinksData,
  GetAllShareLinksResponse,
  DownloadPatientZipcodeCsvTemplateResponse,
  GetMapDataData,
  GetMapDataResponse,
  RegenerateInvoiceWithCurrentRenewalDateData,
  RegenerateInvoiceWithCurrentRenewalDateResponse,
  RegenerateEmployerMembershipInvoiceData,
  RegenerateEmployerMembershipInvoiceResponse,
  UploadEmployeeUploadTemplateData,
  UploadEmployeeUploadTemplateResponse,
  GetEmployeeUploadTemplateResponse,
  DownloadExcelTemplateResponse,
  DownloadCsvTemplateResponse,
  GetCsvTemplateAsFileResponse,
  PlaceOrderData,
  PlaceOrderResponse,
  AddToCartData,
  AddToCartResponse,
  UpdateQuantityData,
  UpdateQuantityResponse,
  GetAllCartsData,
  GetAllCartsResponse,
  DeleteCartByUuidData,
  DeleteCartByUuidResponse,
  RefreshData,
  RefreshResponse,
  ConfirmEnrollmentData,
  ConfirmEnrollmentResponse,
  LogoutData,
  LogoutResponse,
  LoginData,
  LoginResponse,
  VerifyOtpData,
  VerifyOtpResponse,
  ForgotPasswordData,
  ForgotPasswordResponse,
  JitsiTokenData,
  JitsiTokenResponse,
  GetAllSpecialitiesData,
  GetAllSpecialitiesResponse,
  GetAllPhysicianAccountTypesData,
  GetAllPhysicianAccountTypesResponse,
  GetEmailHistoryByUserData,
  GetEmailHistoryByUserResponse,
  GetEmployerManagementStatsData,
  GetEmployerManagementStatsResponse,
  GetAffiliateStatsResponse,
  GetAffiliatePortalStatsData,
  GetAffiliatePortalStatsResponse,
  MarkReviewResultData,
  MarkReviewResultResponse,
  GetPendingItemsData,
  GetPendingItemsResponse,
  GetPendingFormsCountData,
  GetPendingFormsCountResponse,
  GetPatientReportsData,
  GetPatientReportsResponse,
  GetPatientPortalCountsData,
  GetPatientPortalCountsResponse,
  GetMessegeInfoData,
  GetMessegeInfoResponse,
  GetLabAndImagingResultsData,
  GetLabAndImagingResultsResponse,
  GetWorkNoteByUuidData,
  GetWorkNoteByUuidResponse,
  UpdateWorkNoteData,
  UpdateWorkNoteResponse,
  DeleteWorkNoteByUuidData,
  DeleteWorkNoteByUuidResponse,
  AddWorkNoteData,
  AddWorkNoteResponse,
  GetAllWorkNotesData,
  GetAllWorkNotesResponse,
  GetVitalByUuidData,
  GetVitalByUuidResponse,
  UpdateVitalData,
  UpdateVitalResponse,
  DeleteVitalData,
  DeleteVitalResponse,
  AddVitalData,
  AddVitalResponse,
  RecalculateGrowthPercentilesResponse,
  GetAllVitalsData,
  GetAllVitalsResponse,
  GetVaccineByUuidData,
  GetVaccineByUuidResponse,
  UpdateVaccineData,
  UpdateVaccineResponse,
  DeleteVaccineByUuidData,
  DeleteVaccineByUuidResponse,
  CreateVaccineData,
  CreateVaccineResponse,
  GetAllVaccinesData,
  GetAllVaccinesResponse,
  GetTaskByUuidData,
  GetTaskByUuidResponse,
  UpdateTaskData,
  UpdateTaskResponse,
  DeleteTaskData,
  DeleteTaskResponse,
  AddTaskData,
  AddTaskResponse,
  ResolveTasksForThreadData,
  ResolveTasksForThreadResponse,
  ProcessTaskRemindersResponse,
  HasUnresolvedTaskForThreadData,
  HasUnresolvedTaskForThreadResponse,
  GetAllTasksData,
  GetAllTasksResponse,
  UpdateStatusConfigurationData,
  UpdateStatusConfigurationResponse,
  CreateStatusConfigurationData,
  CreateStatusConfigurationResponse,
  GetStatusConfigurationByUuidData,
  GetStatusConfigurationByUuidResponse,
  DeleteStatusConfigurationByUuidData,
  DeleteStatusConfigurationByUuidResponse,
  GetAllStatusConfigurationsData,
  GetAllStatusConfigurationsResponse,
  GetSocialHistoryByUuidData,
  GetSocialHistoryByUuidResponse,
  UpdateSocialHistoryData,
  UpdateSocialHistoryResponse,
  DeleteSocialHistoryByUuidData,
  DeleteSocialHistoryByUuidResponse,
  GetAllSocialHistoryData,
  GetAllSocialHistoryResponse,
  UpdateSoapNoteData,
  UpdateSoapNoteResponse,
  AddSoapNoteData,
  AddSoapNoteResponse,
  UpdatePreEngagedStatusData,
  UpdatePreEngagedStatusResponse,
  GetSoapNoteByUuidData,
  GetSoapNoteByUuidResponse,
  DeleteSoapNoteData,
  DeleteSoapNoteResponse,
  GetAllWorkNotes1Data,
  GetAllWorkNotes1Response,
  GetSoapNotesByPatientUuidData,
  GetSoapNotesByPatientUuidResponse,
  GetAllInstructionsData,
  GetAllInstructionsResponse,
  GetSoapNoteByAppointmentUuidData,
  GetSoapNoteByAppointmentUuidResponse,
  GetSoapNoteAndHandPnoteByAppointmentUuidData,
  GetSoapNoteAndHandPnoteByAppointmentUuidResponse,
  GetVisitNotesByPatientUuidData,
  GetVisitNotesByPatientUuidResponse,
  GetAllEncounterDetailsData,
  GetAllEncounterDetailsResponse,
  GetAllCarePlanNotesData,
  GetAllCarePlanNotesResponse,
  GetAllSoapNotesData,
  GetAllSoapNotesResponse,
  GetSoapNoteTemplateByUuidData,
  GetSoapNoteTemplateByUuidResponse,
  UpdateSoapNoteTemplateData,
  UpdateSoapNoteTemplateResponse,
  DeleteSoapNoteTemplateByUuidData,
  DeleteSoapNoteTemplateByUuidResponse,
  AddSoapNoteTemplateData,
  AddSoapNoteTemplateResponse,
  UpdateSoapNoteTemplateBookmarkData,
  UpdateSoapNoteTemplateBookmarkResponse,
  GetAllSoapNoteTemplatesData,
  GetAllSoapNoteTemplatesResponse,
  GetScreenHistoryByUuidData,
  GetScreenHistoryByUuidResponse,
  UpdateScreenHistoryData,
  UpdateScreenHistoryResponse,
  DeleteScreenHistoryByUuidData,
  DeleteScreenHistoryByUuidResponse,
  Create11Data,
  Create11Response,
  GetAllScreenHistoryData,
  GetAllScreenHistoryResponse,
  GetReviewOfSystemTemplateByUuidData,
  GetReviewOfSystemTemplateByUuidResponse,
  UpdateReviewOfSystemTemplateData,
  UpdateReviewOfSystemTemplateResponse,
  DeleteReviewOfSystemTemplateData,
  DeleteReviewOfSystemTemplateResponse,
  AddReviewOfSystemTemplateData,
  AddReviewOfSystemTemplateResponse,
  UpdateRosBookmarkData,
  UpdateRosBookmarkResponse,
  GetAllReviewOfSystemTemplatesData,
  GetAllReviewOfSystemTemplatesResponse,
  GetReviewOfSystemByUuidData,
  GetReviewOfSystemByUuidResponse,
  UpdateReviewOfSystemData,
  UpdateReviewOfSystemResponse,
  DeleteReviewOfSystemData,
  DeleteReviewOfSystemResponse,
  AddReviewOfSystemData,
  AddReviewOfSystemResponse,
  GetAllReviewOfSystemsData,
  GetAllReviewOfSystemsResponse,
  UpdateReferralByUuidData,
  UpdateReferralByUuidResponse,
  SaveReferralData,
  SaveReferralResponse,
  GetReferralByUuidData,
  GetReferralByUuidResponse,
  DeleteReferralByUuidData,
  DeleteReferralByUuidResponse,
  GetAllReferralsByProvidersData,
  GetAllReferralsByProvidersResponse,
  GetAllReferralsForGlobalData,
  GetAllReferralsForGlobalResponse,
  GetAllChartItemResponse,
  GetAllReferralsData,
  GetAllReferralsResponse,
  UpdateProviderDirectoryData,
  UpdateProviderDirectoryResponse,
  UploadCsv1Data,
  UploadCsv1Response,
  GetNppesImportHistoryData,
  GetNppesImportHistoryResponse,
  TriggerNppesImportResponse,
  TriggerNppesFileImportData,
  TriggerNppesFileImportResponse,
  SaveProviderDirectoryData,
  SaveProviderDirectoryResponse,
  GetProviderDirectoryUuidData,
  GetProviderDirectoryUuidResponse,
  DeleteProviderDirectoryByUuidData,
  DeleteProviderDirectoryByUuidResponse,
  GetAllReferralTypesData,
  GetAllReferralTypesResponse,
  ProviderDirectoryExportCsvData,
  ProviderDirectoryExportCsvResponse,
  GetAllProviderDirectoryData,
  GetAllProviderDirectoryResponse,
  UpdatePointOfCareLabData,
  UpdatePointOfCareLabResponse,
  CreatePointOfCareLabData,
  CreatePointOfCareLabResponse,
  GetPointOfCareLabByUuidData,
  GetPointOfCareLabByUuidResponse,
  DeletePointOfCareLabByUuidData,
  DeletePointOfCareLabByUuidResponse,
  GetAllPointOfCareLabData,
  GetAllPointOfCareLabResponse,
  GetPocLabTestByIdData,
  GetPocLabTestByIdResponse,
  UpdatePocLabTestData,
  UpdatePocLabTestResponse,
  DeletePocLabTestData,
  DeletePocLabTestResponse,
  AddPocLabTestData,
  AddPocLabTestResponse,
  GetAllPocLabTestsData,
  GetAllPocLabTestsResponse,
  DeletePocTestFieldsData,
  DeletePocTestFieldsResponse,
  GetPocLabResultByIdData,
  GetPocLabResultByIdResponse,
  UpdatePocLabResultData,
  UpdatePocLabResultResponse,
  DeletePocLabResultData,
  DeletePocLabResultResponse,
  AddPocLabResultData,
  AddPocLabResultResponse,
  GetAllPocLabResultsData,
  GetAllPocLabResultsResponse,
  GetPhysicalExamTemplateByUuidData,
  GetPhysicalExamTemplateByUuidResponse,
  UpdatePhysicalExamTemplateData,
  UpdatePhysicalExamTemplateResponse,
  DeletePhysicalExamTemplateByUuidData,
  DeletePhysicalExamTemplateByUuidResponse,
  AddPhysicalExamTemplateData,
  AddPhysicalExamTemplateResponse,
  UpdatePhysicalExamTemplateBookmarkData,
  UpdatePhysicalExamTemplateBookmarkResponse,
  GetAllPhysicalExamTemplatesData,
  GetAllPhysicalExamTemplatesResponse,
  GetPhysicalExamByUuidData,
  GetPhysicalExamByUuidResponse,
  UpdatePhysicalExamData,
  UpdatePhysicalExamResponse,
  DeletePhysicalExamByUuidData,
  DeletePhysicalExamByUuidResponse,
  AddPhysicalExamData,
  AddPhysicalExamResponse,
  GetAllPhysicalExamsData,
  GetAllPhysicalExamsResponse,
  GetPharmacyByUuidData,
  GetPharmacyByUuidResponse,
  UpdatePharmacyData,
  UpdatePharmacyResponse,
  DeletePharmacyData,
  DeletePharmacyResponse,
  AddPharmacyData,
  AddPharmacyResponse,
  GetAllPharmaciesData,
  GetAllPharmaciesResponse,
  GetPatientVaccinationByUuidData,
  GetPatientVaccinationByUuidResponse,
  UpdatePatientVaccinationData,
  UpdatePatientVaccinationResponse,
  DeletePatientVaccinationData,
  DeletePatientVaccinationResponse,
  CreatePatientVaccinationData,
  CreatePatientVaccinationResponse,
  GetAllVaccinationsForPdfData,
  GetAllVaccinationsForPdfResponse,
  ExportPatientVaccinationsData,
  ExportPatientVaccinationsResponse,
  GetAllPatientVaccinationData,
  GetAllPatientVaccinationResponse,
  GetAllPatientVaccinationForVaccineTableData,
  GetAllPatientVaccinationForVaccineTableResponse,
  GetPatientFlagByUuidData,
  GetPatientFlagByUuidResponse,
  UpdatePatientFlagData,
  UpdatePatientFlagResponse,
  DeletePatientFlagData,
  DeletePatientFlagResponse,
  AddPatientFlagData,
  AddPatientFlagResponse,
  GetAllPatientFlagsData,
  GetAllPatientFlagsResponse,
  GetPastSurgicalHistoryByUuidData,
  GetPastSurgicalHistoryByUuidResponse,
  UpdatePastSurgicalHistoryData,
  UpdatePastSurgicalHistoryResponse,
  DeletePastSurgicalHistoryByUuidData,
  DeletePastSurgicalHistoryByUuidResponse,
  AddPastSurgicalHistoryData,
  AddPastSurgicalHistoryResponse,
  GetAllPastSurgicalHistoryData,
  GetAllPastSurgicalHistoryResponse,
  GetPastMedicalHistoryByUuidData,
  GetPastMedicalHistoryByUuidResponse,
  UpdatePastMedicalHistoryData,
  UpdatePastMedicalHistoryResponse,
  DeletePastMedicalHistoryByUuidData,
  DeletePastMedicalHistoryByUuidResponse,
  AddPastMedicalHistoryData,
  AddPastMedicalHistoryResponse,
  GetAllPastMedicalHistoryData,
  GetAllPastMedicalHistoryResponse,
  UpdateNoteByUuidData,
  UpdateNoteByUuidResponse,
  SaveThreadToChartData,
  SaveThreadToChartResponse,
  SaveNoteData,
  SaveNoteResponse,
  UpdateNoteFlagData,
  UpdateNoteFlagResponse,
  GetNoteByUuidData,
  GetNoteByUuidResponse,
  DeleteNoteByUuidData,
  DeleteNoteByUuidResponse,
  GetNoteByThreadUuidData,
  GetNoteByThreadUuidResponse,
  GetAllNotesData,
  GetAllNotesResponse,
  GetAllFlagNotesData,
  GetAllFlagNotesResponse,
  GetMedicationByUuidData,
  GetMedicationByUuidResponse,
  UpdateMedicationByUuidData,
  UpdateMedicationByUuidResponse,
  DeleteMedicationByUuidData,
  DeleteMedicationByUuidResponse,
  UploadMedicationsData,
  UploadMedicationsResponse,
  SaveMedicationData,
  SaveMedicationResponse,
  GetAllMedicationsForPdfData,
  GetAllMedicationsForPdfResponse,
  DownloadCsvTemplate11Response,
  GetAllMedicationsData,
  GetAllMedicationsResponse,
  GetMacroByUuidData,
  GetMacroByUuidResponse,
  UpdateMacroData,
  UpdateMacroResponse,
  DeleteMacroData,
  DeleteMacroResponse,
  AddMacroData,
  AddMacroResponse,
  UpdateMacroBookmarkData,
  UpdateMacroBookmarkResponse,
  GetMacroByTextData,
  GetMacroByTextResponse,
  GetAllMacroData,
  GetAllMacroResponse,
  UpdateLocationData,
  UpdateLocationResponse,
  AddLocationData,
  AddLocationResponse,
  GetLocationByUuidData,
  GetLocationByUuidResponse,
  DeleteLocationByUuidData,
  DeleteLocationByUuidResponse,
  ExportLocationsToCsvData,
  ExportLocationsToCsvResponse,
  GetAllLocationListResponse,
  GetAllLocationData,
  GetAllLocationResponse,
  UpdateSingleToggleData,
  UpdateSingleToggleResponse,
  GetAllSettingsByLocationData,
  GetAllSettingsByLocationResponse,
  UpdateLocationGroupData,
  UpdateLocationGroupResponse,
  AddLocationGroupData,
  AddLocationGroupResponse,
  GetLocationGroupByUuidData,
  GetLocationGroupByUuidResponse,
  DeleteLocationGroupByUuidData,
  DeleteLocationGroupByUuidResponse,
  GetAllLocationGroupData,
  GetAllLocationGroupResponse,
  GetLocationAvailabilityByUuidData,
  GetLocationAvailabilityByUuidResponse,
  UpdateLocationAvailabilityData,
  UpdateLocationAvailabilityResponse,
  DeleteLocationAvailabilityByUuidData,
  DeleteLocationAvailabilityByUuidResponse,
  Create21Data,
  Create21Response,
  GetAllLocationAvailabilityData,
  GetAllLocationAvailabilityResponse,
  SetDefaultPharmacyData,
  SetDefaultPharmacyResponse,
  LinkPharmacyData,
  LinkPharmacyResponse,
  GetAllPharmaciesForPatientData,
  GetAllPharmaciesForPatientResponse,
  DeletePharmacyForPatientByUuidData,
  DeletePharmacyForPatientByUuidResponse,
  UpdateLabTestData,
  UpdateLabTestResponse,
  CreateLabTestData,
  CreateLabTestResponse,
  GetLabTestByUuidData,
  GetLabTestByUuidResponse,
  DeleteLabTestByUuidData,
  DeleteLabTestByUuidResponse,
  GetAllLabTestData,
  GetAllLabTestResponse,
  ApproveLabResultData,
  ApproveLabResultResponse,
  ProccesResultResponse,
  GetAllLabResultsByOrderUuidData,
  GetAllLabResultsByOrderUuidResponse,
  AddLabResultByOrderUuidData,
  AddLabResultByOrderUuidResponse,
  AddLabResultData,
  AddLabResultResponse,
  GetAllLabResultsByPatientUuidData,
  GetAllLabResultsByPatientUuidResponse,
  GetAllLabResultsData,
  GetAllLabResultsResponse,
  ArchiveLabResultData,
  ArchiveLabResultResponse,
  UpdateLabOrderData,
  UpdateLabOrderResponse,
  CreateLabOrderData,
  CreateLabOrderResponse,
  CalculatePriceData,
  CalculatePriceResponse,
  GetLabOrderByUuidData,
  GetLabOrderByUuidResponse,
  DeleteLabOrderByUuidData,
  DeleteLabOrderByUuidResponse,
  MarkAsCompleteData,
  MarkAsCompleteResponse,
  ArchiveLabOrderByUuidData,
  ArchiveLabOrderByUuidResponse,
  GetSpecimenLabelData,
  GetSpecimenLabelResponse,
  GetLabOrderHistoryData,
  GetLabOrderHistoryResponse,
  GetTestCodesWithOrderSetsData,
  GetTestCodesWithOrderSetsResponse,
  GetAllLabOrdersForPdf1Data,
  GetAllLabOrdersForPdf1Response,
  GetAllDraftLabAndImagingOrdersData,
  GetAllDraftLabAndImagingOrdersResponse,
  GetAllLabOrderData,
  GetAllLabOrderResponse,
  UpdateLabOrderSetData,
  UpdateLabOrderSetResponse,
  CreateLabOrderSetData,
  CreateLabOrderSetResponse,
  GetLabOrderSetByUuidData,
  GetLabOrderSetByUuidResponse,
  DeleteLabOrderSetByUuidData,
  DeleteLabOrderSetByUuidResponse,
  GetAllLabOrderSetData,
  GetAllLabOrderSetResponse,
  GetGlobalLabOrderSetData,
  GetGlobalLabOrderSetResponse,
  GetInvoiceByUuidData,
  GetInvoiceByUuidResponse,
  UpdateInvoiceByUuidData,
  UpdateInvoiceByUuidResponse,
  DeleteInvoiceByUuidData,
  DeleteInvoiceByUuidResponse,
  SaveInvoiceStatementData,
  SaveInvoiceStatementResponse,
  SaveInvoiceData,
  SaveInvoiceResponse,
  GetInvoiceStatement1Data,
  GetInvoiceStatement1Response,
  ExportInvoicesToCsvData,
  ExportInvoicesToCsvResponse,
  GetAllInvoicesData,
  GetAllInvoicesResponse,
  UpdateInsuranceData,
  UpdateInsuranceResponse,
  CreateInsuranceData,
  CreateInsuranceResponse,
  GetAllPatientInsuranceWithDependentsData,
  GetAllPatientInsuranceWithDependentsResponse,
  GetInsuranceByUuidData,
  GetInsuranceByUuidResponse,
  DeleteInsuranceByUuidData,
  DeleteInsuranceByUuidResponse,
  GetAllPatientInsuranceData,
  GetAllPatientInsuranceResponse,
  GetImagingResultByUuidData,
  GetImagingResultByUuidResponse,
  UpdateImagingResultData,
  UpdateImagingResultResponse,
  DeleteImagingResultByUuidData,
  DeleteImagingResultByUuidResponse,
  SaveImagingResultData,
  SaveImagingResultResponse,
  ExportCsv1Data,
  ExportCsv1Response,
  GetAllImagingResultsData,
  GetAllImagingResultsResponse,
  GetImagingOrderByUuidData,
  GetImagingOrderByUuidResponse,
  UpdateImagingOrderData,
  UpdateImagingOrderResponse,
  DeleteImagingOrderByUuidData,
  DeleteImagingOrderByUuidResponse,
  SaveImagingOrderData,
  SaveImagingOrderResponse,
  GetAllImagingOrderData,
  GetAllImagingOrderResponse,
  GetIcdCodeByUuidData,
  GetIcdCodeByUuidResponse,
  UpdateIcdCodeData,
  UpdateIcdCodeResponse,
  DeleteIcdCodeByUuidData,
  DeleteIcdCodeByUuidResponse,
  CreateIcdCodeData,
  CreateIcdCodeResponse,
  SearchExternalIcdCodesData,
  SearchExternalIcdCodesResponse,
  GetAllIcdCodesData,
  GetAllIcdCodesResponse,
  GetHandPnoteByUuidData,
  GetHandPnoteByUuidResponse,
  UpdateHandPnoteData,
  UpdateHandPnoteResponse,
  DeleteHandPnoteData,
  DeleteHandPnoteResponse,
  AddHandPnoteData,
  AddHandPnoteResponse,
  GetUnsignedNotesByUserData,
  GetUnsignedNotesByUserResponse,
  GetHandPnotesByPatientUuidData,
  GetHandPnotesByPatientUuidResponse,
  GetHandPnoteByAppointmentUuidData,
  GetHandPnoteByAppointmentUuidResponse,
  GetAllEncountersWithoutDateFilterData,
  GetAllEncountersWithoutDateFilterResponse,
  GetAllHandPnotesData,
  GetAllHandPnotesResponse,
  GetAllEncounterData,
  GetAllEncounterResponse,
  GetHabitsByUuidData,
  GetHabitsByUuidResponse,
  UpdateHabitsData,
  UpdateHabitsResponse,
  DeleteHabitsByUuidData,
  DeleteHabitsByUuidResponse,
  Create31Data,
  Create31Response,
  GetAllHabitsData,
  GetAllHabitsResponse,
  GetGlobalHolidayByUuidData,
  GetGlobalHolidayByUuidResponse,
  UpdateGlobalHolidayData,
  UpdateGlobalHolidayResponse,
  DeleteGlobalHolidayByUuidData,
  DeleteGlobalHolidayByUuidResponse,
  AddGlobalHolidayData,
  AddGlobalHolidayResponse,
  ToggleGlobalHolidayData,
  ToggleGlobalHolidayResponse,
  GetHolidaysForLocationData,
  GetHolidaysForLocationResponse,
  GetAllGlobalHolidaysData,
  GetAllGlobalHolidaysResponse,
  GetFormTemplateByUuidData,
  GetFormTemplateByUuidResponse,
  UpdateFormTemplateData,
  UpdateFormTemplateResponse,
  DeleteFormTemplateData,
  DeleteFormTemplateResponse,
  SetFormAsDefaultData,
  SetFormAsDefaultResponse,
  UpdateFormTemplateWithPdfData,
  UpdateFormTemplateWithPdfResponse,
  GetAllFormTemplatesData,
  GetAllFormTemplatesResponse,
  CreateFormTemplateData,
  CreateFormTemplateResponse,
  DuplicateFormTemplateData,
  DuplicateFormTemplateResponse,
  CreateFormTemplateWithPdfData,
  CreateFormTemplateWithPdfResponse,
  GetFormJsonData,
  GetFormJsonResponse,
  CheckIfFormDefaultExistsData,
  CheckIfFormDefaultExistsResponse,
  GetFormTemplateContentByTypeData,
  GetFormTemplateContentByTypeResponse,
  GetFdbMedicationByUuidData,
  GetFdbMedicationByUuidResponse,
  UpdateFdbMedicationData,
  UpdateFdbMedicationResponse,
  DeleteFdbMedicationByUuidData,
  DeleteFdbMedicationByUuidResponse,
  Create4Data,
  Create4Response,
  GetAllFdbMedicationsData,
  GetAllFdbMedicationsResponse,
  GetFamilyHistoryByUuidData,
  GetFamilyHistoryByUuidResponse,
  UpdateFamilyHistoryData,
  UpdateFamilyHistoryResponse,
  DeleteFamilyHistoryByUuidData,
  DeleteFamilyHistoryByUuidResponse,
  AddFamilyHistoryData,
  AddFamilyHistoryResponse,
  GetAllFamilyHistoryData,
  GetAllFamilyHistoryResponse,
  GetEducationalMaterialByUuidData,
  GetEducationalMaterialByUuidResponse,
  UpdateEducationalMaterialData,
  UpdateEducationalMaterialResponse,
  DeleteEducationalMaterialData,
  DeleteEducationalMaterialResponse,
  CreateEducationalMaterialData,
  CreateEducationalMaterialResponse,
  SetPatientsForMaterialData,
  SetPatientsForMaterialResponse,
  UpdatePatientMaterialBookmarkData,
  UpdatePatientMaterialBookmarkResponse,
  UpdateBookmarkData,
  UpdateBookmarkResponse,
  GetAllEducationalMaterialsData,
  GetAllEducationalMaterialsResponse,
  UpdateDrugIntoleranceData,
  UpdateDrugIntoleranceResponse,
  AddDrugIntoleranceData,
  AddDrugIntoleranceResponse,
  GetDrugIntoleranceByUuidData,
  GetDrugIntoleranceByUuidResponse,
  DeleteDrugIntoleranceByUuidData,
  DeleteDrugIntoleranceByUuidResponse,
  GetAllDrugIntolerancesForPdfData,
  GetAllDrugIntolerancesForPdfResponse,
  GetAllDrugIntolerancesData,
  GetAllDrugIntolerancesResponse,
  UpdateDocumentTypeData,
  UpdateDocumentTypeResponse,
  SaveDocumentTypeData,
  SaveDocumentTypeResponse,
  GetDocumentTypeByUuidData,
  GetDocumentTypeByUuidResponse,
  DeleteDocumentTypeByUuidData,
  DeleteDocumentTypeByUuidResponse,
  GetAllDocumentTypesData,
  GetAllDocumentTypesResponse,
  GetDiagnosisByUuidData,
  GetDiagnosisByUuidResponse,
  UpdateDiagnosisData,
  UpdateDiagnosisResponse,
  DeleteDiagnosisData,
  DeleteDiagnosisResponse,
  AddDiagnosisData,
  AddDiagnosisResponse,
  ResolvedDiagnosisData,
  ResolvedDiagnosisResponse,
  GetAllDiagnosisForPdfData,
  GetAllDiagnosisForPdfResponse,
  GetAllDiagnosesData,
  GetAllDiagnosesResponse,
  UpdateIcdCode1Data,
  UpdateIcdCode1Response,
  AddCptCodeData,
  AddCptCodeResponse,
  GetIcdCodeByUuid1Data,
  GetIcdCodeByUuid1Response,
  DeleteIcdCodeByUuid1Data,
  DeleteIcdCodeByUuid1Response,
  GetAllIcdCodes1Data,
  GetAllIcdCodes1Response,
  GetMessageByUuidData,
  GetMessageByUuidResponse,
  UpdateMessageData,
  UpdateMessageResponse,
  DeleteMessageData,
  DeleteMessageResponse,
  AddMessageData,
  AddMessageResponse,
  GetAssignableUsersForTaskData,
  GetAssignableUsersForTaskResponse,
  GetAllMessagesData,
  GetAllMessagesResponse,
  GetCarePlanByUuidData,
  GetCarePlanByUuidResponse,
  UpdateCarePlanByUuidData,
  UpdateCarePlanByUuidResponse,
  DeleteCarePlanData,
  DeleteCarePlanResponse,
  SaveCarePlanData,
  SaveCarePlanResponse,
  GetCarePlansData,
  GetCarePlansResponse,
  GetAllCarePlansData,
  GetAllCarePlansResponse,
  UpdateAvailabilityData,
  UpdateAvailabilityResponse,
  AddAvailabilityData,
  AddAvailabilityResponse,
  CreateAvailabilityForDateData,
  CreateAvailabilityForDateResponse,
  GetBlockDaysForProvidersData,
  GetBlockDaysForProvidersResponse,
  CreateBlockSlotData,
  CreateBlockSlotResponse,
  GetAvailabilityByProviderUuidData,
  GetAvailabilityByProviderUuidResponse,
  GetAvailabilitySlotsData,
  GetAvailabilitySlotsResponse,
  GetAvailabilitySlotForCalendarData,
  GetAvailabilitySlotForCalendarResponse,
  GetAllAvailabilityData,
  GetAllAvailabilityResponse,
  DeleteAvailabilityByUuidData,
  DeleteAvailabilityByUuidResponse,
  UpdateAppointmentData,
  UpdateAppointmentResponse,
  CreateAppointmentData,
  CreateAppointmentResponse,
  CancelAppointmentByUuidData,
  CancelAppointmentByUuidResponse,
  SubmitVideoConsentData,
  SubmitVideoConsentResponse,
  ConfirmAppointmentFromSmsData,
  ConfirmAppointmentFromSmsResponse,
  GenerateCalendarSyncUrlResponse,
  UpdateAppointmentStatusData,
  UpdateAppointmentStatusResponse,
  GetAppointmentByUuidData,
  GetAppointmentByUuidResponse,
  GetAppointmentVisitDetailsData,
  GetAppointmentVisitDetailsResponse,
  GetVideoConsentFormResponse,
  GetAppointmentForDashBoardData,
  GetAppointmentForDashBoardResponse,
  GetProviderCalendarIcsData,
  GetProviderCalendarIcsResponse,
  GetAllAppointmentsData,
  GetAllAppointmentsResponse,
  DeleteAppointmentByUuidData,
  DeleteAppointmentByUuidResponse,
  UpdateAppointmentTypeData,
  UpdateAppointmentTypeResponse,
  CreateAppointmentTypeData,
  CreateAppointmentTypeResponse,
  GetAppointmentTypeByUuidData,
  GetAppointmentTypeByUuidResponse,
  DeleteAppointmentTypeByUuidData,
  DeleteAppointmentTypeByUuidResponse,
  GetAllAppointmentTypeData,
  GetAllAppointmentTypeResponse,
  GetAnnotableImageData,
  GetAnnotableImageResponse,
  UpdateAnnotableImageData,
  UpdateAnnotableImageResponse,
  DeleteAnnotableImageData,
  DeleteAnnotableImageResponse,
  AddAnnotableImageData,
  AddAnnotableImageResponse,
  GetAllAnnotableImagesData,
  GetAllAnnotableImagesResponse,
  GetAnnotableImageTemplateByUuidData,
  GetAnnotableImageTemplateByUuidResponse,
  UpdateAnnotableImageTemplateData,
  UpdateAnnotableImageTemplateResponse,
  DeleteAnnotableImageTemplateData,
  DeleteAnnotableImageTemplateResponse,
  AddAnnotableImageTemplateData,
  AddAnnotableImageTemplateResponse,
  UpdateAnnotableImageTemplateBookmarkData,
  UpdateAnnotableImageTemplateBookmarkResponse,
  GetAllAnnotableImageTemplateData,
  GetAllAnnotableImageTemplateResponse,
  GetAnnotableImagePinByUuidData,
  GetAnnotableImagePinByUuidResponse,
  UpdateAnnotableImagePinData,
  UpdateAnnotableImagePinResponse,
  DeleteAnnotableImagePinData,
  DeleteAnnotableImagePinResponse,
  AddAnnotableImagePinData,
  AddAnnotableImagePinResponse,
  GetAllAnnotableImagePinsData,
  GetAllAnnotableImagePinsResponse,
  GetAllergyByUuidData,
  GetAllergyByUuidResponse,
  UpdateAllergy1Data,
  UpdateAllergy1Response,
  DeleteAllergyByUuIdData,
  DeleteAllergyByUuIdResponse,
  AddAllergyData,
  AddAllergyResponse,
  GetAllAllergiesForPdfData,
  GetAllAllergiesForPdfResponse,
  GetAllAllergiesData,
  GetAllAllergiesResponse,
  SubmitQuestionnaireMultipartData,
  SubmitQuestionnaireMultipartResponse,
  SendQuestionnaireReminderData,
  SendQuestionnaireReminderResponse,
  SendQuestionnaireFax1Data,
  SendQuestionnaireFax1Response,
  UploadPdfData,
  UploadPdfResponse,
  MarkAsReviewedData,
  MarkAsReviewedResponse,
  GetQuestionnairePdfUrlsData,
  GetQuestionnairePdfUrlsResponse,
  GetQuestionnaireTableMappingsData,
  GetQuestionnaireTableMappingsResponse,
  GetQuestionnaireContentForPatientData,
  GetQuestionnaireContentForPatientResponse,
  GetQuestionnairesForPatientPortalData,
  GetQuestionnairesForPatientPortalResponse,
  DeleteQuestionnaireData,
  DeleteQuestionnaireResponse,
  ReceiveQuestResultData,
  ReceiveQuestResultResponse,
  GetOrderDocumentData,
  GetOrderDocumentResponse,
  GetAllCptCodesData,
  GetAllCptCodesResponse,
  GetAoeQuestionsData,
  GetAoeQuestionsResponse,
  GetAllCodesData,
  GetAllCodesResponse,
  UpdateCompadiumResponse,
  SendOrderData,
  SendOrderResponse,
  SubmitToQuestData,
  SubmitToQuestResponse,
  TestOrderQuestData,
  TestOrderQuestResponse,
  GetResultsData,
  GetResultsResponse,
  SendFormToPatientData,
  SendFormToPatientResponse,
  SendMultipleFormsToPatientData,
  SendMultipleFormsToPatientResponse,
  SendFormToBulkPatientsData,
  SendFormToBulkPatientsResponse,
  UploadDocumentData,
  UploadDocumentResponse,
  SaveDocumentData,
  SaveDocumentResponse,
  UnshareDocumentWithPatientData,
  UnshareDocumentWithPatientResponse,
  ShareDocumentWithPatientData,
  ShareDocumentWithPatientResponse,
  UpdateReviewRequiredData,
  UpdateReviewRequiredResponse,
  ExpireDocumentData,
  ExpireDocumentResponse,
  GetDocumentByUuidData,
  GetDocumentByUuidResponse,
  DeleteDocumentByUuidData,
  DeleteDocumentByUuidResponse,
  GetAllDocuments1Data,
  GetAllDocuments1Response,
  SaveContactDirectoryData,
  SaveContactDirectoryResponse,
  GetContactDirectoryUuidData,
  GetContactDirectoryUuidResponse,
  DeleteContactDirectoryByUuidData,
  DeleteContactDirectoryByUuidResponse,
  GetAllContactDirectoryData,
  GetAllContactDirectoryResponse,
  UploadImageAsMultipartData,
  UploadImageAsMultipartResponse,
  UploadImageAsBase64Data,
  UploadImageAsBase64Response,
  UploadDocumentAsMultipartData,
  UploadDocumentAsMultipartResponse,
  UploadDocumentAsBase64Data,
  UploadDocumentAsBase64Response,
  GetFileData,
  GetFileResponse,
  GetFile1Data,
  GetFile1Response,
  GetDownloadUrlData,
  GetDownloadUrlResponse,
  GetDownloadUrl1Data,
  GetDownloadUrl1Response,
  SubmitAgreementMultipartData,
  SubmitAgreementMultipartResponse,
  CreateAffiliateAgreementData,
  CreateAffiliateAgreementResponse,
  CreateMultipleAffiliateAgreementsData,
  CreateMultipleAffiliateAgreementsResponse,
  GetAgreementByUuidData,
  GetAgreementByUuidResponse,
  DeleteAgreementData,
  DeleteAgreementResponse,
  GetAgreementPdfUrlsData,
  GetAgreementPdfUrlsResponse,
  GetAgreementContentForAffiliateGroupData,
  GetAgreementContentForAffiliateGroupResponse,
  GetAgreementsForPortalData,
  GetAgreementsForPortalResponse,
  GetAllAgreementsForFirmsData,
  GetAllAgreementsForFirmsResponse,
  GetPendingAgreementForLoginData,
  GetPendingAgreementForLoginResponse,
  GetAllTribleTestCodesData,
  GetAllTribleTestCodesResponse,
  GetByPatientUuidData,
  GetByPatientUuidResponse,
  GetAllLabOrdersForPdfData,
  GetAllLabOrdersForPdfResponse,
  GetAll1Data,
  GetAll1Response,
  GetAllTaskCategoriesData,
  GetAllTaskCategoriesResponse,
  GetProcedureCodesData,
  GetProcedureCodesResponse,
  GetAllPlaceholdersResponse,
  GetAllDocumentsData,
  GetAllDocumentsResponse,
  GetGrowthChartData,
  GetGrowthChartResponse,
  GetAvailableFieldsResponse,
  GetAuditHistoryByUuidData,
  GetAuditHistoryByUuidResponse,
  GetUserAuditLogsData,
  GetUserAuditLogsResponse,
  GetTicketAuditLogsData,
  GetTicketAuditLogsResponse,
  GetTaskAuditLogsData,
  GetTaskAuditLogsResponse,
  GetSoapNoteAuditLogsData,
  GetSoapNoteAuditLogsResponse,
  GetPatientModuleAccessAuditLogsData,
  GetPatientModuleAccessAuditLogsResponse,
  GetInventoryAuditLogsData,
  GetInventoryAuditLogsResponse,
  GetHandPnoteAuditLogsData,
  GetHandPnoteAuditLogsResponse,
  ExportTaskAuditLogsCsvData,
  ExportTaskAuditLogsCsvResponse,
  ExportAuditLogsPdfData,
  ExportAuditLogsPdfResponse,
  ExportInventoryAuditLogsPdfData,
  ExportInventoryAuditLogsPdfResponse,
  ExportInventoryAuditLogsCsvData,
  ExportInventoryAuditLogsCsvResponse,
  ExportEmployerAuditLogsCsvData,
  ExportEmployerAuditLogsCsvResponse,
  ExportEmployeeAuditLogsCsvData,
  ExportEmployeeAuditLogsCsvResponse,
  ExportAuditLogsCsvData,
  ExportAuditLogsCsvResponse,
  ExportAuditLogsCsv1Data,
  ExportAuditLogsCsv1Response,
  ExportAdminAuditLogsCsvData,
  ExportAdminAuditLogsCsvResponse,
  GetTicketRelatedAuditLogsData,
  GetTicketRelatedAuditLogsResponse,
  GetEmployerAuditLogsData,
  GetEmployerAuditLogsResponse,
  GetEmployerAdministratorAuditLogsData,
  GetEmployerAdministratorAuditLogsResponse,
  GetEmployeeAuditLogsData,
  GetEmployeeAuditLogsResponse,
  GetBreakGlassAuditLogsData,
  GetBreakGlassAuditLogsResponse,
  GetAllAuditEntitiesResponse,
  GetAllTicketAuditLogsData,
  GetAllTicketAuditLogsResponse,
  GetAllAuditHistoryData,
  GetAllAuditHistoryResponse,
  GetAdminAuditLogsData,
  GetAdminAuditLogsResponse,
  MarkAsReadData,
  MarkAsReadResponse,
  GetAllNotificationsData,
  GetAllNotificationsResponse,
  CreateNotificationData,
  CreateNotificationResponse,
  GetNotificationData,
  GetNotificationResponse,
  DeleteNotificationData,
  DeleteNotificationResponse,
  GetNotificationCountByUserUuidData,
  GetNotificationCountByUserUuidResponse,
  UpdateNotificationPreferenceData,
  UpdateNotificationPreferenceResponse,
  AddNotificationPreferenceData,
  AddNotificationPreferenceResponse,
  GetAllNotificationPreferenceResponse,
  UpdateSingleToggle1Data,
  UpdateSingleToggle1Response,
  UploadEmailStructureAndTemplateToS32Data,
  UploadEmailStructureAndTemplateToS32Response,
  UpdateStatusData,
  UpdateStatusResponse,
  GetEmployerManagementNotificationSettingyUuidData,
  GetEmployerManagementNotificationSettingyUuidResponse,
  GetAllSettingsByEmployerData,
  GetAllSettingsByEmployerResponse,
  GetAllEmployerManagementNotificationSettingsData,
  GetAllEmployerManagementNotificationSettingsResponse,
  SendFcmNotificationData,
  SendFcmNotificationResponse,
  SendFcmBulkNotificationData,
  SendFcmBulkNotificationResponse,
  GetNotificationSettingyUuidData,
  GetNotificationSettingyUuidResponse,
  UpdateCustomNotificationData,
  UpdateCustomNotificationResponse,
  SendEmailForSetPasswordData,
  SendEmailForSetPasswordResponse,
  UploadEmailTemplateToS3Data,
  UploadEmailTemplateToS3Response,
  UploadEmailStructureAndTemplateToS3Data,
  UploadEmailStructureAndTemplateToS3Response,
  SendEmailForData,
  SendEmailForResponse,
  SendEmailForAddPaymentToPatientData,
  SendEmailForAddPaymentToPatientResponse,
  SendAddressChangeMailToPhpData,
  SendAddressChangeMailToPhpResponse,
  SendEmailForProviderSignupData,
  SendEmailForProviderSignupResponse,
  SendAppointmentJoinNotificationToPatientData,
  SendAppointmentJoinNotificationToPatientResponse,
  SendLabResultToPatientData,
  SendLabResultToPatientResponse,
  SendRetailEnrollmentNotificationResponse,
  SendRefundEmailData,
  SendRefundEmailResponse,
  SendEmailForPatientBirthdayResponse,
  SendUpcomingInvoiceNotificationData,
  SendUpcomingInvoiceNotificationResponse,
  SendPatientNotificationEmailData,
  SendPatientNotificationEmailResponse,
  SendPatientEnrollmentRequestNotificationData,
  SendPatientEnrollmentRequestNotificationResponse,
  SendMultipleFormsEmailData,
  SendMultipleFormsEmailResponse,
  SendMembershipPaidEmailData,
  SendMembershipPaidEmailResponse,
  SendMembershipCreatedEmailData,
  SendMembershipCreatedEmailResponse,
  SendLabResultReadyNotificationData,
  SendLabResultReadyNotificationResponse,
  SendEmailForInvoiceNotificationAutopayDisabledResponse,
  SendEmailForInvoiceNotificationAutopayResponse,
  SendEmailForInvoiceData,
  SendEmailForInvoiceResponse,
  SendEmailsForInvoiceNotificationResponse,
  SendFailedPaymentSummaryToAdminResponse,
  SendUpcomingInvoiceNotificationToEmployerData,
  SendUpcomingInvoiceNotificationToEmployerResponse,
  SendPatientPaidNotificationToEmployerData,
  SendPatientPaidNotificationToEmployerResponse,
  SendInvoiceIssuedNotificationToEmployerData,
  SendInvoiceIssuedNotificationToEmployerResponse,
  SendCreatedInvoiceNotificationToEmployerData,
  SendCreatedInvoiceNotificationToEmployerResponse,
  SendAutopayProcessedNotificationToEmployerData,
  SendAutopayProcessedNotificationToEmployerResponse,
  SendEmployerInvoiceCreationReminderNotificationResponse,
  SendEmailForChargePaidData,
  SendEmailForChargePaidResponse,
  SendEmailForCardExpiringSoonResponse,
  SendCardSharedEmailData,
  SendCardSharedEmailResponse,
  SendEmailForRemovalOfCardData,
  SendEmailForRemovalOfCardResponse,
  SendCardReceivedEmailData,
  SendCardReceivedEmailResponse,
  SendCallInvitationNotificationData,
  SendCallInvitationNotificationResponse,
  SendSignBrokerData,
  SendSignBrokerResponse,
  SendEmailForRemovalOfBankData,
  SendEmailForRemovalOfBankResponse,
  SendAppointmentEmailData,
  SendAppointmentEmailResponse,
  SendAgentFirmAgreementCreatedEmailData,
  SendAgentFirmAgreementCreatedEmailResponse,
  SendAffiliateAgreementCreatedEmailData,
  SendAffiliateAgreementCreatedEmailResponse,
  GetFile11Data,
  GetFile11Response,
  GetAllNotificationSettingsData,
  GetAllNotificationSettingsResponse,
  HandleSnsNotificationData,
  HandleSnsNotificationResponse,
  UploadEmailStructureAndTemplateToS31Data,
  UploadEmailStructureAndTemplateToS31Response,
  EmployerNotificationSettingUuidData,
  EmployerNotificationSettingUuidResponse,
  GetAllEmployerNotificationSettingsData,
  GetAllEmployerNotificationSettingsResponse,
  SendReferralEmailData,
  SendReferralEmailResponse,
  SendReferralEmailWithLinkData,
  SendReferralEmailWithLinkResponse,
  SendProviderReassignmentEmailsData,
  SendProviderReassignmentEmailsResponse,
  SendFormTemplateData,
  SendFormTemplateResponse,
  SendBulkEmailData,
  SendBulkEmailResponse,
  SendInvitationEmailData,
  SendInvitationEmailResponse,
  GetSubscription1Data,
  GetSubscription1Response,
  UpdateSubscription1Data,
  UpdateSubscription1Response,
  CancelSubscription1Data,
  CancelSubscription1Response,
  ChangePlan1Data,
  ChangePlan1Response,
  ChangePlanWithProration1Data,
  ChangePlanWithProration1Response,
  UpdatePromotionalCoupon1Data,
  UpdatePromotionalCoupon1Response,
  CreatePromotionalCoupon1Data,
  CreatePromotionalCoupon1Response,
  CreateSubscription1Data,
  CreateSubscription1Response,
  CreateSubscriptionWithPayment1Data,
  CreateSubscriptionWithPayment1Response,
  CreateSetupIntentWithCustomer1Data,
  CreateSetupIntentWithCustomer1Response,
  SetDefaultPaymentMethod1Data,
  SetDefaultPaymentMethod1Response,
  SaveCardToCustomerWithCharging1Data,
  SaveCardToCustomerWithCharging1Response,
  SaveCardToCustomer1Data,
  SaveCardToCustomer1Response,
  CreateProduct1Data,
  CreateProduct1Response,
  CreatePriceForProduct1Data,
  CreatePriceForProduct1Response,
  CreateProductAndPrice1Data,
  CreateProductAndPrice1Response,
  CreatePaymentIntent1Data,
  CreatePaymentIntent1Response,
  CreateCustomer1Data,
  CreateCustomer1Response,
  GetStripeConfig1Response,
  UpdateTicketData,
  UpdateTicketResponse,
  DeleteTicketData,
  DeleteTicketResponse,
  UpdateTicketPriorityData,
  UpdateTicketPriorityResponse,
  UpdateTicketStatusData,
  UpdateTicketStatusResponse,
  CreateTicketData,
  CreateTicketResponse,
  GetTicketByUuidData,
  GetTicketByUuidResponse,
  GetTicketsByEmployerUuidData,
  GetTicketsByEmployerUuidResponse,
  GetTotalTicketsCountByUuidData,
  GetTotalTicketsCountByUuidResponse,
  GetTicketCountsByStatusByUuidData,
  GetTicketCountsByStatusByUuidResponse,
  GetEmployerInfoData,
  GetEmployerInfoResponse,
  GetEmployerStatsData,
  GetEmployerStatsResponse,
  GetCreatorTicketStatsData,
  GetCreatorTicketStatsResponse,
  GetTicketCountsData,
  GetTicketCountsResponse,
  GetAllTicketsWithFiltersData,
  GetAllTicketsWithFiltersResponse,
  GetAdminTicketStatusData,
  GetAdminTicketStatusResponse,
  GetTicketTaskByUuidData,
  GetTicketTaskByUuidResponse,
  UpdateTicketTaskData,
  UpdateTicketTaskResponse,
  DeleteTicketTaskData,
  DeleteTicketTaskResponse,
  UpdateTicketTaskStatusData,
  UpdateTicketTaskStatusResponse,
  UpdateTicketTaskPriorityData,
  UpdateTicketTaskPriorityResponse,
  UpdateTicketTaskAssigneeData,
  UpdateTicketTaskAssigneeResponse,
  CreateTicketTaskData,
  CreateTicketTaskResponse,
  GetAllTasksByEmployerData,
  GetAllTasksByEmployerResponse,
  GetAllTasksByTicketUuidData,
  GetAllTasksByTicketUuidResponse,
  GetTicketNotesByUuidData,
  GetTicketNotesByUuidResponse,
  UpdateTicketNotesData,
  UpdateTicketNotesResponse,
  DeleteTicketNotesData,
  DeleteTicketNotesResponse,
  CreateTicketNotesData,
  CreateTicketNotesResponse,
  GetAllNotesByEmployerData,
  GetAllNotesByEmployerResponse,
  GetAllTicketNotesData,
  GetAllTicketNotesResponse,
  GetAttachmentByUuidData,
  GetAttachmentByUuidResponse,
  UpdateAttachmentData,
  UpdateAttachmentResponse,
  DeleteAttachmentData,
  DeleteAttachmentResponse,
  AddAttachmentData,
  AddAttachmentResponse,
  GetAllAttachmentsByEmployerData,
  GetAllAttachmentsByEmployerResponse,
  GetAllAttachmentsByTicketUuidData,
  GetAllAttachmentsByTicketUuidResponse,
  GetTemplateData,
  GetTemplateResponse,
  UpdateTemplateData,
  UpdateTemplateResponse,
  DeleteTemplateData,
  DeleteTemplateResponse,
  AddTemplateData,
  AddTemplateResponse,
  GetAllTemplatesData,
  GetAllTemplatesResponse,
  GetAllTemplates1Data,
  GetAllTemplates1Response,
  GetTaskByUuid1Data,
  GetTaskByUuid1Response,
  UpdateCrmTaskData,
  UpdateCrmTaskResponse,
  DeleteCrmTaskData,
  DeleteCrmTaskResponse,
  UpdateTaskPriorityData,
  UpdateTaskPriorityResponse,
  CreateTaskData,
  CreateTaskResponse,
  GetAllTasksByContactUuidData,
  GetAllTasksByContactUuidResponse,
  GetAllTasks1Data,
  GetAllTasks1Response,
  GetTaskLogByUuidData,
  GetTaskLogByUuidResponse,
  UpdateTaskLogData,
  UpdateTaskLogResponse,
  DeleteTaskLogData,
  DeleteTaskLogResponse,
  CreateTaskLogData,
  CreateTaskLogResponse,
  GetAllTaskLogsData,
  GetAllTaskLogsResponse,
  UpdateNewsletterData,
  UpdateNewsletterResponse,
  DeleteNewsletterData,
  DeleteNewsletterResponse,
  CreateNewsletterData,
  CreateNewsletterResponse,
  GetNewsletterByUuidResponse,
  GetAllNewsletterData,
  GetAllNewsletterResponse,
  GetCampaignByUuidData,
  GetCampaignByUuidResponse,
  UpdateCampaignData,
  UpdateCampaignResponse,
  DeleteCampaignResponse,
  CreateCampaignData,
  CreateCampaignResponse,
  GetAllCampaignData,
  GetAllCampaignResponse,
  GetCallLogByUuidData,
  GetCallLogByUuidResponse,
  UpdateCallLogData,
  UpdateCallLogResponse,
  DeleteCallLogData,
  DeleteCallLogResponse,
  CreateCallLogData,
  CreateCallLogResponse,
  GetAllCallLogsData,
  GetAllCallLogsResponse,
  MergeTicketData,
  MergeTicketResponse,
  GetMergedTicketData,
  GetMergedTicketResponse,
  GetAllMergedTicketsData,
  GetAllMergedTicketsResponse,
  LinkTicketData,
  LinkTicketResponse,
  GetLinkedTicketByUuidData,
  GetLinkedTicketByUuidResponse,
  GetAllLinkedTicketsData,
  GetAllLinkedTicketsResponse,
  UnlinkTicketData,
  UnlinkTicketResponse,
  CreateConversationData,
  CreateConversationResponse,
  GetConversationByUuidData,
  GetConversationByUuidResponse,
  GetAllConversationsByTicketUuidData,
  GetAllConversationsByTicketUuidResponse,
  MarkMessageUrgentData,
  MarkMessageUrgentResponse,
  MarkMessageReadByUserData,
  MarkMessageReadByUserResponse,
  CancelScheduledMessageData,
  CancelScheduledMessageResponse,
  MarkAllMessagesReadInThreadData,
  MarkAllMessagesReadInThreadResponse,
  MarkAllMessagesReadInThreadForUserData,
  MarkAllMessagesReadInThreadForUserResponse,
  RescheduleMessageData,
  RescheduleMessageResponse,
  EditScheduledMessageData,
  EditScheduledMessageResponse,
  RemoveMessageUrgentData,
  RemoveMessageUrgentResponse,
  SendMessageData,
  SendMessageResponse,
  SendScheduledMessageNowData,
  SendScheduledMessageNowResponse,
  RemoveAttacmentData,
  RemoveAttacmentResponse,
  GetUnreadMessageCountByUserUuidData,
  GetUnreadMessageCountByUserUuidResponse,
  GetMessageSummariesByUserUuidData,
  GetMessageSummariesByUserUuidResponse,
  GetUrgentUnreadMessagesForUserData,
  GetUrgentUnreadMessagesForUserResponse,
  GetUrgentUnreadMessageCountForUserData,
  GetUrgentUnreadMessageCountForUserResponse,
  GetUnreadMessagesForUserData,
  GetUnreadMessagesForUserResponse,
  GetUnreadMessageCountForUserResponse,
  ListMessagesData,
  ListMessagesResponse,
  GetScheduledMessagesData,
  GetScheduledMessagesResponse,
  CountUnreadData,
  CountUnreadResponse,
  CountUnreadForUserData,
  CountUnreadForUserResponse,
  SearchMessagesData,
  SearchMessagesResponse,
  GetPatientDependentsMessageSummaryData,
  GetPatientDependentsMessageSummaryResponse,
  DeleteMessageByUuidData,
  DeleteMessageByUuidResponse,
  DeleteScheduledMessageData,
  DeleteScheduledMessageResponse,
  EndCallData,
  EndCallResponse,
  DeclineCallData,
  DeclineCallResponse,
  CancelCallData,
  CancelCallResponse,
  AcceptCallData,
  AcceptCallResponse,
  StartCallData,
  StartCallResponse,
  GetCallData,
  GetCallResponse,
  OutboundDialData,
  OutboundDialResponse,
  InboundCallData,
  InboundCallResponse,
  DialActionData,
  DialActionResponse,
  AppDialData,
  AppDialResponse,
  RecordingsData,
  RecordingsResponse,
  EventsData,
  EventsResponse,
  IssueTokenData,
  IssueTokenResponse,
  UnregisterResponse,
  CallLogData,
  CallLogResponse,
  PlaceCallData,
  PlaceCallResponse,
  HangUpResponse,
  StatusResponse,
  GetCall1Data,
  GetCall1Response,
  ReadTranscriptData,
  ReadTranscriptResponse,
  PlayRecordingData,
  PlayRecordingResponse,
  InboundSmsData,
  InboundSmsResponse,
  SendSmsData,
  SendSmsResponse,
  SendGenericSmsData,
  SendGenericSmsResponse,
  GenerateAccessTokenResponse,
  GetServiceStatusResponse,
  CheckHealthResponse,
  CreateThreadData,
  CreateThreadResponse,
  ResumeThreadData,
  ResumeThreadResponse,
  BroadcastThreadListUpdateData,
  BroadcastThreadListUpdateResponse,
  BroadcastThreadSummariesData,
  BroadcastThreadSummariesResponse,
  RouteThreadData,
  RouteThreadResponse,
  CreateOpenThreadData,
  CreateOpenThreadResponse,
  MarkThreadUrgentData,
  MarkThreadUrgentResponse,
  UpdateThreadStatusData,
  UpdateThreadStatusResponse,
  UpdateOpenThreadData,
  UpdateOpenThreadResponse,
  GetThreadByIdData,
  GetThreadByIdResponse,
  GetOpenThreadUsersData,
  GetOpenThreadUsersResponse,
  SearchThreadsData,
  SearchThreadsResponse,
  GetThreadsByPatientData,
  GetThreadsByPatientResponse,
  GetThreadsListData,
  GetThreadsListResponse,
  GetMyThreadsData,
  GetMyThreadsResponse,
  GetThreadCategoriesResponse,
  BroadcastData,
  BroadcastResponse,
  BookmarkThreadData,
  BookmarkThreadResponse,
  UnbookmarkThreadData,
  UnbookmarkThreadResponse,
  BookmarkMessageData,
  BookmarkMessageResponse,
  UnbookmarkMessageData,
  UnbookmarkMessageResponse,
  GetBookmarkedThreadsData,
  GetBookmarkedThreadsResponse,
  GetBookmarkedMessagesData,
  GetBookmarkedMessagesResponse,
  GetMessagePositionInThreadData,
  GetMessagePositionInThreadResponse,
  GetBookmarkedMessagesByThreadData,
  GetBookmarkedMessagesByThreadResponse,
  UnbookmarkMessagesByThreadData,
  UnbookmarkMessagesByThreadResponse,
  $OpenApiTs,
} from "../requests/types.gen";
export type UserControllerServiceGetProfileDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getProfile>
>;
export type UserControllerServiceGetProfileQueryResult<
  TData = UserControllerServiceGetProfileDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetProfileKey =
  "UserControllerServiceGetProfile";
export const UseUserControllerServiceGetProfileKeyFn = (
  queryKey?: Array<unknown>,
) => [useUserControllerServiceGetProfileKey, ...(queryKey ?? [])];
export type UserControllerServiceGetAllUsersDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getAllUsers>
>;
export type UserControllerServiceGetAllUsersQueryResult<
  TData = UserControllerServiceGetAllUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetAllUsersKey =
  "UserControllerServiceGetAllUsers";
export const UseUserControllerServiceGetAllUsersKeyFn = (
  {
    archive,
    page,
    role,
    roleType,
    searchString,
    size,
    sortBy,
    sortDirection,
    status,
  }: {
    archive?: boolean;
    page?: number;
    role?: string;
    roleType?:
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER";
    searchString?: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetAllUsersKey,
  ...(queryKey ?? [
    {
      archive,
      page,
      role,
      roleType,
      searchString,
      size,
      sortBy,
      sortDirection,
      status,
    },
  ]),
];
export type UserControllerServiceGetAllProviderAndStaffUserDefaultResponse =
  Awaited<ReturnType<typeof UserControllerService.getAllProviderAndStaffUser>>;
export type UserControllerServiceGetAllProviderAndStaffUserQueryResult<
  TData = UserControllerServiceGetAllProviderAndStaffUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetAllProviderAndStaffUserKey =
  "UserControllerServiceGetAllProviderAndStaffUser";
export const UseUserControllerServiceGetAllProviderAndStaffUserKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetAllProviderAndStaffUserKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type UserControllerServiceGetClinicalStaffDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getClinicalStaff>
>;
export type UserControllerServiceGetClinicalStaffQueryResult<
  TData = UserControllerServiceGetClinicalStaffDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetClinicalStaffKey =
  "UserControllerServiceGetClinicalStaff";
export const UseUserControllerServiceGetClinicalStaffKeyFn = (
  {
    locationUuids,
    page,
    pageSize,
    roleTypes,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    roleTypes?: (
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER"
    )[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetClinicalStaffKey,
  ...(queryKey ?? [
    {
      locationUuids,
      page,
      pageSize,
      roleTypes,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type UserControllerServiceGetUsersByRoleTypeDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getUsersByRoleType>
>;
export type UserControllerServiceGetUsersByRoleTypeQueryResult<
  TData = UserControllerServiceGetUsersByRoleTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetUsersByRoleTypeKey =
  "UserControllerServiceGetUsersByRoleType";
export const UseUserControllerServiceGetUsersByRoleTypeKeyFn = (
  {
    employerUuid,
    page,
    pageSize,
    roleType,
    searchString,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    roleType?:
      | "ADMIN"
      | "USER"
      | "EHR"
      | "EMPLOYER"
      | "PATIENT"
      | "AGENT"
      | "AFFILIATE"
      | "BROKER"
      | "CLINIC_USER";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetUsersByRoleTypeKey,
  ...(queryKey ?? [
    {
      employerUuid,
      page,
      pageSize,
      roleType,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type UserControllerServiceGetUserDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getUser>
>;
export type UserControllerServiceGetUserQueryResult<
  TData = UserControllerServiceGetUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetUserKey =
  "UserControllerServiceGetUser";
export const UseUserControllerServiceGetUserKeyFn = (
  {
    userId,
  }: {
    userId: string;
  },
  queryKey?: Array<unknown>,
) => [useUserControllerServiceGetUserKey, ...(queryKey ?? [{ userId }])];
export type UserControllerServiceGetUserFromIamidDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getUserFromIamid>
>;
export type UserControllerServiceGetUserFromIamidQueryResult<
  TData = UserControllerServiceGetUserFromIamidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetUserFromIamidKey =
  "UserControllerServiceGetUserFromIamid";
export const UseUserControllerServiceGetUserFromIamidKeyFn = (
  {
    iamid,
  }: {
    iamid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetUserFromIamidKey,
  ...(queryKey ?? [{ iamid }]),
];
export type UserControllerServiceCheckDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.check>
>;
export type UserControllerServiceCheckQueryResult<
  TData = UserControllerServiceCheckDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceCheckKey = "UserControllerServiceCheck";
export const UseUserControllerServiceCheckKeyFn = (
  queryKey?: Array<unknown>,
) => [useUserControllerServiceCheckKey, ...(queryKey ?? [])];
export type UserControllerServiceCheckUserRegistrationDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.checkUserRegistration>
>;
export type UserControllerServiceCheckUserRegistrationQueryResult<
  TData = UserControllerServiceCheckUserRegistrationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceCheckUserRegistrationKey =
  "UserControllerServiceCheckUserRegistration";
export const UseUserControllerServiceCheckUserRegistrationKeyFn = (
  {
    registrationUuid,
  }: {
    registrationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceCheckUserRegistrationKey,
  ...(queryKey ?? [{ registrationUuid }]),
];
export type UserControllerServiceGetAssignedLocationsDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getAssignedLocations>
>;
export type UserControllerServiceGetAssignedLocationsQueryResult<
  TData = UserControllerServiceGetAssignedLocationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetAssignedLocationsKey =
  "UserControllerServiceGetAssignedLocations";
export const UseUserControllerServiceGetAssignedLocationsKeyFn = (
  {
    isAffiliate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isAffiliate?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetAssignedLocationsKey,
  ...(queryKey ?? [
    { isAffiliate, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type UserControllerServiceGetUsersDefaultResponse = Awaited<
  ReturnType<typeof UserControllerService.getUsers>
>;
export type UserControllerServiceGetUsersQueryResult<
  TData = UserControllerServiceGetUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useUserControllerServiceGetUsersKey =
  "UserControllerServiceGetUsers";
export const UseUserControllerServiceGetUsersKeyFn = (
  {
    affiliate,
    flag,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    affiliate?: boolean;
    flag?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useUserControllerServiceGetUsersKey,
  ...(queryKey ?? [
    { affiliate, flag, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type EmployeeUploadControllerServiceGetUploadDetailsByUploadUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployeeUploadControllerService.getUploadDetailsByUploadUuid
    >
  >;
export type EmployeeUploadControllerServiceGetUploadDetailsByUploadUuidQueryResult<
  TData =
    EmployeeUploadControllerServiceGetUploadDetailsByUploadUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceGetUploadDetailsByUploadUuidKey =
  "EmployeeUploadControllerServiceGetUploadDetailsByUploadUuid";
export const UseEmployeeUploadControllerServiceGetUploadDetailsByUploadUuidKeyFn =
  (
    {
      mute,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      status,
      uploadUuid,
    }: {
      mute?: boolean;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      status?: "SUCCESS" | "WARNING" | "ERROR";
      uploadUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployeeUploadControllerServiceGetUploadDetailsByUploadUuidKey,
    ...(queryKey ?? [
      {
        mute,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        status,
        uploadUuid,
      },
    ]),
  ];
export type EmployeeUploadControllerServiceGetRowFromCsvDefaultResponse =
  Awaited<ReturnType<typeof EmployeeUploadControllerService.getRowFromCsv>>;
export type EmployeeUploadControllerServiceGetRowFromCsvQueryResult<
  TData = EmployeeUploadControllerServiceGetRowFromCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceGetRowFromCsvKey =
  "EmployeeUploadControllerServiceGetRowFromCsv";
export const UseEmployeeUploadControllerServiceGetRowFromCsvKeyFn = (
  {
    rowNumber,
    uploadUuid,
  }: {
    rowNumber: number;
    uploadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployeeUploadControllerServiceGetRowFromCsvKey,
  ...(queryKey ?? [{ rowNumber, uploadUuid }]),
];
export type EmployeeUploadControllerServiceExportRowsDefaultResponse = Awaited<
  ReturnType<typeof EmployeeUploadControllerService.exportRows>
>;
export type EmployeeUploadControllerServiceExportRowsQueryResult<
  TData = EmployeeUploadControllerServiceExportRowsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceExportRowsKey =
  "EmployeeUploadControllerServiceExportRows";
export const UseEmployeeUploadControllerServiceExportRowsKeyFn = (
  {
    status,
    uploadUuid,
  }: {
    status: "SUCCESS" | "WARNING" | "ERROR";
    uploadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployeeUploadControllerServiceExportRowsKey,
  ...(queryKey ?? [{ status, uploadUuid }]),
];
export type EmployeeUploadControllerServiceDownloadFileDefaultResponse =
  Awaited<ReturnType<typeof EmployeeUploadControllerService.downloadFile>>;
export type EmployeeUploadControllerServiceDownloadFileQueryResult<
  TData = EmployeeUploadControllerServiceDownloadFileDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceDownloadFileKey =
  "EmployeeUploadControllerServiceDownloadFile";
export const UseEmployeeUploadControllerServiceDownloadFileKeyFn = (
  {
    uploadUuid,
  }: {
    uploadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployeeUploadControllerServiceDownloadFileKey,
  ...(queryKey ?? [{ uploadUuid }]),
];
export type EmployeeUploadControllerServiceGetAllUploadsDefaultResponse =
  Awaited<ReturnType<typeof EmployeeUploadControllerService.getAllUploads>>;
export type EmployeeUploadControllerServiceGetAllUploadsQueryResult<
  TData = EmployeeUploadControllerServiceGetAllUploadsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceGetAllUploadsKey =
  "EmployeeUploadControllerServiceGetAllUploads";
export const UseEmployeeUploadControllerServiceGetAllUploadsKeyFn = (
  {
    employerUuid,
    fileName,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    fileName?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployeeUploadControllerServiceGetAllUploadsKey,
  ...(queryKey ?? [
    { employerUuid, fileName, page, pageSize, sortBy, sortDirection },
  ]),
];
export type EmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployeeUploadControllerService.getAllUploadDetailsByUploadUuid
    >
  >;
export type EmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidQueryResult<
  TData =
    EmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidKey =
  "EmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuid";
export const UseEmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidKeyFn =
  (
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
      status,
      uploadUuid,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
      status?: "SUCCESS" | "WARNING" | "ERROR";
      uploadUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployeeUploadControllerServiceGetAllUploadDetailsByUploadUuidKey,
    ...(queryKey ?? [
      { page, pageSize, sortBy, sortDirection, status, uploadUuid },
    ]),
  ];
export type StripeControllerServiceGetSubscriptionDefaultResponse = Awaited<
  ReturnType<typeof StripeControllerService.getSubscription>
>;
export type StripeControllerServiceGetSubscriptionQueryResult<
  TData = StripeControllerServiceGetSubscriptionDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripeControllerServiceGetSubscriptionKey =
  "StripeControllerServiceGetSubscription";
export const UseStripeControllerServiceGetSubscriptionKeyFn = (
  {
    subscriptionId,
  }: {
    subscriptionId: string;
  },
  queryKey?: Array<unknown>,
) => [
  useStripeControllerServiceGetSubscriptionKey,
  ...(queryKey ?? [{ subscriptionId }]),
];
export type StripeControllerServiceGetPhpUserDefaultResponse = Awaited<
  ReturnType<typeof StripeControllerService.getPhpUser>
>;
export type StripeControllerServiceGetPhpUserQueryResult<
  TData = StripeControllerServiceGetPhpUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripeControllerServiceGetPhpUserKey =
  "StripeControllerServiceGetPhpUser";
export const UseStripeControllerServiceGetPhpUserKeyFn = (
  queryKey?: Array<unknown>,
) => [useStripeControllerServiceGetPhpUserKey, ...(queryKey ?? [])];
export type StripeControllerServiceGetStripeConfigDefaultResponse = Awaited<
  ReturnType<typeof StripeControllerService.getStripeConfig>
>;
export type StripeControllerServiceGetStripeConfigQueryResult<
  TData = StripeControllerServiceGetStripeConfigDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripeControllerServiceGetStripeConfigKey =
  "StripeControllerServiceGetStripeConfig";
export const UseStripeControllerServiceGetStripeConfigKeyFn = (
  queryKey?: Array<unknown>,
) => [useStripeControllerServiceGetStripeConfigKey, ...(queryKey ?? [])];
export type StripeControllerServiceCheckServicesOfUserDefaultResponse = Awaited<
  ReturnType<typeof StripeControllerService.checkServicesOfUser>
>;
export type StripeControllerServiceCheckServicesOfUserQueryResult<
  TData = StripeControllerServiceCheckServicesOfUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripeControllerServiceCheckServicesOfUserKey =
  "StripeControllerServiceCheckServicesOfUser";
export const UseStripeControllerServiceCheckServicesOfUserKeyFn = (
  {
    userTypes,
    uuid,
  }: {
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useStripeControllerServiceCheckServicesOfUserKey,
  ...(queryKey ?? [{ userTypes, uuid }]),
];
export type ScriptSureControllerServiceGetPrescriptionIframeDefaultResponse =
  Awaited<ReturnType<typeof ScriptSureControllerService.getPrescriptionIframe>>;
export type ScriptSureControllerServiceGetPrescriptionIframeQueryResult<
  TData = ScriptSureControllerServiceGetPrescriptionIframeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetPrescriptionIframeKey =
  "ScriptSureControllerServiceGetPrescriptionIframe";
export const UseScriptSureControllerServiceGetPrescriptionIframeKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetPrescriptionIframeKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type ScriptSureControllerServiceGetMessageCountDefaultResponse = Awaited<
  ReturnType<typeof ScriptSureControllerService.getMessageCount>
>;
export type ScriptSureControllerServiceGetMessageCountQueryResult<
  TData = ScriptSureControllerServiceGetMessageCountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetMessageCountKey =
  "ScriptSureControllerServiceGetMessageCount";
export const UseScriptSureControllerServiceGetMessageCountKeyFn = (
  {
    doctorId,
  }: {
    doctorId: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetMessageCountKey,
  ...(queryKey ?? [{ doctorId }]),
];
export type ScriptSureControllerServiceGetMedCartIframeDefaultResponse =
  Awaited<ReturnType<typeof ScriptSureControllerService.getMedCartIframe>>;
export type ScriptSureControllerServiceGetMedCartIframeQueryResult<
  TData = ScriptSureControllerServiceGetMedCartIframeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetMedCartIframeKey =
  "ScriptSureControllerServiceGetMedCartIframe";
export const UseScriptSureControllerServiceGetMedCartIframeKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetMedCartIframeKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type ScriptSureControllerServiceSearchDrugsDefaultResponse = Awaited<
  ReturnType<typeof ScriptSureControllerService.searchDrugs>
>;
export type ScriptSureControllerServiceSearchDrugsQueryResult<
  TData = ScriptSureControllerServiceSearchDrugsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceSearchDrugsKey =
  "ScriptSureControllerServiceSearchDrugs";
export const UseScriptSureControllerServiceSearchDrugsKeyFn = (
  {
    page,
    pageSize,
    query,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    query: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceSearchDrugsKey,
  ...(queryKey ?? [{ page, pageSize, query, sortBy, sortDirection }]),
];
export type ScriptSureControllerServiceGetDrugDosesDefaultResponse = Awaited<
  ReturnType<typeof ScriptSureControllerService.getDrugDoses>
>;
export type ScriptSureControllerServiceGetDrugDosesQueryResult<
  TData = ScriptSureControllerServiceGetDrugDosesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetDrugDosesKey =
  "ScriptSureControllerServiceGetDrugDoses";
export const UseScriptSureControllerServiceGetDrugDosesKeyFn = (
  {
    drugId,
  }: {
    drugId: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetDrugDosesKey,
  ...(queryKey ?? [{ drugId }]),
];
export type ScriptSureControllerServiceGetDrugHistoryIframeDefaultResponse =
  Awaited<ReturnType<typeof ScriptSureControllerService.getDrugHistoryIframe>>;
export type ScriptSureControllerServiceGetDrugHistoryIframeQueryResult<
  TData = ScriptSureControllerServiceGetDrugHistoryIframeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetDrugHistoryIframeKey =
  "ScriptSureControllerServiceGetDrugHistoryIframe";
export const UseScriptSureControllerServiceGetDrugHistoryIframeKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetDrugHistoryIframeKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type ScriptSureControllerServiceGetCpoeIframeDefaultResponse = Awaited<
  ReturnType<typeof ScriptSureControllerService.getCpoeIframe>
>;
export type ScriptSureControllerServiceGetCpoeIframeQueryResult<
  TData = ScriptSureControllerServiceGetCpoeIframeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetCpoeIframeKey =
  "ScriptSureControllerServiceGetCpoeIframe";
export const UseScriptSureControllerServiceGetCpoeIframeKeyFn = (
  queryKey?: Array<unknown>,
) => [useScriptSureControllerServiceGetCpoeIframeKey, ...(queryKey ?? [])];
export type ScriptSureControllerServiceSearchAllergiesDefaultResponse = Awaited<
  ReturnType<typeof ScriptSureControllerService.searchAllergies>
>;
export type ScriptSureControllerServiceSearchAllergiesQueryResult<
  TData = ScriptSureControllerServiceSearchAllergiesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceSearchAllergiesKey =
  "ScriptSureControllerServiceSearchAllergies";
export const UseScriptSureControllerServiceSearchAllergiesKeyFn = (
  {
    patientUuid,
    query,
  }: {
    patientUuid: string;
    query: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceSearchAllergiesKey,
  ...(queryKey ?? [{ patientUuid, query }]),
];
export type ScriptSureControllerServiceGetAllergyIframeDefaultResponse =
  Awaited<ReturnType<typeof ScriptSureControllerService.getAllergyIframe>>;
export type ScriptSureControllerServiceGetAllergyIframeQueryResult<
  TData = ScriptSureControllerServiceGetAllergyIframeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScriptSureControllerServiceGetAllergyIframeKey =
  "ScriptSureControllerServiceGetAllergyIframe";
export const UseScriptSureControllerServiceGetAllergyIframeKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useScriptSureControllerServiceGetAllergyIframeKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type SavedCardControllerServiceGetAllSavedCardsDefaultResponse = Awaited<
  ReturnType<typeof SavedCardControllerService.getAllSavedCards>
>;
export type SavedCardControllerServiceGetAllSavedCardsQueryResult<
  TData = SavedCardControllerServiceGetAllSavedCardsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSavedCardControllerServiceGetAllSavedCardsKey =
  "SavedCardControllerServiceGetAllSavedCards";
export const UseSavedCardControllerServiceGetAllSavedCardsKeyFn = (
  {
    active,
    brand,
    isDefault,
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    active?: boolean;
    brand?: string;
    isDefault?: boolean;
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSavedCardControllerServiceGetAllSavedCardsKey,
  ...(queryKey ?? [
    { active, brand, isDefault, page, size, sort, userTypes, uuid },
  ]),
];
export type SavedCardControllerServiceGetAllSavedCards1DefaultResponse =
  Awaited<ReturnType<typeof SavedCardControllerService.getAllSavedCards1>>;
export type SavedCardControllerServiceGetAllSavedCards1QueryResult<
  TData = SavedCardControllerServiceGetAllSavedCards1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSavedCardControllerServiceGetAllSavedCards1Key =
  "SavedCardControllerServiceGetAllSavedCards1";
export const UseSavedCardControllerServiceGetAllSavedCards1KeyFn = (
  {
    active,
    brand,
    isDefault,
    page,
    size,
    sort,
    userUuid,
  }: {
    active?: boolean;
    brand?: string;
    isDefault?: boolean;
    page?: number;
    size?: number;
    sort?: string[];
    userUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSavedCardControllerServiceGetAllSavedCards1Key,
  ...(queryKey ?? [{ active, brand, isDefault, page, size, sort, userUuid }]),
];
export type SavedBankControllerServiceGetAllSavedBanksDefaultResponse = Awaited<
  ReturnType<typeof SavedBankControllerService.getAllSavedBanks>
>;
export type SavedBankControllerServiceGetAllSavedBanksQueryResult<
  TData = SavedBankControllerServiceGetAllSavedBanksDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSavedBankControllerServiceGetAllSavedBanksKey =
  "SavedBankControllerServiceGetAllSavedBanks";
export const UseSavedBankControllerServiceGetAllSavedBanksKeyFn = (
  {
    bankName,
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    bankName?: string;
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSavedBankControllerServiceGetAllSavedBanksKey,
  ...(queryKey ?? [{ bankName, page, size, sort, userTypes, uuid }]),
];
export type SavedBankControllerServiceGetAllSavedBanks1DefaultResponse =
  Awaited<ReturnType<typeof SavedBankControllerService.getAllSavedBanks1>>;
export type SavedBankControllerServiceGetAllSavedBanks1QueryResult<
  TData = SavedBankControllerServiceGetAllSavedBanks1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSavedBankControllerServiceGetAllSavedBanks1Key =
  "SavedBankControllerServiceGetAllSavedBanks1";
export const UseSavedBankControllerServiceGetAllSavedBanks1KeyFn = (
  {
    bankName,
    page,
    size,
    sort,
    userUuid,
  }: {
    bankName?: string;
    page?: number;
    size?: number;
    sort?: string[];
    userUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSavedBankControllerServiceGetAllSavedBanks1Key,
  ...(queryKey ?? [{ bankName, page, size, sort, userUuid }]),
];
export type SalesTaxProfileControllerServiceGetSalesTaxProfileByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof SalesTaxProfileControllerService.getSalesTaxProfileByUuid>
  >;
export type SalesTaxProfileControllerServiceGetSalesTaxProfileByUuidQueryResult<
  TData =
    SalesTaxProfileControllerServiceGetSalesTaxProfileByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSalesTaxProfileControllerServiceGetSalesTaxProfileByUuidKey =
  "SalesTaxProfileControllerServiceGetSalesTaxProfileByUuid";
export const UseSalesTaxProfileControllerServiceGetSalesTaxProfileByUuidKeyFn =
  (
    {
      salesTaxProfileUuid,
    }: {
      salesTaxProfileUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useSalesTaxProfileControllerServiceGetSalesTaxProfileByUuidKey,
    ...(queryKey ?? [{ salesTaxProfileUuid }]),
  ];
export type SalesTaxProfileControllerServiceGetAllSalesTaxProfilesDefaultResponse =
  Awaited<
    ReturnType<typeof SalesTaxProfileControllerService.getAllSalesTaxProfiles>
  >;
export type SalesTaxProfileControllerServiceGetAllSalesTaxProfilesQueryResult<
  TData = SalesTaxProfileControllerServiceGetAllSalesTaxProfilesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSalesTaxProfileControllerServiceGetAllSalesTaxProfilesKey =
  "SalesTaxProfileControllerServiceGetAllSalesTaxProfiles";
export const UseSalesTaxProfileControllerServiceGetAllSalesTaxProfilesKeyFn = (
  {
    page,
    size,
    sort,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSalesTaxProfileControllerServiceGetAllSalesTaxProfilesKey,
  ...(queryKey ?? [{ page, size, sort }]),
];
export type SalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof SalesTaxJurisdictionControllerService.getSalesTaxJurisdictionByUuid
    >
  >;
export type SalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidQueryResult<
  TData =
    SalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidKey =
  "SalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuid";
export const UseSalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidKeyFn =
  (
    {
      salesTaxJurisdictionUuid,
    }: {
      salesTaxJurisdictionUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useSalesTaxJurisdictionControllerServiceGetSalesTaxJurisdictionByUuidKey,
    ...(queryKey ?? [{ salesTaxJurisdictionUuid }]),
  ];
export type SalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsDefaultResponse =
  Awaited<
    ReturnType<
      typeof SalesTaxJurisdictionControllerService.getAllSalesTaxJurisdictions
    >
  >;
export type SalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsQueryResult<
  TData =
    SalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsKey =
  "SalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictions";
export const UseSalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsKeyFn =
  (
    {
      page,
      size,
      sort,
    }: {
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useSalesTaxJurisdictionControllerServiceGetAllSalesTaxJurisdictionsKey,
    ...(queryKey ?? [{ page, size, sort }]),
  ];
export type RolesAndPermissionControllerServiceGetRoleTypesDefaultResponse =
  Awaited<ReturnType<typeof RolesAndPermissionControllerService.getRoleTypes>>;
export type RolesAndPermissionControllerServiceGetRoleTypesQueryResult<
  TData = RolesAndPermissionControllerServiceGetRoleTypesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRolesAndPermissionControllerServiceGetRoleTypesKey =
  "RolesAndPermissionControllerServiceGetRoleTypes";
export const UseRolesAndPermissionControllerServiceGetRoleTypesKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useRolesAndPermissionControllerServiceGetRoleTypesKey,
  ...(queryKey ?? []),
];
export type RolesAndPermissionControllerServiceGetRolesByRoleTypeDefaultResponse =
  Awaited<
    ReturnType<typeof RolesAndPermissionControllerService.getRolesByRoleType>
  >;
export type RolesAndPermissionControllerServiceGetRolesByRoleTypeQueryResult<
  TData = RolesAndPermissionControllerServiceGetRolesByRoleTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRolesAndPermissionControllerServiceGetRolesByRoleTypeKey =
  "RolesAndPermissionControllerServiceGetRolesByRoleType";
export const UseRolesAndPermissionControllerServiceGetRolesByRoleTypeKeyFn = (
  {
    roleType,
  }: {
    roleType: string;
  },
  queryKey?: Array<unknown>,
) => [
  useRolesAndPermissionControllerServiceGetRolesByRoleTypeKey,
  ...(queryKey ?? [{ roleType }]),
];
export type RolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeDefaultResponse =
  Awaited<
    ReturnType<
      typeof RolesAndPermissionControllerService.getFeaturesByRoleAndRoleType
    >
  >;
export type RolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeQueryResult<
  TData =
    RolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeKey =
  "RolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleType";
export const UseRolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeKeyFn =
  (
    {
      roleId,
    }: {
      roleId: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useRolesAndPermissionControllerServiceGetFeaturesByRoleAndRoleTypeKey,
    ...(queryKey ?? [{ roleId }]),
  ];
export type RoleTypeManagementControllerServiceGetRoleTypeByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof RoleTypeManagementControllerService.getRoleTypeByUuid>
  >;
export type RoleTypeManagementControllerServiceGetRoleTypeByUuidQueryResult<
  TData = RoleTypeManagementControllerServiceGetRoleTypeByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeManagementControllerServiceGetRoleTypeByUuidKey =
  "RoleTypeManagementControllerServiceGetRoleTypeByUuid";
export const UseRoleTypeManagementControllerServiceGetRoleTypeByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useRoleTypeManagementControllerServiceGetRoleTypeByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type RoleTypeManagementControllerServiceGetAllRoleTypesDefaultResponse =
  Awaited<
    ReturnType<typeof RoleTypeManagementControllerService.getAllRoleTypes>
  >;
export type RoleTypeManagementControllerServiceGetAllRoleTypesQueryResult<
  TData = RoleTypeManagementControllerServiceGetAllRoleTypesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeManagementControllerServiceGetAllRoleTypesKey =
  "RoleTypeManagementControllerServiceGetAllRoleTypes";
export const UseRoleTypeManagementControllerServiceGetAllRoleTypesKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useRoleTypeManagementControllerServiceGetAllRoleTypesKey,
  ...(queryKey ?? []),
];
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.getRoleTypeFeatureByUuid
    >
  >;
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidQueryResult<
  TData =
    RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidKey =
  "RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuid";
export const UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type RoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesDefaultResponse =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.getAllRoleTypeFeatures
    >
  >;
export type RoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesQueryResult<
  TData =
    RoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesKey =
  "RoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeatures";
export const UseRoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesKeyFn =
  (queryKey?: Array<unknown>) => [
    useRoleTypeFeatureManagementControllerServiceGetAllRoleTypeFeaturesKey,
    ...(queryKey ?? []),
  ];
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeDefaultResponse =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.getRoleTypeFeaturesByRoleType
    >
  >;
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeQueryResult<
  TData =
    RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeKey =
  "RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleType";
export const UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeKeyFn =
  (
    {
      roleTypeUuid,
    }: {
      roleTypeUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByRoleTypeKey,
    ...(queryKey ?? [{ roleTypeUuid }]),
  ];
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureDefaultResponse =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.getRoleTypeFeatureByRoleTypeAndFeature
    >
  >;
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureQueryResult<
  TData =
    RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureKey =
  "RoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeature";
export const UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureKeyFn =
  (
    {
      featureUuid,
      roleTypeUuid,
    }: {
      featureUuid: string;
      roleTypeUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeatureByRoleTypeAndFeatureKey,
    ...(queryKey ?? [{ featureUuid, roleTypeUuid }]),
  ];
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureDefaultResponse =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.getRoleTypeFeaturesByFeature
    >
  >;
export type RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureQueryResult<
  TData =
    RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureKey =
  "RoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeature";
export const UseRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureKeyFn =
  (
    {
      featureUuid,
    }: {
      featureUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useRoleTypeFeatureManagementControllerServiceGetRoleTypeFeaturesByFeatureKey,
    ...(queryKey ?? [{ featureUuid }]),
  ];
export type ProviderControllerServiceGetProviderByUuidDefaultResponse = Awaited<
  ReturnType<typeof ProviderControllerService.getProviderByUuid>
>;
export type ProviderControllerServiceGetProviderByUuidQueryResult<
  TData = ProviderControllerServiceGetProviderByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceGetProviderByUuidKey =
  "ProviderControllerServiceGetProviderByUuid";
export const UseProviderControllerServiceGetProviderByUuidKeyFn = (
  {
    providerUuid,
  }: {
    providerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useProviderControllerServiceGetProviderByUuidKey,
  ...(queryKey ?? [{ providerUuid }]),
];
export type ProviderControllerServiceIsProviderWithUrgentMessageAlertsDefaultResponse =
  Awaited<
    ReturnType<
      typeof ProviderControllerService.isProviderWithUrgentMessageAlerts
    >
  >;
export type ProviderControllerServiceIsProviderWithUrgentMessageAlertsQueryResult<
  TData =
    ProviderControllerServiceIsProviderWithUrgentMessageAlertsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceIsProviderWithUrgentMessageAlertsKey =
  "ProviderControllerServiceIsProviderWithUrgentMessageAlerts";
export const UseProviderControllerServiceIsProviderWithUrgentMessageAlertsKeyFn =
  (
    {
      userIamId,
    }: {
      userIamId: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useProviderControllerServiceIsProviderWithUrgentMessageAlertsKey,
    ...(queryKey ?? [{ userIamId }]),
  ];
export type ProviderControllerServiceGetCoveringProvidersForUrgentAlertsDefaultResponse =
  Awaited<
    ReturnType<
      typeof ProviderControllerService.getCoveringProvidersForUrgentAlerts
    >
  >;
export type ProviderControllerServiceGetCoveringProvidersForUrgentAlertsQueryResult<
  TData =
    ProviderControllerServiceGetCoveringProvidersForUrgentAlertsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceGetCoveringProvidersForUrgentAlertsKey =
  "ProviderControllerServiceGetCoveringProvidersForUrgentAlerts";
export const UseProviderControllerServiceGetCoveringProvidersForUrgentAlertsKeyFn =
  (
    {
      userIamId,
    }: {
      userIamId: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useProviderControllerServiceGetCoveringProvidersForUrgentAlertsKey,
    ...(queryKey ?? [{ userIamId }]),
  ];
export type ProviderControllerServiceGetProviderProfileDefaultResponse =
  Awaited<ReturnType<typeof ProviderControllerService.getProviderProfile>>;
export type ProviderControllerServiceGetProviderProfileQueryResult<
  TData = ProviderControllerServiceGetProviderProfileDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceGetProviderProfileKey =
  "ProviderControllerServiceGetProviderProfile";
export const UseProviderControllerServiceGetProviderProfileKeyFn = (
  {
    xLocationId,
  }: {
    xLocationId?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderControllerServiceGetProviderProfileKey,
  ...(queryKey ?? [{ xLocationId }]),
];
export type ProviderControllerServiceGetAllProvidersDefaultResponse = Awaited<
  ReturnType<typeof ProviderControllerService.getAllProviders>
>;
export type ProviderControllerServiceGetAllProvidersQueryResult<
  TData = ProviderControllerServiceGetAllProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceGetAllProvidersKey =
  "ProviderControllerServiceGetAllProviders";
export const UseProviderControllerServiceGetAllProvidersKeyFn = (
  {
    careTeamUserUuid,
    couponCode,
    couponLocationUuid,
    employer,
    employerPageUuid,
    filterBy,
    filterValue,
    isAffiliate,
    isPatientEnrollment,
    latitude,
    leadUuid,
    locationNames,
    locationUuids,
    longitude,
    page,
    pageSize,
    roleUuid,
    searchString,
    sortBy,
    sortDirection,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    careTeamUserUuid?: string;
    couponCode?: string;
    couponLocationUuid?: string[];
    employer?: boolean;
    employerPageUuid?: string;
    filterBy?: string;
    filterValue?: string[];
    isAffiliate?: boolean;
    isPatientEnrollment?: boolean;
    latitude?: string;
    leadUuid?: string;
    locationNames?: string[];
    locationUuids?: string[];
    longitude?: string;
    page?: number;
    pageSize?: number;
    roleUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderControllerServiceGetAllProvidersKey,
  ...(queryKey ?? [
    {
      careTeamUserUuid,
      couponCode,
      couponLocationUuid,
      employer,
      employerPageUuid,
      filterBy,
      filterValue,
      isAffiliate,
      isPatientEnrollment,
      latitude,
      leadUuid,
      locationNames,
      locationUuids,
      longitude,
      page,
      pageSize,
      roleUuid,
      searchString,
      sortBy,
      sortDirection,
      specialityNames,
      stateNames,
      status,
      zipcode,
    },
  ]),
];
export type ProviderControllerServiceGetAllProvidersByIsAffiliateDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderControllerService.getAllProvidersByIsAffiliate>
  >;
export type ProviderControllerServiceGetAllProvidersByIsAffiliateQueryResult<
  TData = ProviderControllerServiceGetAllProvidersByIsAffiliateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceGetAllProvidersByIsAffiliateKey =
  "ProviderControllerServiceGetAllProvidersByIsAffiliate";
export const UseProviderControllerServiceGetAllProvidersByIsAffiliateKeyFn = (
  {
    affiliateGroupUuids,
    employer,
    employerPageUuid,
    filterBy,
    filterValue,
    isAffiliate,
    isPatientEnrollment,
    latitude,
    locationNames,
    locationUuid,
    longitude,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    affiliateGroupUuids?: string[];
    employer?: boolean;
    employerPageUuid?: string;
    filterBy?: string;
    filterValue?: string[];
    isAffiliate?: boolean;
    isPatientEnrollment?: boolean;
    latitude?: string;
    locationNames?: string[];
    locationUuid?: string;
    longitude?: string;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderControllerServiceGetAllProvidersByIsAffiliateKey,
  ...(queryKey ?? [
    {
      affiliateGroupUuids,
      employer,
      employerPageUuid,
      filterBy,
      filterValue,
      isAffiliate,
      isPatientEnrollment,
      latitude,
      locationNames,
      locationUuid,
      longitude,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      specialityNames,
      stateNames,
      status,
      zipcode,
    },
  ]),
];
export type ProviderControllerServiceExportAffiliateProvidersCsvDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderControllerService.exportAffiliateProvidersCsv>
  >;
export type ProviderControllerServiceExportAffiliateProvidersCsvQueryResult<
  TData = ProviderControllerServiceExportAffiliateProvidersCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderControllerServiceExportAffiliateProvidersCsvKey =
  "ProviderControllerServiceExportAffiliateProvidersCsv";
export const UseProviderControllerServiceExportAffiliateProvidersCsvKeyFn = (
  {
    affiliateGroupUuids,
    employer,
    locationNames,
    locationUuid,
    searchString,
    specialityNames,
    stateNames,
    status,
    zipcode,
  }: {
    affiliateGroupUuids?: string[];
    employer?: boolean;
    locationNames?: string[];
    locationUuid?: string;
    searchString?: string;
    specialityNames?: string[];
    stateNames?: string[];
    status?: boolean;
    zipcode?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderControllerServiceExportAffiliateProvidersCsvKey,
  ...(queryKey ?? [
    {
      affiliateGroupUuids,
      employer,
      locationNames,
      locationUuid,
      searchString,
      specialityNames,
      stateNames,
      status,
      zipcode,
    },
  ]),
];
export type PlanControllerServiceGetPlanAmountDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.getPlanAmount>
>;
export type PlanControllerServiceGetPlanAmountQueryResult<
  TData = PlanControllerServiceGetPlanAmountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceGetPlanAmountKey =
  "PlanControllerServiceGetPlanAmount";
export const UsePlanControllerServiceGetPlanAmountKeyFn = (
  {
    birthDate,
    employer,
    planUuid,
    primaryLeadUuid,
  }: {
    birthDate?: string;
    employer?: boolean;
    planUuid?: string;
    primaryLeadUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceGetPlanAmountKey,
  ...(queryKey ?? [{ birthDate, employer, planUuid, primaryLeadUuid }]),
];
export type PlanControllerServiceGetPlanByUuidDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.getPlanByUuid>
>;
export type PlanControllerServiceGetPlanByUuidQueryResult<
  TData = PlanControllerServiceGetPlanByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceGetPlanByUuidKey =
  "PlanControllerServiceGetPlanByUuid";
export const UsePlanControllerServiceGetPlanByUuidKeyFn = (
  {
    planUuid,
  }: {
    planUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceGetPlanByUuidKey,
  ...(queryKey ?? [{ planUuid }]),
];
export type PlanControllerServiceGetPlanDetailsByUuidDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.getPlanDetailsByUuid>
>;
export type PlanControllerServiceGetPlanDetailsByUuidQueryResult<
  TData = PlanControllerServiceGetPlanDetailsByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceGetPlanDetailsByUuidKey =
  "PlanControllerServiceGetPlanDetailsByUuid";
export const UsePlanControllerServiceGetPlanDetailsByUuidKeyFn = (
  {
    employerUuid,
    planUuid,
  }: {
    employerUuid?: string;
    planUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceGetPlanDetailsByUuidKey,
  ...(queryKey ?? [{ employerUuid, planUuid }]),
];
export type PlanControllerServiceGetPlanStatusDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.getPlanStatus>
>;
export type PlanControllerServiceGetPlanStatusQueryResult<
  TData = PlanControllerServiceGetPlanStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceGetPlanStatusKey =
  "PlanControllerServiceGetPlanStatus";
export const UsePlanControllerServiceGetPlanStatusKeyFn = (
  {
    planUuid,
  }: {
    planUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceGetPlanStatusKey,
  ...(queryKey ?? [{ planUuid }]),
];
export type PlanControllerServiceCheckMyPlanDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.checkMyPlan>
>;
export type PlanControllerServiceCheckMyPlanQueryResult<
  TData = PlanControllerServiceCheckMyPlanDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceCheckMyPlanKey =
  "PlanControllerServiceCheckMyPlan";
export const UsePlanControllerServiceCheckMyPlanKeyFn = (
  {
    defaultBillingPeriod,
    dependentBirthDate,
    dependentName,
    employer,
    planUuid,
    primaryLeadUuid,
    providerUuids,
    relationShip,
  }: {
    defaultBillingPeriod?: "ANNUAL" | "MONTH" | "QUARTERLY" | "SEMI_ANNUALLY";
    dependentBirthDate?: string;
    dependentName?: string;
    employer?: boolean;
    planUuid?: string;
    primaryLeadUuid?: string;
    providerUuids?: string[];
    relationShip?:
      | "NONE"
      | "ALL"
      | "SELF"
      | "SPOUSE"
      | "SIBLING"
      | "MOTHER"
      | "FATHER"
      | "GUARDIAN"
      | "PARENT"
      | "CHILDREN"
      | "GRANDPARENT"
      | "GRANDCHILDREN"
      | "FRIEND"
      | "PARTNER"
      | "OTHER";
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceCheckMyPlanKey,
  ...(queryKey ?? [
    {
      defaultBillingPeriod,
      dependentBirthDate,
      dependentName,
      employer,
      planUuid,
      primaryLeadUuid,
      providerUuids,
      relationShip,
    },
  ]),
];
export type PlanControllerServiceGetAllPlanDefaultResponse = Awaited<
  ReturnType<typeof PlanControllerService.getAllPlan>
>;
export type PlanControllerServiceGetAllPlanQueryResult<
  TData = PlanControllerServiceGetAllPlanDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlanControllerServiceGetAllPlanKey =
  "PlanControllerServiceGetAllPlan";
export const UsePlanControllerServiceGetAllPlanKeyFn = (
  {
    archive,
    defaultPlan,
    employer,
    employerplan,
    page,
    pageSize,
    planType,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    defaultPlan?: boolean;
    employer?: boolean;
    employerplan?: "ALL" | "CURRENT" | "PAST" | "FUTURE";
    page?: number;
    pageSize?: number;
    planType?: "EMPLOYER" | "RETAIL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePlanControllerServiceGetAllPlanKey,
  ...(queryKey ?? [
    {
      archive,
      defaultPlan,
      employer,
      employerplan,
      page,
      pageSize,
      planType,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type PaymentTransactionControllerServiceGetPaymentTransactionByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof PaymentTransactionControllerService.getPaymentTransactionByUuid
    >
  >;
export type PaymentTransactionControllerServiceGetPaymentTransactionByUuidQueryResult<
  TData =
    PaymentTransactionControllerServiceGetPaymentTransactionByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePaymentTransactionControllerServiceGetPaymentTransactionByUuidKey =
  "PaymentTransactionControllerServiceGetPaymentTransactionByUuid";
export const UsePaymentTransactionControllerServiceGetPaymentTransactionByUuidKeyFn =
  (
    {
      paymentTransactionUuid,
    }: {
      paymentTransactionUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePaymentTransactionControllerServiceGetPaymentTransactionByUuidKey,
    ...(queryKey ?? [{ paymentTransactionUuid }]),
  ];
export type PaymentTransactionControllerServiceGetAllPaymentTransactionsDefaultResponse =
  Awaited<
    ReturnType<
      typeof PaymentTransactionControllerService.getAllPaymentTransactions
    >
  >;
export type PaymentTransactionControllerServiceGetAllPaymentTransactionsQueryResult<
  TData =
    PaymentTransactionControllerServiceGetAllPaymentTransactionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePaymentTransactionControllerServiceGetAllPaymentTransactionsKey =
  "PaymentTransactionControllerServiceGetAllPaymentTransactions";
export const UsePaymentTransactionControllerServiceGetAllPaymentTransactionsKeyFn =
  (
    {
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    usePaymentTransactionControllerServiceGetAllPaymentTransactionsKey,
    ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
  ];
export type PatientControllerServiceGetPatientByUuidDefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getPatientByUuid>
>;
export type PatientControllerServiceGetPatientByUuidQueryResult<
  TData = PatientControllerServiceGetPatientByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientByUuidKey =
  "PatientControllerServiceGetPatientByUuid";
export const UsePatientControllerServiceGetPatientByUuidKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientByUuidKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceGetPatientLocationWithSalesTaxDefaultResponse =
  Awaited<
    ReturnType<typeof PatientControllerService.getPatientLocationWithSalesTax>
  >;
export type PatientControllerServiceGetPatientLocationWithSalesTaxQueryResult<
  TData = PatientControllerServiceGetPatientLocationWithSalesTaxDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientLocationWithSalesTaxKey =
  "PatientControllerServiceGetPatientLocationWithSalesTax";
export const UsePatientControllerServiceGetPatientLocationWithSalesTaxKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientLocationWithSalesTaxKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceGetLabPayerDefaultsDefaultResponse =
  Awaited<ReturnType<typeof PatientControllerService.getLabPayerDefaults>>;
export type PatientControllerServiceGetLabPayerDefaultsQueryResult<
  TData = PatientControllerServiceGetLabPayerDefaultsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetLabPayerDefaultsKey =
  "PatientControllerServiceGetLabPayerDefaults";
export const UsePatientControllerServiceGetLabPayerDefaultsKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetLabPayerDefaultsKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceGetRecentlyViewedPatientsDefaultResponse =
  Awaited<
    ReturnType<typeof PatientControllerService.getRecentlyViewedPatients>
  >;
export type PatientControllerServiceGetRecentlyViewedPatientsQueryResult<
  TData = PatientControllerServiceGetRecentlyViewedPatientsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetRecentlyViewedPatientsKey =
  "PatientControllerServiceGetRecentlyViewedPatients";
export const UsePatientControllerServiceGetRecentlyViewedPatientsKeyFn = (
  {
    limit,
    locationUuids,
    providerUuid,
  }: {
    limit?: number;
    locationUuids?: string[];
    providerUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetRecentlyViewedPatientsKey,
  ...(queryKey ?? [{ limit, locationUuids, providerUuid }]),
];
export type PatientControllerServiceGetProfile1DefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getProfile1>
>;
export type PatientControllerServiceGetProfile1QueryResult<
  TData = PatientControllerServiceGetProfile1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetProfile1Key =
  "PatientControllerServiceGetProfile1";
export const UsePatientControllerServiceGetProfile1KeyFn = (
  queryKey?: Array<unknown>,
) => [usePatientControllerServiceGetProfile1Key, ...(queryKey ?? [])];
export type PatientControllerServiceGetPatientPlanDetailsDefaultResponse =
  Awaited<ReturnType<typeof PatientControllerService.getPatientPlanDetails>>;
export type PatientControllerServiceGetPatientPlanDetailsQueryResult<
  TData = PatientControllerServiceGetPatientPlanDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientPlanDetailsKey =
  "PatientControllerServiceGetPatientPlanDetails";
export const UsePatientControllerServiceGetPatientPlanDetailsKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientPlanDetailsKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceGetPatientOverviewDefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getPatientOverview>
>;
export type PatientControllerServiceGetPatientOverviewQueryResult<
  TData = PatientControllerServiceGetPatientOverviewDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientOverviewKey =
  "PatientControllerServiceGetPatientOverview";
export const UsePatientControllerServiceGetPatientOverviewKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientOverviewKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceGetPatientMemberShipDefaultResponse =
  Awaited<ReturnType<typeof PatientControllerService.getPatientMemberShip>>;
export type PatientControllerServiceGetPatientMemberShipQueryResult<
  TData = PatientControllerServiceGetPatientMemberShipDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientMemberShipKey =
  "PatientControllerServiceGetPatientMemberShip";
export const UsePatientControllerServiceGetPatientMemberShipKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientMemberShipKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type PatientControllerServiceGetPatientEmployeeMembershipDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientControllerService.getPatientEmployeeMembershipDetails
    >
  >;
export type PatientControllerServiceGetPatientEmployeeMembershipDetailsQueryResult<
  TData =
    PatientControllerServiceGetPatientEmployeeMembershipDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientEmployeeMembershipDetailsKey =
  "PatientControllerServiceGetPatientEmployeeMembershipDetails";
export const UsePatientControllerServiceGetPatientEmployeeMembershipDetailsKeyFn =
  (
    {
      patientUuid,
      paymentTransactionUuid,
    }: {
      patientUuid: string;
      paymentTransactionUuid?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientControllerServiceGetPatientEmployeeMembershipDetailsKey,
    ...(queryKey ?? [{ patientUuid, paymentTransactionUuid }]),
  ];
export type PatientControllerServiceGetPatientDropDownDefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getPatientDropDown>
>;
export type PatientControllerServiceGetPatientDropDownQueryResult<
  TData = PatientControllerServiceGetPatientDropDownDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientDropDownKey =
  "PatientControllerServiceGetPatientDropDown";
export const UsePatientControllerServiceGetPatientDropDownKeyFn = (
  {
    affiliateGroupUuid,
    birthDateEnd,
    birthDateStart,
    employers,
    employerUuids,
    excludeExistingDependents,
    isAffiliate,
    locationUuids,
    page,
    pageSize,
    patientStatus,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
  }: {
    affiliateGroupUuid?: string;
    birthDateEnd?: string;
    birthDateStart?: string;
    employers?: boolean;
    employerUuids?: string[];
    excludeExistingDependents?: boolean;
    isAffiliate?: boolean;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientDropDownKey,
  ...(queryKey ?? [
    {
      affiliateGroupUuid,
      birthDateEnd,
      birthDateStart,
      employers,
      employerUuids,
      excludeExistingDependents,
      isAffiliate,
      locationUuids,
      page,
      pageSize,
      patientStatus,
      providerUuids,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type PatientControllerServiceGetPatientWithDependentsDefaultResponse =
  Awaited<ReturnType<typeof PatientControllerService.getPatientWithDependents>>;
export type PatientControllerServiceGetPatientWithDependentsQueryResult<
  TData = PatientControllerServiceGetPatientWithDependentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetPatientWithDependentsKey =
  "PatientControllerServiceGetPatientWithDependents";
export const UsePatientControllerServiceGetPatientWithDependentsKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetPatientWithDependentsKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type PatientControllerServiceExportPatientsByAffiliateGroupDefaultResponse =
  Awaited<
    ReturnType<typeof PatientControllerService.exportPatientsByAffiliateGroup>
  >;
export type PatientControllerServiceExportPatientsByAffiliateGroupQueryResult<
  TData = PatientControllerServiceExportPatientsByAffiliateGroupDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceExportPatientsByAffiliateGroupKey =
  "PatientControllerServiceExportPatientsByAffiliateGroup";
export const UsePatientControllerServiceExportPatientsByAffiliateGroupKeyFn = (
  {
    affiliateGroupUuid,
    providerUuid,
  }: {
    affiliateGroupUuid: string;
    providerUuid?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceExportPatientsByAffiliateGroupKey,
  ...(queryKey ?? [{ affiliateGroupUuid, providerUuid }]),
];
export type PatientControllerServiceGetDependentsDefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getDependents>
>;
export type PatientControllerServiceGetDependentsQueryResult<
  TData = PatientControllerServiceGetDependentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetDependentsKey =
  "PatientControllerServiceGetDependents";
export const UsePatientControllerServiceGetDependentsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    primaryPatient,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    primaryPatient?: boolean;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetDependentsKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, primaryPatient, sortBy, sortDirection },
  ]),
];
export type PatientControllerServiceGetAllPatientDefaultResponse = Awaited<
  ReturnType<typeof PatientControllerService.getAllPatient>
>;
export type PatientControllerServiceGetAllPatientQueryResult<
  TData = PatientControllerServiceGetAllPatientDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientControllerServiceGetAllPatientKey =
  "PatientControllerServiceGetAllPatient";
export const UsePatientControllerServiceGetAllPatientKeyFn = (
  {
    affiliateGroupUuid,
    billing,
    breakGlassUuid,
    employers,
    employerUuids,
    endDate,
    isProvider,
    joinedPracticeDate,
    joinedPracticeEndDate,
    page,
    pageSize,
    paid,
    patientStatus,
    planUuids,
    providerUuid,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    affiliateGroupUuid?: string;
    billing?: boolean;
    breakGlassUuid?: string;
    employers?: boolean;
    employerUuids?: string[];
    endDate?: string;
    isProvider?: boolean;
    joinedPracticeDate?: string;
    joinedPracticeEndDate?: string;
    page?: number;
    pageSize?: number;
    paid?: boolean;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
    planUuids?: string[];
    providerUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePatientControllerServiceGetAllPatientKey,
  ...(queryKey ?? [
    {
      affiliateGroupUuid,
      billing,
      breakGlassUuid,
      employers,
      employerUuids,
      endDate,
      isProvider,
      joinedPracticeDate,
      joinedPracticeEndDate,
      page,
      pageSize,
      paid,
      patientStatus,
      planUuids,
      providerUuid,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    },
  ]),
];
export type PatientModuleControllerServiceGetByUuid1DefaultResponse = Awaited<
  ReturnType<typeof PatientModuleControllerService.getByUuid1>
>;
export type PatientModuleControllerServiceGetByUuid1QueryResult<
  TData = PatientModuleControllerServiceGetByUuid1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientModuleControllerServiceGetByUuid1Key =
  "PatientModuleControllerServiceGetByUuid1";
export const UsePatientModuleControllerServiceGetByUuid1KeyFn = (
  {
    patientModuleUuid,
  }: {
    patientModuleUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientModuleControllerServiceGetByUuid1Key,
  ...(queryKey ?? [{ patientModuleUuid }]),
];
export type PatientModuleControllerServiceGetAllDefaultResponse = Awaited<
  ReturnType<typeof PatientModuleControllerService.getAll>
>;
export type PatientModuleControllerServiceGetAllQueryResult<
  TData = PatientModuleControllerServiceGetAllDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientModuleControllerServiceGetAllKey =
  "PatientModuleControllerServiceGetAll";
export const UsePatientModuleControllerServiceGetAllKeyFn = (
  queryKey?: Array<unknown>,
) => [usePatientModuleControllerServiceGetAllKey, ...(queryKey ?? [])];
export type PatientModuleAccessControllerServiceGetByUuid2DefaultResponse =
  Awaited<ReturnType<typeof PatientModuleAccessControllerService.getByUuid2>>;
export type PatientModuleAccessControllerServiceGetByUuid2QueryResult<
  TData = PatientModuleAccessControllerServiceGetByUuid2DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientModuleAccessControllerServiceGetByUuid2Key =
  "PatientModuleAccessControllerServiceGetByUuid2";
export const UsePatientModuleAccessControllerServiceGetByUuid2KeyFn = (
  {
    patientModuleAccessUuid,
  }: {
    patientModuleAccessUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientModuleAccessControllerServiceGetByUuid2Key,
  ...(queryKey ?? [{ patientModuleAccessUuid }]),
];
export type PatientModuleAccessControllerServiceGetAllByGranteeDefaultResponse =
  Awaited<
    ReturnType<typeof PatientModuleAccessControllerService.getAllByGrantee>
  >;
export type PatientModuleAccessControllerServiceGetAllByGranteeQueryResult<
  TData = PatientModuleAccessControllerServiceGetAllByGranteeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientModuleAccessControllerServiceGetAllByGranteeKey =
  "PatientModuleAccessControllerServiceGetAllByGrantee";
export const UsePatientModuleAccessControllerServiceGetAllByGranteeKeyFn = (
  {
    granteePatientUuid,
  }: {
    granteePatientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientModuleAccessControllerServiceGetAllByGranteeKey,
  ...(queryKey ?? [{ granteePatientUuid }]),
];
export type PatientModuleAccessControllerServiceGetAllByOwnerAndGranteeDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientModuleAccessControllerService.getAllByOwnerAndGrantee
    >
  >;
export type PatientModuleAccessControllerServiceGetAllByOwnerAndGranteeQueryResult<
  TData =
    PatientModuleAccessControllerServiceGetAllByOwnerAndGranteeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientModuleAccessControllerServiceGetAllByOwnerAndGranteeKey =
  "PatientModuleAccessControllerServiceGetAllByOwnerAndGrantee";
export const UsePatientModuleAccessControllerServiceGetAllByOwnerAndGranteeKeyFn =
  (
    {
      granteePatientUuid,
      ownerPatientUuid,
    }: {
      granteePatientUuid: string;
      ownerPatientUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientModuleAccessControllerServiceGetAllByOwnerAndGranteeKey,
    ...(queryKey ?? [{ granteePatientUuid, ownerPatientUuid }]),
  ];
export type PatientInformationControllerServiceGetByUuidDefaultResponse =
  Awaited<ReturnType<typeof PatientInformationControllerService.getByUuid>>;
export type PatientInformationControllerServiceGetByUuidQueryResult<
  TData = PatientInformationControllerServiceGetByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientInformationControllerServiceGetByUuidKey =
  "PatientInformationControllerServiceGetByUuid";
export const UsePatientInformationControllerServiceGetByUuidKeyFn = (
  {
    patientInformationUuid,
  }: {
    patientInformationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientInformationControllerServiceGetByUuidKey,
  ...(queryKey ?? [{ patientInformationUuid }]),
];
export type PatientInformationControllerServiceGetAllByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof PatientInformationControllerService.getAllByPatientUuid>
  >;
export type PatientInformationControllerServiceGetAllByPatientUuidQueryResult<
  TData = PatientInformationControllerServiceGetAllByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientInformationControllerServiceGetAllByPatientUuidKey =
  "PatientInformationControllerServiceGetAllByPatientUuid";
export const UsePatientInformationControllerServiceGetAllByPatientUuidKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientInformationControllerServiceGetAllByPatientUuidKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type NurseStaffProviderControllerServiceGetNurseStaffProviderByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof NurseStaffProviderControllerService.getNurseStaffProviderByUuid
    >
  >;
export type NurseStaffProviderControllerServiceGetNurseStaffProviderByUuidQueryResult<
  TData =
    NurseStaffProviderControllerServiceGetNurseStaffProviderByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNurseStaffProviderControllerServiceGetNurseStaffProviderByUuidKey =
  "NurseStaffProviderControllerServiceGetNurseStaffProviderByUuid";
export const UseNurseStaffProviderControllerServiceGetNurseStaffProviderByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useNurseStaffProviderControllerServiceGetNurseStaffProviderByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type NurseStaffProviderControllerServiceGetAllNurseStaffProvidersDefaultResponse =
  Awaited<
    ReturnType<
      typeof NurseStaffProviderControllerService.getAllNurseStaffProviders
    >
  >;
export type NurseStaffProviderControllerServiceGetAllNurseStaffProvidersQueryResult<
  TData =
    NurseStaffProviderControllerServiceGetAllNurseStaffProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNurseStaffProviderControllerServiceGetAllNurseStaffProvidersKey =
  "NurseStaffProviderControllerServiceGetAllNurseStaffProviders";
export const UseNurseStaffProviderControllerServiceGetAllNurseStaffProvidersKeyFn =
  (
    {
      locationUuid,
      page,
      pageSize,
      providerUuid,
      roleUuids,
      searchString,
      sortBy,
      sortDirection,
      status,
    }: {
      locationUuid?: string;
      page?: number;
      pageSize?: number;
      providerUuid?: string;
      roleUuids?: string[];
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      status?: boolean;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useNurseStaffProviderControllerServiceGetAllNurseStaffProvidersKey,
    ...(queryKey ?? [
      {
        locationUuid,
        page,
        pageSize,
        providerUuid,
        roleUuids,
        searchString,
        sortBy,
        sortDirection,
        status,
      },
    ]),
  ];
export type LeadControllerServiceGetLeadByUuidDefaultResponse = Awaited<
  ReturnType<typeof LeadControllerService.getLeadByUuid>
>;
export type LeadControllerServiceGetLeadByUuidQueryResult<
  TData = LeadControllerServiceGetLeadByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLeadControllerServiceGetLeadByUuidKey =
  "LeadControllerServiceGetLeadByUuid";
export const UseLeadControllerServiceGetLeadByUuidKeyFn = (
  {
    leadUuid,
  }: {
    leadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLeadControllerServiceGetLeadByUuidKey,
  ...(queryKey ?? [{ leadUuid }]),
];
export type LeadControllerServiceValidateCouponCodeDefaultResponse = Awaited<
  ReturnType<typeof LeadControllerService.validateCouponCode>
>;
export type LeadControllerServiceValidateCouponCodeQueryResult<
  TData = LeadControllerServiceValidateCouponCodeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLeadControllerServiceValidateCouponCodeKey =
  "LeadControllerServiceValidateCouponCode";
export const UseLeadControllerServiceValidateCouponCodeKeyFn = (
  {
    couponCode,
  }: {
    couponCode: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLeadControllerServiceValidateCouponCodeKey,
  ...(queryKey ?? [{ couponCode }]),
];
export type LeadControllerServiceGetLeadFullInfoDefaultResponse = Awaited<
  ReturnType<typeof LeadControllerService.getLeadFullInfo>
>;
export type LeadControllerServiceGetLeadFullInfoQueryResult<
  TData = LeadControllerServiceGetLeadFullInfoDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLeadControllerServiceGetLeadFullInfoKey =
  "LeadControllerServiceGetLeadFullInfo";
export const UseLeadControllerServiceGetLeadFullInfoKeyFn = (
  {
    leadUuid,
  }: {
    leadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLeadControllerServiceGetLeadFullInfoKey,
  ...(queryKey ?? [{ leadUuid }]),
];
export type LeadControllerServiceGetAllLeadDefaultResponse = Awaited<
  ReturnType<typeof LeadControllerService.getAllLead>
>;
export type LeadControllerServiceGetAllLeadQueryResult<
  TData = LeadControllerServiceGetAllLeadDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLeadControllerServiceGetAllLeadKey =
  "LeadControllerServiceGetAllLead";
export const UseLeadControllerServiceGetAllLeadKeyFn = (
  {
    isContact,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isContact?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLeadControllerServiceGetAllLeadKey,
  ...(queryKey ?? [
    { isContact, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type InvoiceSettingControllerServiceGetInvoiceSettingByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof InvoiceSettingControllerService.getInvoiceSettingByUuid>
  >;
export type InvoiceSettingControllerServiceGetInvoiceSettingByUuidQueryResult<
  TData = InvoiceSettingControllerServiceGetInvoiceSettingByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceSettingControllerServiceGetInvoiceSettingByUuidKey =
  "InvoiceSettingControllerServiceGetInvoiceSettingByUuid";
export const UseInvoiceSettingControllerServiceGetInvoiceSettingByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useInvoiceSettingControllerServiceGetInvoiceSettingByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type InvoiceSettingControllerServiceGetAllInvoiceSettingsDefaultResponse =
  Awaited<
    ReturnType<typeof InvoiceSettingControllerService.getAllInvoiceSettings>
  >;
export type InvoiceSettingControllerServiceGetAllInvoiceSettingsQueryResult<
  TData = InvoiceSettingControllerServiceGetAllInvoiceSettingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceSettingControllerServiceGetAllInvoiceSettingsKey =
  "InvoiceSettingControllerServiceGetAllInvoiceSettings";
export const UseInvoiceSettingControllerServiceGetAllInvoiceSettingsKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInvoiceSettingControllerServiceGetAllInvoiceSettingsKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
];
export type FeatureManagementControllerServiceGetFeatureByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof FeatureManagementControllerService.getFeatureByUuid>
  >;
export type FeatureManagementControllerServiceGetFeatureByUuidQueryResult<
  TData = FeatureManagementControllerServiceGetFeatureByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFeatureManagementControllerServiceGetFeatureByUuidKey =
  "FeatureManagementControllerServiceGetFeatureByUuid";
export const UseFeatureManagementControllerServiceGetFeatureByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFeatureManagementControllerServiceGetFeatureByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type FeatureManagementControllerServiceGetAllFeaturesDefaultResponse =
  Awaited<ReturnType<typeof FeatureManagementControllerService.getAllFeatures>>;
export type FeatureManagementControllerServiceGetAllFeaturesQueryResult<
  TData = FeatureManagementControllerServiceGetAllFeaturesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFeatureManagementControllerServiceGetAllFeaturesKey =
  "FeatureManagementControllerServiceGetAllFeatures";
export const UseFeatureManagementControllerServiceGetAllFeaturesKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useFeatureManagementControllerServiceGetAllFeaturesKey,
  ...(queryKey ?? []),
];
export type FaxControllerServiceFetchSentFaxesByLocationDefaultResponse =
  Awaited<ReturnType<typeof FaxControllerService.fetchSentFaxesByLocation>>;
export type FaxControllerServiceFetchSentFaxesByLocationQueryResult<
  TData = FaxControllerServiceFetchSentFaxesByLocationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchSentFaxesByLocationKey =
  "FaxControllerServiceFetchSentFaxesByLocation";
export const UseFaxControllerServiceFetchSentFaxesByLocationKeyFn = (
  {
    locationUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchSentFaxesByLocationKey,
  ...(queryKey ?? [
    { locationUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type FaxControllerServiceRetrieveFaxDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.retrieveFax>
>;
export type FaxControllerServiceRetrieveFaxQueryResult<
  TData = FaxControllerServiceRetrieveFaxDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceRetrieveFaxKey =
  "FaxControllerServiceRetrieveFax";
export const UseFaxControllerServiceRetrieveFaxKeyFn = (
  {
    direction,
    uuid,
  }: {
    direction: string;
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceRetrieveFaxKey,
  ...(queryKey ?? [{ direction, uuid }]),
];
export type FaxControllerServiceGetImagingResultPdfDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.getImagingResultPdf>
>;
export type FaxControllerServiceGetImagingResultPdfQueryResult<
  TData = FaxControllerServiceGetImagingResultPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceGetImagingResultPdfKey =
  "FaxControllerServiceGetImagingResultPdf";
export const UseFaxControllerServiceGetImagingResultPdfKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceGetImagingResultPdfKey,
  ...(queryKey ?? [{ uuid }]),
];
export type FaxControllerServiceGetLabOrderPdfDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.getLabOrderPdf>
>;
export type FaxControllerServiceGetLabOrderPdfQueryResult<
  TData = FaxControllerServiceGetLabOrderPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceGetLabOrderPdfKey =
  "FaxControllerServiceGetLabOrderPdf";
export const UseFaxControllerServiceGetLabOrderPdfKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [useFaxControllerServiceGetLabOrderPdfKey, ...(queryKey ?? [{ uuid }])];
export type FaxControllerServiceFetchOutboxFaxesDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchOutboxFaxes>
>;
export type FaxControllerServiceFetchOutboxFaxesQueryResult<
  TData = FaxControllerServiceFetchOutboxFaxesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchOutboxFaxesKey =
  "FaxControllerServiceFetchOutboxFaxes";
export const UseFaxControllerServiceFetchOutboxFaxesKeyFn = (
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchOutboxFaxesKey,
  ...(queryKey ?? [{ page, pageSize }]),
];
export type FaxControllerServiceFetchInboxFaxesDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchInboxFaxes>
>;
export type FaxControllerServiceFetchInboxFaxesQueryResult<
  TData = FaxControllerServiceFetchInboxFaxesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchInboxFaxesKey =
  "FaxControllerServiceFetchInboxFaxes";
export const UseFaxControllerServiceFetchInboxFaxesKeyFn = (
  {
    locationUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    locationUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchInboxFaxesKey,
  ...(queryKey ?? [{ locationUuid, page, pageSize, sortBy, sortDirection }]),
];
export type FaxControllerServiceFetchInboxWithSubUsersDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchInboxWithSubUsers>
>;
export type FaxControllerServiceFetchInboxWithSubUsersQueryResult<
  TData = FaxControllerServiceFetchInboxWithSubUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchInboxWithSubUsersKey =
  "FaxControllerServiceFetchInboxWithSubUsers";
export const UseFaxControllerServiceFetchInboxWithSubUsersKeyFn = (
  queryKey?: Array<unknown>,
) => [useFaxControllerServiceFetchInboxWithSubUsersKey, ...(queryKey ?? [])];
export type FaxControllerServiceFetchSentFaxesFromEfaxDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchSentFaxesFromEfax>
>;
export type FaxControllerServiceFetchSentFaxesFromEfaxQueryResult<
  TData = FaxControllerServiceFetchSentFaxesFromEfaxDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchSentFaxesFromEfaxKey =
  "FaxControllerServiceFetchSentFaxesFromEfax";
export const UseFaxControllerServiceFetchSentFaxesFromEfaxKeyFn = (
  {
    locationUuid,
    paginationLimit,
    paginationOffset,
  }: {
    locationUuid: string;
    paginationLimit?: number;
    paginationOffset?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchSentFaxesFromEfaxKey,
  ...(queryKey ?? [{ locationUuid, paginationLimit, paginationOffset }]),
];
export type FaxControllerServiceFetchReceivedFaxesFromEfaxDefaultResponse =
  Awaited<ReturnType<typeof FaxControllerService.fetchReceivedFaxesFromEfax>>;
export type FaxControllerServiceFetchReceivedFaxesFromEfaxQueryResult<
  TData = FaxControllerServiceFetchReceivedFaxesFromEfaxDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchReceivedFaxesFromEfaxKey =
  "FaxControllerServiceFetchReceivedFaxesFromEfax";
export const UseFaxControllerServiceFetchReceivedFaxesFromEfaxKeyFn = (
  {
    locationUuid,
    paginationLimit,
    paginationOffset,
  }: {
    locationUuid: string;
    paginationLimit?: number;
    paginationOffset?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchReceivedFaxesFromEfaxKey,
  ...(queryKey ?? [{ locationUuid, paginationLimit, paginationOffset }]),
];
export type FaxControllerServiceFetchEfaxFaxPagesDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchEfaxFaxPages>
>;
export type FaxControllerServiceFetchEfaxFaxPagesQueryResult<
  TData = FaxControllerServiceFetchEfaxFaxPagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchEfaxFaxPagesKey =
  "FaxControllerServiceFetchEfaxFaxPages";
export const UseFaxControllerServiceFetchEfaxFaxPagesKeyFn = (
  {
    faxId,
    locationUuid,
    numPages,
    startPage,
  }: {
    faxId: string;
    locationUuid: string;
    numPages?: number;
    startPage?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchEfaxFaxPagesKey,
  ...(queryKey ?? [{ faxId, locationUuid, numPages, startPage }]),
];
export type FaxControllerServiceFetchEfaxOutboundFaxMetadataDefaultResponse =
  Awaited<ReturnType<typeof FaxControllerService.fetchEfaxOutboundFaxMetadata>>;
export type FaxControllerServiceFetchEfaxOutboundFaxMetadataQueryResult<
  TData = FaxControllerServiceFetchEfaxOutboundFaxMetadataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchEfaxOutboundFaxMetadataKey =
  "FaxControllerServiceFetchEfaxOutboundFaxMetadata";
export const UseFaxControllerServiceFetchEfaxOutboundFaxMetadataKeyFn = (
  {
    faxId,
    locationUuid,
  }: {
    faxId: string;
    locationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchEfaxOutboundFaxMetadataKey,
  ...(queryKey ?? [{ faxId, locationUuid }]),
];
export type FaxControllerServiceFetchEfaxFaxMetadataDefaultResponse = Awaited<
  ReturnType<typeof FaxControllerService.fetchEfaxFaxMetadata>
>;
export type FaxControllerServiceFetchEfaxFaxMetadataQueryResult<
  TData = FaxControllerServiceFetchEfaxFaxMetadataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaxControllerServiceFetchEfaxFaxMetadataKey =
  "FaxControllerServiceFetchEfaxFaxMetadata";
export const UseFaxControllerServiceFetchEfaxFaxMetadataKeyFn = (
  {
    faxId,
    locationUuid,
  }: {
    faxId: string;
    locationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFaxControllerServiceFetchEfaxFaxMetadataKey,
  ...(queryKey ?? [{ faxId, locationUuid }]),
];
export type FaceSheetLayoutControllerServiceGetLayoutDefaultResponse = Awaited<
  ReturnType<typeof FaceSheetLayoutControllerService.getLayout>
>;
export type FaceSheetLayoutControllerServiceGetLayoutQueryResult<
  TData = FaceSheetLayoutControllerServiceGetLayoutDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFaceSheetLayoutControllerServiceGetLayoutKey =
  "FaceSheetLayoutControllerServiceGetLayout";
export const UseFaceSheetLayoutControllerServiceGetLayoutKeyFn = (
  queryKey?: Array<unknown>,
) => [useFaceSheetLayoutControllerServiceGetLayoutKey, ...(queryKey ?? [])];
export type EmployerControllerServiceGetPricingDetailsDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getPricingDetails>
>;
export type EmployerControllerServiceGetPricingDetailsQueryResult<
  TData = EmployerControllerServiceGetPricingDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetPricingDetailsKey =
  "EmployerControllerServiceGetPricingDetails";
export const UseEmployerControllerServiceGetPricingDetailsKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetPricingDetailsKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type EmployerControllerServiceGetOnlineSignUpDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getOnlineSignUp>
>;
export type EmployerControllerServiceGetOnlineSignUpQueryResult<
  TData = EmployerControllerServiceGetOnlineSignUpDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetOnlineSignUpKey =
  "EmployerControllerServiceGetOnlineSignUp";
export const UseEmployerControllerServiceGetOnlineSignUpKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetOnlineSignUpKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type EmployerControllerServiceGetAccountDetailsDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getAccountDetails>
>;
export type EmployerControllerServiceGetAccountDetailsQueryResult<
  TData = EmployerControllerServiceGetAccountDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetAccountDetailsKey =
  "EmployerControllerServiceGetAccountDetails";
export const UseEmployerControllerServiceGetAccountDetailsKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetAccountDetailsKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type EmployerControllerServiceGetInvoiceSettingDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getInvoiceSetting>
>;
export type EmployerControllerServiceGetInvoiceSettingQueryResult<
  TData = EmployerControllerServiceGetInvoiceSettingDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetInvoiceSettingKey =
  "EmployerControllerServiceGetInvoiceSetting";
export const UseEmployerControllerServiceGetInvoiceSettingKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetInvoiceSettingKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type EmployerControllerServiceGetAllEmployerTotalCountDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerControllerService.getAllEmployerTotalCount>
  >;
export type EmployerControllerServiceGetAllEmployerTotalCountQueryResult<
  TData = EmployerControllerServiceGetAllEmployerTotalCountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetAllEmployerTotalCountKey =
  "EmployerControllerServiceGetAllEmployerTotalCount";
export const UseEmployerControllerServiceGetAllEmployerTotalCountKeyFn = (
  {
    employerUuid,
    isEmployeePatient,
    patientStatus,
  }: {
    employerUuid?: string;
    isEmployeePatient?: boolean;
    patientStatus?: "ACTIVE" | "PENDING" | "INACTIVE";
  } = {},
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetAllEmployerTotalCountKey,
  ...(queryKey ?? [{ employerUuid, isEmployeePatient, patientStatus }]),
];
export type EmployerControllerServiceGetEmployerMemberShipDefaultResponse =
  Awaited<ReturnType<typeof EmployerControllerService.getEmployerMemberShip>>;
export type EmployerControllerServiceGetEmployerMemberShipQueryResult<
  TData = EmployerControllerServiceGetEmployerMemberShipDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetEmployerMemberShipKey =
  "EmployerControllerServiceGetEmployerMemberShip";
export const UseEmployerControllerServiceGetEmployerMemberShipKeyFn = (
  {
    employerUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetEmployerMemberShipKey,
  ...(queryKey ?? [{ employerUuid, page, pageSize, sortBy, sortDirection }]),
];
export type EmployerControllerServiceGetMembershipDetailsDefaultResponse =
  Awaited<ReturnType<typeof EmployerControllerService.getMembershipDetails>>;
export type EmployerControllerServiceGetMembershipDetailsQueryResult<
  TData = EmployerControllerServiceGetMembershipDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetMembershipDetailsKey =
  "EmployerControllerServiceGetMembershipDetails";
export const UseEmployerControllerServiceGetMembershipDetailsKeyFn = (
  {
    employerPlanHistoryUuid,
    employerUuid,
    planUuid,
  }: {
    employerPlanHistoryUuid?: string;
    employerUuid: string;
    planUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetMembershipDetailsKey,
  ...(queryKey ?? [{ employerPlanHistoryUuid, employerUuid, planUuid }]),
];
export type EmployerControllerServiceGetEmployerByUuidDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getEmployerByUuid>
>;
export type EmployerControllerServiceGetEmployerByUuidQueryResult<
  TData = EmployerControllerServiceGetEmployerByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetEmployerByUuidKey =
  "EmployerControllerServiceGetEmployerByUuid";
export const UseEmployerControllerServiceGetEmployerByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetEmployerByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type EmployerControllerServiceGetEmployerCustomLogoByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerControllerService.getEmployerCustomLogoByUuid>
  >;
export type EmployerControllerServiceGetEmployerCustomLogoByUuidQueryResult<
  TData = EmployerControllerServiceGetEmployerCustomLogoByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetEmployerCustomLogoByUuidKey =
  "EmployerControllerServiceGetEmployerCustomLogoByUuid";
export const UseEmployerControllerServiceGetEmployerCustomLogoByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetEmployerCustomLogoByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type EmployerControllerServiceGetEmployerCoveragePlansDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerControllerService.getEmployerCoveragePlans>
  >;
export type EmployerControllerServiceGetEmployerCoveragePlansQueryResult<
  TData = EmployerControllerServiceGetEmployerCoveragePlansDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetEmployerCoveragePlansKey =
  "EmployerControllerServiceGetEmployerCoveragePlans";
export const UseEmployerControllerServiceGetEmployerCoveragePlansKeyFn = (
  {
    employerUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    employerUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetEmployerCoveragePlansKey,
  ...(queryKey ?? [
    { employerUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type EmployerControllerServiceGetBasicDetailsByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerControllerService.getBasicDetailsByPatientUuid>
  >;
export type EmployerControllerServiceGetBasicDetailsByPatientUuidQueryResult<
  TData = EmployerControllerServiceGetBasicDetailsByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetBasicDetailsByPatientUuidKey =
  "EmployerControllerServiceGetBasicDetailsByPatientUuid";
export const UseEmployerControllerServiceGetBasicDetailsByPatientUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetBasicDetailsByPatientUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type EmployerControllerServiceGetAllEmployersDefaultResponse = Awaited<
  ReturnType<typeof EmployerControllerService.getAllEmployers>
>;
export type EmployerControllerServiceGetAllEmployersQueryResult<
  TData = EmployerControllerServiceGetAllEmployersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerControllerServiceGetAllEmployersKey =
  "EmployerControllerServiceGetAllEmployers";
export const UseEmployerControllerServiceGetAllEmployersKeyFn = (
  {
    page,
    pageSize,
    planName,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    planName?: string;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useEmployerControllerServiceGetAllEmployersKey,
  ...(queryKey ?? [
    { page, pageSize, planName, search, sortBy, sortDirection, status },
  ]),
];
export type EmployerPageControllerServiceGetEmployerPageByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerPageControllerService.getEmployerPageByUuid>
  >;
export type EmployerPageControllerServiceGetEmployerPageByUuidQueryResult<
  TData = EmployerPageControllerServiceGetEmployerPageByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerPageControllerServiceGetEmployerPageByUuidKey =
  "EmployerPageControllerServiceGetEmployerPageByUuid";
export const UseEmployerPageControllerServiceGetEmployerPageByUuidKeyFn = (
  {
    employerPageUuid,
  }: {
    employerPageUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerPageControllerServiceGetEmployerPageByUuidKey,
  ...(queryKey ?? [{ employerPageUuid }]),
];
export type EmployerPageControllerServiceIsLinkActiveDefaultResponse = Awaited<
  ReturnType<typeof EmployerPageControllerService.isLinkActive>
>;
export type EmployerPageControllerServiceIsLinkActiveQueryResult<
  TData = EmployerPageControllerServiceIsLinkActiveDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerPageControllerServiceIsLinkActiveKey =
  "EmployerPageControllerServiceIsLinkActive";
export const UseEmployerPageControllerServiceIsLinkActiveKeyFn = (
  {
    employerPageUuid,
  }: {
    employerPageUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmployerPageControllerServiceIsLinkActiveKey,
  ...(queryKey ?? [{ employerPageUuid }]),
];
export type EmployerPageControllerServiceGetAllEmployerPagesDefaultResponse =
  Awaited<ReturnType<typeof EmployerPageControllerService.getAllEmployerPages>>;
export type EmployerPageControllerServiceGetAllEmployerPagesQueryResult<
  TData = EmployerPageControllerServiceGetAllEmployerPagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerPageControllerServiceGetAllEmployerPagesKey =
  "EmployerPageControllerServiceGetAllEmployerPages";
export const UseEmployerPageControllerServiceGetAllEmployerPagesKeyFn = (
  {
    employerOnlineSignUpUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    employerOnlineSignUpUuid?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useEmployerPageControllerServiceGetAllEmployerPagesKey,
  ...(queryKey ?? [
    { employerOnlineSignUpUuid, page, pageSize, sortBy, sortDirection },
  ]),
];
export type EmployerDivisionControllerServiceGetEmployerDivisionByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerDivisionControllerService.getEmployerDivisionByUuid
    >
  >;
export type EmployerDivisionControllerServiceGetEmployerDivisionByUuidQueryResult<
  TData =
    EmployerDivisionControllerServiceGetEmployerDivisionByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerDivisionControllerServiceGetEmployerDivisionByUuidKey =
  "EmployerDivisionControllerServiceGetEmployerDivisionByUuid";
export const UseEmployerDivisionControllerServiceGetEmployerDivisionByUuidKeyFn =
  (
    {
      employerDivisionUuid,
    }: {
      employerDivisionUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerDivisionControllerServiceGetEmployerDivisionByUuidKey,
    ...(queryKey ?? [{ employerDivisionUuid }]),
  ];
export type EmployerDivisionControllerServiceGetAllEmployerDivisionsDefaultResponse =
  Awaited<
    ReturnType<typeof EmployerDivisionControllerService.getAllEmployerDivisions>
  >;
export type EmployerDivisionControllerServiceGetAllEmployerDivisionsQueryResult<
  TData =
    EmployerDivisionControllerServiceGetAllEmployerDivisionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerDivisionControllerServiceGetAllEmployerDivisionsKey =
  "EmployerDivisionControllerServiceGetAllEmployerDivisions";
export const UseEmployerDivisionControllerServiceGetAllEmployerDivisionsKeyFn =
  (
    {
      employerUuid,
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      employerUuid?: string;
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useEmployerDivisionControllerServiceGetAllEmployerDivisionsKey,
    ...(queryKey ?? [{ employerUuid, page, pageSize, sortBy, sortDirection }]),
  ];
export type EmployerAdministratorControllerServiceGetEmployerAdministratorByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerAdministratorControllerService.getEmployerAdministratorByUuid
    >
  >;
export type EmployerAdministratorControllerServiceGetEmployerAdministratorByUuidQueryResult<
  TData =
    EmployerAdministratorControllerServiceGetEmployerAdministratorByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerAdministratorControllerServiceGetEmployerAdministratorByUuidKey =
  "EmployerAdministratorControllerServiceGetEmployerAdministratorByUuid";
export const UseEmployerAdministratorControllerServiceGetEmployerAdministratorByUuidKeyFn =
  (
    {
      employerAdministratorUuid,
    }: {
      employerAdministratorUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerAdministratorControllerServiceGetEmployerAdministratorByUuidKey,
    ...(queryKey ?? [{ employerAdministratorUuid }]),
  ];
export type EmployerAdministratorControllerServiceGetAllEmployerAdministratorsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerAdministratorControllerService.getAllEmployerAdministrators
    >
  >;
export type EmployerAdministratorControllerServiceGetAllEmployerAdministratorsQueryResult<
  TData =
    EmployerAdministratorControllerServiceGetAllEmployerAdministratorsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerAdministratorControllerServiceGetAllEmployerAdministratorsKey =
  "EmployerAdministratorControllerServiceGetAllEmployerAdministrators";
export const UseEmployerAdministratorControllerServiceGetAllEmployerAdministratorsKeyFn =
  (
    {
      employerUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      employerUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerAdministratorControllerServiceGetAllEmployerAdministratorsKey,
    ...(queryKey ?? [
      { employerUuid, page, pageSize, searchString, sortBy, sortDirection },
    ]),
  ];
export type CreditControllerServiceGetCreditByUuidDefaultResponse = Awaited<
  ReturnType<typeof CreditControllerService.getCreditByUuid>
>;
export type CreditControllerServiceGetCreditByUuidQueryResult<
  TData = CreditControllerServiceGetCreditByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCreditControllerServiceGetCreditByUuidKey =
  "CreditControllerServiceGetCreditByUuid";
export const UseCreditControllerServiceGetCreditByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCreditControllerServiceGetCreditByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type CreditControllerServiceGetTotalCreditByUuidDefaultResponse =
  Awaited<ReturnType<typeof CreditControllerService.getTotalCreditByUuid>>;
export type CreditControllerServiceGetTotalCreditByUuidQueryResult<
  TData = CreditControllerServiceGetTotalCreditByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCreditControllerServiceGetTotalCreditByUuidKey =
  "CreditControllerServiceGetTotalCreditByUuid";
export const UseCreditControllerServiceGetTotalCreditByUuidKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCreditControllerServiceGetTotalCreditByUuidKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type CreditControllerServiceGetAllCreditsDefaultResponse = Awaited<
  ReturnType<typeof CreditControllerService.getAllCredits>
>;
export type CreditControllerServiceGetAllCreditsQueryResult<
  TData = CreditControllerServiceGetAllCreditsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCreditControllerServiceGetAllCreditsKey =
  "CreditControllerServiceGetAllCredits";
export const UseCreditControllerServiceGetAllCreditsKeyFn = (
  {
    expired,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    expired?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCreditControllerServiceGetAllCreditsKey,
  ...(queryKey ?? [
    { expired, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type CoverageRuleControllerServiceGetCoverageRuleByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof CoverageRuleControllerService.getCoverageRuleByUuid>
  >;
export type CoverageRuleControllerServiceGetCoverageRuleByUuidQueryResult<
  TData = CoverageRuleControllerServiceGetCoverageRuleByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCoverageRuleControllerServiceGetCoverageRuleByUuidKey =
  "CoverageRuleControllerServiceGetCoverageRuleByUuid";
export const UseCoverageRuleControllerServiceGetCoverageRuleByUuidKeyFn = (
  {
    coverageRuleUuid,
  }: {
    coverageRuleUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCoverageRuleControllerServiceGetCoverageRuleByUuidKey,
  ...(queryKey ?? [{ coverageRuleUuid }]),
];
export type CoverageRuleControllerServiceGetAllCoverageRuleDefaultResponse =
  Awaited<ReturnType<typeof CoverageRuleControllerService.getAllCoverageRule>>;
export type CoverageRuleControllerServiceGetAllCoverageRuleQueryResult<
  TData = CoverageRuleControllerServiceGetAllCoverageRuleDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCoverageRuleControllerServiceGetAllCoverageRuleKey =
  "CoverageRuleControllerServiceGetAllCoverageRule";
export const UseCoverageRuleControllerServiceGetAllCoverageRuleKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCoverageRuleControllerServiceGetAllCoverageRuleKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
];
export type CoveragePlanControllerServiceGetCoveragePlanByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof CoveragePlanControllerService.getCoveragePlanByUuid>
  >;
export type CoveragePlanControllerServiceGetCoveragePlanByUuidQueryResult<
  TData = CoveragePlanControllerServiceGetCoveragePlanByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCoveragePlanControllerServiceGetCoveragePlanByUuidKey =
  "CoveragePlanControllerServiceGetCoveragePlanByUuid";
export const UseCoveragePlanControllerServiceGetCoveragePlanByUuidKeyFn = (
  {
    coveragePlanUuid,
  }: {
    coveragePlanUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCoveragePlanControllerServiceGetCoveragePlanByUuidKey,
  ...(queryKey ?? [{ coveragePlanUuid }]),
];
export type CoveragePlanControllerServiceGetAllCoveragePlanDefaultResponse =
  Awaited<ReturnType<typeof CoveragePlanControllerService.getAllCoveragePlan>>;
export type CoveragePlanControllerServiceGetAllCoveragePlanQueryResult<
  TData = CoveragePlanControllerServiceGetAllCoveragePlanDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCoveragePlanControllerServiceGetAllCoveragePlanKey =
  "CoveragePlanControllerServiceGetAllCoveragePlan";
export const UseCoveragePlanControllerServiceGetAllCoveragePlanKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCoveragePlanControllerServiceGetAllCoveragePlanKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type CouponControllerServiceGetCouponByUuidDefaultResponse = Awaited<
  ReturnType<typeof CouponControllerService.getCouponByUuid>
>;
export type CouponControllerServiceGetCouponByUuidQueryResult<
  TData = CouponControllerServiceGetCouponByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCouponControllerServiceGetCouponByUuidKey =
  "CouponControllerServiceGetCouponByUuid";
export const UseCouponControllerServiceGetCouponByUuidKeyFn = (
  {
    couponUuid,
  }: {
    couponUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCouponControllerServiceGetCouponByUuidKey,
  ...(queryKey ?? [{ couponUuid }]),
];
export type CouponControllerServiceGetAllCouponsDefaultResponse = Awaited<
  ReturnType<typeof CouponControllerService.getAllCoupons>
>;
export type CouponControllerServiceGetAllCouponsQueryResult<
  TData = CouponControllerServiceGetAllCouponsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCouponControllerServiceGetAllCouponsKey =
  "CouponControllerServiceGetAllCoupons";
export const UseCouponControllerServiceGetAllCouponsKeyFn = (
  {
    activeExpired,
    page,
    pageSize,
    providerUuids,
    redeemableNonRedeemable,
    searchString,
    sortBy,
    sortDirection,
  }: {
    activeExpired?:
      | "CURRENT"
      | "REDEEMABLE"
      | "NON_REDEEMABLE"
      | "ARCHIVE"
      | "EXPIRED";
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    redeemableNonRedeemable?:
      | "CURRENT"
      | "REDEEMABLE"
      | "NON_REDEEMABLE"
      | "ARCHIVE"
      | "EXPIRED";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCouponControllerServiceGetAllCouponsKey,
  ...(queryKey ?? [
    {
      activeExpired,
      page,
      pageSize,
      providerUuids,
      redeemableNonRedeemable,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type ChargeItemControllerServiceGetChargeItemByUuidDefaultResponse =
  Awaited<ReturnType<typeof ChargeItemControllerService.getChargeItemByUuid>>;
export type ChargeItemControllerServiceGetChargeItemByUuidQueryResult<
  TData = ChargeItemControllerServiceGetChargeItemByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceGetChargeItemByUuidKey =
  "ChargeItemControllerServiceGetChargeItemByUuid";
export const UseChargeItemControllerServiceGetChargeItemByUuidKeyFn = (
  {
    chargeItemUuid,
  }: {
    chargeItemUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useChargeItemControllerServiceGetChargeItemByUuidKey,
  ...(queryKey ?? [{ chargeItemUuid }]),
];
export type ChargeItemControllerServiceGetChargeItemTaxMappingDefaultResponse =
  Awaited<
    ReturnType<typeof ChargeItemControllerService.getChargeItemTaxMapping>
  >;
export type ChargeItemControllerServiceGetChargeItemTaxMappingQueryResult<
  TData = ChargeItemControllerServiceGetChargeItemTaxMappingDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceGetChargeItemTaxMappingKey =
  "ChargeItemControllerServiceGetChargeItemTaxMapping";
export const UseChargeItemControllerServiceGetChargeItemTaxMappingKeyFn = (
  {
    chargeItemUuid,
    patientUuid,
  }: {
    chargeItemUuid: string;
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useChargeItemControllerServiceGetChargeItemTaxMappingKey,
  ...(queryKey ?? [{ chargeItemUuid, patientUuid }]),
];
export type ChargeItemControllerServiceDownloadPriceUpdateCsvTemplateDefaultResponse =
  Awaited<
    ReturnType<
      typeof ChargeItemControllerService.downloadPriceUpdateCsvTemplate
    >
  >;
export type ChargeItemControllerServiceDownloadPriceUpdateCsvTemplateQueryResult<
  TData =
    ChargeItemControllerServiceDownloadPriceUpdateCsvTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceDownloadPriceUpdateCsvTemplateKey =
  "ChargeItemControllerServiceDownloadPriceUpdateCsvTemplate";
export const UseChargeItemControllerServiceDownloadPriceUpdateCsvTemplateKeyFn =
  (queryKey?: Array<unknown>) => [
    useChargeItemControllerServiceDownloadPriceUpdateCsvTemplateKey,
    ...(queryKey ?? []),
  ];
export type ChargeItemControllerServiceExportCsvDefaultResponse = Awaited<
  ReturnType<typeof ChargeItemControllerService.exportCsv>
>;
export type ChargeItemControllerServiceExportCsvQueryResult<
  TData = ChargeItemControllerServiceExportCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceExportCsvKey =
  "ChargeItemControllerServiceExportCsv";
export const UseChargeItemControllerServiceExportCsvKeyFn = (
  {
    categoryName,
    maxPrice,
    minPrice,
    search,
  }: {
    categoryName?: string;
    maxPrice?: number;
    minPrice?: number;
    search?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useChargeItemControllerServiceExportCsvKey,
  ...(queryKey ?? [{ categoryName, maxPrice, minPrice, search }]),
];
export type ChargeItemControllerServiceDownloadCsvTemplate1DefaultResponse =
  Awaited<ReturnType<typeof ChargeItemControllerService.downloadCsvTemplate1>>;
export type ChargeItemControllerServiceDownloadCsvTemplate1QueryResult<
  TData = ChargeItemControllerServiceDownloadCsvTemplate1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceDownloadCsvTemplate1Key =
  "ChargeItemControllerServiceDownloadCsvTemplate1";
export const UseChargeItemControllerServiceDownloadCsvTemplate1KeyFn = (
  queryKey?: Array<unknown>,
) => [
  useChargeItemControllerServiceDownloadCsvTemplate1Key,
  ...(queryKey ?? []),
];
export type ChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof ChargeItemControllerService.getChargeItemsByChargeCategoryUuid
    >
  >;
export type ChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidQueryResult<
  TData =
    ChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidKey =
  "ChargeItemControllerServiceGetChargeItemsByChargeCategoryUuid";
export const UseChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidKeyFn =
  (
    {
      chargeCategoryUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      chargeCategoryUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useChargeItemControllerServiceGetChargeItemsByChargeCategoryUuidKey,
    ...(queryKey ?? [
      {
        chargeCategoryUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      },
    ]),
  ];
export type ChargeItemControllerServiceSearchAndFilterChargeItemsDefaultResponse =
  Awaited<
    ReturnType<typeof ChargeItemControllerService.searchAndFilterChargeItems>
  >;
export type ChargeItemControllerServiceSearchAndFilterChargeItemsQueryResult<
  TData = ChargeItemControllerServiceSearchAndFilterChargeItemsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeItemControllerServiceSearchAndFilterChargeItemsKey =
  "ChargeItemControllerServiceSearchAndFilterChargeItems";
export const UseChargeItemControllerServiceSearchAndFilterChargeItemsKeyFn = (
  {
    categoryName,
    maxPrice,
    minPrice,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    categoryName?: string;
    maxPrice?: number;
    minPrice?: number;
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: "ACTIVE" | "PENDING" | "ENDED";
  } = {},
  queryKey?: Array<unknown>,
) => [
  useChargeItemControllerServiceSearchAndFilterChargeItemsKey,
  ...(queryKey ?? [
    {
      categoryName,
      maxPrice,
      minPrice,
      page,
      pageSize,
      search,
      sortBy,
      sortDirection,
      status,
    },
  ]),
];
export type ChargeCategoryControllerServiceGetChargeCategoryByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ChargeCategoryControllerService.getChargeCategoryByUuid>
  >;
export type ChargeCategoryControllerServiceGetChargeCategoryByUuidQueryResult<
  TData = ChargeCategoryControllerServiceGetChargeCategoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeCategoryControllerServiceGetChargeCategoryByUuidKey =
  "ChargeCategoryControllerServiceGetChargeCategoryByUuid";
export const UseChargeCategoryControllerServiceGetChargeCategoryByUuidKeyFn = (
  {
    chargeCategoryUuid,
  }: {
    chargeCategoryUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useChargeCategoryControllerServiceGetChargeCategoryByUuidKey,
  ...(queryKey ?? [{ chargeCategoryUuid }]),
];
export type ChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof ChargeCategoryControllerService.getChargeCategoryByCoveragePlanUuid
    >
  >;
export type ChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidQueryResult<
  TData =
    ChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidKey =
  "ChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuid";
export const UseChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidKeyFn =
  (
    {
      coveragePlanUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      coveragePlanUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useChargeCategoryControllerServiceGetChargeCategoryByCoveragePlanUuidKey,
    ...(queryKey ?? [
      { coveragePlanUuid, page, pageSize, searchString, sortBy, sortDirection },
    ]),
  ];
export type ChargeCategoryControllerServiceGetAllChargeCategoriesDefaultResponse =
  Awaited<
    ReturnType<typeof ChargeCategoryControllerService.getAllChargeCategories>
  >;
export type ChargeCategoryControllerServiceGetAllChargeCategoriesQueryResult<
  TData = ChargeCategoryControllerServiceGetAllChargeCategoriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useChargeCategoryControllerServiceGetAllChargeCategoriesKey =
  "ChargeCategoryControllerServiceGetAllChargeCategories";
export const UseChargeCategoryControllerServiceGetAllChargeCategoriesKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useChargeCategoryControllerServiceGetAllChargeCategoriesKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type CancellationControllerServiceGetCancellationByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof CancellationControllerService.getCancellationByUuid>
  >;
export type CancellationControllerServiceGetCancellationByUuidQueryResult<
  TData = CancellationControllerServiceGetCancellationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCancellationControllerServiceGetCancellationByUuidKey =
  "CancellationControllerServiceGetCancellationByUuid";
export const UseCancellationControllerServiceGetCancellationByUuidKeyFn = (
  {
    cancellationsUuid,
  }: {
    cancellationsUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCancellationControllerServiceGetCancellationByUuidKey,
  ...(queryKey ?? [{ cancellationsUuid }]),
];
export type CancellationControllerServiceGetAllCancellationsDefaultResponse =
  Awaited<ReturnType<typeof CancellationControllerService.getAllCancellations>>;
export type CancellationControllerServiceGetAllCancellationsQueryResult<
  TData = CancellationControllerServiceGetAllCancellationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCancellationControllerServiceGetAllCancellationsKey =
  "CancellationControllerServiceGetAllCancellations";
export const UseCancellationControllerServiceGetAllCancellationsKeyFn = (
  {
    archive,
    description,
    isCustom,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    description?: string;
    isCustom?: boolean;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCancellationControllerServiceGetAllCancellationsKey,
  ...(queryKey ?? [
    { archive, description, isCustom, page, pageSize, sortBy, sortDirection },
  ]),
];
export type BrokerControllerServiceGetBrokerByUuidDefaultResponse = Awaited<
  ReturnType<typeof BrokerControllerService.getBrokerByUuid>
>;
export type BrokerControllerServiceGetBrokerByUuidQueryResult<
  TData = BrokerControllerServiceGetBrokerByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBrokerControllerServiceGetBrokerByUuidKey =
  "BrokerControllerServiceGetBrokerByUuid";
export const UseBrokerControllerServiceGetBrokerByUuidKeyFn = (
  {
    brokerUuid,
  }: {
    brokerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useBrokerControllerServiceGetBrokerByUuidKey,
  ...(queryKey ?? [{ brokerUuid }]),
];
export type BrokerControllerServiceGetAllBrokersDefaultResponse = Awaited<
  ReturnType<typeof BrokerControllerService.getAllBrokers>
>;
export type BrokerControllerServiceGetAllBrokersQueryResult<
  TData = BrokerControllerServiceGetAllBrokersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBrokerControllerServiceGetAllBrokersKey =
  "BrokerControllerServiceGetAllBrokers";
export const UseBrokerControllerServiceGetAllBrokersKeyFn = (
  {
    agentFirmUuids,
    employerUuids,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
  }: {
    agentFirmUuids?: string[];
    employerUuids?: string[];
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useBrokerControllerServiceGetAllBrokersKey,
  ...(queryKey ?? [
    {
      agentFirmUuids,
      employerUuids,
      endDate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      startDate,
      status,
    },
  ]),
];
export type BreakGlassControllerServiceGetByUuid3DefaultResponse = Awaited<
  ReturnType<typeof BreakGlassControllerService.getByUuid3>
>;
export type BreakGlassControllerServiceGetByUuid3QueryResult<
  TData = BreakGlassControllerServiceGetByUuid3DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBreakGlassControllerServiceGetByUuid3Key =
  "BreakGlassControllerServiceGetByUuid3";
export const UseBreakGlassControllerServiceGetByUuid3KeyFn = (
  {
    breakGlassUuid,
  }: {
    breakGlassUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useBreakGlassControllerServiceGetByUuid3Key,
  ...(queryKey ?? [{ breakGlassUuid }]),
];
export type BreakGlassControllerServiceGetAllBreakGlassDefaultResponse =
  Awaited<ReturnType<typeof BreakGlassControllerService.getAllBreakGlass>>;
export type BreakGlassControllerServiceGetAllBreakGlassQueryResult<
  TData = BreakGlassControllerServiceGetAllBreakGlassDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBreakGlassControllerServiceGetAllBreakGlassKey =
  "BreakGlassControllerServiceGetAllBreakGlass";
export const UseBreakGlassControllerServiceGetAllBreakGlassKeyFn = (
  {
    locationUuid,
    nurseStaffProviderUuid,
    patientUuid,
    providerUuid,
  }: {
    locationUuid?: string;
    nurseStaffProviderUuid?: string;
    patientUuid?: string;
    providerUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useBreakGlassControllerServiceGetAllBreakGlassKey,
  ...(queryKey ?? [
    { locationUuid, nurseStaffProviderUuid, patientUuid, providerUuid },
  ]),
];
export type AncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getMiscellaneousServiceChargeByUuid
    >
  >;
export type AncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidKey =
  "AncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuid";
export const UseAncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidKeyFn =
  (
    {
      miscellaneousServiceChargeUuid,
    }: {
      miscellaneousServiceChargeUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetMiscellaneousServiceChargeByUuidKey,
    ...(queryKey ?? [{ miscellaneousServiceChargeUuid }]),
  ];
export type AncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getAncillaryServiceChargesUuid
    >
  >;
export type AncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidKey =
  "AncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuid";
export const UseAncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidKeyFn =
  (
    {
      ancillaryServiceChargesUuid,
    }: {
      ancillaryServiceChargesUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetAncillaryServiceChargesUuidKey,
    ...(queryKey ?? [{ ancillaryServiceChargesUuid }]),
  ];
export type AncillaryServiceChargesControllerServiceTransactionDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.transactionDetails
    >
  >;
export type AncillaryServiceChargesControllerServiceTransactionDetailsQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceTransactionDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceTransactionDetailsKey =
  "AncillaryServiceChargesControllerServiceTransactionDetails";
export const UseAncillaryServiceChargesControllerServiceTransactionDetailsKeyFn =
  (
    {
      endDate,
      page,
      size,
      sort,
      startDate,
      userTypes,
      userUuid,
    }: {
      endDate?: string;
      page?: number;
      size?: number;
      sort?: string[];
      startDate?: string;
      userTypes:
        | "EMPLOYER"
        | "PATIENT"
        | "BROKER"
        | "ADMIN_USER"
        | "PROVIDER"
        | "EMPLOYER_ADMINISTRATION"
        | "EMPLOYEE"
        | "PHP_USER"
        | "AFFILIATE_FIRM"
        | "BROKER_FIRM"
        | "NURSE_USER";
      userUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceTransactionDetailsKey,
    ...(queryKey ?? [
      { endDate, page, size, sort, startDate, userTypes, userUuid },
    ]),
  ];
export type AncillaryServiceChargesControllerServiceInvoiceTransactionDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.invoiceTransactionDetails
    >
  >;
export type AncillaryServiceChargesControllerServiceInvoiceTransactionDetailsQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceInvoiceTransactionDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceInvoiceTransactionDetailsKey =
  "AncillaryServiceChargesControllerServiceInvoiceTransactionDetails";
export const UseAncillaryServiceChargesControllerServiceInvoiceTransactionDetailsKeyFn =
  (
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceInvoiceTransactionDetailsKey,
    ...(queryKey ?? [{ invoiceUuid, page, size, sort }]),
  ];
export type AncillaryServiceChargesControllerServiceGetInvoiceStatementDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getInvoiceStatement
    >
  >;
export type AncillaryServiceChargesControllerServiceGetInvoiceStatementQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetInvoiceStatementDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetInvoiceStatementKey =
  "AncillaryServiceChargesControllerServiceGetInvoiceStatement";
export const UseAncillaryServiceChargesControllerServiceGetInvoiceStatementKeyFn =
  (
    {
      endDate,
      page,
      pageSize,
      sortBy,
      sortDirection,
      startDate,
      userTypes,
      userUuid,
    }: {
      endDate?: string;
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
      userTypes:
        | "EMPLOYER"
        | "PATIENT"
        | "BROKER"
        | "ADMIN_USER"
        | "PROVIDER"
        | "EMPLOYER_ADMINISTRATION"
        | "EMPLOYEE"
        | "PHP_USER"
        | "AFFILIATE_FIRM"
        | "BROKER_FIRM"
        | "NURSE_USER";
      userUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetInvoiceStatementKey,
    ...(queryKey ?? [
      {
        endDate,
        page,
        pageSize,
        sortBy,
        sortDirection,
        startDate,
        userTypes,
        userUuid,
      },
    ]),
  ];
export type AncillaryServiceChargesControllerServiceGetAllScheduledPaymentDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getAllScheduledPayment
    >
  >;
export type AncillaryServiceChargesControllerServiceGetAllScheduledPaymentQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetAllScheduledPaymentDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetAllScheduledPaymentKey =
  "AncillaryServiceChargesControllerServiceGetAllScheduledPayment";
export const UseAncillaryServiceChargesControllerServiceGetAllScheduledPaymentKeyFn =
  (
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetAllScheduledPaymentKey,
    ...(queryKey ?? [{ invoiceUuid, page, size, sort }]),
  ];
export type AncillaryServiceChargesControllerServicePaymentHistoryDefaultResponse =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.paymentHistory>
  >;
export type AncillaryServiceChargesControllerServicePaymentHistoryQueryResult<
  TData = AncillaryServiceChargesControllerServicePaymentHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServicePaymentHistoryKey =
  "AncillaryServiceChargesControllerServicePaymentHistory";
export const UseAncillaryServiceChargesControllerServicePaymentHistoryKeyFn = (
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAncillaryServiceChargesControllerServicePaymentHistoryKey,
  ...(queryKey ?? [{ invoiceUuid }]),
];
export type AncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getAllMiscellaneousServiceCharges
    >
  >;
export type AncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesKey =
  "AncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceCharges";
export const UseAncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesKeyFn =
  (
    {
      invoiceUuid,
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      invoiceUuid: string;
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetAllMiscellaneousServiceChargesKey,
    ...(queryKey ?? [{ invoiceUuid, page, pageSize, sortBy, sortDirection }]),
  ];
export type AncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateRetailPatientInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesKey =
  "AncillaryServiceChargesControllerServiceGenerateRetailPatientInvoices";
export const UseAncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesKeyFn =
  (queryKey?: Array<unknown>) => [
    useAncillaryServiceChargesControllerServiceGenerateRetailPatientInvoicesKey,
    ...(queryKey ?? []),
  ];
export type AncillaryServiceChargesControllerServiceGetInvoiceStatusDefaultResponse =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.getInvoiceStatus>
  >;
export type AncillaryServiceChargesControllerServiceGetInvoiceStatusQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetInvoiceStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetInvoiceStatusKey =
  "AncillaryServiceChargesControllerServiceGetInvoiceStatus";
export const UseAncillaryServiceChargesControllerServiceGetInvoiceStatusKeyFn =
  (
    {
      invoiceUuid,
    }: {
      invoiceUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetInvoiceStatusKey,
    ...(queryKey ?? [{ invoiceUuid }]),
  ];
export type AncillaryServiceChargesControllerServiceInvoiceDetailsDefaultResponse =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.invoiceDetails>
  >;
export type AncillaryServiceChargesControllerServiceInvoiceDetailsQueryResult<
  TData = AncillaryServiceChargesControllerServiceInvoiceDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceInvoiceDetailsKey =
  "AncillaryServiceChargesControllerServiceInvoiceDetails";
export const UseAncillaryServiceChargesControllerServiceInvoiceDetailsKeyFn = (
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAncillaryServiceChargesControllerServiceInvoiceDetailsKey,
  ...(queryKey ?? [{ invoiceUuid }]),
];
export type AncillaryServiceChargesControllerServiceEmployerEmployeesDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.employerEmployeesDetails
    >
  >;
export type AncillaryServiceChargesControllerServiceEmployerEmployeesDetailsQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceEmployerEmployeesDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceEmployerEmployeesDetailsKey =
  "AncillaryServiceChargesControllerServiceEmployerEmployeesDetails";
export const UseAncillaryServiceChargesControllerServiceEmployerEmployeesDetailsKeyFn =
  (
    {
      chargeType,
      employerUuid,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      chargeType?: string;
      employerUuid: string;
      invoiceUuid?: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceEmployerEmployeesDetailsKey,
    ...(queryKey ?? [
      { chargeType, employerUuid, invoiceUuid, page, search, size, sort },
    ]),
  ];
export type AncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getChargeItemNamesByInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceKey =
  "AncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoice";
export const UseAncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceKeyFn =
  (
    {
      invoiceUuid,
    }: {
      invoiceUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetChargeItemNamesByInvoiceKey,
    ...(queryKey ?? [{ invoiceUuid }]),
  ];
export type AncillaryServiceChargesControllerServiceAmountDetailsDefaultResponse =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.amountDetails>
  >;
export type AncillaryServiceChargesControllerServiceAmountDetailsQueryResult<
  TData = AncillaryServiceChargesControllerServiceAmountDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceAmountDetailsKey =
  "AncillaryServiceChargesControllerServiceAmountDetails";
export const UseAncillaryServiceChargesControllerServiceAmountDetailsKeyFn = (
  {
    applyCredit,
    invoiceUuid,
    patientUuid,
    rate,
  }: {
    applyCredit?: boolean;
    invoiceUuid: string;
    patientUuid?: string;
    rate?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useAncillaryServiceChargesControllerServiceAmountDetailsKey,
  ...(queryKey ?? [{ applyCredit, invoiceUuid, patientUuid, rate }]),
];
export type AncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getAllAncillaryServiceCharges
    >
  >;
export type AncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesKey =
  "AncillaryServiceChargesControllerServiceGetAllAncillaryServiceCharges";
export const UseAncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesKeyFn =
  (
    {
      invoiceUuid,
      page,
      size,
      sort,
      userUuid,
    }: {
      invoiceUuid?: string;
      page?: number;
      size?: number;
      sort?: string[];
      userUuid?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetAllAncillaryServiceChargesKey,
    ...(queryKey ?? [{ invoiceUuid, page, size, sort, userUuid }]),
  ];
export type AncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.affiliateFirmEmployeesDetails
    >
  >;
export type AncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsKey =
  "AncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetails";
export const UseAncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsKeyFn =
  (
    {
      affiliateFirmUuid,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      affiliateFirmUuid: string;
      invoiceUuid: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceAffiliateFirmEmployeesDetailsKey,
    ...(queryKey ?? [
      { affiliateFirmUuid, invoiceUuid, page, search, size, sort },
    ]),
  ];
export type AncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.employerDetailsMonthWise
    >
  >;
export type AncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseKey =
  "AncillaryServiceChargesControllerServiceEmployerDetailsMonthWise";
export const UseAncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseKeyFn =
  (
    {
      employerUuid,
      page,
      size,
      sort,
      year,
    }: {
      employerUuid: string;
      page?: number;
      size?: number;
      sort?: string[];
      year?: number;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceEmployerDetailsMonthWiseKey,
    ...(queryKey ?? [{ employerUuid, page, size, sort, year }]),
  ];
export type AncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.getAllAffiliateBrokerServiceCharges
    >
  >;
export type AncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesKey =
  "AncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceCharges";
export const UseAncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesKeyFn =
  (
    {
      invoiceUuid,
      page,
      size,
      sort,
    }: {
      invoiceUuid?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceGetAllAffiliateBrokerServiceChargesKey,
    ...(queryKey ?? [{ invoiceUuid, page, size, sort }]),
  ];
export type AncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.affiliateProviderEmployeeDetails
    >
  >;
export type AncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsQueryResult<
  TData =
    AncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsKey =
  "AncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetails";
export const UseAncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsKeyFn =
  (
    {
      chargeType,
      invoiceUuid,
      page,
      search,
      size,
      sort,
    }: {
      chargeType?: string;
      invoiceUuid: string;
      page?: number;
      search?: string;
      size?: number;
      sort?: string[];
    },
    queryKey?: Array<unknown>,
  ) => [
    useAncillaryServiceChargesControllerServiceAffiliateProviderEmployeeDetailsKey,
    ...(queryKey ?? [{ chargeType, invoiceUuid, page, search, size, sort }]),
  ];
export type AgentFirmControllerServiceGetAgentFirmByUuidDefaultResponse =
  Awaited<ReturnType<typeof AgentFirmControllerService.getAgentFirmByUuid>>;
export type AgentFirmControllerServiceGetAgentFirmByUuidQueryResult<
  TData = AgentFirmControllerServiceGetAgentFirmByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentFirmControllerServiceGetAgentFirmByUuidKey =
  "AgentFirmControllerServiceGetAgentFirmByUuid";
export const UseAgentFirmControllerServiceGetAgentFirmByUuidKeyFn = (
  {
    agentFirmUuid,
  }: {
    agentFirmUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentFirmControllerServiceGetAgentFirmByUuidKey,
  ...(queryKey ?? [{ agentFirmUuid }]),
];
export type AgentFirmControllerServiceGetEmployersUnderAgentFirmDefaultResponse =
  Awaited<
    ReturnType<typeof AgentFirmControllerService.getEmployersUnderAgentFirm>
  >;
export type AgentFirmControllerServiceGetEmployersUnderAgentFirmQueryResult<
  TData = AgentFirmControllerServiceGetEmployersUnderAgentFirmDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentFirmControllerServiceGetEmployersUnderAgentFirmKey =
  "AgentFirmControllerServiceGetEmployersUnderAgentFirm";
export const UseAgentFirmControllerServiceGetEmployersUnderAgentFirmKeyFn = (
  {
    agentFirmUuid,
    brokerUuids,
    commissionStatus,
    employerStatus,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    agentFirmUuid: string;
    brokerUuids?: string[];
    commissionStatus?: string;
    employerStatus?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentFirmControllerServiceGetEmployersUnderAgentFirmKey,
  ...(queryKey ?? [
    {
      agentFirmUuid,
      brokerUuids,
      commissionStatus,
      employerStatus,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type AgentFirmControllerServiceGetAllAgentFirmsDefaultResponse = Awaited<
  ReturnType<typeof AgentFirmControllerService.getAllAgentFirms>
>;
export type AgentFirmControllerServiceGetAllAgentFirmsQueryResult<
  TData = AgentFirmControllerServiceGetAllAgentFirmsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentFirmControllerServiceGetAllAgentFirmsKey =
  "AgentFirmControllerServiceGetAllAgentFirms";
export const UseAgentFirmControllerServiceGetAllAgentFirmsKeyFn = (
  {
    agentFirmType,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    agentFirmType?: "INDEPENDENT" | "AFFILIATED";
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAgentFirmControllerServiceGetAllAgentFirmsKey,
  ...(queryKey ?? [
    { agentFirmType, page, pageSize, search, sortBy, sortDirection },
  ]),
];
export type AgentDealControllerServiceGetAgentDealByUuidDefaultResponse =
  Awaited<ReturnType<typeof AgentDealControllerService.getAgentDealByUuid>>;
export type AgentDealControllerServiceGetAgentDealByUuidQueryResult<
  TData = AgentDealControllerServiceGetAgentDealByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentDealControllerServiceGetAgentDealByUuidKey =
  "AgentDealControllerServiceGetAgentDealByUuid";
export const UseAgentDealControllerServiceGetAgentDealByUuidKeyFn = (
  {
    agentDealUuid,
  }: {
    agentDealUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentDealControllerServiceGetAgentDealByUuidKey,
  ...(queryKey ?? [{ agentDealUuid }]),
];
export type AgentDealControllerServiceGetEmployersUnderBrokerDefaultResponse =
  Awaited<
    ReturnType<typeof AgentDealControllerService.getEmployersUnderBroker>
  >;
export type AgentDealControllerServiceGetEmployersUnderBrokerQueryResult<
  TData = AgentDealControllerServiceGetEmployersUnderBrokerDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentDealControllerServiceGetEmployersUnderBrokerKey =
  "AgentDealControllerServiceGetEmployersUnderBroker";
export const UseAgentDealControllerServiceGetEmployersUnderBrokerKeyFn = (
  {
    brokerUuid,
    commissionStatus,
    employerStatus,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    brokerUuid: string;
    commissionStatus?: string;
    employerStatus?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentDealControllerServiceGetEmployersUnderBrokerKey,
  ...(queryKey ?? [
    {
      brokerUuid,
      commissionStatus,
      employerStatus,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type AgentDealControllerServiceGetAgentDealsByAgentFirmUuidDefaultResponse =
  Awaited<
    ReturnType<typeof AgentDealControllerService.getAgentDealsByAgentFirmUuid>
  >;
export type AgentDealControllerServiceGetAgentDealsByAgentFirmUuidQueryResult<
  TData = AgentDealControllerServiceGetAgentDealsByAgentFirmUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentDealControllerServiceGetAgentDealsByAgentFirmUuidKey =
  "AgentDealControllerServiceGetAgentDealsByAgentFirmUuid";
export const UseAgentDealControllerServiceGetAgentDealsByAgentFirmUuidKeyFn = (
  {
    agentFirmUuid,
    deals,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    agentFirmUuid: string;
    deals?: ("FUTURE" | "ENDED" | "ONGOING")[];
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentDealControllerServiceGetAgentDealsByAgentFirmUuidKey,
  ...(queryKey ?? [
    { agentFirmUuid, deals, page, pageSize, sortBy, sortDirection },
  ]),
];
export type AgentDealControllerServiceGetAllAgentDealsDefaultResponse = Awaited<
  ReturnType<typeof AgentDealControllerService.getAllAgentDeals>
>;
export type AgentDealControllerServiceGetAllAgentDealsQueryResult<
  TData = AgentDealControllerServiceGetAllAgentDealsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentDealControllerServiceGetAllAgentDealsKey =
  "AgentDealControllerServiceGetAllAgentDeals";
export const UseAgentDealControllerServiceGetAllAgentDealsKeyFn = (
  {
    deals,
    employerUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    deals?: ("FUTURE" | "ENDED" | "ONGOING")[];
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAgentDealControllerServiceGetAllAgentDealsKey,
  ...(queryKey ?? [
    { deals, employerUuid, page, pageSize, sortBy, sortDirection },
  ]),
];
export type AffiliateGroupControllerServiceGetAffiliateGropByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof AffiliateGroupControllerService.getAffiliateGropByUuid>
  >;
export type AffiliateGroupControllerServiceGetAffiliateGropByUuidQueryResult<
  TData = AffiliateGroupControllerServiceGetAffiliateGropByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceGetAffiliateGropByUuidKey =
  "AffiliateGroupControllerServiceGetAffiliateGropByUuid";
export const UseAffiliateGroupControllerServiceGetAffiliateGropByUuidKeyFn = (
  {
    affiliateGroupUuid,
  }: {
    affiliateGroupUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAffiliateGroupControllerServiceGetAffiliateGropByUuidKey,
  ...(queryKey ?? [{ affiliateGroupUuid }]),
];
export type AffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AffiliateGroupControllerService.getAffiliateUsersByAffiliateGroupUuid
    >
  >;
export type AffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidQueryResult<
  TData =
    AffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidKey =
  "AffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuid";
export const UseAffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidKeyFn =
  (
    {
      affiliateGroupUuid,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      affiliateGroupUuid: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAffiliateGroupControllerServiceGetAffiliateUsersByAffiliateGroupUuidKey,
    ...(queryKey ?? [
      {
        affiliateGroupUuid,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      },
    ]),
  ];
export type AffiliateGroupControllerServiceDownloadAffiliateDataExcelDefaultResponse =
  Awaited<
    ReturnType<
      typeof AffiliateGroupControllerService.downloadAffiliateDataExcel
    >
  >;
export type AffiliateGroupControllerServiceDownloadAffiliateDataExcelQueryResult<
  TData =
    AffiliateGroupControllerServiceDownloadAffiliateDataExcelDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceDownloadAffiliateDataExcelKey =
  "AffiliateGroupControllerServiceDownloadAffiliateDataExcel";
export const UseAffiliateGroupControllerServiceDownloadAffiliateDataExcelKeyFn =
  (
    {
      affiliateGroupUuid,
    }: {
      affiliateGroupUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAffiliateGroupControllerServiceDownloadAffiliateDataExcelKey,
    ...(queryKey ?? [{ affiliateGroupUuid }]),
  ];
export type AffiliateGroupControllerServiceGetAffiliateUserByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof AffiliateGroupControllerService.getAffiliateUserByUuid>
  >;
export type AffiliateGroupControllerServiceGetAffiliateUserByUuidQueryResult<
  TData = AffiliateGroupControllerServiceGetAffiliateUserByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceGetAffiliateUserByUuidKey =
  "AffiliateGroupControllerServiceGetAffiliateUserByUuid";
export const UseAffiliateGroupControllerServiceGetAffiliateUserByUuidKeyFn = (
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAffiliateGroupControllerServiceGetAffiliateUserByUuidKey,
  ...(queryKey ?? [{ userUuid }]),
];
export type AffiliateGroupControllerServiceExportCsvForAffiliateDefaultResponse =
  Awaited<
    ReturnType<typeof AffiliateGroupControllerService.exportCsvForAffiliate>
  >;
export type AffiliateGroupControllerServiceExportCsvForAffiliateQueryResult<
  TData = AffiliateGroupControllerServiceExportCsvForAffiliateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceExportCsvForAffiliateKey =
  "AffiliateGroupControllerServiceExportCsvForAffiliate";
export const UseAffiliateGroupControllerServiceExportCsvForAffiliateKeyFn = (
  {
    searchString,
  }: {
    searchString?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAffiliateGroupControllerServiceExportCsvForAffiliateKey,
  ...(queryKey ?? [{ searchString }]),
];
export type AffiliateGroupControllerServiceGetAllAffiliatesDefaultResponse =
  Awaited<ReturnType<typeof AffiliateGroupControllerService.getAllAffiliates>>;
export type AffiliateGroupControllerServiceGetAllAffiliatesQueryResult<
  TData = AffiliateGroupControllerServiceGetAllAffiliatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAffiliateGroupControllerServiceGetAllAffiliatesKey =
  "AffiliateGroupControllerServiceGetAllAffiliates";
export const UseAffiliateGroupControllerServiceGetAllAffiliatesKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAffiliateGroupControllerServiceGetAllAffiliatesKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type AdminUserControllerServiceGetAdminUserByUuidDefaultResponse =
  Awaited<ReturnType<typeof AdminUserControllerService.getAdminUserByUuid>>;
export type AdminUserControllerServiceGetAdminUserByUuidQueryResult<
  TData = AdminUserControllerServiceGetAdminUserByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAdminUserControllerServiceGetAdminUserByUuidKey =
  "AdminUserControllerServiceGetAdminUserByUuid";
export const UseAdminUserControllerServiceGetAdminUserByUuidKeyFn = (
  {
    adminUserUuid,
  }: {
    adminUserUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAdminUserControllerServiceGetAdminUserByUuidKey,
  ...(queryKey ?? [{ adminUserUuid }]),
];
export type AdminUserControllerServiceGetSupersetDashBoardIdDefaultResponse =
  Awaited<ReturnType<typeof AdminUserControllerService.getSupersetDashBoardId>>;
export type AdminUserControllerServiceGetSupersetDashBoardIdQueryResult<
  TData = AdminUserControllerServiceGetSupersetDashBoardIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAdminUserControllerServiceGetSupersetDashBoardIdKey =
  "AdminUserControllerServiceGetSupersetDashBoardId";
export const UseAdminUserControllerServiceGetSupersetDashBoardIdKeyFn = (
  {
    dashboardType,
  }: {
    dashboardType:
      | "BROKER"
      | "EMPLOYER_ENROLLMENTS"
      | "RETAIL_PATIENT_ENROLLMENTS"
      | "PAYMENT_OVERVIEW"
      | "PATIENT_BILLING"
      | "PATIENT_BILLING_EMPLOYER"
      | "INVOICE_STATUS"
      | "INVOICE_STATUS_EMPLOYER"
      | "TOTAL_EMPLOYEES"
      | "EMPLOYEE_COUNT"
      | "TICKET_STATUS"
      | "MEMBERSHIP"
      | "TERMINATION"
      | "OUTSTANDING_INVOICE"
      | "INVOICE_REPORT"
      | "DEFERRED_REVENUE"
      | "RECEIVED_PAYMENTS"
      | "ENROLLMENTS"
      | "ABANDONED_SIGN_UP_ATTEMPTS"
      | "COUPONS_IN_USE"
      | "LEAD_SOURCES"
      | "BAD_DEBTS"
      | "CHURN_REPORTS"
      | "EMPLOYERS"
      | "AFFILIATES"
      | "PATIENT_CATEGORIES"
      | "APPOINTMENT_STATUS_TYPE"
      | "UTILIZATION_ENGAGEMENT"
      | "HEALTH_TRENDS_DIAGNOSIS"
      | "CLINIC_PROVIDER_ACTIVITY"
      | "SAVINGS_REPORT"
      | "REFERRALS_ORDERS"
      | "PHARMACY_INVENTORY"
      | "EXPIRING_MEDICATIONS";
  },
  queryKey?: Array<unknown>,
) => [
  useAdminUserControllerServiceGetSupersetDashBoardIdKey,
  ...(queryKey ?? [{ dashboardType }]),
];
export type AdminUserControllerServiceGetUserDetailsDefaultResponse = Awaited<
  ReturnType<typeof AdminUserControllerService.getUserDetails>
>;
export type AdminUserControllerServiceGetUserDetailsQueryResult<
  TData = AdminUserControllerServiceGetUserDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAdminUserControllerServiceGetUserDetailsKey =
  "AdminUserControllerServiceGetUserDetails";
export const UseAdminUserControllerServiceGetUserDetailsKeyFn = (
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAdminUserControllerServiceGetUserDetailsKey,
  ...(queryKey ?? [{ userUuid }]),
];
export type AdminUserControllerServiceGetProfile2DefaultResponse = Awaited<
  ReturnType<typeof AdminUserControllerService.getProfile2>
>;
export type AdminUserControllerServiceGetProfile2QueryResult<
  TData = AdminUserControllerServiceGetProfile2DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAdminUserControllerServiceGetProfile2Key =
  "AdminUserControllerServiceGetProfile2";
export const UseAdminUserControllerServiceGetProfile2KeyFn = (
  queryKey?: Array<unknown>,
) => [useAdminUserControllerServiceGetProfile2Key, ...(queryKey ?? [])];
export type AdminUserControllerServiceGetAllAdminUsersDefaultResponse = Awaited<
  ReturnType<typeof AdminUserControllerService.getAllAdminUsers>
>;
export type AdminUserControllerServiceGetAllAdminUsersQueryResult<
  TData = AdminUserControllerServiceGetAllAdminUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAdminUserControllerServiceGetAllAdminUsersKey =
  "AdminUserControllerServiceGetAllAdminUsers";
export const UseAdminUserControllerServiceGetAllAdminUsersKeyFn = (
  {
    archive,
    notification,
    page,
    pageSize,
    roleName,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    notification?: boolean;
    page?: number;
    pageSize?: number;
    roleName?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAdminUserControllerServiceGetAllAdminUsersKey,
  ...(queryKey ?? [
    {
      archive,
      notification,
      page,
      pageSize,
      roleName,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type SupervisingProviderRequestControllerServiceGetIncomingRequestsDefaultResponse =
  Awaited<
    ReturnType<
      typeof SupervisingProviderRequestControllerService.getIncomingRequests
    >
  >;
export type SupervisingProviderRequestControllerServiceGetIncomingRequestsQueryResult<
  TData =
    SupervisingProviderRequestControllerServiceGetIncomingRequestsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSupervisingProviderRequestControllerServiceGetIncomingRequestsKey =
  "SupervisingProviderRequestControllerServiceGetIncomingRequests";
export const UseSupervisingProviderRequestControllerServiceGetIncomingRequestsKeyFn =
  (
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
      status,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
      status?: "PENDING" | "EXPIRED" | "APPROVED" | "DENIED" | "REVOKED";
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useSupervisingProviderRequestControllerServiceGetIncomingRequestsKey,
    ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection, status }]),
  ];
export type SupervisingProviderRequestControllerServiceGetApprovedProvidersDefaultResponse =
  Awaited<
    ReturnType<
      typeof SupervisingProviderRequestControllerService.getApprovedProviders
    >
  >;
export type SupervisingProviderRequestControllerServiceGetApprovedProvidersQueryResult<
  TData =
    SupervisingProviderRequestControllerServiceGetApprovedProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSupervisingProviderRequestControllerServiceGetApprovedProvidersKey =
  "SupervisingProviderRequestControllerServiceGetApprovedProviders";
export const UseSupervisingProviderRequestControllerServiceGetApprovedProvidersKeyFn =
  (
    {
      nurseStaffProviderUuid,
    }: {
      nurseStaffProviderUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useSupervisingProviderRequestControllerServiceGetApprovedProvidersKey,
    ...(queryKey ?? [{ nurseStaffProviderUuid }]),
  ];
export type ShareCardControllerServiceGetSharedCardsByUserDefaultResponse =
  Awaited<ReturnType<typeof ShareCardControllerService.getSharedCardsByUser>>;
export type ShareCardControllerServiceGetSharedCardsByUserQueryResult<
  TData = ShareCardControllerServiceGetSharedCardsByUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useShareCardControllerServiceGetSharedCardsByUserKey =
  "ShareCardControllerServiceGetSharedCardsByUser";
export const UseShareCardControllerServiceGetSharedCardsByUserKeyFn = (
  {
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useShareCardControllerServiceGetSharedCardsByUserKey,
  ...(queryKey ?? [{ page, size, sort, userTypes, uuid }]),
];
export type ShareCardControllerServiceGetSharedCardCustomersDefaultResponse =
  Awaited<ReturnType<typeof ShareCardControllerService.getSharedCardCustomers>>;
export type ShareCardControllerServiceGetSharedCardCustomersQueryResult<
  TData = ShareCardControllerServiceGetSharedCardCustomersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useShareCardControllerServiceGetSharedCardCustomersKey =
  "ShareCardControllerServiceGetSharedCardCustomers";
export const UseShareCardControllerServiceGetSharedCardCustomersKeyFn = (
  {
    page,
    savedCardUuid,
    size,
    sort,
  }: {
    page?: number;
    savedCardUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useShareCardControllerServiceGetSharedCardCustomersKey,
  ...(queryKey ?? [{ page, savedCardUuid, size, sort }]),
];
export type ShareCardControllerServiceGetSharedCardsByUser1DefaultResponse =
  Awaited<ReturnType<typeof ShareCardControllerService.getSharedCardsByUser1>>;
export type ShareCardControllerServiceGetSharedCardsByUser1QueryResult<
  TData = ShareCardControllerServiceGetSharedCardsByUser1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useShareCardControllerServiceGetSharedCardsByUser1Key =
  "ShareCardControllerServiceGetSharedCardsByUser1";
export const UseShareCardControllerServiceGetSharedCardsByUser1KeyFn = (
  {
    page,
    size,
    sort,
    userUuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useShareCardControllerServiceGetSharedCardsByUser1Key,
  ...(queryKey ?? [{ page, size, sort, userUuid }]),
];
export type ShareBankControllerServiceGetSharedBanksByUserDefaultResponse =
  Awaited<ReturnType<typeof ShareBankControllerService.getSharedBanksByUser>>;
export type ShareBankControllerServiceGetSharedBanksByUserQueryResult<
  TData = ShareBankControllerServiceGetSharedBanksByUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useShareBankControllerServiceGetSharedBanksByUserKey =
  "ShareBankControllerServiceGetSharedBanksByUser";
export const UseShareBankControllerServiceGetSharedBanksByUserKeyFn = (
  {
    page,
    size,
    sort,
    userTypes,
    uuid,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useShareBankControllerServiceGetSharedBanksByUserKey,
  ...(queryKey ?? [{ page, size, sort, userTypes, uuid }]),
];
export type ShareBankControllerServiceGetSharedBankCustomersDefaultResponse =
  Awaited<ReturnType<typeof ShareBankControllerService.getSharedBankCustomers>>;
export type ShareBankControllerServiceGetSharedBankCustomersQueryResult<
  TData = ShareBankControllerServiceGetSharedBankCustomersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useShareBankControllerServiceGetSharedBankCustomersKey =
  "ShareBankControllerServiceGetSharedBankCustomers";
export const UseShareBankControllerServiceGetSharedBankCustomersKeyFn = (
  {
    page,
    savedBankAccountUuid,
    size,
    sort,
  }: {
    page?: number;
    savedBankAccountUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useShareBankControllerServiceGetSharedBankCustomersKey,
  ...(queryKey ?? [{ page, savedBankAccountUuid, size, sort }]),
];
export type ProviderCoverageControllerServiceGetCoveragesDefaultResponse =
  Awaited<ReturnType<typeof ProviderCoverageControllerService.getCoverages>>;
export type ProviderCoverageControllerServiceGetCoveragesQueryResult<
  TData = ProviderCoverageControllerServiceGetCoveragesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderCoverageControllerServiceGetCoveragesKey =
  "ProviderCoverageControllerServiceGetCoverages";
export const UseProviderCoverageControllerServiceGetCoveragesKeyFn = (
  {
    direction,
    page,
    pageSize,
    sortBy,
    sortDirection,
    status,
  }: {
    direction?: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    status?: "PENDING" | "EXPIRED" | "APPROVED" | "DENIED" | "REVOKED";
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderCoverageControllerServiceGetCoveragesKey,
  ...(queryKey ?? [
    { direction, page, pageSize, sortBy, sortDirection, status },
  ]),
];
export type ProviderCoverageControllerServiceGetUrgentMessageAlertDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderCoverageControllerService.getUrgentMessageAlert>
  >;
export type ProviderCoverageControllerServiceGetUrgentMessageAlertQueryResult<
  TData = ProviderCoverageControllerServiceGetUrgentMessageAlertDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderCoverageControllerServiceGetUrgentMessageAlertKey =
  "ProviderCoverageControllerServiceGetUrgentMessageAlert";
export const UseProviderCoverageControllerServiceGetUrgentMessageAlertKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useProviderCoverageControllerServiceGetUrgentMessageAlertKey,
  ...(queryKey ?? []),
];
export type ProviderCoverageControllerServiceGetCoverageByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderCoverageControllerService.getCoverageByUuid>
  >;
export type ProviderCoverageControllerServiceGetCoverageByUuidQueryResult<
  TData = ProviderCoverageControllerServiceGetCoverageByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderCoverageControllerServiceGetCoverageByUuidKey =
  "ProviderCoverageControllerServiceGetCoverageByUuid";
export const UseProviderCoverageControllerServiceGetCoverageByUuidKeyFn = (
  {
    coverageUuid,
  }: {
    coverageUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useProviderCoverageControllerServiceGetCoverageByUuidKey,
  ...(queryKey ?? [{ coverageUuid }]),
];
export type ProviderCoverageControllerServiceGetActiveCoverageDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderCoverageControllerService.getActiveCoverage>
  >;
export type ProviderCoverageControllerServiceGetActiveCoverageQueryResult<
  TData = ProviderCoverageControllerServiceGetActiveCoverageDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderCoverageControllerServiceGetActiveCoverageKey =
  "ProviderCoverageControllerServiceGetActiveCoverage";
export const UseProviderCoverageControllerServiceGetActiveCoverageKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useProviderCoverageControllerServiceGetActiveCoverageKey,
  ...(queryKey ?? []),
];
export type PdfControllerServiceGetLabPdfByPatientDefaultResponse = Awaited<
  ReturnType<typeof PdfControllerService.getLabPdfByPatient>
>;
export type PdfControllerServiceGetLabPdfByPatientQueryResult<
  TData = PdfControllerServiceGetLabPdfByPatientDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePdfControllerServiceGetLabPdfByPatientKey =
  "PdfControllerServiceGetLabPdfByPatient";
export const UsePdfControllerServiceGetLabPdfByPatientKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePdfControllerServiceGetLabPdfByPatientKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type AgentPayoutServiceGetPayoutBankAccountsDefaultResponse = Awaited<
  ReturnType<typeof AgentPayoutService.getPayoutBankAccounts>
>;
export type AgentPayoutServiceGetPayoutBankAccountsQueryResult<
  TData = AgentPayoutServiceGetPayoutBankAccountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgentPayoutServiceGetPayoutBankAccountsKey =
  "AgentPayoutServiceGetPayoutBankAccounts";
export const UseAgentPayoutServiceGetPayoutBankAccountsKeyFn = (
  {
    userTypes,
    userUuid,
  }: {
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgentPayoutServiceGetPayoutBankAccountsKey,
  ...(queryKey ?? [{ userTypes, userUuid }]),
];
export type InventoryOrderControllerServiceGetAllInventoryDefaultResponse =
  Awaited<ReturnType<typeof InventoryOrderControllerService.getAllInventory>>;
export type InventoryOrderControllerServiceGetAllInventoryQueryResult<
  TData = InventoryOrderControllerServiceGetAllInventoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceGetAllInventoryKey =
  "InventoryOrderControllerServiceGetAllInventory";
export const UseInventoryOrderControllerServiceGetAllInventoryKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInventoryOrderControllerServiceGetAllInventoryKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type InventoryOrderControllerServiceLocationBasedFormularyDefaultResponse =
  Awaited<
    ReturnType<typeof InventoryOrderControllerService.locationBasedFormulary>
  >;
export type InventoryOrderControllerServiceLocationBasedFormularyQueryResult<
  TData = InventoryOrderControllerServiceLocationBasedFormularyDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceLocationBasedFormularyKey =
  "InventoryOrderControllerServiceLocationBasedFormulary";
export const UseInventoryOrderControllerServiceLocationBasedFormularyKeyFn = (
  {
    locationUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    locationUuid?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInventoryOrderControllerServiceLocationBasedFormularyKey,
  ...(queryKey ?? [
    { locationUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type InventoryOrderControllerServiceExportLocationBasedInventoryCsvDefaultResponse =
  Awaited<
    ReturnType<
      typeof InventoryOrderControllerService.exportLocationBasedInventoryCsv
    >
  >;
export type InventoryOrderControllerServiceExportLocationBasedInventoryCsvQueryResult<
  TData =
    InventoryOrderControllerServiceExportLocationBasedInventoryCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceExportLocationBasedInventoryCsvKey =
  "InventoryOrderControllerServiceExportLocationBasedInventoryCsv";
export const UseInventoryOrderControllerServiceExportLocationBasedInventoryCsvKeyFn =
  (queryKey?: Array<unknown>) => [
    useInventoryOrderControllerServiceExportLocationBasedInventoryCsvKey,
    ...(queryKey ?? []),
  ];
export type InventoryOrderControllerServiceExportInventoryCsvDefaultResponse =
  Awaited<
    ReturnType<typeof InventoryOrderControllerService.exportInventoryCsv>
  >;
export type InventoryOrderControllerServiceExportInventoryCsvQueryResult<
  TData = InventoryOrderControllerServiceExportInventoryCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceExportInventoryCsvKey =
  "InventoryOrderControllerServiceExportInventoryCsv";
export const UseInventoryOrderControllerServiceExportInventoryCsvKeyFn = (
  {
    formulary,
  }: {
    formulary?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInventoryOrderControllerServiceExportInventoryCsvKey,
  ...(queryKey ?? [{ formulary }]),
];
export type InventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberDefaultResponse =
  Awaited<
    ReturnType<
      typeof InventoryOrderControllerService.getAllShipmentMedicationByInvoiceNumber
    >
  >;
export type InventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberQueryResult<
  TData =
    InventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberKey =
  "InventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumber";
export const UseInventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberKeyFn =
  (
    {
      invoiceId,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      invoiceId?: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useInventoryOrderControllerServiceGetAllShipmentMedicationByInvoiceNumberKey,
    ...(queryKey ?? [
      { invoiceId, page, pageSize, searchString, sortBy, sortDirection },
    ]),
  ];
export type InventoryOrderControllerServiceGetAllShipmentDefaultResponse =
  Awaited<ReturnType<typeof InventoryOrderControllerService.getAllShipment>>;
export type InventoryOrderControllerServiceGetAllShipmentQueryResult<
  TData = InventoryOrderControllerServiceGetAllShipmentDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceGetAllShipmentKey =
  "InventoryOrderControllerServiceGetAllShipment";
export const UseInventoryOrderControllerServiceGetAllShipmentKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInventoryOrderControllerServiceGetAllShipmentKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
];
export type InventoryOrderControllerServiceGetAllOrderDefaultResponse = Awaited<
  ReturnType<typeof InventoryOrderControllerService.getAllOrder>
>;
export type InventoryOrderControllerServiceGetAllOrderQueryResult<
  TData = InventoryOrderControllerServiceGetAllOrderDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInventoryOrderControllerServiceGetAllOrderKey =
  "InventoryOrderControllerServiceGetAllOrder";
export const UseInventoryOrderControllerServiceGetAllOrderKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInventoryOrderControllerServiceGetAllOrderKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type GoogleMapsControllerServiceGetAllShareLinksDefaultResponse =
  Awaited<ReturnType<typeof GoogleMapsControllerService.getAllShareLinks>>;
export type GoogleMapsControllerServiceGetAllShareLinksQueryResult<
  TData = GoogleMapsControllerServiceGetAllShareLinksDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGoogleMapsControllerServiceGetAllShareLinksKey =
  "GoogleMapsControllerServiceGetAllShareLinks";
export const UseGoogleMapsControllerServiceGetAllShareLinksKeyFn = (
  {
    active,
    page,
    search,
    size,
    sort,
  }: {
    active?: boolean;
    page?: number;
    search?: string;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useGoogleMapsControllerServiceGetAllShareLinksKey,
  ...(queryKey ?? [{ active, page, search, size, sort }]),
];
export type GoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateDefaultResponse =
  Awaited<
    ReturnType<
      typeof GoogleMapsControllerService.downloadPatientZipcodeCsvTemplate
    >
  >;
export type GoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateQueryResult<
  TData =
    GoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateKey =
  "GoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplate";
export const UseGoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateKeyFn =
  (queryKey?: Array<unknown>) => [
    useGoogleMapsControllerServiceDownloadPatientZipcodeCsvTemplateKey,
    ...(queryKey ?? []),
  ];
export type GoogleMapsControllerServiceGetMapDataDefaultResponse = Awaited<
  ReturnType<typeof GoogleMapsControllerService.getMapData>
>;
export type GoogleMapsControllerServiceGetMapDataQueryResult<
  TData = GoogleMapsControllerServiceGetMapDataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGoogleMapsControllerServiceGetMapDataKey =
  "GoogleMapsControllerServiceGetMapData";
export const UseGoogleMapsControllerServiceGetMapDataKeyFn = (
  {
    employerUuid,
    onlyPhp,
    shareToken,
    uploadBatchUuid,
  }: {
    employerUuid?: string;
    onlyPhp?: boolean;
    shareToken?: string;
    uploadBatchUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useGoogleMapsControllerServiceGetMapDataKey,
  ...(queryKey ?? [{ employerUuid, onlyPhp, shareToken, uploadBatchUuid }]),
];
export type CsvControllerServiceGetEmployeeUploadTemplateDefaultResponse =
  Awaited<ReturnType<typeof CsvControllerService.getEmployeeUploadTemplate>>;
export type CsvControllerServiceGetEmployeeUploadTemplateQueryResult<
  TData = CsvControllerServiceGetEmployeeUploadTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCsvControllerServiceGetEmployeeUploadTemplateKey =
  "CsvControllerServiceGetEmployeeUploadTemplate";
export const UseCsvControllerServiceGetEmployeeUploadTemplateKeyFn = (
  queryKey?: Array<unknown>,
) => [useCsvControllerServiceGetEmployeeUploadTemplateKey, ...(queryKey ?? [])];
export type CsvControllerServiceDownloadExcelTemplateDefaultResponse = Awaited<
  ReturnType<typeof CsvControllerService.downloadExcelTemplate>
>;
export type CsvControllerServiceDownloadExcelTemplateQueryResult<
  TData = CsvControllerServiceDownloadExcelTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCsvControllerServiceDownloadExcelTemplateKey =
  "CsvControllerServiceDownloadExcelTemplate";
export const UseCsvControllerServiceDownloadExcelTemplateKeyFn = (
  queryKey?: Array<unknown>,
) => [useCsvControllerServiceDownloadExcelTemplateKey, ...(queryKey ?? [])];
export type CsvControllerServiceDownloadCsvTemplateDefaultResponse = Awaited<
  ReturnType<typeof CsvControllerService.downloadCsvTemplate>
>;
export type CsvControllerServiceDownloadCsvTemplateQueryResult<
  TData = CsvControllerServiceDownloadCsvTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCsvControllerServiceDownloadCsvTemplateKey =
  "CsvControllerServiceDownloadCsvTemplate";
export const UseCsvControllerServiceDownloadCsvTemplateKeyFn = (
  queryKey?: Array<unknown>,
) => [useCsvControllerServiceDownloadCsvTemplateKey, ...(queryKey ?? [])];
export type CsvControllerServiceGetCsvTemplateAsFileDefaultResponse = Awaited<
  ReturnType<typeof CsvControllerService.getCsvTemplateAsFile>
>;
export type CsvControllerServiceGetCsvTemplateAsFileQueryResult<
  TData = CsvControllerServiceGetCsvTemplateAsFileDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCsvControllerServiceGetCsvTemplateAsFileKey =
  "CsvControllerServiceGetCsvTemplateAsFile";
export const UseCsvControllerServiceGetCsvTemplateAsFileKeyFn = (
  queryKey?: Array<unknown>,
) => [useCsvControllerServiceGetCsvTemplateAsFileKey, ...(queryKey ?? [])];
export type CartControllerServiceGetAllCartsDefaultResponse = Awaited<
  ReturnType<typeof CartControllerService.getAllCarts>
>;
export type CartControllerServiceGetAllCartsQueryResult<
  TData = CartControllerServiceGetAllCartsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCartControllerServiceGetAllCartsKey =
  "CartControllerServiceGetAllCarts";
export const UseCartControllerServiceGetAllCartsKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCartControllerServiceGetAllCartsKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
];
export type VideoControllerServiceJitsiTokenDefaultResponse = Awaited<
  ReturnType<typeof VideoControllerService.jitsiToken>
>;
export type VideoControllerServiceJitsiTokenQueryResult<
  TData = VideoControllerServiceJitsiTokenDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVideoControllerServiceJitsiTokenKey =
  "VideoControllerServiceJitsiToken";
export const UseVideoControllerServiceJitsiTokenKeyFn = (
  {
    room,
  }: {
    room?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [useVideoControllerServiceJitsiTokenKey, ...(queryKey ?? [{ room }])];
export type SpecialityControllerServiceGetAllSpecialitiesDefaultResponse =
  Awaited<ReturnType<typeof SpecialityControllerService.getAllSpecialities>>;
export type SpecialityControllerServiceGetAllSpecialitiesQueryResult<
  TData = SpecialityControllerServiceGetAllSpecialitiesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSpecialityControllerServiceGetAllSpecialitiesKey =
  "SpecialityControllerServiceGetAllSpecialities";
export const UseSpecialityControllerServiceGetAllSpecialitiesKeyFn = (
  {
    page,
    size,
    sort,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useSpecialityControllerServiceGetAllSpecialitiesKey,
  ...(queryKey ?? [{ page, size, sort }]),
];
export type PhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesDefaultResponse =
  Awaited<
    ReturnType<
      typeof PhysicianAccountTypeControllerService.getAllPhysicianAccountTypes
    >
  >;
export type PhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesQueryResult<
  TData =
    PhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesKey =
  "PhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypes";
export const UsePhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesKeyFn =
  (
    {
      page,
      size,
      sort,
    }: {
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    usePhysicianAccountTypeControllerServiceGetAllPhysicianAccountTypesKey,
    ...(queryKey ?? [{ page, size, sort }]),
  ];
export type EmailHistoryControllerServiceGetEmailHistoryByUserDefaultResponse =
  Awaited<
    ReturnType<typeof EmailHistoryControllerService.getEmailHistoryByUser>
  >;
export type EmailHistoryControllerServiceGetEmailHistoryByUserQueryResult<
  TData = EmailHistoryControllerServiceGetEmailHistoryByUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmailHistoryControllerServiceGetEmailHistoryByUserKey =
  "EmailHistoryControllerServiceGetEmailHistoryByUser";
export const UseEmailHistoryControllerServiceGetEmailHistoryByUserKeyFn = (
  {
    page,
    pageSize,
    read,
    userId,
  }: {
    page?: number;
    pageSize?: number;
    read?: boolean;
    userId: string;
  },
  queryKey?: Array<unknown>,
) => [
  useEmailHistoryControllerServiceGetEmailHistoryByUserKey,
  ...(queryKey ?? [{ page, pageSize, read, userId }]),
];
export type DashboardControllerServiceGetEmployerManagementStatsDefaultResponse =
  Awaited<
    ReturnType<typeof DashboardControllerService.getEmployerManagementStats>
  >;
export type DashboardControllerServiceGetEmployerManagementStatsQueryResult<
  TData = DashboardControllerServiceGetEmployerManagementStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetEmployerManagementStatsKey =
  "DashboardControllerServiceGetEmployerManagementStats";
export const UseDashboardControllerServiceGetEmployerManagementStatsKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetEmployerManagementStatsKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type DashboardControllerServiceGetAffiliateStatsDefaultResponse =
  Awaited<ReturnType<typeof DashboardControllerService.getAffiliateStats>>;
export type DashboardControllerServiceGetAffiliateStatsQueryResult<
  TData = DashboardControllerServiceGetAffiliateStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetAffiliateStatsKey =
  "DashboardControllerServiceGetAffiliateStats";
export const UseDashboardControllerServiceGetAffiliateStatsKeyFn = (
  queryKey?: Array<unknown>,
) => [useDashboardControllerServiceGetAffiliateStatsKey, ...(queryKey ?? [])];
export type DashboardControllerServiceGetAffiliatePortalStatsDefaultResponse =
  Awaited<
    ReturnType<typeof DashboardControllerService.getAffiliatePortalStats>
  >;
export type DashboardControllerServiceGetAffiliatePortalStatsQueryResult<
  TData = DashboardControllerServiceGetAffiliatePortalStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetAffiliatePortalStatsKey =
  "DashboardControllerServiceGetAffiliatePortalStats";
export const UseDashboardControllerServiceGetAffiliatePortalStatsKeyFn = (
  {
    affliateUuid,
  }: {
    affliateUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetAffiliatePortalStatsKey,
  ...(queryKey ?? [{ affliateUuid }]),
];
export type DashboardControllerServiceGetPendingItemsDefaultResponse = Awaited<
  ReturnType<typeof DashboardControllerService.getPendingItems>
>;
export type DashboardControllerServiceGetPendingItemsQueryResult<
  TData = DashboardControllerServiceGetPendingItemsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetPendingItemsKey =
  "DashboardControllerServiceGetPendingItems";
export const UseDashboardControllerServiceGetPendingItemsKeyFn = (
  {
    assignedByUuids,
    assignedToUuids,
    categoryUuids,
    page,
    pageSize,
    providerUuids,
    resolved,
    sortBy,
    sortDirection,
    userUuid,
  }: {
    assignedByUuids?: string[];
    assignedToUuids?: string[];
    categoryUuids?: string[];
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    resolved?: boolean;
    sortBy?: string;
    sortDirection?: string;
    userUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetPendingItemsKey,
  ...(queryKey ?? [
    {
      assignedByUuids,
      assignedToUuids,
      categoryUuids,
      page,
      pageSize,
      providerUuids,
      resolved,
      sortBy,
      sortDirection,
      userUuid,
    },
  ]),
];
export type DashboardControllerServiceGetPendingFormsCountDefaultResponse =
  Awaited<ReturnType<typeof DashboardControllerService.getPendingFormsCount>>;
export type DashboardControllerServiceGetPendingFormsCountQueryResult<
  TData = DashboardControllerServiceGetPendingFormsCountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetPendingFormsCountKey =
  "DashboardControllerServiceGetPendingFormsCount";
export const UseDashboardControllerServiceGetPendingFormsCountKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetPendingFormsCountKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type DashboardControllerServiceGetPatientReportsDefaultResponse =
  Awaited<ReturnType<typeof DashboardControllerService.getPatientReports>>;
export type DashboardControllerServiceGetPatientReportsQueryResult<
  TData = DashboardControllerServiceGetPatientReportsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetPatientReportsKey =
  "DashboardControllerServiceGetPatientReports";
export const UseDashboardControllerServiceGetPatientReportsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    status,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetPatientReportsKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, status }]),
];
export type DashboardControllerServiceGetPatientPortalCountsDefaultResponse =
  Awaited<ReturnType<typeof DashboardControllerService.getPatientPortalCounts>>;
export type DashboardControllerServiceGetPatientPortalCountsQueryResult<
  TData = DashboardControllerServiceGetPatientPortalCountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetPatientPortalCountsKey =
  "DashboardControllerServiceGetPatientPortalCounts";
export const UseDashboardControllerServiceGetPatientPortalCountsKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetPatientPortalCountsKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type DashboardControllerServiceGetMessegeInfoDefaultResponse = Awaited<
  ReturnType<typeof DashboardControllerService.getMessegeInfo>
>;
export type DashboardControllerServiceGetMessegeInfoQueryResult<
  TData = DashboardControllerServiceGetMessegeInfoDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetMessegeInfoKey =
  "DashboardControllerServiceGetMessegeInfo";
export const UseDashboardControllerServiceGetMessegeInfoKeyFn = (
  {
    locationUuid,
    providerUuids,
  }: {
    locationUuid?: string;
    providerUuids?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetMessegeInfoKey,
  ...(queryKey ?? [{ locationUuid, providerUuids }]),
];
export type DashboardControllerServiceGetLabAndImagingResultsDefaultResponse =
  Awaited<
    ReturnType<typeof DashboardControllerService.getLabAndImagingResults>
  >;
export type DashboardControllerServiceGetLabAndImagingResultsQueryResult<
  TData = DashboardControllerServiceGetLabAndImagingResultsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDashboardControllerServiceGetLabAndImagingResultsKey =
  "DashboardControllerServiceGetLabAndImagingResults";
export const UseDashboardControllerServiceGetLabAndImagingResultsKeyFn = (
  {
    locationUuids,
    page,
    pageSize,
    patientUuid,
    providerUuids,
    status,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    providerUuids?: string[];
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useDashboardControllerServiceGetLabAndImagingResultsKey,
  ...(queryKey ?? [
    { locationUuids, page, pageSize, patientUuid, providerUuids, status },
  ]),
];
export type WorkNoteControllerServiceGetWorkNoteByUuidDefaultResponse = Awaited<
  ReturnType<typeof WorkNoteControllerService.getWorkNoteByUuid>
>;
export type WorkNoteControllerServiceGetWorkNoteByUuidQueryResult<
  TData = WorkNoteControllerServiceGetWorkNoteByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useWorkNoteControllerServiceGetWorkNoteByUuidKey =
  "WorkNoteControllerServiceGetWorkNoteByUuid";
export const UseWorkNoteControllerServiceGetWorkNoteByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useWorkNoteControllerServiceGetWorkNoteByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type WorkNoteControllerServiceGetAllWorkNotesDefaultResponse = Awaited<
  ReturnType<typeof WorkNoteControllerService.getAllWorkNotes>
>;
export type WorkNoteControllerServiceGetAllWorkNotesQueryResult<
  TData = WorkNoteControllerServiceGetAllWorkNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useWorkNoteControllerServiceGetAllWorkNotesKey =
  "WorkNoteControllerServiceGetAllWorkNotes";
export const UseWorkNoteControllerServiceGetAllWorkNotesKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useWorkNoteControllerServiceGetAllWorkNotesKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type VitalControllerServiceGetVitalByUuidDefaultResponse = Awaited<
  ReturnType<typeof VitalControllerService.getVitalByUuid>
>;
export type VitalControllerServiceGetVitalByUuidQueryResult<
  TData = VitalControllerServiceGetVitalByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVitalControllerServiceGetVitalByUuidKey =
  "VitalControllerServiceGetVitalByUuid";
export const UseVitalControllerServiceGetVitalByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [useVitalControllerServiceGetVitalByUuidKey, ...(queryKey ?? [{ uuid }])];
export type VitalControllerServiceGetAllVitalsDefaultResponse = Awaited<
  ReturnType<typeof VitalControllerService.getAllVitals>
>;
export type VitalControllerServiceGetAllVitalsQueryResult<
  TData = VitalControllerServiceGetAllVitalsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVitalControllerServiceGetAllVitalsKey =
  "VitalControllerServiceGetAllVitals";
export const UseVitalControllerServiceGetAllVitalsKeyFn = (
  {
    draft,
    endDate,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    startDate,
  }: {
    draft?: boolean;
    endDate?: string;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useVitalControllerServiceGetAllVitalsKey,
  ...(queryKey ?? [
    {
      draft,
      endDate,
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
      startDate,
    },
  ]),
];
export type VaccineControllerServiceGetVaccineByUuidDefaultResponse = Awaited<
  ReturnType<typeof VaccineControllerService.getVaccineByUuid>
>;
export type VaccineControllerServiceGetVaccineByUuidQueryResult<
  TData = VaccineControllerServiceGetVaccineByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVaccineControllerServiceGetVaccineByUuidKey =
  "VaccineControllerServiceGetVaccineByUuid";
export const UseVaccineControllerServiceGetVaccineByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useVaccineControllerServiceGetVaccineByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type VaccineControllerServiceGetAllVaccinesDefaultResponse = Awaited<
  ReturnType<typeof VaccineControllerService.getAllVaccines>
>;
export type VaccineControllerServiceGetAllVaccinesQueryResult<
  TData = VaccineControllerServiceGetAllVaccinesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVaccineControllerServiceGetAllVaccinesKey =
  "VaccineControllerServiceGetAllVaccines";
export const UseVaccineControllerServiceGetAllVaccinesKeyFn = (
  {
    page,
    pageSize,
    type,
  }: {
    page?: number;
    pageSize?: number;
    type?: "ADULT" | "CHILD";
  } = {},
  queryKey?: Array<unknown>,
) => [
  useVaccineControllerServiceGetAllVaccinesKey,
  ...(queryKey ?? [{ page, pageSize, type }]),
];
export type TaskControllerServiceGetTaskByUuidDefaultResponse = Awaited<
  ReturnType<typeof TaskControllerService.getTaskByUuid>
>;
export type TaskControllerServiceGetTaskByUuidQueryResult<
  TData = TaskControllerServiceGetTaskByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskControllerServiceGetTaskByUuidKey =
  "TaskControllerServiceGetTaskByUuid";
export const UseTaskControllerServiceGetTaskByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [useTaskControllerServiceGetTaskByUuidKey, ...(queryKey ?? [{ uuid }])];
export type TaskControllerServiceHasUnresolvedTaskForThreadDefaultResponse =
  Awaited<ReturnType<typeof TaskControllerService.hasUnresolvedTaskForThread>>;
export type TaskControllerServiceHasUnresolvedTaskForThreadQueryResult<
  TData = TaskControllerServiceHasUnresolvedTaskForThreadDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskControllerServiceHasUnresolvedTaskForThreadKey =
  "TaskControllerServiceHasUnresolvedTaskForThread";
export const UseTaskControllerServiceHasUnresolvedTaskForThreadKeyFn = (
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTaskControllerServiceHasUnresolvedTaskForThreadKey,
  ...(queryKey ?? [{ threadUuid }]),
];
export type TaskControllerServiceGetAllTasksDefaultResponse = Awaited<
  ReturnType<typeof TaskControllerService.getAllTasks>
>;
export type TaskControllerServiceGetAllTasksQueryResult<
  TData = TaskControllerServiceGetAllTasksDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskControllerServiceGetAllTasksKey =
  "TaskControllerServiceGetAllTasks";
export const UseTaskControllerServiceGetAllTasksKeyFn = (
  {
    assignedByUuids,
    assignedToUuids,
    categoryUuids,
    createdEndDate,
    createdStartDate,
    dueEndDate,
    dueStartDate,
    flag,
    locationUuid,
    matchAll,
    page,
    pageSize,
    patientUuids,
    priorities,
    resolved,
    searchString,
    sortBy,
    sortDirection,
  }: {
    assignedByUuids?: string[];
    assignedToUuids?: string[];
    categoryUuids?: string[];
    createdEndDate?: string;
    createdStartDate?: string;
    dueEndDate?: string;
    dueStartDate?: string;
    flag?: boolean;
    locationUuid?: string;
    matchAll?: boolean;
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    priorities?: ("URGENT" | "REGULAR")[];
    resolved?: boolean;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTaskControllerServiceGetAllTasksKey,
  ...(queryKey ?? [
    {
      assignedByUuids,
      assignedToUuids,
      categoryUuids,
      createdEndDate,
      createdStartDate,
      dueEndDate,
      dueStartDate,
      flag,
      locationUuid,
      matchAll,
      page,
      pageSize,
      patientUuids,
      priorities,
      resolved,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type StatusConfigurationControllerServiceGetStatusConfigurationByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof StatusConfigurationControllerService.getStatusConfigurationByUuid
    >
  >;
export type StatusConfigurationControllerServiceGetStatusConfigurationByUuidQueryResult<
  TData =
    StatusConfigurationControllerServiceGetStatusConfigurationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStatusConfigurationControllerServiceGetStatusConfigurationByUuidKey =
  "StatusConfigurationControllerServiceGetStatusConfigurationByUuid";
export const UseStatusConfigurationControllerServiceGetStatusConfigurationByUuidKeyFn =
  (
    {
      statusConfigurationUuid,
    }: {
      statusConfigurationUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useStatusConfigurationControllerServiceGetStatusConfigurationByUuidKey,
    ...(queryKey ?? [{ statusConfigurationUuid }]),
  ];
export type StatusConfigurationControllerServiceGetAllStatusConfigurationsDefaultResponse =
  Awaited<
    ReturnType<
      typeof StatusConfigurationControllerService.getAllStatusConfigurations
    >
  >;
export type StatusConfigurationControllerServiceGetAllStatusConfigurationsQueryResult<
  TData =
    StatusConfigurationControllerServiceGetAllStatusConfigurationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStatusConfigurationControllerServiceGetAllStatusConfigurationsKey =
  "StatusConfigurationControllerServiceGetAllStatusConfigurations";
export const UseStatusConfigurationControllerServiceGetAllStatusConfigurationsKeyFn =
  (
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useStatusConfigurationControllerServiceGetAllStatusConfigurationsKey,
    ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
  ];
export type SocialHistoryControllerServiceGetSocialHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof SocialHistoryControllerService.getSocialHistoryByUuid>
  >;
export type SocialHistoryControllerServiceGetSocialHistoryByUuidQueryResult<
  TData = SocialHistoryControllerServiceGetSocialHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSocialHistoryControllerServiceGetSocialHistoryByUuidKey =
  "SocialHistoryControllerServiceGetSocialHistoryByUuid";
export const UseSocialHistoryControllerServiceGetSocialHistoryByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSocialHistoryControllerServiceGetSocialHistoryByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type SocialHistoryControllerServiceGetAllSocialHistoryDefaultResponse =
  Awaited<
    ReturnType<typeof SocialHistoryControllerService.getAllSocialHistory>
  >;
export type SocialHistoryControllerServiceGetAllSocialHistoryQueryResult<
  TData = SocialHistoryControllerServiceGetAllSocialHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSocialHistoryControllerServiceGetAllSocialHistoryKey =
  "SocialHistoryControllerServiceGetAllSocialHistory";
export const UseSocialHistoryControllerServiceGetAllSocialHistoryKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSocialHistoryControllerServiceGetAllSocialHistoryKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type SoapNoteControllerServiceGetSoapNoteByUuidDefaultResponse = Awaited<
  ReturnType<typeof SoapNoteControllerService.getSoapNoteByUuid>
>;
export type SoapNoteControllerServiceGetSoapNoteByUuidQueryResult<
  TData = SoapNoteControllerServiceGetSoapNoteByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetSoapNoteByUuidKey =
  "SoapNoteControllerServiceGetSoapNoteByUuid";
export const UseSoapNoteControllerServiceGetSoapNoteByUuidKeyFn = (
  {
    soapNoteUuid,
    userUuid,
  }: {
    soapNoteUuid: string;
    userUuid?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetSoapNoteByUuidKey,
  ...(queryKey ?? [{ soapNoteUuid, userUuid }]),
];
export type SoapNoteControllerServiceGetAllWorkNotes1DefaultResponse = Awaited<
  ReturnType<typeof SoapNoteControllerService.getAllWorkNotes1>
>;
export type SoapNoteControllerServiceGetAllWorkNotes1QueryResult<
  TData = SoapNoteControllerServiceGetAllWorkNotes1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetAllWorkNotes1Key =
  "SoapNoteControllerServiceGetAllWorkNotes1";
export const UseSoapNoteControllerServiceGetAllWorkNotes1KeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetAllWorkNotes1Key,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetSoapNotesByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof SoapNoteControllerService.getSoapNotesByPatientUuid>
  >;
export type SoapNoteControllerServiceGetSoapNotesByPatientUuidQueryResult<
  TData = SoapNoteControllerServiceGetSoapNotesByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetSoapNotesByPatientUuidKey =
  "SoapNoteControllerServiceGetSoapNotesByPatientUuid";
export const UseSoapNoteControllerServiceGetSoapNotesByPatientUuidKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    signed,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetSoapNotesByPatientUuidKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, signed, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetAllInstructionsDefaultResponse =
  Awaited<ReturnType<typeof SoapNoteControllerService.getAllInstructions>>;
export type SoapNoteControllerServiceGetAllInstructionsQueryResult<
  TData = SoapNoteControllerServiceGetAllInstructionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetAllInstructionsKey =
  "SoapNoteControllerServiceGetAllInstructions";
export const UseSoapNoteControllerServiceGetAllInstructionsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetAllInstructionsKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetSoapNoteByAppointmentUuidDefaultResponse =
  Awaited<
    ReturnType<typeof SoapNoteControllerService.getSoapNoteByAppointmentUuid>
  >;
export type SoapNoteControllerServiceGetSoapNoteByAppointmentUuidQueryResult<
  TData = SoapNoteControllerServiceGetSoapNoteByAppointmentUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetSoapNoteByAppointmentUuidKey =
  "SoapNoteControllerServiceGetSoapNoteByAppointmentUuid";
export const UseSoapNoteControllerServiceGetSoapNoteByAppointmentUuidKeyFn = (
  {
    appointmentUuid,
  }: {
    appointmentUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetSoapNoteByAppointmentUuidKey,
  ...(queryKey ?? [{ appointmentUuid }]),
];
export type SoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof SoapNoteControllerService.getSoapNoteAndHandPnoteByAppointmentUuid
    >
  >;
export type SoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidQueryResult<
  TData =
    SoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidKey =
  "SoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuid";
export const UseSoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidKeyFn =
  (
    {
      appointmentUuid,
    }: {
      appointmentUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useSoapNoteControllerServiceGetSoapNoteAndHandPnoteByAppointmentUuidKey,
    ...(queryKey ?? [{ appointmentUuid }]),
  ];
export type SoapNoteControllerServiceGetVisitNotesByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof SoapNoteControllerService.getVisitNotesByPatientUuid>
  >;
export type SoapNoteControllerServiceGetVisitNotesByPatientUuidQueryResult<
  TData = SoapNoteControllerServiceGetVisitNotesByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetVisitNotesByPatientUuidKey =
  "SoapNoteControllerServiceGetVisitNotesByPatientUuid";
export const UseSoapNoteControllerServiceGetVisitNotesByPatientUuidKeyFn = (
  {
    isDraft,
    noteTypes,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    noteTypes?: (
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE"
    )[];
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetVisitNotesByPatientUuidKey,
  ...(queryKey ?? [
    { isDraft, noteTypes, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetAllEncounterDetailsDefaultResponse =
  Awaited<ReturnType<typeof SoapNoteControllerService.getAllEncounterDetails>>;
export type SoapNoteControllerServiceGetAllEncounterDetailsQueryResult<
  TData = SoapNoteControllerServiceGetAllEncounterDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetAllEncounterDetailsKey =
  "SoapNoteControllerServiceGetAllEncounterDetails";
export const UseSoapNoteControllerServiceGetAllEncounterDetailsKeyFn = (
  {
    noteType,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    noteType?:
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE";
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetAllEncounterDetailsKey,
  ...(queryKey ?? [
    { noteType, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetAllCarePlanNotesDefaultResponse =
  Awaited<ReturnType<typeof SoapNoteControllerService.getAllCarePlanNotes>>;
export type SoapNoteControllerServiceGetAllCarePlanNotesQueryResult<
  TData = SoapNoteControllerServiceGetAllCarePlanNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetAllCarePlanNotesKey =
  "SoapNoteControllerServiceGetAllCarePlanNotes";
export const UseSoapNoteControllerServiceGetAllCarePlanNotesKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetAllCarePlanNotesKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
  ]),
];
export type SoapNoteControllerServiceGetAllSoapNotesDefaultResponse = Awaited<
  ReturnType<typeof SoapNoteControllerService.getAllSoapNotes>
>;
export type SoapNoteControllerServiceGetAllSoapNotesQueryResult<
  TData = SoapNoteControllerServiceGetAllSoapNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteControllerServiceGetAllSoapNotesKey =
  "SoapNoteControllerServiceGetAllSoapNotes";
export const UseSoapNoteControllerServiceGetAllSoapNotesKeyFn = (
  {
    isDraft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useSoapNoteControllerServiceGetAllSoapNotesKey,
  ...(queryKey ?? [
    { isDraft, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type SoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof SoapNoteTemplateControllerService.getSoapNoteTemplateByUuid
    >
  >;
export type SoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidQueryResult<
  TData =
    SoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidKey =
  "SoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuid";
export const UseSoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useSoapNoteTemplateControllerServiceGetSoapNoteTemplateByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type SoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesDefaultResponse =
  Awaited<
    ReturnType<typeof SoapNoteTemplateControllerService.getAllSoapNoteTemplates>
  >;
export type SoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesQueryResult<
  TData =
    SoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useSoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesKey =
  "SoapNoteTemplateControllerServiceGetAllSoapNoteTemplates";
export const UseSoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesKeyFn =
  (
    {
      flag,
      isPrivate,
      noteType,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      noteType?:
        | "INTERNAL_NOTE"
        | "EXTERNAL_NOTE"
        | "SOAP_NOTE"
        | "HANDP_NOTE"
        | "EMPLOYEE_NOTE"
        | "PHONE_NOTE"
        | "NON_VISIT_NOTE"
        | "EMAIL_NOTE"
        | "LIVE_NOTE";
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useSoapNoteTemplateControllerServiceGetAllSoapNoteTemplatesKey,
    ...(queryKey ?? [
      {
        flag,
        isPrivate,
        noteType,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
      },
    ]),
  ];
export type ScreenHistoryControllerServiceGetScreenHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ScreenHistoryControllerService.getScreenHistoryByUuid>
  >;
export type ScreenHistoryControllerServiceGetScreenHistoryByUuidQueryResult<
  TData = ScreenHistoryControllerServiceGetScreenHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScreenHistoryControllerServiceGetScreenHistoryByUuidKey =
  "ScreenHistoryControllerServiceGetScreenHistoryByUuid";
export const UseScreenHistoryControllerServiceGetScreenHistoryByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScreenHistoryControllerServiceGetScreenHistoryByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type ScreenHistoryControllerServiceGetAllScreenHistoryDefaultResponse =
  Awaited<
    ReturnType<typeof ScreenHistoryControllerService.getAllScreenHistory>
  >;
export type ScreenHistoryControllerServiceGetAllScreenHistoryQueryResult<
  TData = ScreenHistoryControllerServiceGetAllScreenHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useScreenHistoryControllerServiceGetAllScreenHistoryKey =
  "ScreenHistoryControllerServiceGetAllScreenHistory";
export const UseScreenHistoryControllerServiceGetAllScreenHistoryKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useScreenHistoryControllerServiceGetAllScreenHistoryKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type ReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof ReviewOfSystemTemplateControllerService.getReviewOfSystemTemplateByUuid
    >
  >;
export type ReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidQueryResult<
  TData =
    ReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidKey =
  "ReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuid";
export const UseReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useReviewOfSystemTemplateControllerServiceGetReviewOfSystemTemplateByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type ReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesDefaultResponse =
  Awaited<
    ReturnType<
      typeof ReviewOfSystemTemplateControllerService.getAllReviewOfSystemTemplates
    >
  >;
export type ReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesQueryResult<
  TData =
    ReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesKey =
  "ReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplates";
export const UseReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesKeyFn =
  (
    {
      flag,
      isPrivate,
      page,
      searchString,
      size,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      searchString?: string;
      size?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useReviewOfSystemTemplateControllerServiceGetAllReviewOfSystemTemplatesKey,
    ...(queryKey ?? [
      { flag, isPrivate, page, searchString, size, sortBy, sortDirection },
    ]),
  ];
export type ReviewOfSystemControllerServiceGetReviewOfSystemByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ReviewOfSystemControllerService.getReviewOfSystemByUuid>
  >;
export type ReviewOfSystemControllerServiceGetReviewOfSystemByUuidQueryResult<
  TData = ReviewOfSystemControllerServiceGetReviewOfSystemByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReviewOfSystemControllerServiceGetReviewOfSystemByUuidKey =
  "ReviewOfSystemControllerServiceGetReviewOfSystemByUuid";
export const UseReviewOfSystemControllerServiceGetReviewOfSystemByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useReviewOfSystemControllerServiceGetReviewOfSystemByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type ReviewOfSystemControllerServiceGetAllReviewOfSystemsDefaultResponse =
  Awaited<
    ReturnType<typeof ReviewOfSystemControllerService.getAllReviewOfSystems>
  >;
export type ReviewOfSystemControllerServiceGetAllReviewOfSystemsQueryResult<
  TData = ReviewOfSystemControllerServiceGetAllReviewOfSystemsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReviewOfSystemControllerServiceGetAllReviewOfSystemsKey =
  "ReviewOfSystemControllerServiceGetAllReviewOfSystems";
export const UseReviewOfSystemControllerServiceGetAllReviewOfSystemsKeyFn = (
  {
    page,
    patientUuid,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useReviewOfSystemControllerServiceGetAllReviewOfSystemsKey,
  ...(queryKey ?? [{ page, patientUuid, size, sortBy, sortDirection }]),
];
export type ReferralControllerServiceGetReferralByUuidDefaultResponse = Awaited<
  ReturnType<typeof ReferralControllerService.getReferralByUuid>
>;
export type ReferralControllerServiceGetReferralByUuidQueryResult<
  TData = ReferralControllerServiceGetReferralByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReferralControllerServiceGetReferralByUuidKey =
  "ReferralControllerServiceGetReferralByUuid";
export const UseReferralControllerServiceGetReferralByUuidKeyFn = (
  {
    referralByUuid,
  }: {
    referralByUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useReferralControllerServiceGetReferralByUuidKey,
  ...(queryKey ?? [{ referralByUuid }]),
];
export type ReferralControllerServiceGetAllReferralsByProvidersDefaultResponse =
  Awaited<
    ReturnType<typeof ReferralControllerService.getAllReferralsByProviders>
  >;
export type ReferralControllerServiceGetAllReferralsByProvidersQueryResult<
  TData = ReferralControllerServiceGetAllReferralsByProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReferralControllerServiceGetAllReferralsByProvidersKey =
  "ReferralControllerServiceGetAllReferralsByProviders";
export const UseReferralControllerServiceGetAllReferralsByProvidersKeyFn = (
  {
    locationUuids,
    page,
    pageSize,
    providerUuids,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useReferralControllerServiceGetAllReferralsByProvidersKey,
  ...(queryKey ?? [
    { locationUuids, page, pageSize, providerUuids, sortBy, sortDirection },
  ]),
];
export type ReferralControllerServiceGetAllReferralsForGlobalDefaultResponse =
  Awaited<
    ReturnType<typeof ReferralControllerService.getAllReferralsForGlobal>
  >;
export type ReferralControllerServiceGetAllReferralsForGlobalQueryResult<
  TData = ReferralControllerServiceGetAllReferralsForGlobalDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReferralControllerServiceGetAllReferralsForGlobalKey =
  "ReferralControllerServiceGetAllReferralsForGlobal";
export const UseReferralControllerServiceGetAllReferralsForGlobalKeyFn = (
  {
    email,
    endDate,
    fax,
    locationUuids,
    page,
    phone,
    providerUuids,
    referralType,
    referredBy,
    referredTo,
    searchString,
    size,
    sort,
    startDate,
    stat,
  }: {
    email?: string;
    endDate?: string;
    fax?: string;
    locationUuids?: string[];
    page?: number;
    phone?: string;
    providerUuids?: string[];
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    referredBy?: string;
    referredTo?: string;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    stat?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useReferralControllerServiceGetAllReferralsForGlobalKey,
  ...(queryKey ?? [
    {
      email,
      endDate,
      fax,
      locationUuids,
      page,
      phone,
      providerUuids,
      referralType,
      referredBy,
      referredTo,
      searchString,
      size,
      sort,
      startDate,
      stat,
    },
  ]),
];
export type ReferralControllerServiceGetAllChartItemDefaultResponse = Awaited<
  ReturnType<typeof ReferralControllerService.getAllChartItem>
>;
export type ReferralControllerServiceGetAllChartItemQueryResult<
  TData = ReferralControllerServiceGetAllChartItemDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReferralControllerServiceGetAllChartItemKey =
  "ReferralControllerServiceGetAllChartItem";
export const UseReferralControllerServiceGetAllChartItemKeyFn = (
  queryKey?: Array<unknown>,
) => [useReferralControllerServiceGetAllChartItemKey, ...(queryKey ?? [])];
export type ReferralControllerServiceGetAllReferralsDefaultResponse = Awaited<
  ReturnType<typeof ReferralControllerService.getAllReferrals>
>;
export type ReferralControllerServiceGetAllReferralsQueryResult<
  TData = ReferralControllerServiceGetAllReferralsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useReferralControllerServiceGetAllReferralsKey =
  "ReferralControllerServiceGetAllReferrals";
export const UseReferralControllerServiceGetAllReferralsKeyFn = (
  {
    draft,
    email,
    endDate,
    fax,
    page,
    patientUuid,
    phone,
    referralType,
    referredBy,
    referredTo,
    searchString,
    size,
    sort,
    startDate,
    stat,
  }: {
    draft?: boolean;
    email?: string;
    endDate?: string;
    fax?: string;
    page?: number;
    patientUuid: string;
    phone?: string;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    referredBy?: string;
    referredTo?: string;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    stat?: boolean;
  },
  queryKey?: Array<unknown>,
) => [
  useReferralControllerServiceGetAllReferralsKey,
  ...(queryKey ?? [
    {
      draft,
      email,
      endDate,
      fax,
      page,
      patientUuid,
      phone,
      referralType,
      referredBy,
      referredTo,
      searchString,
      size,
      sort,
      startDate,
      stat,
    },
  ]),
];
export type ProviderDirectoryControllerServiceGetNppesImportHistoryDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.getNppesImportHistory>
  >;
export type ProviderDirectoryControllerServiceGetNppesImportHistoryQueryResult<
  TData =
    ProviderDirectoryControllerServiceGetNppesImportHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceGetNppesImportHistoryKey =
  "ProviderDirectoryControllerServiceGetNppesImportHistory";
export const UseProviderDirectoryControllerServiceGetNppesImportHistoryKeyFn = (
  {
    limit,
  }: {
    limit?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderDirectoryControllerServiceGetNppesImportHistoryKey,
  ...(queryKey ?? [{ limit }]),
];
export type ProviderDirectoryControllerServiceGetProviderDirectoryUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof ProviderDirectoryControllerService.getProviderDirectoryUuid
    >
  >;
export type ProviderDirectoryControllerServiceGetProviderDirectoryUuidQueryResult<
  TData =
    ProviderDirectoryControllerServiceGetProviderDirectoryUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceGetProviderDirectoryUuidKey =
  "ProviderDirectoryControllerServiceGetProviderDirectoryUuid";
export const UseProviderDirectoryControllerServiceGetProviderDirectoryUuidKeyFn =
  (
    {
      providerDirectoryUuid,
    }: {
      providerDirectoryUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useProviderDirectoryControllerServiceGetProviderDirectoryUuidKey,
    ...(queryKey ?? [{ providerDirectoryUuid }]),
  ];
export type ProviderDirectoryControllerServiceGetAllReferralTypesDefaultResponse =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.getAllReferralTypes>
  >;
export type ProviderDirectoryControllerServiceGetAllReferralTypesQueryResult<
  TData = ProviderDirectoryControllerServiceGetAllReferralTypesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceGetAllReferralTypesKey =
  "ProviderDirectoryControllerServiceGetAllReferralTypes";
export const UseProviderDirectoryControllerServiceGetAllReferralTypesKeyFn = (
  {
    page,
    searchString,
    size,
    sort,
  }: {
    page?: number;
    searchString?: string;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProviderDirectoryControllerServiceGetAllReferralTypesKey,
  ...(queryKey ?? [{ page, searchString, size, sort }]),
];
export type ProviderDirectoryControllerServiceProviderDirectoryExportCsvDefaultResponse =
  Awaited<
    ReturnType<
      typeof ProviderDirectoryControllerService.providerDirectoryExportCsv
    >
  >;
export type ProviderDirectoryControllerServiceProviderDirectoryExportCsvQueryResult<
  TData =
    ProviderDirectoryControllerServiceProviderDirectoryExportCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceProviderDirectoryExportCsvKey =
  "ProviderDirectoryControllerServiceProviderDirectoryExportCsv";
export const UseProviderDirectoryControllerServiceProviderDirectoryExportCsvKeyFn =
  (
    {
      city,
      referralType,
      searchString,
      state,
    }: {
      city?: string;
      referralType?:
        | "IMAGING"
        | "SPECIALIST"
        | "ACUPUNCTURIST"
        | "ADULT_COMPANION"
        | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
        | "ADVANCED_PRACTICE_MIDWIFE"
        | "AIR_CARRIER"
        | "ALLERGY_IMMUNOLOGY"
        | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
        | "AMBULANCE"
        | "ANAPLASTOLOGIST"
        | "ANESTHESIOLOGIST_ASSISTANT"
        | "ANESTHESIOLOGY"
        | "ART_THERAPIST"
        | "ASSISTANT_BEHAVIOR_ANALYST"
        | "ASSISTANT_PODIATRIC"
        | "ASSISTED_LIVING_FACILITY"
        | "AUDIOLOGIST"
        | "AUDIOLOGIST_HEARING_AID_FITTER"
        | "BEHAVIOR_ANALYST"
        | "BEHAVIOR_TECHNICIAN"
        | "BLOOD_BANK"
        | "BUS"
        | "CASE_MANAGEMENT"
        | "CASE_MANAGER_CARE_COORDINATOR"
        | "CHIROPRACTOR"
        | "CHORE_PROVIDER"
        | "CHRISTIAN_SCIENCE_FACILITY"
        | "CHRISTIAN_SCIENCE_SANITORIUM"
        | "CHRONIC_DISEASE_HOSPITAL"
        | "CLINIC_CENTER"
        | "CLINICAL_ETHICIST"
        | "CLINICAL_EXERCISE_PHYSIOLOGIST"
        | "CLINICAL_MEDICAL_LABORATORY"
        | "CLINICAL_NEUROPSYCHOLOGIST"
        | "CLINICAL_NURSE_SPECIALIST"
        | "CLINICAL_PHARMACOLOGY"
        | "COLON_RECTAL_SURGERY"
        | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
        | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
        | "COMMUNITY_HEALTH_WORKER"
        | "COMMUNITY_PARAMEDIC"
        | "COMMUNITY_BEHAVIORAL_HEALTH"
        | "CONTRACTOR"
        | "COUNSELOR"
        | "CUSTODIAL_CARE_FACILITY"
        | "DANCE_THERAPIST"
        | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
        | "DAY_TRAINING_HABILITATION_SPECIALIST"
        | "DENTAL_ASSISTANT"
        | "DENTAL_HYGIENIST"
        | "DENTAL_LABORATORY"
        | "DENTAL_LABORATORY_TECHNICIAN"
        | "DENTAL_THERAPIST"
        | "DENTIST"
        | "DENTURIST"
        | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
        | "DERMATOLOGY"
        | "DEVELOPMENTAL_THERAPIST"
        | "DIETARY_MANAGER"
        | "DIETETIC_TECHNICIAN_REGISTERED"
        | "DIETITIAN_REGISTERED"
        | "DOULA"
        | "DRAMA_THERAPIST"
        | "DRIVER"
        | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
        | "EARLY_INTERVENTION_PROVIDER_AGENCY"
        | "ELECTRODIAGNOSTIC_MEDICINE"
        | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
        | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
        | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
        | "EMERGENCY_MEDICINE"
        | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
        | "EPILEPSY_UNIT"
        | "EXCLUSIVE_PROVIDER_ORGANIZATION"
        | "EYE_BANK"
        | "EYEWEAR_SUPPLIER"
        | "FAMILY_MEDICINE"
        | "FOSTER_CARE_AGENCY"
        | "FUNERAL_DIRECTOR"
        | "GENERAL_ACUTE_CARE_HOSPITAL"
        | "GENERAL_PRACTICE"
        | "GENETIC_COUNSELOR_MS"
        | "HEALTH_WELLNESS_COACH"
        | "HEALTH_EDUCATOR"
        | "HEALTH_MAINTENANCE_ORGANIZATION"
        | "HEARING_AID_EQUIPMENT"
        | "HEARING_INSTRUMENT_SPECIALIST"
        | "HOME_DELIVERED_MEALS"
        | "HOME_HEALTH"
        | "HOME_HEALTH_AIDE"
        | "HOME_INFUSION"
        | "HOMEMAKER"
        | "HOMEOPATH"
        | "HOSPICE_CARE_COMMUNITY_BASED"
        | "HOSPICE_INPATIENT"
        | "HOSPITALIST"
        | "IN_HOME_SUPPORTIVE_CARE"
        | "INDEPENDENT_MEDICAL_EXAMINER"
        | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
        | "INTEGRATIVE_MEDICINE"
        | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
        | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
        | "INTERNAL_MEDICINE"
        | "INTERPRETER"
        | "KINESIOTHERAPIST"
        | "LACTATION_CONSULTANT_NON_RN"
        | "LEGAL_MEDICINE"
        | "LICENSED_PRACTICAL_NURSE"
        | "LICENSED_PSYCHIATRIC_TECHNICIAN"
        | "LICENSED_VOCATIONAL_NURSE"
        | "LOCAL_EDUCATION_AGENCY_LEA"
        | "LODGING"
        | "LONG_TERM_CARE_HOSPITAL"
        | "MARRIAGE_FAMILY_THERAPIST"
        | "MASSAGE_THERAPIST"
        | "MASTECTOMY_FITTER"
        | "MEALS"
        | "MECHANOTHERAPIST"
        | "MEDICAL_FOODS_SUPPLIER"
        | "MEDICAL_GENETICS"
        | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
        | "MEDICARE_DEFINED_SWING_BED_UNIT"
        | "MIDWIFE"
        | "MIDWIFE_LAY"
        | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
        | "MILITARY_HEALTH_CARE_PROVIDER"
        | "MILITARY_HOSPITAL"
        | "MILITARY_U_S_COAST_GUARD_PHARMACY"
        | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
        | "MULTI_SPECIALTY"
        | "MUSIC_THERAPIST"
        | "NAPRAPATH"
        | "NATUROPATH"
        | "NEUROLOGICAL_SURGERY"
        | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
        | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
        | "NON_PHARMACY_DISPENSING_SITE"
        | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
        | "NUCLEAR_MEDICINE"
        | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
        | "NURSE_PRACTITIONER"
        | "NURSE_S_AIDE"
        | "NURSING_CARE"
        | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
        | "NURSING_HOME_ADMINISTRATOR"
        | "NUTRITIONIST"
        | "OBSTETRICS_GYNECOLOGY"
        | "OCCUPATIONAL_THERAPIST"
        | "OCCUPATIONAL_THERAPY_ASSISTANT"
        | "OPHTHALMOLOGY"
        | "OPTOMETRIST"
        | "ORAL_MAXILLOFACIAL_SURGERY"
        | "ORGAN_PROCUREMENT_ORGANIZATION"
        | "ORTHOPAEDIC_SURGERY"
        | "ORTHOTIC_FITTER"
        | "ORTHOTIST"
        | "OTOLARYNGOLOGY"
        | "PAIN_MEDICINE"
        | "PATHOLOGY"
        | "PEDIATRICS"
        | "PEDORTHIST"
        | "PEER_SPECIALIST"
        | "PERFUSIONIST"
        | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
        | "PHARMACIST"
        | "PHARMACY"
        | "PHARMACY_TECHNICIAN"
        | "PHLEBOLOGY"
        | "PHYSICAL_MEDICINE_REHABILITATION"
        | "PHYSICAL_THERAPIST"
        | "PHYSICAL_THERAPY_ASSISTANT"
        | "PHYSICIAN_ASSISTANT"
        | "PHYSIOLOGICAL_LABORATORY"
        | "PLASTIC_SURGERY"
        | "PODIATRIST"
        | "POETRY_THERAPIST"
        | "POINT_OF_SERVICE"
        | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
        | "PREFERRED_PROVIDER_ORGANIZATION"
        | "PREVENTION_PROFESSIONAL"
        | "PREVENTIVE_MEDICINE"
        | "PRIVATE_VEHICLE"
        | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
        | "PROSTHETIC_ORTHOTIC_SUPPLIER"
        | "PROSTHETIST"
        | "PSYCHIATRIC_HOSPITAL"
        | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
        | "PSYCHIATRIC_UNIT"
        | "PSYCHIATRY_NEUROLOGY"
        | "PSYCHOANALYST"
        | "PSYCHOLOGIST"
        | "PUBLIC_HEALTH_OR_WELFARE"
        | "PULMONARY_FUNCTION_TECHNOLOGIST"
        | "RADIOLOGIC_TECHNOLOGIST"
        | "RADIOLOGY"
        | "RADIOLOGY_PRACTITIONER_ASSISTANT"
        | "RECREATION_THERAPIST"
        | "RECREATIONAL_THERAPIST_ASSISTANT"
        | "REFLEXOLOGIST"
        | "REGISTERED_NURSE"
        | "REHABILITATION_COUNSELOR"
        | "REHABILITATION_HOSPITAL"
        | "REHABILITATION_PRACTITIONER"
        | "REHABILITATION_UNIT"
        | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
        | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
        | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
        | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
        | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
        | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
        | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
        | "RESPIRATORY_THERAPIST_CERTIFIED"
        | "RESPIRATORY_THERAPIST_REGISTERED"
        | "RESPITE_CARE"
        | "SECURED_MEDICAL_TRANSPORT_VAN"
        | "SINGLE_SPECIALTY"
        | "SKILLED_NURSING_FACILITY"
        | "SLEEP_SPECIALIST_PHD"
        | "SOCIAL_WORKER"
        | "SPECIAL_HOSPITAL"
        | "SPECIALIST_TECHNOLOGIST"
        | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
        | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
        | "SPECIALIST_TECHNOLOGIST_OTHER"
        | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
        | "SPEECH_LANGUAGE_PATHOLOGIST"
        | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
        | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
        | "SUPPORTS_BROKERAGE"
        | "SURGERY"
        | "TAXI"
        | "TECHNICIAN"
        | "TECHNICIAN_CARDIOLOGY"
        | "TECHNICIAN_HEALTH_INFORMATION"
        | "TECHNICIAN_OTHER"
        | "TECHNICIAN_PATHOLOGY"
        | "TECHNICIAN_TECHNOLOGIST"
        | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
        | "TRAIN"
        | "TRANSPLANT_SURGERY"
        | "TRANSPORTATION_BROKER"
        | "TRANSPORTATION_NETWORK_COMPANY"
        | "UROLOGY"
        | "VETERINARIAN"
        | "VOLUNTARY_OR_CHARITABLE";
      searchString?: string;
      state?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useProviderDirectoryControllerServiceProviderDirectoryExportCsvKey,
    ...(queryKey ?? [{ city, referralType, searchString, state }]),
  ];
export type ProviderDirectoryControllerServiceDownloadCsvTemplate1DefaultResponse =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.downloadCsvTemplate1>
  >;
export type ProviderDirectoryControllerServiceDownloadCsvTemplate1QueryResult<
  TData = ProviderDirectoryControllerServiceDownloadCsvTemplate1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceDownloadCsvTemplate1Key =
  "ProviderDirectoryControllerServiceDownloadCsvTemplate1";
export const UseProviderDirectoryControllerServiceDownloadCsvTemplate1KeyFn = (
  queryKey?: Array<unknown>,
) => [
  useProviderDirectoryControllerServiceDownloadCsvTemplate1Key,
  ...(queryKey ?? []),
];
export type ProviderDirectoryControllerServiceGetAllProviderDirectoryDefaultResponse =
  Awaited<
    ReturnType<
      typeof ProviderDirectoryControllerService.getAllProviderDirectory
    >
  >;
export type ProviderDirectoryControllerServiceGetAllProviderDirectoryQueryResult<
  TData =
    ProviderDirectoryControllerServiceGetAllProviderDirectoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProviderDirectoryControllerServiceGetAllProviderDirectoryKey =
  "ProviderDirectoryControllerServiceGetAllProviderDirectory";
export const UseProviderDirectoryControllerServiceGetAllProviderDirectoryKeyFn =
  (
    {
      city,
      excludeImaging,
      page,
      referralType,
      searchString,
      size,
      sort,
      state,
    }: {
      city?: string;
      excludeImaging?: boolean;
      page?: number;
      referralType?:
        | "IMAGING"
        | "SPECIALIST"
        | "ACUPUNCTURIST"
        | "ADULT_COMPANION"
        | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
        | "ADVANCED_PRACTICE_MIDWIFE"
        | "AIR_CARRIER"
        | "ALLERGY_IMMUNOLOGY"
        | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
        | "AMBULANCE"
        | "ANAPLASTOLOGIST"
        | "ANESTHESIOLOGIST_ASSISTANT"
        | "ANESTHESIOLOGY"
        | "ART_THERAPIST"
        | "ASSISTANT_BEHAVIOR_ANALYST"
        | "ASSISTANT_PODIATRIC"
        | "ASSISTED_LIVING_FACILITY"
        | "AUDIOLOGIST"
        | "AUDIOLOGIST_HEARING_AID_FITTER"
        | "BEHAVIOR_ANALYST"
        | "BEHAVIOR_TECHNICIAN"
        | "BLOOD_BANK"
        | "BUS"
        | "CASE_MANAGEMENT"
        | "CASE_MANAGER_CARE_COORDINATOR"
        | "CHIROPRACTOR"
        | "CHORE_PROVIDER"
        | "CHRISTIAN_SCIENCE_FACILITY"
        | "CHRISTIAN_SCIENCE_SANITORIUM"
        | "CHRONIC_DISEASE_HOSPITAL"
        | "CLINIC_CENTER"
        | "CLINICAL_ETHICIST"
        | "CLINICAL_EXERCISE_PHYSIOLOGIST"
        | "CLINICAL_MEDICAL_LABORATORY"
        | "CLINICAL_NEUROPSYCHOLOGIST"
        | "CLINICAL_NURSE_SPECIALIST"
        | "CLINICAL_PHARMACOLOGY"
        | "COLON_RECTAL_SURGERY"
        | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
        | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
        | "COMMUNITY_HEALTH_WORKER"
        | "COMMUNITY_PARAMEDIC"
        | "COMMUNITY_BEHAVIORAL_HEALTH"
        | "CONTRACTOR"
        | "COUNSELOR"
        | "CUSTODIAL_CARE_FACILITY"
        | "DANCE_THERAPIST"
        | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
        | "DAY_TRAINING_HABILITATION_SPECIALIST"
        | "DENTAL_ASSISTANT"
        | "DENTAL_HYGIENIST"
        | "DENTAL_LABORATORY"
        | "DENTAL_LABORATORY_TECHNICIAN"
        | "DENTAL_THERAPIST"
        | "DENTIST"
        | "DENTURIST"
        | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
        | "DERMATOLOGY"
        | "DEVELOPMENTAL_THERAPIST"
        | "DIETARY_MANAGER"
        | "DIETETIC_TECHNICIAN_REGISTERED"
        | "DIETITIAN_REGISTERED"
        | "DOULA"
        | "DRAMA_THERAPIST"
        | "DRIVER"
        | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
        | "EARLY_INTERVENTION_PROVIDER_AGENCY"
        | "ELECTRODIAGNOSTIC_MEDICINE"
        | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
        | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
        | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
        | "EMERGENCY_MEDICINE"
        | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
        | "EPILEPSY_UNIT"
        | "EXCLUSIVE_PROVIDER_ORGANIZATION"
        | "EYE_BANK"
        | "EYEWEAR_SUPPLIER"
        | "FAMILY_MEDICINE"
        | "FOSTER_CARE_AGENCY"
        | "FUNERAL_DIRECTOR"
        | "GENERAL_ACUTE_CARE_HOSPITAL"
        | "GENERAL_PRACTICE"
        | "GENETIC_COUNSELOR_MS"
        | "HEALTH_WELLNESS_COACH"
        | "HEALTH_EDUCATOR"
        | "HEALTH_MAINTENANCE_ORGANIZATION"
        | "HEARING_AID_EQUIPMENT"
        | "HEARING_INSTRUMENT_SPECIALIST"
        | "HOME_DELIVERED_MEALS"
        | "HOME_HEALTH"
        | "HOME_HEALTH_AIDE"
        | "HOME_INFUSION"
        | "HOMEMAKER"
        | "HOMEOPATH"
        | "HOSPICE_CARE_COMMUNITY_BASED"
        | "HOSPICE_INPATIENT"
        | "HOSPITALIST"
        | "IN_HOME_SUPPORTIVE_CARE"
        | "INDEPENDENT_MEDICAL_EXAMINER"
        | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
        | "INTEGRATIVE_MEDICINE"
        | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
        | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
        | "INTERNAL_MEDICINE"
        | "INTERPRETER"
        | "KINESIOTHERAPIST"
        | "LACTATION_CONSULTANT_NON_RN"
        | "LEGAL_MEDICINE"
        | "LICENSED_PRACTICAL_NURSE"
        | "LICENSED_PSYCHIATRIC_TECHNICIAN"
        | "LICENSED_VOCATIONAL_NURSE"
        | "LOCAL_EDUCATION_AGENCY_LEA"
        | "LODGING"
        | "LONG_TERM_CARE_HOSPITAL"
        | "MARRIAGE_FAMILY_THERAPIST"
        | "MASSAGE_THERAPIST"
        | "MASTECTOMY_FITTER"
        | "MEALS"
        | "MECHANOTHERAPIST"
        | "MEDICAL_FOODS_SUPPLIER"
        | "MEDICAL_GENETICS"
        | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
        | "MEDICARE_DEFINED_SWING_BED_UNIT"
        | "MIDWIFE"
        | "MIDWIFE_LAY"
        | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
        | "MILITARY_HEALTH_CARE_PROVIDER"
        | "MILITARY_HOSPITAL"
        | "MILITARY_U_S_COAST_GUARD_PHARMACY"
        | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
        | "MULTI_SPECIALTY"
        | "MUSIC_THERAPIST"
        | "NAPRAPATH"
        | "NATUROPATH"
        | "NEUROLOGICAL_SURGERY"
        | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
        | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
        | "NON_PHARMACY_DISPENSING_SITE"
        | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
        | "NUCLEAR_MEDICINE"
        | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
        | "NURSE_PRACTITIONER"
        | "NURSE_S_AIDE"
        | "NURSING_CARE"
        | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
        | "NURSING_HOME_ADMINISTRATOR"
        | "NUTRITIONIST"
        | "OBSTETRICS_GYNECOLOGY"
        | "OCCUPATIONAL_THERAPIST"
        | "OCCUPATIONAL_THERAPY_ASSISTANT"
        | "OPHTHALMOLOGY"
        | "OPTOMETRIST"
        | "ORAL_MAXILLOFACIAL_SURGERY"
        | "ORGAN_PROCUREMENT_ORGANIZATION"
        | "ORTHOPAEDIC_SURGERY"
        | "ORTHOTIC_FITTER"
        | "ORTHOTIST"
        | "OTOLARYNGOLOGY"
        | "PAIN_MEDICINE"
        | "PATHOLOGY"
        | "PEDIATRICS"
        | "PEDORTHIST"
        | "PEER_SPECIALIST"
        | "PERFUSIONIST"
        | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
        | "PHARMACIST"
        | "PHARMACY"
        | "PHARMACY_TECHNICIAN"
        | "PHLEBOLOGY"
        | "PHYSICAL_MEDICINE_REHABILITATION"
        | "PHYSICAL_THERAPIST"
        | "PHYSICAL_THERAPY_ASSISTANT"
        | "PHYSICIAN_ASSISTANT"
        | "PHYSIOLOGICAL_LABORATORY"
        | "PLASTIC_SURGERY"
        | "PODIATRIST"
        | "POETRY_THERAPIST"
        | "POINT_OF_SERVICE"
        | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
        | "PREFERRED_PROVIDER_ORGANIZATION"
        | "PREVENTION_PROFESSIONAL"
        | "PREVENTIVE_MEDICINE"
        | "PRIVATE_VEHICLE"
        | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
        | "PROSTHETIC_ORTHOTIC_SUPPLIER"
        | "PROSTHETIST"
        | "PSYCHIATRIC_HOSPITAL"
        | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
        | "PSYCHIATRIC_UNIT"
        | "PSYCHIATRY_NEUROLOGY"
        | "PSYCHOANALYST"
        | "PSYCHOLOGIST"
        | "PUBLIC_HEALTH_OR_WELFARE"
        | "PULMONARY_FUNCTION_TECHNOLOGIST"
        | "RADIOLOGIC_TECHNOLOGIST"
        | "RADIOLOGY"
        | "RADIOLOGY_PRACTITIONER_ASSISTANT"
        | "RECREATION_THERAPIST"
        | "RECREATIONAL_THERAPIST_ASSISTANT"
        | "REFLEXOLOGIST"
        | "REGISTERED_NURSE"
        | "REHABILITATION_COUNSELOR"
        | "REHABILITATION_HOSPITAL"
        | "REHABILITATION_PRACTITIONER"
        | "REHABILITATION_UNIT"
        | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
        | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
        | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
        | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
        | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
        | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
        | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
        | "RESPIRATORY_THERAPIST_CERTIFIED"
        | "RESPIRATORY_THERAPIST_REGISTERED"
        | "RESPITE_CARE"
        | "SECURED_MEDICAL_TRANSPORT_VAN"
        | "SINGLE_SPECIALTY"
        | "SKILLED_NURSING_FACILITY"
        | "SLEEP_SPECIALIST_PHD"
        | "SOCIAL_WORKER"
        | "SPECIAL_HOSPITAL"
        | "SPECIALIST_TECHNOLOGIST"
        | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
        | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
        | "SPECIALIST_TECHNOLOGIST_OTHER"
        | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
        | "SPEECH_LANGUAGE_PATHOLOGIST"
        | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
        | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
        | "SUPPORTS_BROKERAGE"
        | "SURGERY"
        | "TAXI"
        | "TECHNICIAN"
        | "TECHNICIAN_CARDIOLOGY"
        | "TECHNICIAN_HEALTH_INFORMATION"
        | "TECHNICIAN_OTHER"
        | "TECHNICIAN_PATHOLOGY"
        | "TECHNICIAN_TECHNOLOGIST"
        | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
        | "TRAIN"
        | "TRANSPLANT_SURGERY"
        | "TRANSPORTATION_BROKER"
        | "TRANSPORTATION_NETWORK_COMPANY"
        | "UROLOGY"
        | "VETERINARIAN"
        | "VOLUNTARY_OR_CHARITABLE";
      searchString?: string;
      size?: number;
      sort?: string[];
      state?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useProviderDirectoryControllerServiceGetAllProviderDirectoryKey,
    ...(queryKey ?? [
      {
        city,
        excludeImaging,
        page,
        referralType,
        searchString,
        size,
        sort,
        state,
      },
    ]),
  ];
export type PointsOfCareLabControllerServiceGetPointOfCareLabByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof PointsOfCareLabControllerService.getPointOfCareLabByUuid>
  >;
export type PointsOfCareLabControllerServiceGetPointOfCareLabByUuidQueryResult<
  TData =
    PointsOfCareLabControllerServiceGetPointOfCareLabByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePointsOfCareLabControllerServiceGetPointOfCareLabByUuidKey =
  "PointsOfCareLabControllerServiceGetPointOfCareLabByUuid";
export const UsePointsOfCareLabControllerServiceGetPointOfCareLabByUuidKeyFn = (
  {
    pointOfCareUuid,
  }: {
    pointOfCareUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePointsOfCareLabControllerServiceGetPointOfCareLabByUuidKey,
  ...(queryKey ?? [{ pointOfCareUuid }]),
];
export type PointsOfCareLabControllerServiceGetAllPointOfCareLabDefaultResponse =
  Awaited<
    ReturnType<typeof PointsOfCareLabControllerService.getAllPointOfCareLab>
  >;
export type PointsOfCareLabControllerServiceGetAllPointOfCareLabQueryResult<
  TData = PointsOfCareLabControllerServiceGetAllPointOfCareLabDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePointsOfCareLabControllerServiceGetAllPointOfCareLabKey =
  "PointsOfCareLabControllerServiceGetAllPointOfCareLab";
export const UsePointsOfCareLabControllerServiceGetAllPointOfCareLabKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePointsOfCareLabControllerServiceGetAllPointOfCareLabKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, searchString, sortBy, sortDirection },
  ]),
];
export type PocLabTestControllerServiceGetPocLabTestByIdDefaultResponse =
  Awaited<ReturnType<typeof PocLabTestControllerService.getPocLabTestById>>;
export type PocLabTestControllerServiceGetPocLabTestByIdQueryResult<
  TData = PocLabTestControllerServiceGetPocLabTestByIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePocLabTestControllerServiceGetPocLabTestByIdKey =
  "PocLabTestControllerServiceGetPocLabTestById";
export const UsePocLabTestControllerServiceGetPocLabTestByIdKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePocLabTestControllerServiceGetPocLabTestByIdKey,
  ...(queryKey ?? [{ uuid }]),
];
export type PocLabTestControllerServiceGetAllPocLabTestsDefaultResponse =
  Awaited<ReturnType<typeof PocLabTestControllerService.getAllPocLabTests>>;
export type PocLabTestControllerServiceGetAllPocLabTestsQueryResult<
  TData = PocLabTestControllerServiceGetAllPocLabTestsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePocLabTestControllerServiceGetAllPocLabTestsKey =
  "PocLabTestControllerServiceGetAllPocLabTests";
export const UsePocLabTestControllerServiceGetAllPocLabTestsKeyFn = (
  {
    active,
    createdBy,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    active?: boolean;
    createdBy?: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePocLabTestControllerServiceGetAllPocLabTestsKey,
  ...(queryKey ?? [
    {
      active,
      createdBy,
      endDate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    },
  ]),
];
export type PocLabResultControllerServiceGetPocLabResultByIdDefaultResponse =
  Awaited<ReturnType<typeof PocLabResultControllerService.getPocLabResultById>>;
export type PocLabResultControllerServiceGetPocLabResultByIdQueryResult<
  TData = PocLabResultControllerServiceGetPocLabResultByIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePocLabResultControllerServiceGetPocLabResultByIdKey =
  "PocLabResultControllerServiceGetPocLabResultById";
export const UsePocLabResultControllerServiceGetPocLabResultByIdKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePocLabResultControllerServiceGetPocLabResultByIdKey,
  ...(queryKey ?? [{ uuid }]),
];
export type PocLabResultControllerServiceGetAllPocLabResultsDefaultResponse =
  Awaited<ReturnType<typeof PocLabResultControllerService.getAllPocLabResults>>;
export type PocLabResultControllerServiceGetAllPocLabResultsQueryResult<
  TData = PocLabResultControllerServiceGetAllPocLabResultsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePocLabResultControllerServiceGetAllPocLabResultsKey =
  "PocLabResultControllerServiceGetAllPocLabResults";
export const UsePocLabResultControllerServiceGetAllPocLabResultsKeyFn = (
  {
    draft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    status,
  }: {
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePocLabResultControllerServiceGetAllPocLabResultsKey,
  ...(queryKey ?? [
    { draft, page, pageSize, patientUuid, sortBy, sortDirection, status },
  ]),
];
export type PhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.getPhysicalExamTemplateByUuid
    >
  >;
export type PhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidQueryResult<
  TData =
    PhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidKey =
  "PhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuid";
export const UsePhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePhysicalExamTemplateControllerServiceGetPhysicalExamTemplateByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type PhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesDefaultResponse =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.getAllPhysicalExamTemplates
    >
  >;
export type PhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesQueryResult<
  TData =
    PhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesKey =
  "PhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplates";
export const UsePhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesKeyFn =
  (
    {
      flag,
      isPrivate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    usePhysicalExamTemplateControllerServiceGetAllPhysicalExamTemplatesKey,
    ...(queryKey ?? [
      { flag, isPrivate, page, pageSize, searchString, sortBy, sortDirection },
    ]),
  ];
export type PhysicalExamControllerServiceGetPhysicalExamByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof PhysicalExamControllerService.getPhysicalExamByUuid>
  >;
export type PhysicalExamControllerServiceGetPhysicalExamByUuidQueryResult<
  TData = PhysicalExamControllerServiceGetPhysicalExamByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePhysicalExamControllerServiceGetPhysicalExamByUuidKey =
  "PhysicalExamControllerServiceGetPhysicalExamByUuid";
export const UsePhysicalExamControllerServiceGetPhysicalExamByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePhysicalExamControllerServiceGetPhysicalExamByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type PhysicalExamControllerServiceGetAllPhysicalExamsDefaultResponse =
  Awaited<ReturnType<typeof PhysicalExamControllerService.getAllPhysicalExams>>;
export type PhysicalExamControllerServiceGetAllPhysicalExamsQueryResult<
  TData = PhysicalExamControllerServiceGetAllPhysicalExamsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePhysicalExamControllerServiceGetAllPhysicalExamsKey =
  "PhysicalExamControllerServiceGetAllPhysicalExams";
export const UsePhysicalExamControllerServiceGetAllPhysicalExamsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePhysicalExamControllerServiceGetAllPhysicalExamsKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type PharmacyControllerServiceGetPharmacyByUuidDefaultResponse = Awaited<
  ReturnType<typeof PharmacyControllerService.getPharmacyByUuid>
>;
export type PharmacyControllerServiceGetPharmacyByUuidQueryResult<
  TData = PharmacyControllerServiceGetPharmacyByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePharmacyControllerServiceGetPharmacyByUuidKey =
  "PharmacyControllerServiceGetPharmacyByUuid";
export const UsePharmacyControllerServiceGetPharmacyByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePharmacyControllerServiceGetPharmacyByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type PharmacyControllerServiceGetAllPharmaciesDefaultResponse = Awaited<
  ReturnType<typeof PharmacyControllerService.getAllPharmacies>
>;
export type PharmacyControllerServiceGetAllPharmaciesQueryResult<
  TData = PharmacyControllerServiceGetAllPharmaciesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePharmacyControllerServiceGetAllPharmaciesKey =
  "PharmacyControllerServiceGetAllPharmacies";
export const UsePharmacyControllerServiceGetAllPharmaciesKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  usePharmacyControllerServiceGetAllPharmaciesKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type PatientVaccinationControllerServiceGetPatientVaccinationByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.getPatientVaccinationByUuid
    >
  >;
export type PatientVaccinationControllerServiceGetPatientVaccinationByUuidQueryResult<
  TData =
    PatientVaccinationControllerServiceGetPatientVaccinationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientVaccinationControllerServiceGetPatientVaccinationByUuidKey =
  "PatientVaccinationControllerServiceGetPatientVaccinationByUuid";
export const UsePatientVaccinationControllerServiceGetPatientVaccinationByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientVaccinationControllerServiceGetPatientVaccinationByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type PatientVaccinationControllerServiceGetAllVaccinationsForPdfDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.getAllVaccinationsForPdf
    >
  >;
export type PatientVaccinationControllerServiceGetAllVaccinationsForPdfQueryResult<
  TData =
    PatientVaccinationControllerServiceGetAllVaccinationsForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientVaccinationControllerServiceGetAllVaccinationsForPdfKey =
  "PatientVaccinationControllerServiceGetAllVaccinationsForPdf";
export const UsePatientVaccinationControllerServiceGetAllVaccinationsForPdfKeyFn =
  (
    {
      patientUuid,
    }: {
      patientUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientVaccinationControllerServiceGetAllVaccinationsForPdfKey,
    ...(queryKey ?? [{ patientUuid }]),
  ];
export type PatientVaccinationControllerServiceExportPatientVaccinationsDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.exportPatientVaccinations
    >
  >;
export type PatientVaccinationControllerServiceExportPatientVaccinationsQueryResult<
  TData =
    PatientVaccinationControllerServiceExportPatientVaccinationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientVaccinationControllerServiceExportPatientVaccinationsKey =
  "PatientVaccinationControllerServiceExportPatientVaccinations";
export const UsePatientVaccinationControllerServiceExportPatientVaccinationsKeyFn =
  (
    {
      patientUuid,
    }: {
      patientUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientVaccinationControllerServiceExportPatientVaccinationsKey,
    ...(queryKey ?? [{ patientUuid }]),
  ];
export type PatientVaccinationControllerServiceGetAllPatientVaccinationDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.getAllPatientVaccination
    >
  >;
export type PatientVaccinationControllerServiceGetAllPatientVaccinationQueryResult<
  TData =
    PatientVaccinationControllerServiceGetAllPatientVaccinationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientVaccinationControllerServiceGetAllPatientVaccinationKey =
  "PatientVaccinationControllerServiceGetAllPatientVaccination";
export const UsePatientVaccinationControllerServiceGetAllPatientVaccinationKeyFn =
  (
    {
      isDraft,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
    }: {
      isDraft?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientVaccinationControllerServiceGetAllPatientVaccinationKey,
    ...(queryKey ?? [
      {
        isDraft,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
      },
    ]),
  ];
export type PatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.getAllPatientVaccinationForVaccineTable
    >
  >;
export type PatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableQueryResult<
  TData =
    PatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableKey =
  "PatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTable";
export const UsePatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableKeyFn =
  (
    {
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
      type,
    }: {
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
      type?: "ADULT" | "CHILD";
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientVaccinationControllerServiceGetAllPatientVaccinationForVaccineTableKey,
    ...(queryKey ?? [
      { page, pageSize, patientUuid, sortBy, sortDirection, type },
    ]),
  ];
export type PatientFlagControllerServiceGetPatientFlagByUuidDefaultResponse =
  Awaited<ReturnType<typeof PatientFlagControllerService.getPatientFlagByUuid>>;
export type PatientFlagControllerServiceGetPatientFlagByUuidQueryResult<
  TData = PatientFlagControllerServiceGetPatientFlagByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientFlagControllerServiceGetPatientFlagByUuidKey =
  "PatientFlagControllerServiceGetPatientFlagByUuid";
export const UsePatientFlagControllerServiceGetPatientFlagByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientFlagControllerServiceGetPatientFlagByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type PatientFlagControllerServiceGetAllPatientFlagsDefaultResponse =
  Awaited<ReturnType<typeof PatientFlagControllerService.getAllPatientFlags>>;
export type PatientFlagControllerServiceGetAllPatientFlagsQueryResult<
  TData = PatientFlagControllerServiceGetAllPatientFlagsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientFlagControllerServiceGetAllPatientFlagsKey =
  "PatientFlagControllerServiceGetAllPatientFlags";
export const UsePatientFlagControllerServiceGetAllPatientFlagsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  usePatientFlagControllerServiceGetAllPatientFlagsKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type PastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof PastSurgicalHistoryControllerService.getPastSurgicalHistoryByUuid
    >
  >;
export type PastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidQueryResult<
  TData =
    PastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidKey =
  "PastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuid";
export const UsePastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePastSurgicalHistoryControllerServiceGetPastSurgicalHistoryByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type PastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryDefaultResponse =
  Awaited<
    ReturnType<
      typeof PastSurgicalHistoryControllerService.getAllPastSurgicalHistory
    >
  >;
export type PastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryQueryResult<
  TData =
    PastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryKey =
  "PastSurgicalHistoryControllerServiceGetAllPastSurgicalHistory";
export const UsePastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryKeyFn =
  (
    {
      draft,
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
    }: {
      draft?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePastSurgicalHistoryControllerServiceGetAllPastSurgicalHistoryKey,
    ...(queryKey ?? [
      { draft, page, pageSize, patientUuid, sortBy, sortDirection },
    ]),
  ];
export type PastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof PastMedicalHistoryControllerService.getPastMedicalHistoryByUuid
    >
  >;
export type PastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidQueryResult<
  TData =
    PastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidKey =
  "PastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuid";
export const UsePastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePastMedicalHistoryControllerServiceGetPastMedicalHistoryByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type PastMedicalHistoryControllerServiceGetAllPastMedicalHistoryDefaultResponse =
  Awaited<
    ReturnType<
      typeof PastMedicalHistoryControllerService.getAllPastMedicalHistory
    >
  >;
export type PastMedicalHistoryControllerServiceGetAllPastMedicalHistoryQueryResult<
  TData =
    PastMedicalHistoryControllerServiceGetAllPastMedicalHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePastMedicalHistoryControllerServiceGetAllPastMedicalHistoryKey =
  "PastMedicalHistoryControllerServiceGetAllPastMedicalHistory";
export const UsePastMedicalHistoryControllerServiceGetAllPastMedicalHistoryKeyFn =
  (
    {
      draft,
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
    }: {
      draft?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePastMedicalHistoryControllerServiceGetAllPastMedicalHistoryKey,
    ...(queryKey ?? [
      { draft, page, pageSize, patientUuid, sortBy, sortDirection },
    ]),
  ];
export type NoteControllerServiceGetNoteByUuidDefaultResponse = Awaited<
  ReturnType<typeof NoteControllerService.getNoteByUuid>
>;
export type NoteControllerServiceGetNoteByUuidQueryResult<
  TData = NoteControllerServiceGetNoteByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNoteControllerServiceGetNoteByUuidKey =
  "NoteControllerServiceGetNoteByUuid";
export const UseNoteControllerServiceGetNoteByUuidKeyFn = (
  {
    noteByUuid,
  }: {
    noteByUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNoteControllerServiceGetNoteByUuidKey,
  ...(queryKey ?? [{ noteByUuid }]),
];
export type NoteControllerServiceGetNoteByThreadUuidDefaultResponse = Awaited<
  ReturnType<typeof NoteControllerService.getNoteByThreadUuid>
>;
export type NoteControllerServiceGetNoteByThreadUuidQueryResult<
  TData = NoteControllerServiceGetNoteByThreadUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNoteControllerServiceGetNoteByThreadUuidKey =
  "NoteControllerServiceGetNoteByThreadUuid";
export const UseNoteControllerServiceGetNoteByThreadUuidKeyFn = (
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNoteControllerServiceGetNoteByThreadUuidKey,
  ...(queryKey ?? [{ threadUuid }]),
];
export type NoteControllerServiceGetAllNotesDefaultResponse = Awaited<
  ReturnType<typeof NoteControllerService.getAllNotes>
>;
export type NoteControllerServiceGetAllNotesQueryResult<
  TData = NoteControllerServiceGetAllNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNoteControllerServiceGetAllNotesKey =
  "NoteControllerServiceGetAllNotes";
export const UseNoteControllerServiceGetAllNotesKeyFn = (
  {
    createdBy,
    createdDate,
    documentNote,
    isPrivate,
    modifiedBy,
    modifiedDate,
    note,
    page,
    patientUuid,
    size,
    sort,
  }: {
    createdBy?: string[];
    createdDate?: string;
    documentNote?:
      | "INTERNAL_NOTE"
      | "EXTERNAL_NOTE"
      | "SOAP_NOTE"
      | "HANDP_NOTE"
      | "EMPLOYEE_NOTE"
      | "PHONE_NOTE"
      | "NON_VISIT_NOTE"
      | "EMAIL_NOTE"
      | "LIVE_NOTE";
    isPrivate?: boolean;
    modifiedBy?: string[];
    modifiedDate?: string;
    note?: string;
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useNoteControllerServiceGetAllNotesKey,
  ...(queryKey ?? [
    {
      createdBy,
      createdDate,
      documentNote,
      isPrivate,
      modifiedBy,
      modifiedDate,
      note,
      page,
      patientUuid,
      size,
      sort,
    },
  ]),
];
export type NoteControllerServiceGetAllFlagNotesDefaultResponse = Awaited<
  ReturnType<typeof NoteControllerService.getAllFlagNotes>
>;
export type NoteControllerServiceGetAllFlagNotesQueryResult<
  TData = NoteControllerServiceGetAllFlagNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNoteControllerServiceGetAllFlagNotesKey =
  "NoteControllerServiceGetAllFlagNotes";
export const UseNoteControllerServiceGetAllFlagNotesKeyFn = (
  {
    employerUuid,
    flag,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    flag?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useNoteControllerServiceGetAllFlagNotesKey,
  ...(queryKey ?? [
    { employerUuid, flag, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type MedicationControllerServiceGetMedicationByUuidDefaultResponse =
  Awaited<ReturnType<typeof MedicationControllerService.getMedicationByUuid>>;
export type MedicationControllerServiceGetMedicationByUuidQueryResult<
  TData = MedicationControllerServiceGetMedicationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMedicationControllerServiceGetMedicationByUuidKey =
  "MedicationControllerServiceGetMedicationByUuid";
export const UseMedicationControllerServiceGetMedicationByUuidKeyFn = (
  {
    medicationUuid,
  }: {
    medicationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMedicationControllerServiceGetMedicationByUuidKey,
  ...(queryKey ?? [{ medicationUuid }]),
];
export type MedicationControllerServiceGetAllMedicationsForPdfDefaultResponse =
  Awaited<
    ReturnType<typeof MedicationControllerService.getAllMedicationsForPdf>
  >;
export type MedicationControllerServiceGetAllMedicationsForPdfQueryResult<
  TData = MedicationControllerServiceGetAllMedicationsForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMedicationControllerServiceGetAllMedicationsForPdfKey =
  "MedicationControllerServiceGetAllMedicationsForPdf";
export const UseMedicationControllerServiceGetAllMedicationsForPdfKeyFn = (
  {
    medicationStatus,
    medicationUuids,
    patientUuid,
  }: {
    medicationStatus?: "PAST" | "ACTIVE" | "PENDING" | "ONGOING" | "COMPLETED";
    medicationUuids?: string[];
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMedicationControllerServiceGetAllMedicationsForPdfKey,
  ...(queryKey ?? [{ medicationStatus, medicationUuids, patientUuid }]),
];
export type MedicationControllerServiceDownloadCsvTemplate11DefaultResponse =
  Awaited<ReturnType<typeof MedicationControllerService.downloadCsvTemplate11>>;
export type MedicationControllerServiceDownloadCsvTemplate11QueryResult<
  TData = MedicationControllerServiceDownloadCsvTemplate11DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMedicationControllerServiceDownloadCsvTemplate11Key =
  "MedicationControllerServiceDownloadCsvTemplate11";
export const UseMedicationControllerServiceDownloadCsvTemplate11KeyFn = (
  queryKey?: Array<unknown>,
) => [
  useMedicationControllerServiceDownloadCsvTemplate11Key,
  ...(queryKey ?? []),
];
export type MedicationControllerServiceGetAllMedicationsDefaultResponse =
  Awaited<ReturnType<typeof MedicationControllerService.getAllMedications>>;
export type MedicationControllerServiceGetAllMedicationsQueryResult<
  TData = MedicationControllerServiceGetAllMedicationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMedicationControllerServiceGetAllMedicationsKey =
  "MedicationControllerServiceGetAllMedications";
export const UseMedicationControllerServiceGetAllMedicationsKeyFn = (
  {
    draft,
    medicationStatus,
    page,
    patientUuid,
    searchString,
    size,
    sort,
  }: {
    draft?: boolean;
    medicationStatus?: "PAST" | "ACTIVE" | "PENDING" | "ONGOING" | "COMPLETED";
    page?: number;
    patientUuid: string;
    searchString?: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useMedicationControllerServiceGetAllMedicationsKey,
  ...(queryKey ?? [
    { draft, medicationStatus, page, patientUuid, searchString, size, sort },
  ]),
];
export type MacroControllerServiceGetMacroByUuidDefaultResponse = Awaited<
  ReturnType<typeof MacroControllerService.getMacroByUuid>
>;
export type MacroControllerServiceGetMacroByUuidQueryResult<
  TData = MacroControllerServiceGetMacroByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMacroControllerServiceGetMacroByUuidKey =
  "MacroControllerServiceGetMacroByUuid";
export const UseMacroControllerServiceGetMacroByUuidKeyFn = (
  {
    macroUuid,
  }: {
    macroUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMacroControllerServiceGetMacroByUuidKey,
  ...(queryKey ?? [{ macroUuid }]),
];
export type MacroControllerServiceGetMacroByTextDefaultResponse = Awaited<
  ReturnType<typeof MacroControllerService.getMacroByText>
>;
export type MacroControllerServiceGetMacroByTextQueryResult<
  TData = MacroControllerServiceGetMacroByTextDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMacroControllerServiceGetMacroByTextKey =
  "MacroControllerServiceGetMacroByText";
export const UseMacroControllerServiceGetMacroByTextKeyFn = (
  {
    macroText,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    macroText: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMacroControllerServiceGetMacroByTextKey,
  ...(queryKey ?? [{ macroText, page, pageSize, sortBy, sortDirection }]),
];
export type MacroControllerServiceGetAllMacroDefaultResponse = Awaited<
  ReturnType<typeof MacroControllerService.getAllMacro>
>;
export type MacroControllerServiceGetAllMacroQueryResult<
  TData = MacroControllerServiceGetAllMacroDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMacroControllerServiceGetAllMacroKey =
  "MacroControllerServiceGetAllMacro";
export const UseMacroControllerServiceGetAllMacroKeyFn = (
  {
    flag,
    isPrivate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    flag?: boolean;
    isPrivate?: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useMacroControllerServiceGetAllMacroKey,
  ...(queryKey ?? [
    { flag, isPrivate, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type LocationControllerServiceGetLocationByUuidDefaultResponse = Awaited<
  ReturnType<typeof LocationControllerService.getLocationByUuid>
>;
export type LocationControllerServiceGetLocationByUuidQueryResult<
  TData = LocationControllerServiceGetLocationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationControllerServiceGetLocationByUuidKey =
  "LocationControllerServiceGetLocationByUuid";
export const UseLocationControllerServiceGetLocationByUuidKeyFn = (
  {
    locationUuid,
  }: {
    locationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLocationControllerServiceGetLocationByUuidKey,
  ...(queryKey ?? [{ locationUuid }]),
];
export type LocationControllerServiceExportLocationsToCsvDefaultResponse =
  Awaited<ReturnType<typeof LocationControllerService.exportLocationsToCsv>>;
export type LocationControllerServiceExportLocationsToCsvQueryResult<
  TData = LocationControllerServiceExportLocationsToCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationControllerServiceExportLocationsToCsvKey =
  "LocationControllerServiceExportLocationsToCsv";
export const UseLocationControllerServiceExportLocationsToCsvKeyFn = (
  {
    locationGroupUuids,
    onlineSignUp,
    state,
  }: {
    locationGroupUuids?: string[];
    onlineSignUp?: boolean;
    state?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLocationControllerServiceExportLocationsToCsvKey,
  ...(queryKey ?? [{ locationGroupUuids, onlineSignUp, state }]),
];
export type LocationControllerServiceGetAllLocationListDefaultResponse =
  Awaited<ReturnType<typeof LocationControllerService.getAllLocationList>>;
export type LocationControllerServiceGetAllLocationListQueryResult<
  TData = LocationControllerServiceGetAllLocationListDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationControllerServiceGetAllLocationListKey =
  "LocationControllerServiceGetAllLocationList";
export const UseLocationControllerServiceGetAllLocationListKeyFn = (
  queryKey?: Array<unknown>,
) => [useLocationControllerServiceGetAllLocationListKey, ...(queryKey ?? [])];
export type LocationControllerServiceGetAllLocationDefaultResponse = Awaited<
  ReturnType<typeof LocationControllerService.getAllLocation>
>;
export type LocationControllerServiceGetAllLocationQueryResult<
  TData = LocationControllerServiceGetAllLocationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationControllerServiceGetAllLocationKey =
  "LocationControllerServiceGetAllLocation";
export const UseLocationControllerServiceGetAllLocationKeyFn = (
  {
    adminUserUuid,
    affiliateGroupUuids,
    isAffiliate,
    locationGroupUuids,
    nurseStaffUuid,
    onlineSignUp,
    page,
    pageSize,
    providerUuid,
    searchString,
    sortBy,
    sortDirection,
    state,
    status,
  }: {
    adminUserUuid?: string;
    affiliateGroupUuids?: string[];
    isAffiliate?: boolean;
    locationGroupUuids?: string[];
    nurseStaffUuid?: string;
    onlineSignUp?: boolean;
    page?: number;
    pageSize?: number;
    providerUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    state?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLocationControllerServiceGetAllLocationKey,
  ...(queryKey ?? [
    {
      adminUserUuid,
      affiliateGroupUuids,
      isAffiliate,
      locationGroupUuids,
      nurseStaffUuid,
      onlineSignUp,
      page,
      pageSize,
      providerUuid,
      searchString,
      sortBy,
      sortDirection,
      state,
      status,
    },
  ]),
];
export type LocationShareableSettingControllerServiceGetAllSettingsByLocationDefaultResponse =
  Awaited<
    ReturnType<
      typeof LocationShareableSettingControllerService.getAllSettingsByLocation
    >
  >;
export type LocationShareableSettingControllerServiceGetAllSettingsByLocationQueryResult<
  TData =
    LocationShareableSettingControllerServiceGetAllSettingsByLocationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationShareableSettingControllerServiceGetAllSettingsByLocationKey =
  "LocationShareableSettingControllerServiceGetAllSettingsByLocation";
export const UseLocationShareableSettingControllerServiceGetAllSettingsByLocationKeyFn =
  (
    {
      locationUuid,
    }: {
      locationUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useLocationShareableSettingControllerServiceGetAllSettingsByLocationKey,
    ...(queryKey ?? [{ locationUuid }]),
  ];
export type LocationGroupControllerServiceGetLocationGroupByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof LocationGroupControllerService.getLocationGroupByUuid>
  >;
export type LocationGroupControllerServiceGetLocationGroupByUuidQueryResult<
  TData = LocationGroupControllerServiceGetLocationGroupByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationGroupControllerServiceGetLocationGroupByUuidKey =
  "LocationGroupControllerServiceGetLocationGroupByUuid";
export const UseLocationGroupControllerServiceGetLocationGroupByUuidKeyFn = (
  {
    locationGroupUuid,
  }: {
    locationGroupUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLocationGroupControllerServiceGetLocationGroupByUuidKey,
  ...(queryKey ?? [{ locationGroupUuid }]),
];
export type LocationGroupControllerServiceGetAllLocationGroupDefaultResponse =
  Awaited<
    ReturnType<typeof LocationGroupControllerService.getAllLocationGroup>
  >;
export type LocationGroupControllerServiceGetAllLocationGroupQueryResult<
  TData = LocationGroupControllerServiceGetAllLocationGroupDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationGroupControllerServiceGetAllLocationGroupKey =
  "LocationGroupControllerServiceGetAllLocationGroup";
export const UseLocationGroupControllerServiceGetAllLocationGroupKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLocationGroupControllerServiceGetAllLocationGroupKey,
  ...(queryKey ?? [
    { page, pageSize, searchString, sortBy, sortDirection, status },
  ]),
];
export type LocationAvailabilityControllerServiceGetLocationAvailabilityByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof LocationAvailabilityControllerService.getLocationAvailabilityByUuid
    >
  >;
export type LocationAvailabilityControllerServiceGetLocationAvailabilityByUuidQueryResult<
  TData =
    LocationAvailabilityControllerServiceGetLocationAvailabilityByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationAvailabilityControllerServiceGetLocationAvailabilityByUuidKey =
  "LocationAvailabilityControllerServiceGetLocationAvailabilityByUuid";
export const UseLocationAvailabilityControllerServiceGetLocationAvailabilityByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useLocationAvailabilityControllerServiceGetLocationAvailabilityByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type LocationAvailabilityControllerServiceGetAllLocationAvailabilityDefaultResponse =
  Awaited<
    ReturnType<
      typeof LocationAvailabilityControllerService.getAllLocationAvailability
    >
  >;
export type LocationAvailabilityControllerServiceGetAllLocationAvailabilityQueryResult<
  TData =
    LocationAvailabilityControllerServiceGetAllLocationAvailabilityDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLocationAvailabilityControllerServiceGetAllLocationAvailabilityKey =
  "LocationAvailabilityControllerServiceGetAllLocationAvailability";
export const UseLocationAvailabilityControllerServiceGetAllLocationAvailabilityKeyFn =
  (
    {
      page,
      pageSize,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useLocationAvailabilityControllerServiceGetAllLocationAvailabilityKey,
    ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
  ];
export type PatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientDefaultResponse =
  Awaited<
    ReturnType<
      typeof PatientLinkPharmacyControllerService.getAllPharmaciesForPatient
    >
  >;
export type PatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientQueryResult<
  TData =
    PatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientKey =
  "PatientLinkPharmacyControllerServiceGetAllPharmaciesForPatient";
export const UsePatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientKeyFn =
  (
    {
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      pageSize?: number;
      patientUuid: string;
      sortBy?: string;
      sortDirection?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    usePatientLinkPharmacyControllerServiceGetAllPharmaciesForPatientKey,
    ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
  ];
export type LabTestControllerServiceGetLabTestByUuidDefaultResponse = Awaited<
  ReturnType<typeof LabTestControllerService.getLabTestByUuid>
>;
export type LabTestControllerServiceGetLabTestByUuidQueryResult<
  TData = LabTestControllerServiceGetLabTestByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabTestControllerServiceGetLabTestByUuidKey =
  "LabTestControllerServiceGetLabTestByUuid";
export const UseLabTestControllerServiceGetLabTestByUuidKeyFn = (
  {
    labTestUuid,
  }: {
    labTestUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabTestControllerServiceGetLabTestByUuidKey,
  ...(queryKey ?? [{ labTestUuid }]),
];
export type LabTestControllerServiceGetAllLabTestDefaultResponse = Awaited<
  ReturnType<typeof LabTestControllerService.getAllLabTest>
>;
export type LabTestControllerServiceGetAllLabTestQueryResult<
  TData = LabTestControllerServiceGetAllLabTestDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabTestControllerServiceGetAllLabTestKey =
  "LabTestControllerServiceGetAllLabTest";
export const UseLabTestControllerServiceGetAllLabTestKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabTestControllerServiceGetAllLabTestKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type LabResultControllerServiceGetAllLabResultsByOrderUuidDefaultResponse =
  Awaited<
    ReturnType<typeof LabResultControllerService.getAllLabResultsByOrderUuid>
  >;
export type LabResultControllerServiceGetAllLabResultsByOrderUuidQueryResult<
  TData = LabResultControllerServiceGetAllLabResultsByOrderUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabResultControllerServiceGetAllLabResultsByOrderUuidKey =
  "LabResultControllerServiceGetAllLabResultsByOrderUuid";
export const UseLabResultControllerServiceGetAllLabResultsByOrderUuidKeyFn = (
  {
    orderUuid,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    orderUuid: string;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabResultControllerServiceGetAllLabResultsByOrderUuidKey,
  ...(queryKey ?? [{ orderUuid, page, pageSize, sortBy, sortDirection }]),
];
export type LabResultControllerServiceGetAllLabResultsByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof LabResultControllerService.getAllLabResultsByPatientUuid>
  >;
export type LabResultControllerServiceGetAllLabResultsByPatientUuidQueryResult<
  TData =
    LabResultControllerServiceGetAllLabResultsByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabResultControllerServiceGetAllLabResultsByPatientUuidKey =
  "LabResultControllerServiceGetAllLabResultsByPatientUuid";
export const UseLabResultControllerServiceGetAllLabResultsByPatientUuidKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    search,
    sortBy,
    sortDirection,
    status,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  },
  queryKey?: Array<unknown>,
) => [
  useLabResultControllerServiceGetAllLabResultsByPatientUuidKey,
  ...(queryKey ?? [
    { page, pageSize, patientUuid, search, sortBy, sortDirection, status },
  ]),
];
export type LabResultControllerServiceGetAllLabResultsDefaultResponse = Awaited<
  ReturnType<typeof LabResultControllerService.getAllLabResults>
>;
export type LabResultControllerServiceGetAllLabResultsQueryResult<
  TData = LabResultControllerServiceGetAllLabResultsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabResultControllerServiceGetAllLabResultsKey =
  "LabResultControllerServiceGetAllLabResults";
export const UseLabResultControllerServiceGetAllLabResultsKeyFn = (
  {
    locationUuids,
    page,
    pageSize,
    providerUuids,
    sortBy,
    sortDirection,
    status,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
    status?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabResultControllerServiceGetAllLabResultsKey,
  ...(queryKey ?? [
    {
      locationUuids,
      page,
      pageSize,
      providerUuids,
      sortBy,
      sortDirection,
      status,
    },
  ]),
];
export type LabOrderControllerServiceGetLabOrderByUuidDefaultResponse = Awaited<
  ReturnType<typeof LabOrderControllerService.getLabOrderByUuid>
>;
export type LabOrderControllerServiceGetLabOrderByUuidQueryResult<
  TData = LabOrderControllerServiceGetLabOrderByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetLabOrderByUuidKey =
  "LabOrderControllerServiceGetLabOrderByUuid";
export const UseLabOrderControllerServiceGetLabOrderByUuidKeyFn = (
  {
    labOrderUuid,
  }: {
    labOrderUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetLabOrderByUuidKey,
  ...(queryKey ?? [{ labOrderUuid }]),
];
export type LabOrderControllerServiceGetSpecimenLabelDefaultResponse = Awaited<
  ReturnType<typeof LabOrderControllerService.getSpecimenLabel>
>;
export type LabOrderControllerServiceGetSpecimenLabelQueryResult<
  TData = LabOrderControllerServiceGetSpecimenLabelDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetSpecimenLabelKey =
  "LabOrderControllerServiceGetSpecimenLabel";
export const UseLabOrderControllerServiceGetSpecimenLabelKeyFn = (
  {
    labOrderUuid,
  }: {
    labOrderUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetSpecimenLabelKey,
  ...(queryKey ?? [{ labOrderUuid }]),
];
export type LabOrderControllerServiceGetLabOrderHistoryDefaultResponse =
  Awaited<ReturnType<typeof LabOrderControllerService.getLabOrderHistory>>;
export type LabOrderControllerServiceGetLabOrderHistoryQueryResult<
  TData = LabOrderControllerServiceGetLabOrderHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetLabOrderHistoryKey =
  "LabOrderControllerServiceGetLabOrderHistory";
export const UseLabOrderControllerServiceGetLabOrderHistoryKeyFn = (
  {
    labOrderUuid,
    limit,
  }: {
    labOrderUuid: string;
    limit?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetLabOrderHistoryKey,
  ...(queryKey ?? [{ labOrderUuid, limit }]),
];
export type LabOrderControllerServiceGetTestCodesWithOrderSetsDefaultResponse =
  Awaited<
    ReturnType<typeof LabOrderControllerService.getTestCodesWithOrderSets>
  >;
export type LabOrderControllerServiceGetTestCodesWithOrderSetsQueryResult<
  TData = LabOrderControllerServiceGetTestCodesWithOrderSetsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetTestCodesWithOrderSetsKey =
  "LabOrderControllerServiceGetTestCodesWithOrderSets";
export const UseLabOrderControllerServiceGetTestCodesWithOrderSetsKeyFn = (
  {
    isTrible,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    isTrible: boolean;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetTestCodesWithOrderSetsKey,
  ...(queryKey ?? [
    { isTrible, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type LabOrderControllerServiceGetAllLabOrdersForPdf1DefaultResponse =
  Awaited<ReturnType<typeof LabOrderControllerService.getAllLabOrdersForPdf1>>;
export type LabOrderControllerServiceGetAllLabOrdersForPdf1QueryResult<
  TData = LabOrderControllerServiceGetAllLabOrdersForPdf1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetAllLabOrdersForPdf1Key =
  "LabOrderControllerServiceGetAllLabOrdersForPdf1";
export const UseLabOrderControllerServiceGetAllLabOrdersForPdf1KeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetAllLabOrdersForPdf1Key,
  ...(queryKey ?? [{ patientUuid }]),
];
export type LabOrderControllerServiceGetAllDraftLabAndImagingOrdersDefaultResponse =
  Awaited<
    ReturnType<typeof LabOrderControllerService.getAllDraftLabAndImagingOrders>
  >;
export type LabOrderControllerServiceGetAllDraftLabAndImagingOrdersQueryResult<
  TData =
    LabOrderControllerServiceGetAllDraftLabAndImagingOrdersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetAllDraftLabAndImagingOrdersKey =
  "LabOrderControllerServiceGetAllDraftLabAndImagingOrders";
export const UseLabOrderControllerServiceGetAllDraftLabAndImagingOrdersKeyFn = (
  {
    locationUuids,
    page,
    pageSize,
    patientUuid,
    providerUuids,
    sortBy,
    sortDirection,
  }: {
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    providerUuids?: string[];
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetAllDraftLabAndImagingOrdersKey,
  ...(queryKey ?? [
    {
      locationUuids,
      page,
      pageSize,
      patientUuid,
      providerUuids,
      sortBy,
      sortDirection,
    },
  ]),
];
export type LabOrderControllerServiceGetAllLabOrderDefaultResponse = Awaited<
  ReturnType<typeof LabOrderControllerService.getAllLabOrder>
>;
export type LabOrderControllerServiceGetAllLabOrderQueryResult<
  TData = LabOrderControllerServiceGetAllLabOrderDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderControllerServiceGetAllLabOrderKey =
  "LabOrderControllerServiceGetAllLabOrder";
export const UseLabOrderControllerServiceGetAllLabOrderKeyFn = (
  {
    archive,
    draft,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    archive?: boolean;
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabOrderControllerServiceGetAllLabOrderKey,
  ...(queryKey ?? [
    {
      archive,
      draft,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type LabOrderSetControllerServiceGetLabOrderSetByUuidDefaultResponse =
  Awaited<ReturnType<typeof LabOrderSetControllerService.getLabOrderSetByUuid>>;
export type LabOrderSetControllerServiceGetLabOrderSetByUuidQueryResult<
  TData = LabOrderSetControllerServiceGetLabOrderSetByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderSetControllerServiceGetLabOrderSetByUuidKey =
  "LabOrderSetControllerServiceGetLabOrderSetByUuid";
export const UseLabOrderSetControllerServiceGetLabOrderSetByUuidKeyFn = (
  {
    labOrderSetUuid,
  }: {
    labOrderSetUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useLabOrderSetControllerServiceGetLabOrderSetByUuidKey,
  ...(queryKey ?? [{ labOrderSetUuid }]),
];
export type LabOrderSetControllerServiceGetAllLabOrderSetDefaultResponse =
  Awaited<ReturnType<typeof LabOrderSetControllerService.getAllLabOrderSet>>;
export type LabOrderSetControllerServiceGetAllLabOrderSetQueryResult<
  TData = LabOrderSetControllerServiceGetAllLabOrderSetDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderSetControllerServiceGetAllLabOrderSetKey =
  "LabOrderSetControllerServiceGetAllLabOrderSet";
export const UseLabOrderSetControllerServiceGetAllLabOrderSetKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabOrderSetControllerServiceGetAllLabOrderSetKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type LabOrderSetControllerServiceGetGlobalLabOrderSetDefaultResponse =
  Awaited<ReturnType<typeof LabOrderSetControllerService.getGlobalLabOrderSet>>;
export type LabOrderSetControllerServiceGetGlobalLabOrderSetQueryResult<
  TData = LabOrderSetControllerServiceGetGlobalLabOrderSetDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useLabOrderSetControllerServiceGetGlobalLabOrderSetKey =
  "LabOrderSetControllerServiceGetGlobalLabOrderSet";
export const UseLabOrderSetControllerServiceGetGlobalLabOrderSetKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useLabOrderSetControllerServiceGetGlobalLabOrderSetKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type InvoiceControllerServiceGetInvoiceByUuidDefaultResponse = Awaited<
  ReturnType<typeof InvoiceControllerService.getInvoiceByUuid>
>;
export type InvoiceControllerServiceGetInvoiceByUuidQueryResult<
  TData = InvoiceControllerServiceGetInvoiceByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceControllerServiceGetInvoiceByUuidKey =
  "InvoiceControllerServiceGetInvoiceByUuid";
export const UseInvoiceControllerServiceGetInvoiceByUuidKeyFn = (
  {
    invoiceUuid,
  }: {
    invoiceUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useInvoiceControllerServiceGetInvoiceByUuidKey,
  ...(queryKey ?? [{ invoiceUuid }]),
];
export type InvoiceControllerServiceGetInvoiceStatement1DefaultResponse =
  Awaited<ReturnType<typeof InvoiceControllerService.getInvoiceStatement1>>;
export type InvoiceControllerServiceGetInvoiceStatement1QueryResult<
  TData = InvoiceControllerServiceGetInvoiceStatement1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceControllerServiceGetInvoiceStatement1Key =
  "InvoiceControllerServiceGetInvoiceStatement1";
export const UseInvoiceControllerServiceGetInvoiceStatement1KeyFn = (
  {
    page,
    patientUuid,
    size,
    sort,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useInvoiceControllerServiceGetInvoiceStatement1Key,
  ...(queryKey ?? [{ page, patientUuid, size, sort }]),
];
export type InvoiceControllerServiceExportInvoicesToCsvDefaultResponse =
  Awaited<ReturnType<typeof InvoiceControllerService.exportInvoicesToCsv>>;
export type InvoiceControllerServiceExportInvoicesToCsvQueryResult<
  TData = InvoiceControllerServiceExportInvoicesToCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceControllerServiceExportInvoicesToCsvKey =
  "InvoiceControllerServiceExportInvoicesToCsv";
export const UseInvoiceControllerServiceExportInvoicesToCsvKeyFn = (
  {
    brokerFirmUuids,
    employerUuidForBrokerInvoice,
    endDate,
    invoiceChargeType,
    invoiceStatus,
    invoiceUuid,
    invoiceUuids,
    searchString,
    startDate,
    userTypes,
    userUuid,
  }: {
    brokerFirmUuids?: string[];
    employerUuidForBrokerInvoice?: string;
    endDate?: string;
    invoiceChargeType?:
      | "MEMBERSHIP_CHARGE"
      | "PROCEDURE_CHARGE"
      | "MEDICATION_CHARGE"
      | "LAB_CHARGE"
      | "PANEL_CHARGE"
      | "ANCILLARY_CHARGE"
      | "AFFILIATE_COMMISSION_INVOICE"
      | "ADDITIONAL_SERVICE_INVOICE"
      | "COMMISSION_CHARGE";
    invoiceStatus?: (
      | "PAID"
      | "PARTIALLY_PAID"
      | "UNPAID"
      | "BAD_DEBT"
      | "VOID"
      | "OVERDUE"
      | "DRAFT"
      | "PARTIALLY_REFUNDED"
      | "REFUNDED"
      | "PROCESSING"
      | "ISSUED"
    )[];
    invoiceUuid?: string;
    invoiceUuids?: string[];
    searchString?: string;
    startDate?: string;
    userTypes?:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useInvoiceControllerServiceExportInvoicesToCsvKey,
  ...(queryKey ?? [
    {
      brokerFirmUuids,
      employerUuidForBrokerInvoice,
      endDate,
      invoiceChargeType,
      invoiceStatus,
      invoiceUuid,
      invoiceUuids,
      searchString,
      startDate,
      userTypes,
      userUuid,
    },
  ]),
];
export type InvoiceControllerServiceGetAllInvoicesDefaultResponse = Awaited<
  ReturnType<typeof InvoiceControllerService.getAllInvoices>
>;
export type InvoiceControllerServiceGetAllInvoicesQueryResult<
  TData = InvoiceControllerServiceGetAllInvoicesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInvoiceControllerServiceGetAllInvoicesKey =
  "InvoiceControllerServiceGetAllInvoices";
export const UseInvoiceControllerServiceGetAllInvoicesKeyFn = (
  {
    brokerFirmUuids,
    employerUuidForBrokerInvoice,
    endDate,
    invoiceChargeType,
    invoiceStatus,
    invoiceUuid,
    page,
    searchString,
    size,
    sort,
    startDate,
    userTypes,
    userUuid,
  }: {
    brokerFirmUuids?: string[];
    employerUuidForBrokerInvoice?: string;
    endDate?: string;
    invoiceChargeType?:
      | "MEMBERSHIP_CHARGE"
      | "PROCEDURE_CHARGE"
      | "MEDICATION_CHARGE"
      | "LAB_CHARGE"
      | "PANEL_CHARGE"
      | "ANCILLARY_CHARGE"
      | "AFFILIATE_COMMISSION_INVOICE"
      | "ADDITIONAL_SERVICE_INVOICE"
      | "COMMISSION_CHARGE";
    invoiceStatus?: (
      | "PAID"
      | "PARTIALLY_PAID"
      | "UNPAID"
      | "BAD_DEBT"
      | "VOID"
      | "OVERDUE"
      | "DRAFT"
      | "PARTIALLY_REFUNDED"
      | "REFUNDED"
      | "PROCESSING"
      | "ISSUED"
    )[];
    invoiceUuid?: string;
    page?: number;
    searchString?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
    userTypes:
      | "EMPLOYER"
      | "PATIENT"
      | "BROKER"
      | "ADMIN_USER"
      | "PROVIDER"
      | "EMPLOYER_ADMINISTRATION"
      | "EMPLOYEE"
      | "PHP_USER"
      | "AFFILIATE_FIRM"
      | "BROKER_FIRM"
      | "NURSE_USER";
    userUuid?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useInvoiceControllerServiceGetAllInvoicesKey,
  ...(queryKey ?? [
    {
      brokerFirmUuids,
      employerUuidForBrokerInvoice,
      endDate,
      invoiceChargeType,
      invoiceStatus,
      invoiceUuid,
      page,
      searchString,
      size,
      sort,
      startDate,
      userTypes,
      userUuid,
    },
  ]),
];
export type InsuranceControllerServiceGetAllPatientInsuranceWithDependentsDefaultResponse =
  Awaited<
    ReturnType<
      typeof InsuranceControllerService.getAllPatientInsuranceWithDependents
    >
  >;
export type InsuranceControllerServiceGetAllPatientInsuranceWithDependentsQueryResult<
  TData =
    InsuranceControllerServiceGetAllPatientInsuranceWithDependentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInsuranceControllerServiceGetAllPatientInsuranceWithDependentsKey =
  "InsuranceControllerServiceGetAllPatientInsuranceWithDependents";
export const UseInsuranceControllerServiceGetAllPatientInsuranceWithDependentsKeyFn =
  (
    {
      patientUuid,
    }: {
      patientUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useInsuranceControllerServiceGetAllPatientInsuranceWithDependentsKey,
    ...(queryKey ?? [{ patientUuid }]),
  ];
export type InsuranceControllerServiceGetInsuranceByUuidDefaultResponse =
  Awaited<ReturnType<typeof InsuranceControllerService.getInsuranceByUuid>>;
export type InsuranceControllerServiceGetInsuranceByUuidQueryResult<
  TData = InsuranceControllerServiceGetInsuranceByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInsuranceControllerServiceGetInsuranceByUuidKey =
  "InsuranceControllerServiceGetInsuranceByUuid";
export const UseInsuranceControllerServiceGetInsuranceByUuidKeyFn = (
  {
    insuranceUuid,
  }: {
    insuranceUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useInsuranceControllerServiceGetInsuranceByUuidKey,
  ...(queryKey ?? [{ insuranceUuid }]),
];
export type InsuranceControllerServiceGetAllPatientInsuranceDefaultResponse =
  Awaited<ReturnType<typeof InsuranceControllerService.getAllPatientInsurance>>;
export type InsuranceControllerServiceGetAllPatientInsuranceQueryResult<
  TData = InsuranceControllerServiceGetAllPatientInsuranceDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useInsuranceControllerServiceGetAllPatientInsuranceKey =
  "InsuranceControllerServiceGetAllPatientInsurance";
export const UseInsuranceControllerServiceGetAllPatientInsuranceKeyFn = (
  {
    active,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    active?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useInsuranceControllerServiceGetAllPatientInsuranceKey,
  ...(queryKey ?? [
    {
      active,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type ImagingResultControllerServiceGetImagingResultByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ImagingResultControllerService.getImagingResultByUuid>
  >;
export type ImagingResultControllerServiceGetImagingResultByUuidQueryResult<
  TData = ImagingResultControllerServiceGetImagingResultByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useImagingResultControllerServiceGetImagingResultByUuidKey =
  "ImagingResultControllerServiceGetImagingResultByUuid";
export const UseImagingResultControllerServiceGetImagingResultByUuidKeyFn = (
  {
    imagingResultByUuid,
  }: {
    imagingResultByUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useImagingResultControllerServiceGetImagingResultByUuidKey,
  ...(queryKey ?? [{ imagingResultByUuid }]),
];
export type ImagingResultControllerServiceExportCsv1DefaultResponse = Awaited<
  ReturnType<typeof ImagingResultControllerService.exportCsv1>
>;
export type ImagingResultControllerServiceExportCsv1QueryResult<
  TData = ImagingResultControllerServiceExportCsv1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useImagingResultControllerServiceExportCsv1Key =
  "ImagingResultControllerServiceExportCsv1";
export const UseImagingResultControllerServiceExportCsv1KeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useImagingResultControllerServiceExportCsv1Key,
  ...(queryKey ?? [{ patientUuid }]),
];
export type ImagingResultControllerServiceGetAllImagingResultsDefaultResponse =
  Awaited<
    ReturnType<typeof ImagingResultControllerService.getAllImagingResults>
  >;
export type ImagingResultControllerServiceGetAllImagingResultsQueryResult<
  TData = ImagingResultControllerServiceGetAllImagingResultsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useImagingResultControllerServiceGetAllImagingResultsKey =
  "ImagingResultControllerServiceGetAllImagingResults";
export const UseImagingResultControllerServiceGetAllImagingResultsKeyFn = (
  {
    page,
    patientUuid,
    providerUuids,
    searchString,
    size,
    sort,
    status,
  }: {
    page?: number;
    patientUuid: string;
    providerUuids?: string[];
    searchString?: string;
    size?: number;
    sort?: string[];
    status?: boolean;
  },
  queryKey?: Array<unknown>,
) => [
  useImagingResultControllerServiceGetAllImagingResultsKey,
  ...(queryKey ?? [
    { page, patientUuid, providerUuids, searchString, size, sort, status },
  ]),
];
export type ImagingOrderControllerServiceGetImagingOrderByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ImagingOrderControllerService.getImagingOrderByUuid>
  >;
export type ImagingOrderControllerServiceGetImagingOrderByUuidQueryResult<
  TData = ImagingOrderControllerServiceGetImagingOrderByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useImagingOrderControllerServiceGetImagingOrderByUuidKey =
  "ImagingOrderControllerServiceGetImagingOrderByUuid";
export const UseImagingOrderControllerServiceGetImagingOrderByUuidKeyFn = (
  {
    imagingOrderByUuid,
  }: {
    imagingOrderByUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useImagingOrderControllerServiceGetImagingOrderByUuidKey,
  ...(queryKey ?? [{ imagingOrderByUuid }]),
];
export type ImagingOrderControllerServiceGetAllImagingOrderDefaultResponse =
  Awaited<ReturnType<typeof ImagingOrderControllerService.getAllImagingOrder>>;
export type ImagingOrderControllerServiceGetAllImagingOrderQueryResult<
  TData = ImagingOrderControllerServiceGetAllImagingOrderDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useImagingOrderControllerServiceGetAllImagingOrderKey =
  "ImagingOrderControllerServiceGetAllImagingOrder";
export const UseImagingOrderControllerServiceGetAllImagingOrderKeyFn = (
  {
    page,
    patientUuid,
    size,
    sort,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sort?: string[];
  },
  queryKey?: Array<unknown>,
) => [
  useImagingOrderControllerServiceGetAllImagingOrderKey,
  ...(queryKey ?? [{ page, patientUuid, size, sort }]),
];
export type IcdCodeControllerServiceGetIcdCodeByUuidDefaultResponse = Awaited<
  ReturnType<typeof IcdCodeControllerService.getIcdCodeByUuid>
>;
export type IcdCodeControllerServiceGetIcdCodeByUuidQueryResult<
  TData = IcdCodeControllerServiceGetIcdCodeByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useIcdCodeControllerServiceGetIcdCodeByUuidKey =
  "IcdCodeControllerServiceGetIcdCodeByUuid";
export const UseIcdCodeControllerServiceGetIcdCodeByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useIcdCodeControllerServiceGetIcdCodeByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type IcdCodeControllerServiceSearchExternalIcdCodesDefaultResponse =
  Awaited<ReturnType<typeof IcdCodeControllerService.searchExternalIcdCodes>>;
export type IcdCodeControllerServiceSearchExternalIcdCodesQueryResult<
  TData = IcdCodeControllerServiceSearchExternalIcdCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useIcdCodeControllerServiceSearchExternalIcdCodesKey =
  "IcdCodeControllerServiceSearchExternalIcdCodes";
export const UseIcdCodeControllerServiceSearchExternalIcdCodesKeyFn = (
  {
    page,
    pageSize,
    searchString,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useIcdCodeControllerServiceSearchExternalIcdCodesKey,
  ...(queryKey ?? [{ page, pageSize, searchString }]),
];
export type IcdCodeControllerServiceGetAllIcdCodesDefaultResponse = Awaited<
  ReturnType<typeof IcdCodeControllerService.getAllIcdCodes>
>;
export type IcdCodeControllerServiceGetAllIcdCodesQueryResult<
  TData = IcdCodeControllerServiceGetAllIcdCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useIcdCodeControllerServiceGetAllIcdCodesKey =
  "IcdCodeControllerServiceGetAllIcdCodes";
export const UseIcdCodeControllerServiceGetAllIcdCodesKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useIcdCodeControllerServiceGetAllIcdCodesKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type HAndPNoteControllerServiceGetHandPnoteByUuidDefaultResponse =
  Awaited<ReturnType<typeof HAndPNoteControllerService.getHandPnoteByUuid>>;
export type HAndPNoteControllerServiceGetHandPnoteByUuidQueryResult<
  TData = HAndPNoteControllerServiceGetHandPnoteByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetHandPnoteByUuidKey =
  "HAndPNoteControllerServiceGetHandPnoteByUuid";
export const UseHAndPNoteControllerServiceGetHandPnoteByUuidKeyFn = (
  {
    userUuid,
    uuid,
  }: {
    userUuid?: string;
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetHandPnoteByUuidKey,
  ...(queryKey ?? [{ userUuid, uuid }]),
];
export type HAndPNoteControllerServiceGetUnsignedNotesByUserDefaultResponse =
  Awaited<ReturnType<typeof HAndPNoteControllerService.getUnsignedNotesByUser>>;
export type HAndPNoteControllerServiceGetUnsignedNotesByUserQueryResult<
  TData = HAndPNoteControllerServiceGetUnsignedNotesByUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetUnsignedNotesByUserKey =
  "HAndPNoteControllerServiceGetUnsignedNotesByUser";
export const UseHAndPNoteControllerServiceGetUnsignedNotesByUserKeyFn = (
  {
    appointmentModes,
    appointmentTypeUuids,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
    startDateTime,
    userUuid,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetUnsignedNotesByUserKey,
  ...(queryKey ?? [
    {
      appointmentModes,
      appointmentTypeUuids,
      endDateTime,
      locationUuids,
      page,
      pageSize,
      patientUuids,
      providerUuids,
      searchString,
      sortBy,
      sortDirection,
      startDateTime,
      userUuid,
    },
  ]),
];
export type HAndPNoteControllerServiceGetHandPnotesByPatientUuidDefaultResponse =
  Awaited<
    ReturnType<typeof HAndPNoteControllerService.getHandPnotesByPatientUuid>
  >;
export type HAndPNoteControllerServiceGetHandPnotesByPatientUuidQueryResult<
  TData = HAndPNoteControllerServiceGetHandPnotesByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetHandPnotesByPatientUuidKey =
  "HAndPNoteControllerServiceGetHandPnotesByPatientUuid";
export const UseHAndPNoteControllerServiceGetHandPnotesByPatientUuidKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetHandPnotesByPatientUuidKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type HAndPNoteControllerServiceGetHandPnoteByAppointmentUuidDefaultResponse =
  Awaited<
    ReturnType<typeof HAndPNoteControllerService.getHandPnoteByAppointmentUuid>
  >;
export type HAndPNoteControllerServiceGetHandPnoteByAppointmentUuidQueryResult<
  TData =
    HAndPNoteControllerServiceGetHandPnoteByAppointmentUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetHandPnoteByAppointmentUuidKey =
  "HAndPNoteControllerServiceGetHandPnoteByAppointmentUuid";
export const UseHAndPNoteControllerServiceGetHandPnoteByAppointmentUuidKeyFn = (
  {
    appointmentUuid,
  }: {
    appointmentUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetHandPnoteByAppointmentUuidKey,
  ...(queryKey ?? [{ appointmentUuid }]),
];
export type HAndPNoteControllerServiceGetAllEncountersWithoutDateFilterDefaultResponse =
  Awaited<
    ReturnType<
      typeof HAndPNoteControllerService.getAllEncountersWithoutDateFilter
    >
  >;
export type HAndPNoteControllerServiceGetAllEncountersWithoutDateFilterQueryResult<
  TData =
    HAndPNoteControllerServiceGetAllEncountersWithoutDateFilterDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetAllEncountersWithoutDateFilterKey =
  "HAndPNoteControllerServiceGetAllEncountersWithoutDateFilter";
export const UseHAndPNoteControllerServiceGetAllEncountersWithoutDateFilterKeyFn =
  (
    {
      appointmentModes,
      appointmentTypeUuids,
      locationUuids,
      page,
      pageSize,
      patientUuids,
      providerUuids,
      searchString,
      signed,
      sortBy,
      sortDirection,
    }: {
      appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
      appointmentTypeUuids?: string[];
      locationUuids?: string[];
      page?: number;
      pageSize?: number;
      patientUuids?: string[];
      providerUuids?: string[];
      searchString?: string;
      signed?: boolean;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useHAndPNoteControllerServiceGetAllEncountersWithoutDateFilterKey,
    ...(queryKey ?? [
      {
        appointmentModes,
        appointmentTypeUuids,
        locationUuids,
        page,
        pageSize,
        patientUuids,
        providerUuids,
        searchString,
        signed,
        sortBy,
        sortDirection,
      },
    ]),
  ];
export type HAndPNoteControllerServiceGetAllHandPnotesDefaultResponse = Awaited<
  ReturnType<typeof HAndPNoteControllerService.getAllHandPnotes>
>;
export type HAndPNoteControllerServiceGetAllHandPnotesQueryResult<
  TData = HAndPNoteControllerServiceGetAllHandPnotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetAllHandPnotesKey =
  "HAndPNoteControllerServiceGetAllHandPnotes";
export const UseHAndPNoteControllerServiceGetAllHandPnotesKeyFn = (
  {
    isDraft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    isDraft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetAllHandPnotesKey,
  ...(queryKey ?? [
    { isDraft, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type HAndPNoteControllerServiceGetAllEncounterDefaultResponse = Awaited<
  ReturnType<typeof HAndPNoteControllerService.getAllEncounter>
>;
export type HAndPNoteControllerServiceGetAllEncounterQueryResult<
  TData = HAndPNoteControllerServiceGetAllEncounterDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHAndPNoteControllerServiceGetAllEncounterKey =
  "HAndPNoteControllerServiceGetAllEncounter";
export const UseHAndPNoteControllerServiceGetAllEncounterKeyFn = (
  {
    appointmentModes,
    appointmentTypeUuids,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    signed,
    sortBy,
    sortDirection,
    startDateTime,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useHAndPNoteControllerServiceGetAllEncounterKey,
  ...(queryKey ?? [
    {
      appointmentModes,
      appointmentTypeUuids,
      endDateTime,
      locationUuids,
      page,
      pageSize,
      patientUuids,
      providerUuids,
      searchString,
      signed,
      sortBy,
      sortDirection,
      startDateTime,
    },
  ]),
];
export type HabitsControllerServiceGetHabitsByUuidDefaultResponse = Awaited<
  ReturnType<typeof HabitsControllerService.getHabitsByUuid>
>;
export type HabitsControllerServiceGetHabitsByUuidQueryResult<
  TData = HabitsControllerServiceGetHabitsByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHabitsControllerServiceGetHabitsByUuidKey =
  "HabitsControllerServiceGetHabitsByUuid";
export const UseHabitsControllerServiceGetHabitsByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHabitsControllerServiceGetHabitsByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type HabitsControllerServiceGetAllHabitsDefaultResponse = Awaited<
  ReturnType<typeof HabitsControllerService.getAllHabits>
>;
export type HabitsControllerServiceGetAllHabitsQueryResult<
  TData = HabitsControllerServiceGetAllHabitsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useHabitsControllerServiceGetAllHabitsKey =
  "HabitsControllerServiceGetAllHabits";
export const UseHabitsControllerServiceGetAllHabitsKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useHabitsControllerServiceGetAllHabitsKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type GlobalHolidayControllerServiceGetGlobalHolidayByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.getGlobalHolidayByUuid>
  >;
export type GlobalHolidayControllerServiceGetGlobalHolidayByUuidQueryResult<
  TData = GlobalHolidayControllerServiceGetGlobalHolidayByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGlobalHolidayControllerServiceGetGlobalHolidayByUuidKey =
  "GlobalHolidayControllerServiceGetGlobalHolidayByUuid";
export const UseGlobalHolidayControllerServiceGetGlobalHolidayByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useGlobalHolidayControllerServiceGetGlobalHolidayByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type GlobalHolidayControllerServiceGetHolidaysForLocationDefaultResponse =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.getHolidaysForLocation>
  >;
export type GlobalHolidayControllerServiceGetHolidaysForLocationQueryResult<
  TData = GlobalHolidayControllerServiceGetHolidaysForLocationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGlobalHolidayControllerServiceGetHolidaysForLocationKey =
  "GlobalHolidayControllerServiceGetHolidaysForLocation";
export const UseGlobalHolidayControllerServiceGetHolidaysForLocationKeyFn = (
  {
    locationUuid,
  }: {
    locationUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useGlobalHolidayControllerServiceGetHolidaysForLocationKey,
  ...(queryKey ?? [{ locationUuid }]),
];
export type GlobalHolidayControllerServiceGetAllGlobalHolidaysDefaultResponse =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.getAllGlobalHolidays>
  >;
export type GlobalHolidayControllerServiceGetAllGlobalHolidaysQueryResult<
  TData = GlobalHolidayControllerServiceGetAllGlobalHolidaysDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGlobalHolidayControllerServiceGetAllGlobalHolidaysKey =
  "GlobalHolidayControllerServiceGetAllGlobalHolidays";
export const UseGlobalHolidayControllerServiceGetAllGlobalHolidaysKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    year,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    year?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useGlobalHolidayControllerServiceGetAllGlobalHolidaysKey,
  ...(queryKey ?? [
    { page, pageSize, searchString, sortBy, sortDirection, year },
  ]),
];
export type FormTemplateControllerServiceGetFormTemplateByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof FormTemplateControllerService.getFormTemplateByUuid>
  >;
export type FormTemplateControllerServiceGetFormTemplateByUuidQueryResult<
  TData = FormTemplateControllerServiceGetFormTemplateByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFormTemplateControllerServiceGetFormTemplateByUuidKey =
  "FormTemplateControllerServiceGetFormTemplateByUuid";
export const UseFormTemplateControllerServiceGetFormTemplateByUuidKeyFn = (
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFormTemplateControllerServiceGetFormTemplateByUuidKey,
  ...(queryKey ?? [{ formTemplateUuid }]),
];
export type FormTemplateControllerServiceGetAllFormTemplatesDefaultResponse =
  Awaited<ReturnType<typeof FormTemplateControllerService.getAllFormTemplates>>;
export type FormTemplateControllerServiceGetAllFormTemplatesQueryResult<
  TData = FormTemplateControllerServiceGetAllFormTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFormTemplateControllerServiceGetAllFormTemplatesKey =
  "FormTemplateControllerServiceGetAllFormTemplates";
export const UseFormTemplateControllerServiceGetAllFormTemplatesKeyFn = (
  {
    createdBy,
    endDate,
    formBuilderType,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    createdBy?: string[];
    endDate?: string;
    formBuilderType?: (
      | "MEMBERSHIP"
      | "INTAKE"
      | "APPOINTMENTS"
      | "AGREEMENTS"
      | "AFFILIATE_AGREEMENTS"
      | "PATIENT_AGREEMENT"
      | "AGENT_FIRM_AGREEMENTS"
      | "CONSENT"
      | "SEND_SMS"
    )[];
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useFormTemplateControllerServiceGetAllFormTemplatesKey,
  ...(queryKey ?? [
    {
      createdBy,
      endDate,
      formBuilderType,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    },
  ]),
];
export type FormTemplateControllerServiceGetFormJsonDefaultResponse = Awaited<
  ReturnType<typeof FormTemplateControllerService.getFormJson>
>;
export type FormTemplateControllerServiceGetFormJsonQueryResult<
  TData = FormTemplateControllerServiceGetFormJsonDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFormTemplateControllerServiceGetFormJsonKey =
  "FormTemplateControllerServiceGetFormJson";
export const UseFormTemplateControllerServiceGetFormJsonKeyFn = (
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFormTemplateControllerServiceGetFormJsonKey,
  ...(queryKey ?? [{ formTemplateUuid }]),
];
export type FormTemplateControllerServiceCheckIfFormDefaultExistsDefaultResponse =
  Awaited<
    ReturnType<typeof FormTemplateControllerService.checkIfFormDefaultExists>
  >;
export type FormTemplateControllerServiceCheckIfFormDefaultExistsQueryResult<
  TData = FormTemplateControllerServiceCheckIfFormDefaultExistsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFormTemplateControllerServiceCheckIfFormDefaultExistsKey =
  "FormTemplateControllerServiceCheckIfFormDefaultExists";
export const UseFormTemplateControllerServiceCheckIfFormDefaultExistsKeyFn = (
  {
    formTemplateUuid,
  }: {
    formTemplateUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFormTemplateControllerServiceCheckIfFormDefaultExistsKey,
  ...(queryKey ?? [{ formTemplateUuid }]),
];
export type FormTemplateControllerServiceGetFormTemplateContentByTypeDefaultResponse =
  Awaited<
    ReturnType<
      typeof FormTemplateControllerService.getFormTemplateContentByType
    >
  >;
export type FormTemplateControllerServiceGetFormTemplateContentByTypeQueryResult<
  TData =
    FormTemplateControllerServiceGetFormTemplateContentByTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFormTemplateControllerServiceGetFormTemplateContentByTypeKey =
  "FormTemplateControllerServiceGetFormTemplateContentByType";
export const UseFormTemplateControllerServiceGetFormTemplateContentByTypeKeyFn =
  (
    {
      formBuilderType,
    }: {
      formBuilderType:
        | "MEMBERSHIP"
        | "INTAKE"
        | "APPOINTMENTS"
        | "AGREEMENTS"
        | "AFFILIATE_AGREEMENTS"
        | "PATIENT_AGREEMENT"
        | "AGENT_FIRM_AGREEMENTS"
        | "CONSENT"
        | "SEND_SMS";
    },
    queryKey?: Array<unknown>,
  ) => [
    useFormTemplateControllerServiceGetFormTemplateContentByTypeKey,
    ...(queryKey ?? [{ formBuilderType }]),
  ];
export type FdbMedicationsControllerServiceGetFdbMedicationByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof FdbMedicationsControllerService.getFdbMedicationByUuid>
  >;
export type FdbMedicationsControllerServiceGetFdbMedicationByUuidQueryResult<
  TData = FdbMedicationsControllerServiceGetFdbMedicationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFdbMedicationsControllerServiceGetFdbMedicationByUuidKey =
  "FdbMedicationsControllerServiceGetFdbMedicationByUuid";
export const UseFdbMedicationsControllerServiceGetFdbMedicationByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFdbMedicationsControllerServiceGetFdbMedicationByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type FdbMedicationsControllerServiceGetAllFdbMedicationsDefaultResponse =
  Awaited<
    ReturnType<typeof FdbMedicationsControllerService.getAllFdbMedications>
  >;
export type FdbMedicationsControllerServiceGetAllFdbMedicationsQueryResult<
  TData = FdbMedicationsControllerServiceGetAllFdbMedicationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFdbMedicationsControllerServiceGetAllFdbMedicationsKey =
  "FdbMedicationsControllerServiceGetAllFdbMedications";
export const UseFdbMedicationsControllerServiceGetAllFdbMedicationsKeyFn = (
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useFdbMedicationsControllerServiceGetAllFdbMedicationsKey,
  ...(queryKey ?? [{ page, pageSize, search, sortBy, sortDirection }]),
];
export type FamilyHistoryControllerServiceGetFamilyHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof FamilyHistoryControllerService.getFamilyHistoryByUuid>
  >;
export type FamilyHistoryControllerServiceGetFamilyHistoryByUuidQueryResult<
  TData = FamilyHistoryControllerServiceGetFamilyHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFamilyHistoryControllerServiceGetFamilyHistoryByUuidKey =
  "FamilyHistoryControllerServiceGetFamilyHistoryByUuid";
export const UseFamilyHistoryControllerServiceGetFamilyHistoryByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFamilyHistoryControllerServiceGetFamilyHistoryByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type FamilyHistoryControllerServiceGetAllFamilyHistoryDefaultResponse =
  Awaited<
    ReturnType<typeof FamilyHistoryControllerService.getAllFamilyHistory>
  >;
export type FamilyHistoryControllerServiceGetAllFamilyHistoryQueryResult<
  TData = FamilyHistoryControllerServiceGetAllFamilyHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useFamilyHistoryControllerServiceGetAllFamilyHistoryKey =
  "FamilyHistoryControllerServiceGetAllFamilyHistory";
export const UseFamilyHistoryControllerServiceGetAllFamilyHistoryKeyFn = (
  {
    draft,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    draft?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useFamilyHistoryControllerServiceGetAllFamilyHistoryKey,
  ...(queryKey ?? [
    { draft, page, pageSize, patientUuid, sortBy, sortDirection },
  ]),
];
export type EducationalMaterialControllerServiceGetEducationalMaterialByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.getEducationalMaterialByUuid
    >
  >;
export type EducationalMaterialControllerServiceGetEducationalMaterialByUuidQueryResult<
  TData =
    EducationalMaterialControllerServiceGetEducationalMaterialByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEducationalMaterialControllerServiceGetEducationalMaterialByUuidKey =
  "EducationalMaterialControllerServiceGetEducationalMaterialByUuid";
export const UseEducationalMaterialControllerServiceGetEducationalMaterialByUuidKeyFn =
  (
    {
      educationalMaterialUuid,
    }: {
      educationalMaterialUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEducationalMaterialControllerServiceGetEducationalMaterialByUuidKey,
    ...(queryKey ?? [{ educationalMaterialUuid }]),
  ];
export type EducationalMaterialControllerServiceGetAllEducationalMaterialsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.getAllEducationalMaterials
    >
  >;
export type EducationalMaterialControllerServiceGetAllEducationalMaterialsQueryResult<
  TData =
    EducationalMaterialControllerServiceGetAllEducationalMaterialsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEducationalMaterialControllerServiceGetAllEducationalMaterialsKey =
  "EducationalMaterialControllerServiceGetAllEducationalMaterials";
export const UseEducationalMaterialControllerServiceGetAllEducationalMaterialsKeyFn =
  (
    {
      createdByList,
      endDate,
      fileTypes,
      includeAssignments,
      isGlobal,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    }: {
      createdByList?: string[];
      endDate?: string;
      fileTypes?: string;
      includeAssignments?: boolean;
      isGlobal?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid?: string;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useEducationalMaterialControllerServiceGetAllEducationalMaterialsKey,
    ...(queryKey ?? [
      {
        createdByList,
        endDate,
        fileTypes,
        includeAssignments,
        isGlobal,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
    ]),
  ];
export type DrugIntoleranceControllerServiceGetDrugIntoleranceByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof DrugIntoleranceControllerService.getDrugIntoleranceByUuid>
  >;
export type DrugIntoleranceControllerServiceGetDrugIntoleranceByUuidQueryResult<
  TData =
    DrugIntoleranceControllerServiceGetDrugIntoleranceByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDrugIntoleranceControllerServiceGetDrugIntoleranceByUuidKey =
  "DrugIntoleranceControllerServiceGetDrugIntoleranceByUuid";
export const UseDrugIntoleranceControllerServiceGetDrugIntoleranceByUuidKeyFn =
  (
    {
      drugIntoleranceUuid,
    }: {
      drugIntoleranceUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useDrugIntoleranceControllerServiceGetDrugIntoleranceByUuidKey,
    ...(queryKey ?? [{ drugIntoleranceUuid }]),
  ];
export type DrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfDefaultResponse =
  Awaited<
    ReturnType<
      typeof DrugIntoleranceControllerService.getAllDrugIntolerancesForPdf
    >
  >;
export type DrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfQueryResult<
  TData =
    DrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfKey =
  "DrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdf";
export const UseDrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfKeyFn =
  (
    {
      patientUuid,
    }: {
      patientUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useDrugIntoleranceControllerServiceGetAllDrugIntolerancesForPdfKey,
    ...(queryKey ?? [{ patientUuid }]),
  ];
export type DrugIntoleranceControllerServiceGetAllDrugIntolerancesDefaultResponse =
  Awaited<
    ReturnType<typeof DrugIntoleranceControllerService.getAllDrugIntolerances>
  >;
export type DrugIntoleranceControllerServiceGetAllDrugIntolerancesQueryResult<
  TData = DrugIntoleranceControllerServiceGetAllDrugIntolerancesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDrugIntoleranceControllerServiceGetAllDrugIntolerancesKey =
  "DrugIntoleranceControllerServiceGetAllDrugIntolerances";
export const UseDrugIntoleranceControllerServiceGetAllDrugIntolerancesKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDrugIntoleranceControllerServiceGetAllDrugIntolerancesKey,
  ...(queryKey ?? [{ page, pageSize, patientUuid, sortBy, sortDirection }]),
];
export type DocumentTypeControllerServiceGetDocumentTypeByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof DocumentTypeControllerService.getDocumentTypeByUuid>
  >;
export type DocumentTypeControllerServiceGetDocumentTypeByUuidQueryResult<
  TData = DocumentTypeControllerServiceGetDocumentTypeByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDocumentTypeControllerServiceGetDocumentTypeByUuidKey =
  "DocumentTypeControllerServiceGetDocumentTypeByUuid";
export const UseDocumentTypeControllerServiceGetDocumentTypeByUuidKeyFn = (
  {
    documentTypeUuid,
  }: {
    documentTypeUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDocumentTypeControllerServiceGetDocumentTypeByUuidKey,
  ...(queryKey ?? [{ documentTypeUuid }]),
];
export type DocumentTypeControllerServiceGetAllDocumentTypesDefaultResponse =
  Awaited<ReturnType<typeof DocumentTypeControllerService.getAllDocumentTypes>>;
export type DocumentTypeControllerServiceGetAllDocumentTypesQueryResult<
  TData = DocumentTypeControllerServiceGetAllDocumentTypesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDocumentTypeControllerServiceGetAllDocumentTypesKey =
  "DocumentTypeControllerServiceGetAllDocumentTypes";
export const UseDocumentTypeControllerServiceGetAllDocumentTypesKeyFn = (
  {
    documentType,
    page,
    size,
    sort,
  }: {
    documentType?: string;
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useDocumentTypeControllerServiceGetAllDocumentTypesKey,
  ...(queryKey ?? [{ documentType, page, size, sort }]),
];
export type DiagnosisControllerServiceGetDiagnosisByUuidDefaultResponse =
  Awaited<ReturnType<typeof DiagnosisControllerService.getDiagnosisByUuid>>;
export type DiagnosisControllerServiceGetDiagnosisByUuidQueryResult<
  TData = DiagnosisControllerServiceGetDiagnosisByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDiagnosisControllerServiceGetDiagnosisByUuidKey =
  "DiagnosisControllerServiceGetDiagnosisByUuid";
export const UseDiagnosisControllerServiceGetDiagnosisByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDiagnosisControllerServiceGetDiagnosisByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type DiagnosisControllerServiceGetAllDiagnosisForPdfDefaultResponse =
  Awaited<ReturnType<typeof DiagnosisControllerService.getAllDiagnosisForPdf>>;
export type DiagnosisControllerServiceGetAllDiagnosisForPdfQueryResult<
  TData = DiagnosisControllerServiceGetAllDiagnosisForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDiagnosisControllerServiceGetAllDiagnosisForPdfKey =
  "DiagnosisControllerServiceGetAllDiagnosisForPdf";
export const UseDiagnosisControllerServiceGetAllDiagnosisForPdfKeyFn = (
  {
    patientUuid,
    status,
  }: {
    patientUuid: string;
    status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
  },
  queryKey?: Array<unknown>,
) => [
  useDiagnosisControllerServiceGetAllDiagnosisForPdfKey,
  ...(queryKey ?? [{ patientUuid, status }]),
];
export type DiagnosisControllerServiceGetAllDiagnosesDefaultResponse = Awaited<
  ReturnType<typeof DiagnosisControllerService.getAllDiagnoses>
>;
export type DiagnosisControllerServiceGetAllDiagnosesQueryResult<
  TData = DiagnosisControllerServiceGetAllDiagnosesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDiagnosisControllerServiceGetAllDiagnosesKey =
  "DiagnosisControllerServiceGetAllDiagnoses";
export const UseDiagnosisControllerServiceGetAllDiagnosesKeyFn = (
  {
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
    status,
    type,
  }: {
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?: "ACTIVE" | "HISTORICAL" | "RESOLVED";
    type?: "ACUTE" | "CHRONIC";
  },
  queryKey?: Array<unknown>,
) => [
  useDiagnosisControllerServiceGetAllDiagnosesKey,
  ...(queryKey ?? [
    {
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      status,
      type,
    },
  ]),
];
export type CptCodeControllerServiceGetIcdCodeByUuid1DefaultResponse = Awaited<
  ReturnType<typeof CptCodeControllerService.getIcdCodeByUuid1>
>;
export type CptCodeControllerServiceGetIcdCodeByUuid1QueryResult<
  TData = CptCodeControllerServiceGetIcdCodeByUuid1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCptCodeControllerServiceGetIcdCodeByUuid1Key =
  "CptCodeControllerServiceGetIcdCodeByUuid1";
export const UseCptCodeControllerServiceGetIcdCodeByUuid1KeyFn = (
  {
    cptCodeUuid,
  }: {
    cptCodeUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCptCodeControllerServiceGetIcdCodeByUuid1Key,
  ...(queryKey ?? [{ cptCodeUuid }]),
];
export type CptCodeControllerServiceGetAllIcdCodes1DefaultResponse = Awaited<
  ReturnType<typeof CptCodeControllerService.getAllIcdCodes1>
>;
export type CptCodeControllerServiceGetAllIcdCodes1QueryResult<
  TData = CptCodeControllerServiceGetAllIcdCodes1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCptCodeControllerServiceGetAllIcdCodes1Key =
  "CptCodeControllerServiceGetAllIcdCodes1";
export const UseCptCodeControllerServiceGetAllIcdCodes1KeyFn = (
  {
    page,
    pageSize,
    searchString,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCptCodeControllerServiceGetAllIcdCodes1Key,
  ...(queryKey ?? [{ page, pageSize, searchString }]),
];
export type CommentControllerServiceGetMessageByUuidDefaultResponse = Awaited<
  ReturnType<typeof CommentControllerService.getMessageByUuid>
>;
export type CommentControllerServiceGetMessageByUuidQueryResult<
  TData = CommentControllerServiceGetMessageByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCommentControllerServiceGetMessageByUuidKey =
  "CommentControllerServiceGetMessageByUuid";
export const UseCommentControllerServiceGetMessageByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCommentControllerServiceGetMessageByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type CommentControllerServiceGetAssignableUsersForTaskDefaultResponse =
  Awaited<
    ReturnType<typeof CommentControllerService.getAssignableUsersForTask>
  >;
export type CommentControllerServiceGetAssignableUsersForTaskQueryResult<
  TData = CommentControllerServiceGetAssignableUsersForTaskDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCommentControllerServiceGetAssignableUsersForTaskKey =
  "CommentControllerServiceGetAssignableUsersForTask";
export const UseCommentControllerServiceGetAssignableUsersForTaskKeyFn = (
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCommentControllerServiceGetAssignableUsersForTaskKey,
  ...(queryKey ?? [{ taskUuid }]),
];
export type CommentControllerServiceGetAllMessagesDefaultResponse = Awaited<
  ReturnType<typeof CommentControllerService.getAllMessages>
>;
export type CommentControllerServiceGetAllMessagesQueryResult<
  TData = CommentControllerServiceGetAllMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCommentControllerServiceGetAllMessagesKey =
  "CommentControllerServiceGetAllMessages";
export const UseCommentControllerServiceGetAllMessagesKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
    taskUuid,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    taskUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCommentControllerServiceGetAllMessagesKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection, taskUuid }]),
];
export type CarePlanControllerServiceGetCarePlanByUuidDefaultResponse = Awaited<
  ReturnType<typeof CarePlanControllerService.getCarePlanByUuid>
>;
export type CarePlanControllerServiceGetCarePlanByUuidQueryResult<
  TData = CarePlanControllerServiceGetCarePlanByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCarePlanControllerServiceGetCarePlanByUuidKey =
  "CarePlanControllerServiceGetCarePlanByUuid";
export const UseCarePlanControllerServiceGetCarePlanByUuidKeyFn = (
  {
    carePlanUuid,
  }: {
    carePlanUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCarePlanControllerServiceGetCarePlanByUuidKey,
  ...(queryKey ?? [{ carePlanUuid }]),
];
export type CarePlanControllerServiceGetCarePlansDefaultResponse = Awaited<
  ReturnType<typeof CarePlanControllerService.getCarePlans>
>;
export type CarePlanControllerServiceGetCarePlansQueryResult<
  TData = CarePlanControllerServiceGetCarePlansDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCarePlanControllerServiceGetCarePlansKey =
  "CarePlanControllerServiceGetCarePlans";
export const UseCarePlanControllerServiceGetCarePlansKeyFn = (
  {
    page,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCarePlanControllerServiceGetCarePlansKey,
  ...(queryKey ?? [{ page, size, sortBy, sortDirection }]),
];
export type CarePlanControllerServiceGetAllCarePlansDefaultResponse = Awaited<
  ReturnType<typeof CarePlanControllerService.getAllCarePlans>
>;
export type CarePlanControllerServiceGetAllCarePlansQueryResult<
  TData = CarePlanControllerServiceGetAllCarePlansDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCarePlanControllerServiceGetAllCarePlansKey =
  "CarePlanControllerServiceGetAllCarePlans";
export const UseCarePlanControllerServiceGetAllCarePlansKeyFn = (
  {
    name,
    page,
    size,
    sortBy,
    sortDirection,
  }: {
    name?: string;
    page?: number;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCarePlanControllerServiceGetAllCarePlansKey,
  ...(queryKey ?? [{ name, page, size, sortBy, sortDirection }]),
];
export type AvailabilityControllerServiceGetBlockDaysForProvidersDefaultResponse =
  Awaited<
    ReturnType<typeof AvailabilityControllerService.getBlockDaysForProviders>
  >;
export type AvailabilityControllerServiceGetBlockDaysForProvidersQueryResult<
  TData = AvailabilityControllerServiceGetBlockDaysForProvidersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAvailabilityControllerServiceGetBlockDaysForProvidersKey =
  "AvailabilityControllerServiceGetBlockDaysForProviders";
export const UseAvailabilityControllerServiceGetBlockDaysForProvidersKeyFn = (
  {
    blockDate,
    locationUuid,
    providerUuid,
  }: {
    blockDate?: string;
    locationUuid?: string;
    providerUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAvailabilityControllerServiceGetBlockDaysForProvidersKey,
  ...(queryKey ?? [{ blockDate, locationUuid, providerUuid }]),
];
export type AvailabilityControllerServiceGetAvailabilityByProviderUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AvailabilityControllerService.getAvailabilityByProviderUuid
    >
  >;
export type AvailabilityControllerServiceGetAvailabilityByProviderUuidQueryResult<
  TData =
    AvailabilityControllerServiceGetAvailabilityByProviderUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAvailabilityControllerServiceGetAvailabilityByProviderUuidKey =
  "AvailabilityControllerServiceGetAvailabilityByProviderUuid";
export const UseAvailabilityControllerServiceGetAvailabilityByProviderUuidKeyFn =
  (
    {
      providerUuid,
    }: {
      providerUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAvailabilityControllerServiceGetAvailabilityByProviderUuidKey,
    ...(queryKey ?? [{ providerUuid }]),
  ];
export type AvailabilityControllerServiceGetAvailabilitySlotsDefaultResponse =
  Awaited<
    ReturnType<typeof AvailabilityControllerService.getAvailabilitySlots>
  >;
export type AvailabilityControllerServiceGetAvailabilitySlotsQueryResult<
  TData = AvailabilityControllerServiceGetAvailabilitySlotsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAvailabilityControllerServiceGetAvailabilitySlotsKey =
  "AvailabilityControllerServiceGetAvailabilitySlots";
export const UseAvailabilityControllerServiceGetAvailabilitySlotsKeyFn = (
  {
    appointmentMode,
    coBook,
    dayOfWeek,
    duration,
    endDateTime,
    locationUuid,
    providerUuid,
    startDateTime,
  }: {
    appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
    coBook?: boolean;
    dayOfWeek?:
      | "MONDAY"
      | "TUESDAY"
      | "WEDNESDAY"
      | "THURSDAY"
      | "FRIDAY"
      | "SATURDAY"
      | "SUNDAY";
    duration?: number;
    endDateTime: string;
    locationUuid?: string;
    providerUuid?: string;
    startDateTime: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAvailabilityControllerServiceGetAvailabilitySlotsKey,
  ...(queryKey ?? [
    {
      appointmentMode,
      coBook,
      dayOfWeek,
      duration,
      endDateTime,
      locationUuid,
      providerUuid,
      startDateTime,
    },
  ]),
];
export type AvailabilityControllerServiceGetAvailabilitySlotForCalendarDefaultResponse =
  Awaited<
    ReturnType<
      typeof AvailabilityControllerService.getAvailabilitySlotForCalendar
    >
  >;
export type AvailabilityControllerServiceGetAvailabilitySlotForCalendarQueryResult<
  TData =
    AvailabilityControllerServiceGetAvailabilitySlotForCalendarDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAvailabilityControllerServiceGetAvailabilitySlotForCalendarKey =
  "AvailabilityControllerServiceGetAvailabilitySlotForCalendar";
export const UseAvailabilityControllerServiceGetAvailabilitySlotForCalendarKeyFn =
  (
    {
      appointmentMode,
      blockDayUuid,
      endDateTime,
      locationUuid,
      providerUuid,
      recurringBlockDayUuid,
      startDateTime,
    }: {
      appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
      blockDayUuid?: string;
      endDateTime?: string;
      locationUuid?: string;
      providerUuid?: string;
      recurringBlockDayUuid?: string;
      startDateTime?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAvailabilityControllerServiceGetAvailabilitySlotForCalendarKey,
    ...(queryKey ?? [
      {
        appointmentMode,
        blockDayUuid,
        endDateTime,
        locationUuid,
        providerUuid,
        recurringBlockDayUuid,
        startDateTime,
      },
    ]),
  ];
export type AvailabilityControllerServiceGetAllAvailabilityDefaultResponse =
  Awaited<ReturnType<typeof AvailabilityControllerService.getAllAvailability>>;
export type AvailabilityControllerServiceGetAllAvailabilityQueryResult<
  TData = AvailabilityControllerServiceGetAllAvailabilityDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAvailabilityControllerServiceGetAllAvailabilityKey =
  "AvailabilityControllerServiceGetAllAvailability";
export const UseAvailabilityControllerServiceGetAllAvailabilityKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAvailabilityControllerServiceGetAllAvailabilityKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type AppointmentControllerServiceGetAppointmentByUuidDefaultResponse =
  Awaited<ReturnType<typeof AppointmentControllerService.getAppointmentByUuid>>;
export type AppointmentControllerServiceGetAppointmentByUuidQueryResult<
  TData = AppointmentControllerServiceGetAppointmentByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetAppointmentByUuidKey =
  "AppointmentControllerServiceGetAppointmentByUuid";
export const UseAppointmentControllerServiceGetAppointmentByUuidKeyFn = (
  {
    appointmentUuid,
    occurrenceDate,
  }: {
    appointmentUuid: string;
    occurrenceDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetAppointmentByUuidKey,
  ...(queryKey ?? [{ appointmentUuid, occurrenceDate }]),
];
export type AppointmentControllerServiceGetAppointmentVisitDetailsDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentControllerService.getAppointmentVisitDetails>
  >;
export type AppointmentControllerServiceGetAppointmentVisitDetailsQueryResult<
  TData = AppointmentControllerServiceGetAppointmentVisitDetailsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetAppointmentVisitDetailsKey =
  "AppointmentControllerServiceGetAppointmentVisitDetails";
export const UseAppointmentControllerServiceGetAppointmentVisitDetailsKeyFn = (
  {
    confidential,
    page,
    pageSize,
    patientUuid,
    sortBy,
    sortDirection,
    visitType,
  }: {
    confidential?: boolean;
    page?: number;
    pageSize?: number;
    patientUuid?: string;
    sortBy?: string;
    sortDirection?: string;
    visitType?: "PAST" | "UPCOMING";
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetAppointmentVisitDetailsKey,
  ...(queryKey ?? [
    {
      confidential,
      page,
      pageSize,
      patientUuid,
      sortBy,
      sortDirection,
      visitType,
    },
  ]),
];
export type AppointmentControllerServiceGetVideoConsentFormDefaultResponse =
  Awaited<ReturnType<typeof AppointmentControllerService.getVideoConsentForm>>;
export type AppointmentControllerServiceGetVideoConsentFormQueryResult<
  TData = AppointmentControllerServiceGetVideoConsentFormDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetVideoConsentFormKey =
  "AppointmentControllerServiceGetVideoConsentForm";
export const UseAppointmentControllerServiceGetVideoConsentFormKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetVideoConsentFormKey,
  ...(queryKey ?? []),
];
export type AppointmentControllerServiceGetAppointmentForDashBoardDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentControllerService.getAppointmentForDashBoard>
  >;
export type AppointmentControllerServiceGetAppointmentForDashBoardQueryResult<
  TData = AppointmentControllerServiceGetAppointmentForDashBoardDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetAppointmentForDashBoardKey =
  "AppointmentControllerServiceGetAppointmentForDashBoard";
export const UseAppointmentControllerServiceGetAppointmentForDashBoardKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetAppointmentForDashBoardKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type AppointmentControllerServiceGetProviderCalendarIcsDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentControllerService.getProviderCalendarIcs>
  >;
export type AppointmentControllerServiceGetProviderCalendarIcsQueryResult<
  TData = AppointmentControllerServiceGetProviderCalendarIcsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetProviderCalendarIcsKey =
  "AppointmentControllerServiceGetProviderCalendarIcs";
export const UseAppointmentControllerServiceGetProviderCalendarIcsKeyFn = (
  {
    token,
  }: {
    token: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetProviderCalendarIcsKey,
  ...(queryKey ?? [{ token }]),
];
export type AppointmentControllerServiceGetAllAppointmentsDefaultResponse =
  Awaited<ReturnType<typeof AppointmentControllerService.getAllAppointments>>;
export type AppointmentControllerServiceGetAllAppointmentsQueryResult<
  TData = AppointmentControllerServiceGetAllAppointmentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentControllerServiceGetAllAppointmentsKey =
  "AppointmentControllerServiceGetAllAppointments";
export const UseAppointmentControllerServiceGetAllAppointmentsKeyFn = (
  {
    appointmentModes,
    appointmentTypeUuids,
    calendar,
    endDateTime,
    locationUuids,
    page,
    pageSize,
    patientUuids,
    providerUuids,
    searchString,
    sortBy,
    sortDirection,
    startDateTime,
    statusConfigurationUuids,
  }: {
    appointmentModes?: ("IN_PERSON" | "VIDEO" | "TELEPHONE")[];
    appointmentTypeUuids?: string[];
    calendar?: boolean;
    endDateTime?: string;
    locationUuids?: string[];
    page?: number;
    pageSize?: number;
    patientUuids?: string[];
    providerUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDateTime?: string;
    statusConfigurationUuids?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAppointmentControllerServiceGetAllAppointmentsKey,
  ...(queryKey ?? [
    {
      appointmentModes,
      appointmentTypeUuids,
      calendar,
      endDateTime,
      locationUuids,
      page,
      pageSize,
      patientUuids,
      providerUuids,
      searchString,
      sortBy,
      sortDirection,
      startDateTime,
      statusConfigurationUuids,
    },
  ]),
];
export type AppointmentTypeControllerServiceGetAppointmentTypeByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentTypeControllerService.getAppointmentTypeByUuid>
  >;
export type AppointmentTypeControllerServiceGetAppointmentTypeByUuidQueryResult<
  TData =
    AppointmentTypeControllerServiceGetAppointmentTypeByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentTypeControllerServiceGetAppointmentTypeByUuidKey =
  "AppointmentTypeControllerServiceGetAppointmentTypeByUuid";
export const UseAppointmentTypeControllerServiceGetAppointmentTypeByUuidKeyFn =
  (
    {
      appointmentTypeUuid,
    }: {
      appointmentTypeUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAppointmentTypeControllerServiceGetAppointmentTypeByUuidKey,
    ...(queryKey ?? [{ appointmentTypeUuid }]),
  ];
export type AppointmentTypeControllerServiceGetAllAppointmentTypeDefaultResponse =
  Awaited<
    ReturnType<typeof AppointmentTypeControllerService.getAllAppointmentType>
  >;
export type AppointmentTypeControllerServiceGetAllAppointmentTypeQueryResult<
  TData = AppointmentTypeControllerServiceGetAllAppointmentTypeDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAppointmentTypeControllerServiceGetAllAppointmentTypeKey =
  "AppointmentTypeControllerServiceGetAllAppointmentType";
export const UseAppointmentTypeControllerServiceGetAllAppointmentTypeKeyFn = (
  {
    appointmentMode,
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    appointmentMode?: "IN_PERSON" | "VIDEO" | "TELEPHONE";
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAppointmentTypeControllerServiceGetAllAppointmentTypeKey,
  ...(queryKey ?? [{ appointmentMode, page, pageSize, sortBy, sortDirection }]),
];
export type AnnotableImageControllerServiceGetAnnotableImageDefaultResponse =
  Awaited<ReturnType<typeof AnnotableImageControllerService.getAnnotableImage>>;
export type AnnotableImageControllerServiceGetAnnotableImageQueryResult<
  TData = AnnotableImageControllerServiceGetAnnotableImageDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImageControllerServiceGetAnnotableImageKey =
  "AnnotableImageControllerServiceGetAnnotableImage";
export const UseAnnotableImageControllerServiceGetAnnotableImageKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAnnotableImageControllerServiceGetAnnotableImageKey,
  ...(queryKey ?? [{ uuid }]),
];
export type AnnotableImageControllerServiceGetAllAnnotableImagesDefaultResponse =
  Awaited<
    ReturnType<typeof AnnotableImageControllerService.getAllAnnotableImages>
  >;
export type AnnotableImageControllerServiceGetAllAnnotableImagesQueryResult<
  TData = AnnotableImageControllerServiceGetAllAnnotableImagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImageControllerServiceGetAllAnnotableImagesKey =
  "AnnotableImageControllerServiceGetAllAnnotableImages";
export const UseAnnotableImageControllerServiceGetAllAnnotableImagesKeyFn = (
  {
    page,
    patientUuid,
    size,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAnnotableImageControllerServiceGetAllAnnotableImagesKey,
  ...(queryKey ?? [{ page, patientUuid, size, sortBy, sortDirection }]),
];
export type AnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.getAnnotableImageTemplateByUuid
    >
  >;
export type AnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidQueryResult<
  TData =
    AnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidKey =
  "AnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuid";
export const UseAnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidKeyFn =
  (
    {
      anotableImageTemplateUuid,
    }: {
      anotableImageTemplateUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAnnotableImageTemplateControllerServiceGetAnnotableImageTemplateByUuidKey,
    ...(queryKey ?? [{ anotableImageTemplateUuid }]),
  ];
export type AnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateDefaultResponse =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.getAllAnnotableImageTemplate
    >
  >;
export type AnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateQueryResult<
  TData =
    AnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateKey =
  "AnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplate";
export const UseAnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateKeyFn =
  (
    {
      flag,
      isPrivate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
    }: {
      flag?: boolean;
      isPrivate?: boolean;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAnnotableImageTemplateControllerServiceGetAllAnnotableImageTemplateKey,
    ...(queryKey ?? [
      { flag, isPrivate, page, pageSize, searchString, sortBy, sortDirection },
    ]),
  ];
export type AnnotableImagePinControllerServiceGetAnnotableImagePinByUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof AnnotableImagePinControllerService.getAnnotableImagePinByUuid
    >
  >;
export type AnnotableImagePinControllerServiceGetAnnotableImagePinByUuidQueryResult<
  TData =
    AnnotableImagePinControllerServiceGetAnnotableImagePinByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImagePinControllerServiceGetAnnotableImagePinByUuidKey =
  "AnnotableImagePinControllerServiceGetAnnotableImagePinByUuid";
export const UseAnnotableImagePinControllerServiceGetAnnotableImagePinByUuidKeyFn =
  (
    {
      uuid,
    }: {
      uuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAnnotableImagePinControllerServiceGetAnnotableImagePinByUuidKey,
    ...(queryKey ?? [{ uuid }]),
  ];
export type AnnotableImagePinControllerServiceGetAllAnnotableImagePinsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AnnotableImagePinControllerService.getAllAnnotableImagePins
    >
  >;
export type AnnotableImagePinControllerServiceGetAllAnnotableImagePinsQueryResult<
  TData =
    AnnotableImagePinControllerServiceGetAllAnnotableImagePinsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAnnotableImagePinControllerServiceGetAllAnnotableImagePinsKey =
  "AnnotableImagePinControllerServiceGetAllAnnotableImagePins";
export const UseAnnotableImagePinControllerServiceGetAllAnnotableImagePinsKeyFn =
  (
    {
      page,
      size,
      sortBy,
      sortDirection,
    }: {
      page?: number;
      size?: number;
      sortBy?: string;
      sortDirection?: string;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAnnotableImagePinControllerServiceGetAllAnnotableImagePinsKey,
    ...(queryKey ?? [{ page, size, sortBy, sortDirection }]),
  ];
export type AllergyControllerServiceGetAllergyByUuidDefaultResponse = Awaited<
  ReturnType<typeof AllergyControllerService.getAllergyByUuid>
>;
export type AllergyControllerServiceGetAllergyByUuidQueryResult<
  TData = AllergyControllerServiceGetAllergyByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAllergyControllerServiceGetAllergyByUuidKey =
  "AllergyControllerServiceGetAllergyByUuid";
export const UseAllergyControllerServiceGetAllergyByUuidKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAllergyControllerServiceGetAllergyByUuidKey,
  ...(queryKey ?? [{ uuid }]),
];
export type AllergyControllerServiceGetAllAllergiesForPdfDefaultResponse =
  Awaited<ReturnType<typeof AllergyControllerService.getAllAllergiesForPdf>>;
export type AllergyControllerServiceGetAllAllergiesForPdfQueryResult<
  TData = AllergyControllerServiceGetAllAllergiesForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAllergyControllerServiceGetAllAllergiesForPdfKey =
  "AllergyControllerServiceGetAllAllergiesForPdf";
export const UseAllergyControllerServiceGetAllAllergiesForPdfKeyFn = (
  {
    patientUuid,
    status,
  }: {
    patientUuid: string;
    status?: boolean;
  },
  queryKey?: Array<unknown>,
) => [
  useAllergyControllerServiceGetAllAllergiesForPdfKey,
  ...(queryKey ?? [{ patientUuid, status }]),
];
export type AllergyControllerServiceGetAllAllergiesDefaultResponse = Awaited<
  ReturnType<typeof AllergyControllerService.getAllAllergies>
>;
export type AllergyControllerServiceGetAllAllergiesQueryResult<
  TData = AllergyControllerServiceGetAllAllergiesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAllergyControllerServiceGetAllAllergiesKey =
  "AllergyControllerServiceGetAllAllergies";
export const UseAllergyControllerServiceGetAllAllergiesKeyFn = (
  {
    draft,
    filter,
    page,
    pageSize,
    patientUuid,
    searchString,
    sortBy,
    sortDirection,
  }: {
    draft?: boolean;
    filter?: "ALL" | "CURRENT" | "INACTIVE" | "ARCHIVED";
    page?: number;
    pageSize?: number;
    patientUuid: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAllergyControllerServiceGetAllAllergiesKey,
  ...(queryKey ?? [
    {
      draft,
      filter,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type QuestionnaireControllerServiceGetQuestionnairePdfUrlsDefaultResponse =
  Awaited<
    ReturnType<typeof QuestionnaireControllerService.getQuestionnairePdfUrls>
  >;
export type QuestionnaireControllerServiceGetQuestionnairePdfUrlsQueryResult<
  TData = QuestionnaireControllerServiceGetQuestionnairePdfUrlsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestionnaireControllerServiceGetQuestionnairePdfUrlsKey =
  "QuestionnaireControllerServiceGetQuestionnairePdfUrls";
export const UseQuestionnaireControllerServiceGetQuestionnairePdfUrlsKeyFn = (
  {
    questionnaireUuid,
  }: {
    questionnaireUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useQuestionnaireControllerServiceGetQuestionnairePdfUrlsKey,
  ...(queryKey ?? [{ questionnaireUuid }]),
];
export type QuestionnaireControllerServiceGetQuestionnaireTableMappingsDefaultResponse =
  Awaited<
    ReturnType<
      typeof QuestionnaireControllerService.getQuestionnaireTableMappings
    >
  >;
export type QuestionnaireControllerServiceGetQuestionnaireTableMappingsQueryResult<
  TData =
    QuestionnaireControllerServiceGetQuestionnaireTableMappingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestionnaireControllerServiceGetQuestionnaireTableMappingsKey =
  "QuestionnaireControllerServiceGetQuestionnaireTableMappings";
export const UseQuestionnaireControllerServiceGetQuestionnaireTableMappingsKeyFn =
  (
    {
      patientUuid,
      questionnaireUuid,
    }: {
      patientUuid: string;
      questionnaireUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useQuestionnaireControllerServiceGetQuestionnaireTableMappingsKey,
    ...(queryKey ?? [{ patientUuid, questionnaireUuid }]),
  ];
export type QuestionnaireControllerServiceGetQuestionnaireContentForPatientDefaultResponse =
  Awaited<
    ReturnType<
      typeof QuestionnaireControllerService.getQuestionnaireContentForPatient
    >
  >;
export type QuestionnaireControllerServiceGetQuestionnaireContentForPatientQueryResult<
  TData =
    QuestionnaireControllerServiceGetQuestionnaireContentForPatientDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestionnaireControllerServiceGetQuestionnaireContentForPatientKey =
  "QuestionnaireControllerServiceGetQuestionnaireContentForPatient";
export const UseQuestionnaireControllerServiceGetQuestionnaireContentForPatientKeyFn =
  (
    {
      patientUuid,
      questionnaireUuid,
    }: {
      patientUuid: string;
      questionnaireUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useQuestionnaireControllerServiceGetQuestionnaireContentForPatientKey,
    ...(queryKey ?? [{ patientUuid, questionnaireUuid }]),
  ];
export type QuestionnaireControllerServiceGetQuestionnairesForPatientPortalDefaultResponse =
  Awaited<
    ReturnType<
      typeof QuestionnaireControllerService.getQuestionnairesForPatientPortal
    >
  >;
export type QuestionnaireControllerServiceGetQuestionnairesForPatientPortalQueryResult<
  TData =
    QuestionnaireControllerServiceGetQuestionnairesForPatientPortalDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestionnaireControllerServiceGetQuestionnairesForPatientPortalKey =
  "QuestionnaireControllerServiceGetQuestionnairesForPatientPortal";
export const UseQuestionnaireControllerServiceGetQuestionnairesForPatientPortalKeyFn =
  (
    {
      appointmentUuid,
      endDate,
      formBuilderType,
      isPdfFormSubmission,
      page,
      pageSize,
      patientUuid,
      searchString,
      sortBy,
      sortDirection,
      startDate,
      submitted,
    }: {
      appointmentUuid?: string;
      endDate?: string;
      formBuilderType?: string;
      isPdfFormSubmission?: boolean;
      page?: number;
      pageSize?: number;
      patientUuid: string;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
      submitted?: boolean;
    },
    queryKey?: Array<unknown>,
  ) => [
    useQuestionnaireControllerServiceGetQuestionnairesForPatientPortalKey,
    ...(queryKey ?? [
      {
        appointmentUuid,
        endDate,
        formBuilderType,
        isPdfFormSubmission,
        page,
        pageSize,
        patientUuid,
        searchString,
        sortBy,
        sortDirection,
        startDate,
        submitted,
      },
    ]),
  ];
export type QuestControllerServiceGetAllCptCodesDefaultResponse = Awaited<
  ReturnType<typeof QuestControllerService.getAllCptCodes>
>;
export type QuestControllerServiceGetAllCptCodesQueryResult<
  TData = QuestControllerServiceGetAllCptCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestControllerServiceGetAllCptCodesKey =
  "QuestControllerServiceGetAllCptCodes";
export const UseQuestControllerServiceGetAllCptCodesKeyFn = (
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useQuestControllerServiceGetAllCptCodesKey,
  ...(queryKey ?? [{ page, pageSize, search, sortBy, sortDirection }]),
];
export type QuestControllerServiceGetAoeQuestionsDefaultResponse = Awaited<
  ReturnType<typeof QuestControllerService.getAoeQuestions>
>;
export type QuestControllerServiceGetAoeQuestionsQueryResult<
  TData = QuestControllerServiceGetAoeQuestionsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestControllerServiceGetAoeQuestionsKey =
  "QuestControllerServiceGetAoeQuestions";
export const UseQuestControllerServiceGetAoeQuestionsKeyFn = (
  {
    testCode,
  }: {
    testCode: string;
  },
  queryKey?: Array<unknown>,
) => [
  useQuestControllerServiceGetAoeQuestionsKey,
  ...(queryKey ?? [{ testCode }]),
];
export type QuestControllerServiceGetAllCodesDefaultResponse = Awaited<
  ReturnType<typeof QuestControllerService.getAllCodes>
>;
export type QuestControllerServiceGetAllCodesQueryResult<
  TData = QuestControllerServiceGetAllCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useQuestControllerServiceGetAllCodesKey =
  "QuestControllerServiceGetAllCodes";
export const UseQuestControllerServiceGetAllCodesKeyFn = (
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useQuestControllerServiceGetAllCodesKey,
  ...(queryKey ?? [{ page, pageSize, search, sortBy, sortDirection }]),
];
export type DocumentControllerServiceGetDocumentByUuidDefaultResponse = Awaited<
  ReturnType<typeof DocumentControllerService.getDocumentByUuid>
>;
export type DocumentControllerServiceGetDocumentByUuidQueryResult<
  TData = DocumentControllerServiceGetDocumentByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDocumentControllerServiceGetDocumentByUuidKey =
  "DocumentControllerServiceGetDocumentByUuid";
export const UseDocumentControllerServiceGetDocumentByUuidKeyFn = (
  {
    documentUuid,
  }: {
    documentUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDocumentControllerServiceGetDocumentByUuidKey,
  ...(queryKey ?? [{ documentUuid }]),
];
export type DocumentControllerServiceGetAllDocuments1DefaultResponse = Awaited<
  ReturnType<typeof DocumentControllerService.getAllDocuments1>
>;
export type DocumentControllerServiceGetAllDocuments1QueryResult<
  TData = DocumentControllerServiceGetAllDocuments1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDocumentControllerServiceGetAllDocuments1Key =
  "DocumentControllerServiceGetAllDocuments1";
export const UseDocumentControllerServiceGetAllDocuments1KeyFn = (
  {
    documentType,
    endDate,
    fileName,
    includeArchived,
    page,
    patientUuid,
    reviewRequired,
    shared,
    size,
    sort,
    startDate,
  }: {
    documentType?: string;
    endDate?: string;
    fileName?: string;
    includeArchived?: boolean;
    page?: number;
    patientUuid: string;
    reviewRequired?: boolean;
    shared?: boolean;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useDocumentControllerServiceGetAllDocuments1Key,
  ...(queryKey ?? [
    {
      documentType,
      endDate,
      fileName,
      includeArchived,
      page,
      patientUuid,
      reviewRequired,
      shared,
      size,
      sort,
      startDate,
    },
  ]),
];
export type ContactDirectoryControllerServiceGetContactDirectoryUuidDefaultResponse =
  Awaited<
    ReturnType<typeof ContactDirectoryControllerService.getContactDirectoryUuid>
  >;
export type ContactDirectoryControllerServiceGetContactDirectoryUuidQueryResult<
  TData =
    ContactDirectoryControllerServiceGetContactDirectoryUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useContactDirectoryControllerServiceGetContactDirectoryUuidKey =
  "ContactDirectoryControllerServiceGetContactDirectoryUuid";
export const UseContactDirectoryControllerServiceGetContactDirectoryUuidKeyFn =
  (
    {
      contactDirectoryUuid,
    }: {
      contactDirectoryUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useContactDirectoryControllerServiceGetContactDirectoryUuidKey,
    ...(queryKey ?? [{ contactDirectoryUuid }]),
  ];
export type ContactDirectoryControllerServiceGetAllContactDirectoryDefaultResponse =
  Awaited<
    ReturnType<typeof ContactDirectoryControllerService.getAllContactDirectory>
  >;
export type ContactDirectoryControllerServiceGetAllContactDirectoryQueryResult<
  TData =
    ContactDirectoryControllerServiceGetAllContactDirectoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useContactDirectoryControllerServiceGetAllContactDirectoryKey =
  "ContactDirectoryControllerServiceGetAllContactDirectory";
export const UseContactDirectoryControllerServiceGetAllContactDirectoryKeyFn = (
  {
    city,
    page,
    referralType,
    searchString,
    size,
    sort,
    state,
  }: {
    city?: string;
    page?: number;
    referralType?:
      | "IMAGING"
      | "SPECIALIST"
      | "ACUPUNCTURIST"
      | "ADULT_COMPANION"
      | "ADVANCED_PRACTICE_DENTAL_THERAPIST"
      | "ADVANCED_PRACTICE_MIDWIFE"
      | "AIR_CARRIER"
      | "ALLERGY_IMMUNOLOGY"
      | "ALZHEIMER_CENTER_DEMENTIA_CENTER"
      | "AMBULANCE"
      | "ANAPLASTOLOGIST"
      | "ANESTHESIOLOGIST_ASSISTANT"
      | "ANESTHESIOLOGY"
      | "ART_THERAPIST"
      | "ASSISTANT_BEHAVIOR_ANALYST"
      | "ASSISTANT_PODIATRIC"
      | "ASSISTED_LIVING_FACILITY"
      | "AUDIOLOGIST"
      | "AUDIOLOGIST_HEARING_AID_FITTER"
      | "BEHAVIOR_ANALYST"
      | "BEHAVIOR_TECHNICIAN"
      | "BLOOD_BANK"
      | "BUS"
      | "CASE_MANAGEMENT"
      | "CASE_MANAGER_CARE_COORDINATOR"
      | "CHIROPRACTOR"
      | "CHORE_PROVIDER"
      | "CHRISTIAN_SCIENCE_FACILITY"
      | "CHRISTIAN_SCIENCE_SANITORIUM"
      | "CHRONIC_DISEASE_HOSPITAL"
      | "CLINIC_CENTER"
      | "CLINICAL_ETHICIST"
      | "CLINICAL_EXERCISE_PHYSIOLOGIST"
      | "CLINICAL_MEDICAL_LABORATORY"
      | "CLINICAL_NEUROPSYCHOLOGIST"
      | "CLINICAL_NURSE_SPECIALIST"
      | "CLINICAL_PHARMACOLOGY"
      | "COLON_RECTAL_SURGERY"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "COMMUNITY_BASED_RESIDENTIAL_TREATMENT_FACILITY_MENTAL_ILLNESS"
      | "COMMUNITY_HEALTH_WORKER"
      | "COMMUNITY_PARAMEDIC"
      | "COMMUNITY_BEHAVIORAL_HEALTH"
      | "CONTRACTOR"
      | "COUNSELOR"
      | "CUSTODIAL_CARE_FACILITY"
      | "DANCE_THERAPIST"
      | "DAY_TRAINING_DEVELOPMENTALLY_DISABLED_SERVICES"
      | "DAY_TRAINING_HABILITATION_SPECIALIST"
      | "DENTAL_ASSISTANT"
      | "DENTAL_HYGIENIST"
      | "DENTAL_LABORATORY"
      | "DENTAL_LABORATORY_TECHNICIAN"
      | "DENTAL_THERAPIST"
      | "DENTIST"
      | "DENTURIST"
      | "DEPARTMENT_OF_VETERANS_AFFAIRS_VA_PHARMACY"
      | "DERMATOLOGY"
      | "DEVELOPMENTAL_THERAPIST"
      | "DIETARY_MANAGER"
      | "DIETETIC_TECHNICIAN_REGISTERED"
      | "DIETITIAN_REGISTERED"
      | "DOULA"
      | "DRAMA_THERAPIST"
      | "DRIVER"
      | "DURABLE_MEDICAL_EQUIPMENT_MEDICAL_SUPPLIES"
      | "EARLY_INTERVENTION_PROVIDER_AGENCY"
      | "ELECTRODIAGNOSTIC_MEDICINE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_BASIC"
      | "EMERGENCY_MEDICAL_TECHNICIAN_INTERMEDIATE"
      | "EMERGENCY_MEDICAL_TECHNICIAN_PARAMEDIC"
      | "EMERGENCY_MEDICINE"
      | "EMERGENCY_RESPONSE_SYSTEM_COMPANIES"
      | "EPILEPSY_UNIT"
      | "EXCLUSIVE_PROVIDER_ORGANIZATION"
      | "EYE_BANK"
      | "EYEWEAR_SUPPLIER"
      | "FAMILY_MEDICINE"
      | "FOSTER_CARE_AGENCY"
      | "FUNERAL_DIRECTOR"
      | "GENERAL_ACUTE_CARE_HOSPITAL"
      | "GENERAL_PRACTICE"
      | "GENETIC_COUNSELOR_MS"
      | "HEALTH_WELLNESS_COACH"
      | "HEALTH_EDUCATOR"
      | "HEALTH_MAINTENANCE_ORGANIZATION"
      | "HEARING_AID_EQUIPMENT"
      | "HEARING_INSTRUMENT_SPECIALIST"
      | "HOME_DELIVERED_MEALS"
      | "HOME_HEALTH"
      | "HOME_HEALTH_AIDE"
      | "HOME_INFUSION"
      | "HOMEMAKER"
      | "HOMEOPATH"
      | "HOSPICE_CARE_COMMUNITY_BASED"
      | "HOSPICE_INPATIENT"
      | "HOSPITALIST"
      | "IN_HOME_SUPPORTIVE_CARE"
      | "INDEPENDENT_MEDICAL_EXAMINER"
      | "INDIAN_HEALTH_SERVICE_TRIBAL_URBAN_INDIAN_HEALTH_I_T_U_PHARMACY"
      | "INTEGRATIVE_MEDICINE"
      | "INTERMEDIATE_CARE_FACILITY_INTELLECTUAL_DISABILITIES"
      | "INTERMEDIATE_CARE_FACILITY_MENTAL_ILLNESS"
      | "INTERNAL_MEDICINE"
      | "INTERPRETER"
      | "KINESIOTHERAPIST"
      | "LACTATION_CONSULTANT_NON_RN"
      | "LEGAL_MEDICINE"
      | "LICENSED_PRACTICAL_NURSE"
      | "LICENSED_PSYCHIATRIC_TECHNICIAN"
      | "LICENSED_VOCATIONAL_NURSE"
      | "LOCAL_EDUCATION_AGENCY_LEA"
      | "LODGING"
      | "LONG_TERM_CARE_HOSPITAL"
      | "MARRIAGE_FAMILY_THERAPIST"
      | "MASSAGE_THERAPIST"
      | "MASTECTOMY_FITTER"
      | "MEALS"
      | "MECHANOTHERAPIST"
      | "MEDICAL_FOODS_SUPPLIER"
      | "MEDICAL_GENETICS"
      | "MEDICAL_GENETICS_PH_D_MEDICAL_GENETICS"
      | "MEDICARE_DEFINED_SWING_BED_UNIT"
      | "MIDWIFE"
      | "MIDWIFE_LAY"
      | "MILITARY_CLINICAL_MEDICAL_LABORATORY"
      | "MILITARY_HEALTH_CARE_PROVIDER"
      | "MILITARY_HOSPITAL"
      | "MILITARY_U_S_COAST_GUARD_PHARMACY"
      | "MILITARY_U_S_COAST_GUARD_TRANSPORT"
      | "MULTI_SPECIALTY"
      | "MUSIC_THERAPIST"
      | "NAPRAPATH"
      | "NATUROPATH"
      | "NEUROLOGICAL_SURGERY"
      | "NEUROMUSCULOSKELETAL_MEDICINE_OMM"
      | "NEUROMUSCULOSKELETAL_MEDICINE_SPORTS_MEDICINE"
      | "NON_PHARMACY_DISPENSING_SITE"
      | "NON_EMERGENCY_MEDICAL_TRANSPORT_VAN"
      | "NUCLEAR_MEDICINE"
      | "NURSE_ANESTHETIST_CERTIFIED_REGISTERED"
      | "NURSE_PRACTITIONER"
      | "NURSE_S_AIDE"
      | "NURSING_CARE"
      | "NURSING_FACILITY_INTERMEDIATE_CARE_FACILITY"
      | "NURSING_HOME_ADMINISTRATOR"
      | "NUTRITIONIST"
      | "OBSTETRICS_GYNECOLOGY"
      | "OCCUPATIONAL_THERAPIST"
      | "OCCUPATIONAL_THERAPY_ASSISTANT"
      | "OPHTHALMOLOGY"
      | "OPTOMETRIST"
      | "ORAL_MAXILLOFACIAL_SURGERY"
      | "ORGAN_PROCUREMENT_ORGANIZATION"
      | "ORTHOPAEDIC_SURGERY"
      | "ORTHOTIC_FITTER"
      | "ORTHOTIST"
      | "OTOLARYNGOLOGY"
      | "PAIN_MEDICINE"
      | "PATHOLOGY"
      | "PEDIATRICS"
      | "PEDORTHIST"
      | "PEER_SPECIALIST"
      | "PERFUSIONIST"
      | "PERSONAL_EMERGENCY_RESPONSE_ATTENDANT"
      | "PHARMACIST"
      | "PHARMACY"
      | "PHARMACY_TECHNICIAN"
      | "PHLEBOLOGY"
      | "PHYSICAL_MEDICINE_REHABILITATION"
      | "PHYSICAL_THERAPIST"
      | "PHYSICAL_THERAPY_ASSISTANT"
      | "PHYSICIAN_ASSISTANT"
      | "PHYSIOLOGICAL_LABORATORY"
      | "PLASTIC_SURGERY"
      | "PODIATRIST"
      | "POETRY_THERAPIST"
      | "POINT_OF_SERVICE"
      | "PORTABLE_X_RAY_AND_OR_OTHER_PORTABLE_DIAGNOSTIC_IMAGING_SUPPLIER"
      | "PREFERRED_PROVIDER_ORGANIZATION"
      | "PREVENTION_PROFESSIONAL"
      | "PREVENTIVE_MEDICINE"
      | "PRIVATE_VEHICLE"
      | "PROGRAM_OF_ALL_INCLUSIVE_CARE_FOR_THE_ELDERLY_PACE_PROVIDER_ORGANIZATION"
      | "PROSTHETIC_ORTHOTIC_SUPPLIER"
      | "PROSTHETIST"
      | "PSYCHIATRIC_HOSPITAL"
      | "PSYCHIATRIC_RESIDENTIAL_TREATMENT_FACILITY"
      | "PSYCHIATRIC_UNIT"
      | "PSYCHIATRY_NEUROLOGY"
      | "PSYCHOANALYST"
      | "PSYCHOLOGIST"
      | "PUBLIC_HEALTH_OR_WELFARE"
      | "PULMONARY_FUNCTION_TECHNOLOGIST"
      | "RADIOLOGIC_TECHNOLOGIST"
      | "RADIOLOGY"
      | "RADIOLOGY_PRACTITIONER_ASSISTANT"
      | "RECREATION_THERAPIST"
      | "RECREATIONAL_THERAPIST_ASSISTANT"
      | "REFLEXOLOGIST"
      | "REGISTERED_NURSE"
      | "REHABILITATION_COUNSELOR"
      | "REHABILITATION_HOSPITAL"
      | "REHABILITATION_PRACTITIONER"
      | "REHABILITATION_UNIT"
      | "REHABILITATION_SUBSTANCE_USE_DISORDER_UNIT"
      | "RELIGIOUS_NONMEDICAL_HEALTH_CARE_INSTITUTION"
      | "RELIGIOUS_NONMEDICAL_NURSING_PERSONNEL"
      | "RELIGIOUS_NONMEDICAL_PRACTITIONER"
      | "RESIDENTIAL_TREATMENT_FACILITY_EMOTIONALLY_DISTURBED_CHILDREN"
      | "RESIDENTIAL_TREATMENT_FACILITY_INTELLECTUAL_AND_OR_DEVELOPMENTAL_DISABILITIES"
      | "RESIDENTIAL_TREATMENT_FACILITY_PHYSICAL_DISABILITIES"
      | "RESPIRATORY_THERAPIST_CERTIFIED"
      | "RESPIRATORY_THERAPIST_REGISTERED"
      | "RESPITE_CARE"
      | "SECURED_MEDICAL_TRANSPORT_VAN"
      | "SINGLE_SPECIALTY"
      | "SKILLED_NURSING_FACILITY"
      | "SLEEP_SPECIALIST_PHD"
      | "SOCIAL_WORKER"
      | "SPECIAL_HOSPITAL"
      | "SPECIALIST_TECHNOLOGIST"
      | "SPECIALIST_TECHNOLOGIST_CARDIOVASCULAR"
      | "SPECIALIST_TECHNOLOGIST_HEALTH_INFORMATION"
      | "SPECIALIST_TECHNOLOGIST_OTHER"
      | "SPECIALIST_TECHNOLOGIST_PATHOLOGY"
      | "SPEECH_LANGUAGE_PATHOLOGIST"
      | "STUDENT_IN_AN_ORGANIZED_HEALTH_CARE_EDUCATION_TRAINING_PROGRAM"
      | "SUBSTANCE_ABUSE_REHABILITATION_FACILITY"
      | "SUPPORTS_BROKERAGE"
      | "SURGERY"
      | "TAXI"
      | "TECHNICIAN"
      | "TECHNICIAN_CARDIOLOGY"
      | "TECHNICIAN_HEALTH_INFORMATION"
      | "TECHNICIAN_OTHER"
      | "TECHNICIAN_PATHOLOGY"
      | "TECHNICIAN_TECHNOLOGIST"
      | "THORACIC_SURGERY_CARDIOTHORACIC_VASCULAR_SURGERY"
      | "TRAIN"
      | "TRANSPLANT_SURGERY"
      | "TRANSPORTATION_BROKER"
      | "TRANSPORTATION_NETWORK_COMPANY"
      | "UROLOGY"
      | "VETERINARIAN"
      | "VOLUNTARY_OR_CHARITABLE";
    searchString?: string;
    size?: number;
    sort?: string[];
    state?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useContactDirectoryControllerServiceGetAllContactDirectoryKey,
  ...(queryKey ?? [
    { city, page, referralType, searchString, size, sort, state },
  ]),
];
export type AwsControllerServiceGetFileDefaultResponse = Awaited<
  ReturnType<typeof AwsControllerService.getFile>
>;
export type AwsControllerServiceGetFileQueryResult<
  TData = AwsControllerServiceGetFileDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAwsControllerServiceGetFileKey = "AwsControllerServiceGetFile";
export const UseAwsControllerServiceGetFileKeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [useAwsControllerServiceGetFileKey, ...(queryKey ?? [{ key }])];
export type AwsControllerServiceGetFile1DefaultResponse = Awaited<
  ReturnType<typeof AwsControllerService.getFile1>
>;
export type AwsControllerServiceGetFile1QueryResult<
  TData = AwsControllerServiceGetFile1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAwsControllerServiceGetFile1Key =
  "AwsControllerServiceGetFile1";
export const UseAwsControllerServiceGetFile1KeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [useAwsControllerServiceGetFile1Key, ...(queryKey ?? [{ key }])];
export type AwsControllerServiceGetDownloadUrlDefaultResponse = Awaited<
  ReturnType<typeof AwsControllerService.getDownloadUrl>
>;
export type AwsControllerServiceGetDownloadUrlQueryResult<
  TData = AwsControllerServiceGetDownloadUrlDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAwsControllerServiceGetDownloadUrlKey =
  "AwsControllerServiceGetDownloadUrl";
export const UseAwsControllerServiceGetDownloadUrlKeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [useAwsControllerServiceGetDownloadUrlKey, ...(queryKey ?? [{ key }])];
export type AwsControllerServiceGetDownloadUrl1DefaultResponse = Awaited<
  ReturnType<typeof AwsControllerService.getDownloadUrl1>
>;
export type AwsControllerServiceGetDownloadUrl1QueryResult<
  TData = AwsControllerServiceGetDownloadUrl1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAwsControllerServiceGetDownloadUrl1Key =
  "AwsControllerServiceGetDownloadUrl1";
export const UseAwsControllerServiceGetDownloadUrl1KeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [useAwsControllerServiceGetDownloadUrl1Key, ...(queryKey ?? [{ key }])];
export type AgreementControllerServiceGetAgreementByUuidDefaultResponse =
  Awaited<ReturnType<typeof AgreementControllerService.getAgreementByUuid>>;
export type AgreementControllerServiceGetAgreementByUuidQueryResult<
  TData = AgreementControllerServiceGetAgreementByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetAgreementByUuidKey =
  "AgreementControllerServiceGetAgreementByUuid";
export const UseAgreementControllerServiceGetAgreementByUuidKeyFn = (
  {
    agreementUuid,
  }: {
    agreementUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgreementControllerServiceGetAgreementByUuidKey,
  ...(queryKey ?? [{ agreementUuid }]),
];
export type AgreementControllerServiceGetAgreementPdfUrlsDefaultResponse =
  Awaited<ReturnType<typeof AgreementControllerService.getAgreementPdfUrls>>;
export type AgreementControllerServiceGetAgreementPdfUrlsQueryResult<
  TData = AgreementControllerServiceGetAgreementPdfUrlsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetAgreementPdfUrlsKey =
  "AgreementControllerServiceGetAgreementPdfUrls";
export const UseAgreementControllerServiceGetAgreementPdfUrlsKeyFn = (
  {
    agreementUuid,
  }: {
    agreementUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgreementControllerServiceGetAgreementPdfUrlsKey,
  ...(queryKey ?? [{ agreementUuid }]),
];
export type AgreementControllerServiceGetAgreementContentForAffiliateGroupDefaultResponse =
  Awaited<
    ReturnType<
      typeof AgreementControllerService.getAgreementContentForAffiliateGroup
    >
  >;
export type AgreementControllerServiceGetAgreementContentForAffiliateGroupQueryResult<
  TData =
    AgreementControllerServiceGetAgreementContentForAffiliateGroupDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetAgreementContentForAffiliateGroupKey =
  "AgreementControllerServiceGetAgreementContentForAffiliateGroup";
export const UseAgreementControllerServiceGetAgreementContentForAffiliateGroupKeyFn =
  (
    {
      affiliateGroupUuid,
      agreementUuid,
    }: {
      affiliateGroupUuid: string;
      agreementUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAgreementControllerServiceGetAgreementContentForAffiliateGroupKey,
    ...(queryKey ?? [{ affiliateGroupUuid, agreementUuid }]),
  ];
export type AgreementControllerServiceGetAgreementsForPortalDefaultResponse =
  Awaited<ReturnType<typeof AgreementControllerService.getAgreementsForPortal>>;
export type AgreementControllerServiceGetAgreementsForPortalQueryResult<
  TData = AgreementControllerServiceGetAgreementsForPortalDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetAgreementsForPortalKey =
  "AgreementControllerServiceGetAgreementsForPortal";
export const UseAgreementControllerServiceGetAgreementsForPortalKeyFn = (
  {
    page,
    pageSize,
    signed,
    sortBy,
    sortDirection,
    uuid,
  }: {
    page?: number;
    pageSize?: number;
    signed?: boolean;
    sortBy?: string;
    sortDirection?: string;
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgreementControllerServiceGetAgreementsForPortalKey,
  ...(queryKey ?? [{ page, pageSize, signed, sortBy, sortDirection, uuid }]),
];
export type AgreementControllerServiceGetAllAgreementsForFirmsDefaultResponse =
  Awaited<
    ReturnType<typeof AgreementControllerService.getAllAgreementsForFirms>
  >;
export type AgreementControllerServiceGetAllAgreementsForFirmsQueryResult<
  TData = AgreementControllerServiceGetAllAgreementsForFirmsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetAllAgreementsForFirmsKey =
  "AgreementControllerServiceGetAllAgreementsForFirms";
export const UseAgreementControllerServiceGetAllAgreementsForFirmsKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAgreementControllerServiceGetAllAgreementsForFirmsKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection }]),
];
export type AgreementControllerServiceGetPendingAgreementForLoginDefaultResponse =
  Awaited<
    ReturnType<typeof AgreementControllerService.getPendingAgreementForLogin>
  >;
export type AgreementControllerServiceGetPendingAgreementForLoginQueryResult<
  TData = AgreementControllerServiceGetPendingAgreementForLoginDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAgreementControllerServiceGetPendingAgreementForLoginKey =
  "AgreementControllerServiceGetPendingAgreementForLogin";
export const UseAgreementControllerServiceGetPendingAgreementForLoginKeyFn = (
  {
    affiliateGroupUuid,
  }: {
    affiliateGroupUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAgreementControllerServiceGetPendingAgreementForLoginKey,
  ...(queryKey ?? [{ affiliateGroupUuid }]),
];
export type TribleLabControllerServiceGetAllTribleTestCodesDefaultResponse =
  Awaited<ReturnType<typeof TribleLabControllerService.getAllTribleTestCodes>>;
export type TribleLabControllerServiceGetAllTribleTestCodesQueryResult<
  TData = TribleLabControllerServiceGetAllTribleTestCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTribleLabControllerServiceGetAllTribleTestCodesKey =
  "TribleLabControllerServiceGetAllTribleTestCodes";
export const UseTribleLabControllerServiceGetAllTribleTestCodesKeyFn = (
  {
    pageable,
    search,
  }: {
    pageable: Pageable;
    search?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTribleLabControllerServiceGetAllTribleTestCodesKey,
  ...(queryKey ?? [{ pageable, search }]),
];
export type TribleLabControllerServiceGetByPatientUuidDefaultResponse = Awaited<
  ReturnType<typeof TribleLabControllerService.getByPatientUuid>
>;
export type TribleLabControllerServiceGetByPatientUuidQueryResult<
  TData = TribleLabControllerServiceGetByPatientUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTribleLabControllerServiceGetByPatientUuidKey =
  "TribleLabControllerServiceGetByPatientUuid";
export const UseTribleLabControllerServiceGetByPatientUuidKeyFn = (
  {
    isApprove,
    patientUuid,
  }: {
    isApprove?: boolean;
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTribleLabControllerServiceGetByPatientUuidKey,
  ...(queryKey ?? [{ isApprove, patientUuid }]),
];
export type TribleLabControllerServiceGetAllLabOrdersForPdfDefaultResponse =
  Awaited<ReturnType<typeof TribleLabControllerService.getAllLabOrdersForPdf>>;
export type TribleLabControllerServiceGetAllLabOrdersForPdfQueryResult<
  TData = TribleLabControllerServiceGetAllLabOrdersForPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTribleLabControllerServiceGetAllLabOrdersForPdfKey =
  "TribleLabControllerServiceGetAllLabOrdersForPdf";
export const UseTribleLabControllerServiceGetAllLabOrdersForPdfKeyFn = (
  {
    patientUuid,
  }: {
    patientUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTribleLabControllerServiceGetAllLabOrdersForPdfKey,
  ...(queryKey ?? [{ patientUuid }]),
];
export type TribleLabControllerServiceGetAll1DefaultResponse = Awaited<
  ReturnType<typeof TribleLabControllerService.getAll1>
>;
export type TribleLabControllerServiceGetAll1QueryResult<
  TData = TribleLabControllerServiceGetAll1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTribleLabControllerServiceGetAll1Key =
  "TribleLabControllerServiceGetAll1";
export const UseTribleLabControllerServiceGetAll1KeyFn = (
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTribleLabControllerServiceGetAll1Key,
  ...(queryKey ?? [{ page, pageSize }]),
];
export type TaskCategoryControllerServiceGetAllTaskCategoriesDefaultResponse =
  Awaited<
    ReturnType<typeof TaskCategoryControllerService.getAllTaskCategories>
  >;
export type TaskCategoryControllerServiceGetAllTaskCategoriesQueryResult<
  TData = TaskCategoryControllerServiceGetAllTaskCategoriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskCategoryControllerServiceGetAllTaskCategoriesKey =
  "TaskCategoryControllerServiceGetAllTaskCategories";
export const UseTaskCategoryControllerServiceGetAllTaskCategoriesKeyFn = (
  {
    page,
    pageSize,
  }: {
    page?: number;
    pageSize?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTaskCategoryControllerServiceGetAllTaskCategoriesKey,
  ...(queryKey ?? [{ page, pageSize }]),
];
export type ProcedureCodeControllerServiceGetProcedureCodesDefaultResponse =
  Awaited<ReturnType<typeof ProcedureCodeControllerService.getProcedureCodes>>;
export type ProcedureCodeControllerServiceGetProcedureCodesQueryResult<
  TData = ProcedureCodeControllerServiceGetProcedureCodesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useProcedureCodeControllerServiceGetProcedureCodesKey =
  "ProcedureCodeControllerServiceGetProcedureCodes";
export const UseProcedureCodeControllerServiceGetProcedureCodesKeyFn = (
  {
    code,
    page,
    size,
    sort,
  }: {
    code?: string;
    page?: number;
    size?: number;
    sort?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useProcedureCodeControllerServiceGetProcedureCodesKey,
  ...(queryKey ?? [{ code, page, size, sort }]),
];
export type PlaceholderControllerServiceGetAllPlaceholdersDefaultResponse =
  Awaited<ReturnType<typeof PlaceholderControllerService.getAllPlaceholders>>;
export type PlaceholderControllerServiceGetAllPlaceholdersQueryResult<
  TData = PlaceholderControllerServiceGetAllPlaceholdersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const usePlaceholderControllerServiceGetAllPlaceholdersKey =
  "PlaceholderControllerServiceGetAllPlaceholders";
export const UsePlaceholderControllerServiceGetAllPlaceholdersKeyFn = (
  queryKey?: Array<unknown>,
) => [
  usePlaceholderControllerServiceGetAllPlaceholdersKey,
  ...(queryKey ?? []),
];
export type OrderStudyControllerServiceGetAllDocumentsDefaultResponse = Awaited<
  ReturnType<typeof OrderStudyControllerService.getAllDocuments>
>;
export type OrderStudyControllerServiceGetAllDocumentsQueryResult<
  TData = OrderStudyControllerServiceGetAllDocumentsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useOrderStudyControllerServiceGetAllDocumentsKey =
  "OrderStudyControllerServiceGetAllDocuments";
export const UseOrderStudyControllerServiceGetAllDocumentsKeyFn = (
  {
    page,
    size,
    sort,
    studyName,
  }: {
    page?: number;
    size?: number;
    sort?: string[];
    studyName?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useOrderStudyControllerServiceGetAllDocumentsKey,
  ...(queryKey ?? [{ page, size, sort, studyName }]),
];
export type GrowthChartControllerServiceGetGrowthChartDefaultResponse = Awaited<
  ReturnType<typeof GrowthChartControllerService.getGrowthChart>
>;
export type GrowthChartControllerServiceGetGrowthChartQueryResult<
  TData = GrowthChartControllerServiceGetGrowthChartDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useGrowthChartControllerServiceGetGrowthChartKey =
  "GrowthChartControllerServiceGetGrowthChart";
export const UseGrowthChartControllerServiceGetGrowthChartKeyFn = (
  {
    chartType,
    combined,
    gestationalAgeWeeks,
    patientUuid,
    standard,
  }: {
    chartType?:
      | "WEIGHT_FOR_AGE"
      | "LENGTH_HEIGHT_FOR_AGE"
      | "WEIGHT_FOR_LENGTH"
      | "BMI_FOR_AGE"
      | "HEAD_CIRCUMFERENCE_FOR_AGE";
    combined?: boolean;
    gestationalAgeWeeks?: number;
    patientUuid: string;
    standard?: "WHO" | "CDC" | "DOWN_SYNDROME" | "PRETERM";
  },
  queryKey?: Array<unknown>,
) => [
  useGrowthChartControllerServiceGetGrowthChartKey,
  ...(queryKey ?? [
    { chartType, combined, gestationalAgeWeeks, patientUuid, standard },
  ]),
];
export type DynamicMappingControllerServiceGetAvailableFieldsDefaultResponse =
  Awaited<
    ReturnType<typeof DynamicMappingControllerService.getAvailableFields>
  >;
export type DynamicMappingControllerServiceGetAvailableFieldsQueryResult<
  TData = DynamicMappingControllerServiceGetAvailableFieldsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useDynamicMappingControllerServiceGetAvailableFieldsKey =
  "DynamicMappingControllerServiceGetAvailableFields";
export const UseDynamicMappingControllerServiceGetAvailableFieldsKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useDynamicMappingControllerServiceGetAvailableFieldsKey,
  ...(queryKey ?? []),
];
export type AuditHistoryControllerServiceGetAuditHistoryByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getAuditHistoryByUuid>
  >;
export type AuditHistoryControllerServiceGetAuditHistoryByUuidQueryResult<
  TData = AuditHistoryControllerServiceGetAuditHistoryByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetAuditHistoryByUuidKey =
  "AuditHistoryControllerServiceGetAuditHistoryByUuid";
export const UseAuditHistoryControllerServiceGetAuditHistoryByUuidKeyFn = (
  {
    auditUuid,
    entityName,
  }: {
    auditUuid: string;
    entityName: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetAuditHistoryByUuidKey,
  ...(queryKey ?? [{ auditUuid, entityName }]),
];
export type AuditHistoryControllerServiceGetUserAuditLogsDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getUserAuditLogs>>;
export type AuditHistoryControllerServiceGetUserAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetUserAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetUserAuditLogsKey =
  "AuditHistoryControllerServiceGetUserAuditLogs";
export const UseAuditHistoryControllerServiceGetUserAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    userUuid,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetUserAuditLogsKey,
  ...(queryKey ?? [
    { endDate, entityNames, page, size, sort, startDate, userUuid },
  ]),
];
export type AuditHistoryControllerServiceGetTicketAuditLogsDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getTicketAuditLogs>>;
export type AuditHistoryControllerServiceGetTicketAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetTicketAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetTicketAuditLogsKey =
  "AuditHistoryControllerServiceGetTicketAuditLogs";
export const UseAuditHistoryControllerServiceGetTicketAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    ticketUuid,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    ticketUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetTicketAuditLogsKey,
  ...(queryKey ?? [
    { endDate, entityNames, page, size, sort, startDate, ticketUuid },
  ]),
];
export type AuditHistoryControllerServiceGetTaskAuditLogsDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getTaskAuditLogs>>;
export type AuditHistoryControllerServiceGetTaskAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetTaskAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetTaskAuditLogsKey =
  "AuditHistoryControllerServiceGetTaskAuditLogs";
export const UseAuditHistoryControllerServiceGetTaskAuditLogsKeyFn = (
  {
    flag,
    pageable,
    userUuid,
  }: {
    flag: boolean;
    pageable: Pageable;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetTaskAuditLogsKey,
  ...(queryKey ?? [{ flag, pageable, userUuid }]),
];
export type AuditHistoryControllerServiceGetSoapNoteAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getSoapNoteAuditLogs>
  >;
export type AuditHistoryControllerServiceGetSoapNoteAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetSoapNoteAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetSoapNoteAuditLogsKey =
  "AuditHistoryControllerServiceGetSoapNoteAuditLogs";
export const UseAuditHistoryControllerServiceGetSoapNoteAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    page,
    size,
    soapNoteUuid,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    soapNoteUuid: string;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetSoapNoteAuditLogsKey,
  ...(queryKey ?? [
    { endDate, entityNames, page, size, soapNoteUuid, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceGetPatientModuleAccessAuditLogsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AuditHistoryControllerService.getPatientModuleAccessAuditLogs
    >
  >;
export type AuditHistoryControllerServiceGetPatientModuleAccessAuditLogsQueryResult<
  TData =
    AuditHistoryControllerServiceGetPatientModuleAccessAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetPatientModuleAccessAuditLogsKey =
  "AuditHistoryControllerServiceGetPatientModuleAccessAuditLogs";
export const UseAuditHistoryControllerServiceGetPatientModuleAccessAuditLogsKeyFn =
  (
    {
      endDate,
      page,
      patientUuid,
      size,
      sort,
      startDate,
    }: {
      endDate?: string;
      page?: number;
      patientUuid: string;
      size?: number;
      sort?: string[];
      startDate?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAuditHistoryControllerServiceGetPatientModuleAccessAuditLogsKey,
    ...(queryKey ?? [{ endDate, page, patientUuid, size, sort, startDate }]),
  ];
export type AuditHistoryControllerServiceGetInventoryAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getInventoryAuditLogs>
  >;
export type AuditHistoryControllerServiceGetInventoryAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetInventoryAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetInventoryAuditLogsKey =
  "AuditHistoryControllerServiceGetInventoryAuditLogs";
export const UseAuditHistoryControllerServiceGetInventoryAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
    username,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetInventoryAuditLogsKey,
  ...(queryKey ?? [
    { endDate, entityNames, page, size, sort, startDate, username },
  ]),
];
export type AuditHistoryControllerServiceGetHandPnoteAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getHandPnoteAuditLogs>
  >;
export type AuditHistoryControllerServiceGetHandPnoteAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetHandPnoteAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetHandPnoteAuditLogsKey =
  "AuditHistoryControllerServiceGetHandPnoteAuditLogs";
export const UseAuditHistoryControllerServiceGetHandPnoteAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    hAndPnoteUuid,
    page,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    hAndPnoteUuid: string;
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetHandPnoteAuditLogsKey,
  ...(queryKey ?? [
    { endDate, entityNames, hAndPnoteUuid, page, size, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceExportTaskAuditLogsCsvDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportTaskAuditLogsCsv>
  >;
export type AuditHistoryControllerServiceExportTaskAuditLogsCsvQueryResult<
  TData = AuditHistoryControllerServiceExportTaskAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportTaskAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportTaskAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportTaskAuditLogsCsvKeyFn = (
  {
    flag,
    userUuid,
  }: {
    flag: boolean;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportTaskAuditLogsCsvKey,
  ...(queryKey ?? [{ flag, userUuid }]),
];
export type AuditHistoryControllerServiceExportAuditLogsPdfDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.exportAuditLogsPdf>>;
export type AuditHistoryControllerServiceExportAuditLogsPdfQueryResult<
  TData = AuditHistoryControllerServiceExportAuditLogsPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportAuditLogsPdfKey =
  "AuditHistoryControllerServiceExportAuditLogsPdf";
export const UseAuditHistoryControllerServiceExportAuditLogsPdfKeyFn = (
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportAuditLogsPdfKey,
  ...(queryKey ?? [
    { actions, endDate, roles, roleTypes, startDate, username },
  ]),
];
export type AuditHistoryControllerServiceExportInventoryAuditLogsPdfDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportInventoryAuditLogsPdf>
  >;
export type AuditHistoryControllerServiceExportInventoryAuditLogsPdfQueryResult<
  TData =
    AuditHistoryControllerServiceExportInventoryAuditLogsPdfDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportInventoryAuditLogsPdfKey =
  "AuditHistoryControllerServiceExportInventoryAuditLogsPdf";
export const UseAuditHistoryControllerServiceExportInventoryAuditLogsPdfKeyFn =
  (
    {
      endDate,
      entityNames,
      startDate,
      username,
    }: {
      endDate?: string;
      entityNames?: string[];
      startDate?: string;
      username?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAuditHistoryControllerServiceExportInventoryAuditLogsPdfKey,
    ...(queryKey ?? [{ endDate, entityNames, startDate, username }]),
  ];
export type AuditHistoryControllerServiceExportInventoryAuditLogsCsvDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportInventoryAuditLogsCsv>
  >;
export type AuditHistoryControllerServiceExportInventoryAuditLogsCsvQueryResult<
  TData =
    AuditHistoryControllerServiceExportInventoryAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportInventoryAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportInventoryAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportInventoryAuditLogsCsvKeyFn =
  (
    {
      endDate,
      entityNames,
      startDate,
      username,
    }: {
      endDate?: string;
      entityNames?: string[];
      startDate?: string;
      username?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useAuditHistoryControllerServiceExportInventoryAuditLogsCsvKey,
    ...(queryKey ?? [{ endDate, entityNames, startDate, username }]),
  ];
export type AuditHistoryControllerServiceExportEmployerAuditLogsCsvDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportEmployerAuditLogsCsv>
  >;
export type AuditHistoryControllerServiceExportEmployerAuditLogsCsvQueryResult<
  TData =
    AuditHistoryControllerServiceExportEmployerAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportEmployerAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportEmployerAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportEmployerAuditLogsCsvKeyFn = (
  {
    employerUuid,
    endDate,
    entityNames,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportEmployerAuditLogsCsvKey,
  ...(queryKey ?? [{ employerUuid, endDate, entityNames, startDate }]),
];
export type AuditHistoryControllerServiceExportEmployeeAuditLogsCsvDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportEmployeeAuditLogsCsv>
  >;
export type AuditHistoryControllerServiceExportEmployeeAuditLogsCsvQueryResult<
  TData =
    AuditHistoryControllerServiceExportEmployeeAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportEmployeeAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportEmployeeAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportEmployeeAuditLogsCsvKeyFn = (
  {
    employeeUuid,
    endDate,
    entityNames,
    startDate,
  }: {
    employeeUuid: string;
    endDate?: string;
    entityNames?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportEmployeeAuditLogsCsvKey,
  ...(queryKey ?? [{ employeeUuid, endDate, entityNames, startDate }]),
];
export type AuditHistoryControllerServiceExportAuditLogsCsvDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.exportAuditLogsCsv>>;
export type AuditHistoryControllerServiceExportAuditLogsCsvQueryResult<
  TData = AuditHistoryControllerServiceExportAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportAuditLogsCsvKeyFn = (
  {
    endDate,
    entityNames,
    patientUuid,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    patientUuid?: string;
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportAuditLogsCsvKey,
  ...(queryKey ?? [{ endDate, entityNames, patientUuid, startDate }]),
];
export type AuditHistoryControllerServiceExportAuditLogsCsv1DefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.exportAuditLogsCsv1>>;
export type AuditHistoryControllerServiceExportAuditLogsCsv1QueryResult<
  TData = AuditHistoryControllerServiceExportAuditLogsCsv1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportAuditLogsCsv1Key =
  "AuditHistoryControllerServiceExportAuditLogsCsv1";
export const UseAuditHistoryControllerServiceExportAuditLogsCsv1KeyFn = (
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportAuditLogsCsv1Key,
  ...(queryKey ?? [
    { actions, endDate, roles, roleTypes, startDate, username },
  ]),
];
export type AuditHistoryControllerServiceExportAdminAuditLogsCsvDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.exportAdminAuditLogsCsv>
  >;
export type AuditHistoryControllerServiceExportAdminAuditLogsCsvQueryResult<
  TData = AuditHistoryControllerServiceExportAdminAuditLogsCsvDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceExportAdminAuditLogsCsvKey =
  "AuditHistoryControllerServiceExportAdminAuditLogsCsv";
export const UseAuditHistoryControllerServiceExportAdminAuditLogsCsvKeyFn = (
  {
    actions,
    endDate,
    roles,
    roleTypes,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    roles?: string[];
    roleTypes?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceExportAdminAuditLogsCsvKey,
  ...(queryKey ?? [
    { actions, endDate, roles, roleTypes, startDate, username },
  ]),
];
export type AuditHistoryControllerServiceGetTicketRelatedAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getTicketRelatedAuditLogs>
  >;
export type AuditHistoryControllerServiceGetTicketRelatedAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetTicketRelatedAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetTicketRelatedAuditLogsKey =
  "AuditHistoryControllerServiceGetTicketRelatedAuditLogs";
export const UseAuditHistoryControllerServiceGetTicketRelatedAuditLogsKeyFn = (
  {
    employerUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetTicketRelatedAuditLogsKey,
  ...(queryKey ?? [
    { employerUuid, endDate, entityNames, page, size, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceGetEmployerAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getEmployerAuditLogs>
  >;
export type AuditHistoryControllerServiceGetEmployerAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetEmployerAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetEmployerAuditLogsKey =
  "AuditHistoryControllerServiceGetEmployerAuditLogs";
export const UseAuditHistoryControllerServiceGetEmployerAuditLogsKeyFn = (
  {
    employerUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employerUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetEmployerAuditLogsKey,
  ...(queryKey ?? [
    { employerUuid, endDate, entityNames, page, size, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceGetEmployerAdministratorAuditLogsDefaultResponse =
  Awaited<
    ReturnType<
      typeof AuditHistoryControllerService.getEmployerAdministratorAuditLogs
    >
  >;
export type AuditHistoryControllerServiceGetEmployerAdministratorAuditLogsQueryResult<
  TData =
    AuditHistoryControllerServiceGetEmployerAdministratorAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetEmployerAdministratorAuditLogsKey =
  "AuditHistoryControllerServiceGetEmployerAdministratorAuditLogs";
export const UseAuditHistoryControllerServiceGetEmployerAdministratorAuditLogsKeyFn =
  (
    {
      employerAdministratorUuid,
      endDate,
      entityNames,
      page,
      size,
      sort,
      startDate,
    }: {
      employerAdministratorUuid: string;
      endDate?: string;
      entityNames?: string[];
      page?: number;
      size?: number;
      sort?: string[];
      startDate?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useAuditHistoryControllerServiceGetEmployerAdministratorAuditLogsKey,
    ...(queryKey ?? [
      {
        employerAdministratorUuid,
        endDate,
        entityNames,
        page,
        size,
        sort,
        startDate,
      },
    ]),
  ];
export type AuditHistoryControllerServiceGetEmployeeAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getEmployeeAuditLogs>
  >;
export type AuditHistoryControllerServiceGetEmployeeAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetEmployeeAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetEmployeeAuditLogsKey =
  "AuditHistoryControllerServiceGetEmployeeAuditLogs";
export const UseAuditHistoryControllerServiceGetEmployeeAuditLogsKeyFn = (
  {
    employeeUuid,
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    employeeUuid: string;
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetEmployeeAuditLogsKey,
  ...(queryKey ?? [
    { employeeUuid, endDate, entityNames, page, size, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceGetBreakGlassAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getBreakGlassAuditLogs>
  >;
export type AuditHistoryControllerServiceGetBreakGlassAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetBreakGlassAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetBreakGlassAuditLogsKey =
  "AuditHistoryControllerServiceGetBreakGlassAuditLogs";
export const UseAuditHistoryControllerServiceGetBreakGlassAuditLogsKeyFn = (
  {
    clinicUserUuid,
    endDate,
    entityNames,
    locationUuid,
    page,
    patientUuid,
    providerUuid,
    size,
    sort,
    startDate,
  }: {
    clinicUserUuid?: string;
    endDate?: string;
    entityNames?: string[];
    locationUuid: string;
    page?: number;
    patientUuid?: string;
    providerUuid?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetBreakGlassAuditLogsKey,
  ...(queryKey ?? [
    {
      clinicUserUuid,
      endDate,
      entityNames,
      locationUuid,
      page,
      patientUuid,
      providerUuid,
      size,
      sort,
      startDate,
    },
  ]),
];
export type AuditHistoryControllerServiceGetAllAuditEntitiesDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getAllAuditEntities>>;
export type AuditHistoryControllerServiceGetAllAuditEntitiesQueryResult<
  TData = AuditHistoryControllerServiceGetAllAuditEntitiesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetAllAuditEntitiesKey =
  "AuditHistoryControllerServiceGetAllAuditEntities";
export const UseAuditHistoryControllerServiceGetAllAuditEntitiesKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetAllAuditEntitiesKey,
  ...(queryKey ?? []),
];
export type AuditHistoryControllerServiceGetAllTicketAuditLogsDefaultResponse =
  Awaited<
    ReturnType<typeof AuditHistoryControllerService.getAllTicketAuditLogs>
  >;
export type AuditHistoryControllerServiceGetAllTicketAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetAllTicketAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetAllTicketAuditLogsKey =
  "AuditHistoryControllerServiceGetAllTicketAuditLogs";
export const UseAuditHistoryControllerServiceGetAllTicketAuditLogsKeyFn = (
  {
    endDate,
    entityNames,
    page,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    size?: number;
    sort?: string[];
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetAllTicketAuditLogsKey,
  ...(queryKey ?? [{ endDate, entityNames, page, size, sort, startDate }]),
];
export type AuditHistoryControllerServiceGetAllAuditHistoryDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getAllAuditHistory>>;
export type AuditHistoryControllerServiceGetAllAuditHistoryQueryResult<
  TData = AuditHistoryControllerServiceGetAllAuditHistoryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetAllAuditHistoryKey =
  "AuditHistoryControllerServiceGetAllAuditHistory";
export const UseAuditHistoryControllerServiceGetAllAuditHistoryKeyFn = (
  {
    endDate,
    entityNames,
    page,
    patientUuid,
    size,
    sort,
    startDate,
  }: {
    endDate?: string;
    entityNames?: string[];
    page?: number;
    patientUuid?: string;
    size?: number;
    sort?: string[];
    startDate?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetAllAuditHistoryKey,
  ...(queryKey ?? [
    { endDate, entityNames, page, patientUuid, size, sort, startDate },
  ]),
];
export type AuditHistoryControllerServiceGetAdminAuditLogsDefaultResponse =
  Awaited<ReturnType<typeof AuditHistoryControllerService.getAdminAuditLogs>>;
export type AuditHistoryControllerServiceGetAdminAuditLogsQueryResult<
  TData = AuditHistoryControllerServiceGetAdminAuditLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useAuditHistoryControllerServiceGetAdminAuditLogsKey =
  "AuditHistoryControllerServiceGetAdminAuditLogs";
export const UseAuditHistoryControllerServiceGetAdminAuditLogsKeyFn = (
  {
    actions,
    endDate,
    page,
    roles,
    roleTypes,
    size,
    sort,
    startDate,
    username,
  }: {
    actions?: string[];
    endDate?: string;
    page?: number;
    roles?: string[];
    roleTypes?: string[];
    size?: number;
    sort?: string[];
    startDate?: string;
    username?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useAuditHistoryControllerServiceGetAdminAuditLogsKey,
  ...(queryKey ?? [
    {
      actions,
      endDate,
      page,
      roles,
      roleTypes,
      size,
      sort,
      startDate,
      username,
    },
  ]),
];
export type NotificationControllerServiceGetAllNotificationsDefaultResponse =
  Awaited<ReturnType<typeof NotificationControllerService.getAllNotifications>>;
export type NotificationControllerServiceGetAllNotificationsQueryResult<
  TData = NotificationControllerServiceGetAllNotificationsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationControllerServiceGetAllNotificationsKey =
  "NotificationControllerServiceGetAllNotifications";
export const UseNotificationControllerServiceGetAllNotificationsKeyFn = (
  {
    isRead,
    page,
    pageSize,
    sortBy,
    sortDirection,
    userUuid,
  }: {
    isRead?: boolean;
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNotificationControllerServiceGetAllNotificationsKey,
  ...(queryKey ?? [
    { isRead, page, pageSize, sortBy, sortDirection, userUuid },
  ]),
];
export type NotificationControllerServiceGetNotificationDefaultResponse =
  Awaited<ReturnType<typeof NotificationControllerService.getNotification>>;
export type NotificationControllerServiceGetNotificationQueryResult<
  TData = NotificationControllerServiceGetNotificationDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationControllerServiceGetNotificationKey =
  "NotificationControllerServiceGetNotification";
export const UseNotificationControllerServiceGetNotificationKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNotificationControllerServiceGetNotificationKey,
  ...(queryKey ?? [{ uuid }]),
];
export type NotificationControllerServiceGetNotificationCountByUserUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof NotificationControllerService.getNotificationCountByUserUuid
    >
  >;
export type NotificationControllerServiceGetNotificationCountByUserUuidQueryResult<
  TData =
    NotificationControllerServiceGetNotificationCountByUserUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationControllerServiceGetNotificationCountByUserUuidKey =
  "NotificationControllerServiceGetNotificationCountByUserUuid";
export const UseNotificationControllerServiceGetNotificationCountByUserUuidKeyFn =
  (
    {
      userUuid,
    }: {
      userUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useNotificationControllerServiceGetNotificationCountByUserUuidKey,
    ...(queryKey ?? [{ userUuid }]),
  ];
export type NotificationPreferenceControllerServiceGetAllNotificationPreferenceDefaultResponse =
  Awaited<
    ReturnType<
      typeof NotificationPreferenceControllerService.getAllNotificationPreference
    >
  >;
export type NotificationPreferenceControllerServiceGetAllNotificationPreferenceQueryResult<
  TData =
    NotificationPreferenceControllerServiceGetAllNotificationPreferenceDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationPreferenceControllerServiceGetAllNotificationPreferenceKey =
  "NotificationPreferenceControllerServiceGetAllNotificationPreference";
export const UseNotificationPreferenceControllerServiceGetAllNotificationPreferenceKeyFn =
  (queryKey?: Array<unknown>) => [
    useNotificationPreferenceControllerServiceGetAllNotificationPreferenceKey,
    ...(queryKey ?? []),
  ];
export type EmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.getEmployerManagementNotificationSettingyUuid
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidQueryResult<
  TData =
    EmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidKey =
  "EmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuid";
export const UseEmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidKeyFn =
  (
    {
      employerManagementNotificationSettingyUuid,
    }: {
      employerManagementNotificationSettingyUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerManagementNotificationSettingControllerServiceGetEmployerManagementNotificationSettingyUuidKey,
    ...(queryKey ?? [{ employerManagementNotificationSettingyUuid }]),
  ];
export type EmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.getAllSettingsByEmployer
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerQueryResult<
  TData =
    EmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerKey =
  "EmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployer";
export const UseEmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerKeyFn =
  (
    {
      employerUuid,
    }: {
      employerUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerManagementNotificationSettingControllerServiceGetAllSettingsByEmployerKey,
    ...(queryKey ?? [{ employerUuid }]),
  ];
export type EmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.getAllEmployerManagementNotificationSettings
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsQueryResult<
  TData =
    EmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsKey =
  "EmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettings";
export const UseEmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsKeyFn =
  (
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useEmployerManagementNotificationSettingControllerServiceGetAllEmployerManagementNotificationSettingsKey,
    ...(queryKey ?? [{ category, page, size, sort }]),
  ];
export type NotificationSettingControllerServiceGetNotificationSettingyUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.getNotificationSettingyUuid
    >
  >;
export type NotificationSettingControllerServiceGetNotificationSettingyUuidQueryResult<
  TData =
    NotificationSettingControllerServiceGetNotificationSettingyUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationSettingControllerServiceGetNotificationSettingyUuidKey =
  "NotificationSettingControllerServiceGetNotificationSettingyUuid";
export const UseNotificationSettingControllerServiceGetNotificationSettingyUuidKeyFn =
  (
    {
      notificationSettingUuid,
    }: {
      notificationSettingUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useNotificationSettingControllerServiceGetNotificationSettingyUuidKey,
    ...(queryKey ?? [{ notificationSettingUuid }]),
  ];
export type NotificationSettingControllerServiceGetFile1DefaultResponse =
  Awaited<ReturnType<typeof NotificationSettingControllerService.getFile1>>;
export type NotificationSettingControllerServiceGetFile1QueryResult<
  TData = NotificationSettingControllerServiceGetFile1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationSettingControllerServiceGetFile1Key =
  "NotificationSettingControllerServiceGetFile1";
export const UseNotificationSettingControllerServiceGetFile1KeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNotificationSettingControllerServiceGetFile1Key,
  ...(queryKey ?? [{ key }]),
];
export type NotificationSettingControllerServiceGetFile11DefaultResponse =
  Awaited<ReturnType<typeof NotificationSettingControllerService.getFile11>>;
export type NotificationSettingControllerServiceGetFile11QueryResult<
  TData = NotificationSettingControllerServiceGetFile11DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationSettingControllerServiceGetFile11Key =
  "NotificationSettingControllerServiceGetFile11";
export const UseNotificationSettingControllerServiceGetFile11KeyFn = (
  {
    key,
  }: {
    key: string;
  },
  queryKey?: Array<unknown>,
) => [
  useNotificationSettingControllerServiceGetFile11Key,
  ...(queryKey ?? [{ key }]),
];
export type NotificationSettingControllerServiceGetAllNotificationSettingsDefaultResponse =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.getAllNotificationSettings
    >
  >;
export type NotificationSettingControllerServiceGetAllNotificationSettingsQueryResult<
  TData =
    NotificationSettingControllerServiceGetAllNotificationSettingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useNotificationSettingControllerServiceGetAllNotificationSettingsKey =
  "NotificationSettingControllerServiceGetAllNotificationSettings";
export const UseNotificationSettingControllerServiceGetAllNotificationSettingsKeyFn =
  (
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useNotificationSettingControllerServiceGetAllNotificationSettingsKey,
    ...(queryKey ?? [{ category, page, size, sort }]),
  ];
export type EmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerNotificationSettingControllerService.employerNotificationSettingUuid
    >
  >;
export type EmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidQueryResult<
  TData =
    EmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidKey =
  "EmployerNotificationSettingControllerServiceEmployerNotificationSettingUuid";
export const UseEmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidKeyFn =
  (
    {
      employerNotificationSettingUuid,
    }: {
      employerNotificationSettingUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useEmployerNotificationSettingControllerServiceEmployerNotificationSettingUuidKey,
    ...(queryKey ?? [{ employerNotificationSettingUuid }]),
  ];
export type EmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsDefaultResponse =
  Awaited<
    ReturnType<
      typeof EmployerNotificationSettingControllerService.getAllEmployerNotificationSettings
    >
  >;
export type EmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsQueryResult<
  TData =
    EmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useEmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsKey =
  "EmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettings";
export const UseEmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsKeyFn =
  (
    {
      category,
      page,
      size,
      sort,
    }: {
      category?: string;
      page?: number;
      size?: number;
      sort?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useEmployerNotificationSettingControllerServiceGetAllEmployerNotificationSettingsKey,
    ...(queryKey ?? [{ category, page, size, sort }]),
  ];
export type StripControllerServiceGetSubscription1DefaultResponse = Awaited<
  ReturnType<typeof StripControllerService.getSubscription1>
>;
export type StripControllerServiceGetSubscription1QueryResult<
  TData = StripControllerServiceGetSubscription1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripControllerServiceGetSubscription1Key =
  "StripControllerServiceGetSubscription1";
export const UseStripControllerServiceGetSubscription1KeyFn = (
  {
    subscriptionId,
  }: {
    subscriptionId: string;
  },
  queryKey?: Array<unknown>,
) => [
  useStripControllerServiceGetSubscription1Key,
  ...(queryKey ?? [{ subscriptionId }]),
];
export type StripControllerServiceGetStripeConfig1DefaultResponse = Awaited<
  ReturnType<typeof StripControllerService.getStripeConfig1>
>;
export type StripControllerServiceGetStripeConfig1QueryResult<
  TData = StripControllerServiceGetStripeConfig1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useStripControllerServiceGetStripeConfig1Key =
  "StripControllerServiceGetStripeConfig1";
export const UseStripControllerServiceGetStripeConfig1KeyFn = (
  queryKey?: Array<unknown>,
) => [useStripControllerServiceGetStripeConfig1Key, ...(queryKey ?? [])];
export type TicketControllerServiceGetTicketByUuidDefaultResponse = Awaited<
  ReturnType<typeof TicketControllerService.getTicketByUuid>
>;
export type TicketControllerServiceGetTicketByUuidQueryResult<
  TData = TicketControllerServiceGetTicketByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetTicketByUuidKey =
  "TicketControllerServiceGetTicketByUuid";
export const UseTicketControllerServiceGetTicketByUuidKeyFn = (
  {
    ticketUuid,
  }: {
    ticketUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetTicketByUuidKey,
  ...(queryKey ?? [{ ticketUuid }]),
];
export type TicketControllerServiceGetTicketsByEmployerUuidDefaultResponse =
  Awaited<ReturnType<typeof TicketControllerService.getTicketsByEmployerUuid>>;
export type TicketControllerServiceGetTicketsByEmployerUuidQueryResult<
  TData = TicketControllerServiceGetTicketsByEmployerUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetTicketsByEmployerUuidKey =
  "TicketControllerServiceGetTicketsByEmployerUuid";
export const UseTicketControllerServiceGetTicketsByEmployerUuidKeyFn = (
  {
    assignToUuids,
    createdByUuids,
    employerUuid,
    employerUuids,
    page,
    pageSize,
    priority,
    requestedByUuids,
    searchString,
    sortBy,
    sortDirection,
    status,
    ticketType,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuid: string;
    employerUuids?: string[];
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    requestedByUuids?: string[];
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?:
      | "PENDING"
      | "ONGOING"
      | "RESOLVED"
      | "OPEN"
      | "CLOSED"
      | "ASSIGNED"
      | "UNDER_REVIEW"
      | "IN_PROGRESS";
    ticketType?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetTicketsByEmployerUuidKey,
  ...(queryKey ?? [
    {
      assignToUuids,
      createdByUuids,
      employerUuid,
      employerUuids,
      page,
      pageSize,
      priority,
      requestedByUuids,
      searchString,
      sortBy,
      sortDirection,
      status,
      ticketType,
    },
  ]),
];
export type TicketControllerServiceGetTotalTicketsCountByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketControllerService.getTotalTicketsCountByUuid>
  >;
export type TicketControllerServiceGetTotalTicketsCountByUuidQueryResult<
  TData = TicketControllerServiceGetTotalTicketsCountByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetTotalTicketsCountByUuidKey =
  "TicketControllerServiceGetTotalTicketsCountByUuid";
export const UseTicketControllerServiceGetTotalTicketsCountByUuidKeyFn = (
  {
    employerUuid,
    requestedByUuid,
  }: {
    employerUuid?: string;
    requestedByUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetTotalTicketsCountByUuidKey,
  ...(queryKey ?? [{ employerUuid, requestedByUuid }]),
];
export type TicketControllerServiceGetTicketCountsByStatusByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketControllerService.getTicketCountsByStatusByUuid>
  >;
export type TicketControllerServiceGetTicketCountsByStatusByUuidQueryResult<
  TData = TicketControllerServiceGetTicketCountsByStatusByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetTicketCountsByStatusByUuidKey =
  "TicketControllerServiceGetTicketCountsByStatusByUuid";
export const UseTicketControllerServiceGetTicketCountsByStatusByUuidKeyFn = (
  {
    employerUuid,
    requestedByUuid,
  }: {
    employerUuid?: string;
    requestedByUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetTicketCountsByStatusByUuidKey,
  ...(queryKey ?? [{ employerUuid, requestedByUuid }]),
];
export type TicketControllerServiceGetEmployerInfoDefaultResponse = Awaited<
  ReturnType<typeof TicketControllerService.getEmployerInfo>
>;
export type TicketControllerServiceGetEmployerInfoQueryResult<
  TData = TicketControllerServiceGetEmployerInfoDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetEmployerInfoKey =
  "TicketControllerServiceGetEmployerInfo";
export const UseTicketControllerServiceGetEmployerInfoKeyFn = (
  {
    employerUuid,
  }: {
    employerUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetEmployerInfoKey,
  ...(queryKey ?? [{ employerUuid }]),
];
export type TicketControllerServiceGetEmployerStatsDefaultResponse = Awaited<
  ReturnType<typeof TicketControllerService.getEmployerStats>
>;
export type TicketControllerServiceGetEmployerStatsQueryResult<
  TData = TicketControllerServiceGetEmployerStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetEmployerStatsKey =
  "TicketControllerServiceGetEmployerStats";
export const UseTicketControllerServiceGetEmployerStatsKeyFn = (
  {
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetEmployerStatsKey,
  ...(queryKey ?? [{ page, pageSize, search, sortBy, sortDirection }]),
];
export type TicketControllerServiceGetCreatorTicketStatsDefaultResponse =
  Awaited<ReturnType<typeof TicketControllerService.getCreatorTicketStats>>;
export type TicketControllerServiceGetCreatorTicketStatsQueryResult<
  TData = TicketControllerServiceGetCreatorTicketStatsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetCreatorTicketStatsKey =
  "TicketControllerServiceGetCreatorTicketStats";
export const UseTicketControllerServiceGetCreatorTicketStatsKeyFn = (
  {
    creatorUuid,
  }: {
    creatorUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetCreatorTicketStatsKey,
  ...(queryKey ?? [{ creatorUuid }]),
];
export type TicketControllerServiceGetTicketCountsDefaultResponse = Awaited<
  ReturnType<typeof TicketControllerService.getTicketCounts>
>;
export type TicketControllerServiceGetTicketCountsQueryResult<
  TData = TicketControllerServiceGetTicketCountsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetTicketCountsKey =
  "TicketControllerServiceGetTicketCounts";
export const UseTicketControllerServiceGetTicketCountsKeyFn = (
  {
    employerAdminUuid,
  }: {
    employerAdminUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetTicketCountsKey,
  ...(queryKey ?? [{ employerAdminUuid }]),
];
export type TicketControllerServiceGetAllTicketsWithFiltersDefaultResponse =
  Awaited<ReturnType<typeof TicketControllerService.getAllTicketsWithFilters>>;
export type TicketControllerServiceGetAllTicketsWithFiltersQueryResult<
  TData = TicketControllerServiceGetAllTicketsWithFiltersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetAllTicketsWithFiltersKey =
  "TicketControllerServiceGetAllTicketsWithFilters";
export const UseTicketControllerServiceGetAllTicketsWithFiltersKeyFn = (
  {
    assignToUuids,
    createdByUuids,
    employerUuids,
    endDate,
    excludeClosed,
    page,
    pageSize,
    priority,
    requestedByUuids,
    requestedStartDate,
    searchString,
    sortBy,
    sortDirection,
    status,
    ticketType,
    ticketUuids,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuids?: string[];
    endDate?: string;
    excludeClosed?: boolean;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    requestedByUuids?: string[];
    requestedStartDate?: string;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    status?:
      | "PENDING"
      | "ONGOING"
      | "RESOLVED"
      | "OPEN"
      | "CLOSED"
      | "ASSIGNED"
      | "UNDER_REVIEW"
      | "IN_PROGRESS";
    ticketType?: string;
    ticketUuids?: string[];
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetAllTicketsWithFiltersKey,
  ...(queryKey ?? [
    {
      assignToUuids,
      createdByUuids,
      employerUuids,
      endDate,
      excludeClosed,
      page,
      pageSize,
      priority,
      requestedByUuids,
      requestedStartDate,
      searchString,
      sortBy,
      sortDirection,
      status,
      ticketType,
      ticketUuids,
    },
  ]),
];
export type TicketControllerServiceGetAdminTicketStatusDefaultResponse =
  Awaited<ReturnType<typeof TicketControllerService.getAdminTicketStatus>>;
export type TicketControllerServiceGetAdminTicketStatusQueryResult<
  TData = TicketControllerServiceGetAdminTicketStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketControllerServiceGetAdminTicketStatusKey =
  "TicketControllerServiceGetAdminTicketStatus";
export const UseTicketControllerServiceGetAdminTicketStatusKeyFn = (
  {
    employerUuid,
    page,
    pageSize,
    search,
    sortBy,
    sortDirection,
  }: {
    employerUuid?: string;
    page?: number;
    pageSize?: number;
    search?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketControllerServiceGetAdminTicketStatusKey,
  ...(queryKey ?? [
    { employerUuid, page, pageSize, search, sortBy, sortDirection },
  ]),
];
export type TicketTaskControllerServiceGetTicketTaskByUuidDefaultResponse =
  Awaited<ReturnType<typeof TicketTaskControllerService.getTicketTaskByUuid>>;
export type TicketTaskControllerServiceGetTicketTaskByUuidQueryResult<
  TData = TicketTaskControllerServiceGetTicketTaskByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketTaskControllerServiceGetTicketTaskByUuidKey =
  "TicketTaskControllerServiceGetTicketTaskByUuid";
export const UseTicketTaskControllerServiceGetTicketTaskByUuidKeyFn = (
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketTaskControllerServiceGetTicketTaskByUuidKey,
  ...(queryKey ?? [{ taskUuid }]),
];
export type TicketTaskControllerServiceGetAllTasksByEmployerDefaultResponse =
  Awaited<ReturnType<typeof TicketTaskControllerService.getAllTasksByEmployer>>;
export type TicketTaskControllerServiceGetAllTasksByEmployerQueryResult<
  TData = TicketTaskControllerServiceGetAllTasksByEmployerDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketTaskControllerServiceGetAllTasksByEmployerKey =
  "TicketTaskControllerServiceGetAllTasksByEmployer";
export const UseTicketTaskControllerServiceGetAllTasksByEmployerKeyFn = (
  {
    assignToUuids,
    createdByUuids,
    employerUuid,
    endDate,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    employerUuid: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: "OPEN" | "CLOSED";
  },
  queryKey?: Array<unknown>,
) => [
  useTicketTaskControllerServiceGetAllTasksByEmployerKey,
  ...(queryKey ?? [
    {
      assignToUuids,
      createdByUuids,
      employerUuid,
      endDate,
      page,
      pageSize,
      priority,
      searchString,
      sortBy,
      sortDirection,
      startDate,
      status,
    },
  ]),
];
export type TicketTaskControllerServiceGetAllTasksByTicketUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketTaskControllerService.getAllTasksByTicketUuid>
  >;
export type TicketTaskControllerServiceGetAllTasksByTicketUuidQueryResult<
  TData = TicketTaskControllerServiceGetAllTasksByTicketUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketTaskControllerServiceGetAllTasksByTicketUuidKey =
  "TicketTaskControllerServiceGetAllTasksByTicketUuid";
export const UseTicketTaskControllerServiceGetAllTasksByTicketUuidKeyFn = (
  {
    assignToUuids,
    createdByUuids,
    endDate,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
    startDate,
    status,
    ticketUuid,
  }: {
    assignToUuids?: string[];
    createdByUuids?: string[];
    endDate?: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
    status?: "OPEN" | "CLOSED";
    ticketUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketTaskControllerServiceGetAllTasksByTicketUuidKey,
  ...(queryKey ?? [
    {
      assignToUuids,
      createdByUuids,
      endDate,
      page,
      pageSize,
      priority,
      searchString,
      sortBy,
      sortDirection,
      startDate,
      status,
      ticketUuid,
    },
  ]),
];
export type TicketNotesControllerServiceGetTicketNotesByUuidDefaultResponse =
  Awaited<ReturnType<typeof TicketNotesControllerService.getTicketNotesByUuid>>;
export type TicketNotesControllerServiceGetTicketNotesByUuidQueryResult<
  TData = TicketNotesControllerServiceGetTicketNotesByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketNotesControllerServiceGetTicketNotesByUuidKey =
  "TicketNotesControllerServiceGetTicketNotesByUuid";
export const UseTicketNotesControllerServiceGetTicketNotesByUuidKeyFn = (
  {
    notesUuid,
  }: {
    notesUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketNotesControllerServiceGetTicketNotesByUuidKey,
  ...(queryKey ?? [{ notesUuid }]),
];
export type TicketNotesControllerServiceGetAllNotesByEmployerDefaultResponse =
  Awaited<
    ReturnType<typeof TicketNotesControllerService.getAllNotesByEmployer>
  >;
export type TicketNotesControllerServiceGetAllNotesByEmployerQueryResult<
  TData = TicketNotesControllerServiceGetAllNotesByEmployerDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketNotesControllerServiceGetAllNotesByEmployerKey =
  "TicketNotesControllerServiceGetAllNotesByEmployer";
export const UseTicketNotesControllerServiceGetAllNotesByEmployerKeyFn = (
  {
    createdByUuids,
    employerUuid,
    endDate,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    startDate,
  }: {
    createdByUuids?: string[];
    employerUuid: string;
    endDate?: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    startDate?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketNotesControllerServiceGetAllNotesByEmployerKey,
  ...(queryKey ?? [
    {
      createdByUuids,
      employerUuid,
      endDate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    },
  ]),
];
export type TicketNotesControllerServiceGetAllTicketNotesDefaultResponse =
  Awaited<ReturnType<typeof TicketNotesControllerService.getAllTicketNotes>>;
export type TicketNotesControllerServiceGetAllTicketNotesQueryResult<
  TData = TicketNotesControllerServiceGetAllTicketNotesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketNotesControllerServiceGetAllTicketNotesKey =
  "TicketNotesControllerServiceGetAllTicketNotes";
export const UseTicketNotesControllerServiceGetAllTicketNotesKeyFn = (
  {
    page,
    pageSize,
    sortBy,
    sortDirection,
    ticketUuid,
  }: {
    page?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: string;
    ticketUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketNotesControllerServiceGetAllTicketNotesKey,
  ...(queryKey ?? [{ page, pageSize, sortBy, sortDirection, ticketUuid }]),
];
export type TicketAttachmentControllerServiceGetAttachmentByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketAttachmentControllerService.getAttachmentByUuid>
  >;
export type TicketAttachmentControllerServiceGetAttachmentByUuidQueryResult<
  TData = TicketAttachmentControllerServiceGetAttachmentByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketAttachmentControllerServiceGetAttachmentByUuidKey =
  "TicketAttachmentControllerServiceGetAttachmentByUuid";
export const UseTicketAttachmentControllerServiceGetAttachmentByUuidKeyFn = (
  {
    attachmentUuid,
  }: {
    attachmentUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketAttachmentControllerServiceGetAttachmentByUuidKey,
  ...(queryKey ?? [{ attachmentUuid }]),
];
export type TicketAttachmentControllerServiceGetAllAttachmentsByEmployerDefaultResponse =
  Awaited<
    ReturnType<
      typeof TicketAttachmentControllerService.getAllAttachmentsByEmployer
    >
  >;
export type TicketAttachmentControllerServiceGetAllAttachmentsByEmployerQueryResult<
  TData =
    TicketAttachmentControllerServiceGetAllAttachmentsByEmployerDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketAttachmentControllerServiceGetAllAttachmentsByEmployerKey =
  "TicketAttachmentControllerServiceGetAllAttachmentsByEmployer";
export const UseTicketAttachmentControllerServiceGetAllAttachmentsByEmployerKeyFn =
  (
    {
      employerUuid,
      endDate,
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      startDate,
    }: {
      employerUuid: string;
      endDate?: string;
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      startDate?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useTicketAttachmentControllerServiceGetAllAttachmentsByEmployerKey,
    ...(queryKey ?? [
      {
        employerUuid,
        endDate,
        page,
        pageSize,
        searchString,
        sortBy,
        sortDirection,
        startDate,
      },
    ]),
  ];
export type TicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof TicketAttachmentControllerService.getAllAttachmentsByTicketUuid
    >
  >;
export type TicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidQueryResult<
  TData =
    TicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidKey =
  "TicketAttachmentControllerServiceGetAllAttachmentsByTicketUuid";
export const UseTicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidKeyFn =
  (
    {
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      ticketUuid,
    }: {
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      ticketUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useTicketAttachmentControllerServiceGetAllAttachmentsByTicketUuidKey,
    ...(queryKey ?? [
      { page, pageSize, searchString, sortBy, sortDirection, ticketUuid },
    ]),
  ];
export type CrmTemplateControllerServiceGetTemplateDefaultResponse = Awaited<
  ReturnType<typeof CrmTemplateControllerService.getTemplate>
>;
export type CrmTemplateControllerServiceGetTemplateQueryResult<
  TData = CrmTemplateControllerServiceGetTemplateDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTemplateControllerServiceGetTemplateKey =
  "CrmTemplateControllerServiceGetTemplate";
export const UseCrmTemplateControllerServiceGetTemplateKeyFn = (
  {
    templateUuid,
  }: {
    templateUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCrmTemplateControllerServiceGetTemplateKey,
  ...(queryKey ?? [{ templateUuid }]),
];
export type CrmTemplateControllerServiceGetAllTemplatesDefaultResponse =
  Awaited<ReturnType<typeof CrmTemplateControllerService.getAllTemplates>>;
export type CrmTemplateControllerServiceGetAllTemplatesQueryResult<
  TData = CrmTemplateControllerServiceGetAllTemplatesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTemplateControllerServiceGetAllTemplatesKey =
  "CrmTemplateControllerServiceGetAllTemplates";
export const UseCrmTemplateControllerServiceGetAllTemplatesKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCrmTemplateControllerServiceGetAllTemplatesKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type CrmTemplateControllerServiceGetAllTemplates1DefaultResponse =
  Awaited<ReturnType<typeof CrmTemplateControllerService.getAllTemplates1>>;
export type CrmTemplateControllerServiceGetAllTemplates1QueryResult<
  TData = CrmTemplateControllerServiceGetAllTemplates1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTemplateControllerServiceGetAllTemplates1Key =
  "CrmTemplateControllerServiceGetAllTemplates1";
export const UseCrmTemplateControllerServiceGetAllTemplates1KeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
    templateCategory,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
    templateCategory?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCrmTemplateControllerServiceGetAllTemplates1Key,
  ...(queryKey ?? [
    { page, pageSize, searchString, sortBy, sortDirection, templateCategory },
  ]),
];
export type CrmTaskControllerServiceGetTaskByUuid1DefaultResponse = Awaited<
  ReturnType<typeof CrmTaskControllerService.getTaskByUuid1>
>;
export type CrmTaskControllerServiceGetTaskByUuid1QueryResult<
  TData = CrmTaskControllerServiceGetTaskByUuid1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTaskControllerServiceGetTaskByUuid1Key =
  "CrmTaskControllerServiceGetTaskByUuid1";
export const UseCrmTaskControllerServiceGetTaskByUuid1KeyFn = (
  {
    taskUuid,
  }: {
    taskUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCrmTaskControllerServiceGetTaskByUuid1Key,
  ...(queryKey ?? [{ taskUuid }]),
];
export type CrmTaskControllerServiceGetAllTasksByContactUuidDefaultResponse =
  Awaited<ReturnType<typeof CrmTaskControllerService.getAllTasksByContactUuid>>;
export type CrmTaskControllerServiceGetAllTasksByContactUuidQueryResult<
  TData = CrmTaskControllerServiceGetAllTasksByContactUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTaskControllerServiceGetAllTasksByContactUuidKey =
  "CrmTaskControllerServiceGetAllTasksByContactUuid";
export const UseCrmTaskControllerServiceGetAllTasksByContactUuidKeyFn = (
  {
    contactUuid,
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
  }: {
    contactUuid: string;
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCrmTaskControllerServiceGetAllTasksByContactUuidKey,
  ...(queryKey ?? [
    {
      contactUuid,
      page,
      pageSize,
      priority,
      searchString,
      sortBy,
      sortDirection,
    },
  ]),
];
export type CrmTaskControllerServiceGetAllTasks1DefaultResponse = Awaited<
  ReturnType<typeof CrmTaskControllerService.getAllTasks1>
>;
export type CrmTaskControllerServiceGetAllTasks1QueryResult<
  TData = CrmTaskControllerServiceGetAllTasks1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmTaskControllerServiceGetAllTasks1Key =
  "CrmTaskControllerServiceGetAllTasks1";
export const UseCrmTaskControllerServiceGetAllTasks1KeyFn = (
  {
    page,
    pageSize,
    priority,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    priority?: "LOW" | "MEDIUM" | "HIGH" | "CRITICAL";
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCrmTaskControllerServiceGetAllTasks1Key,
  ...(queryKey ?? [
    { page, pageSize, priority, searchString, sortBy, sortDirection },
  ]),
];
export type TaskLogControllerServiceGetTaskLogByUuidDefaultResponse = Awaited<
  ReturnType<typeof TaskLogControllerService.getTaskLogByUuid>
>;
export type TaskLogControllerServiceGetTaskLogByUuidQueryResult<
  TData = TaskLogControllerServiceGetTaskLogByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskLogControllerServiceGetTaskLogByUuidKey =
  "TaskLogControllerServiceGetTaskLogByUuid";
export const UseTaskLogControllerServiceGetTaskLogByUuidKeyFn = (
  {
    taskLogUuid,
  }: {
    taskLogUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTaskLogControllerServiceGetTaskLogByUuidKey,
  ...(queryKey ?? [{ taskLogUuid }]),
];
export type TaskLogControllerServiceGetAllTaskLogsDefaultResponse = Awaited<
  ReturnType<typeof TaskLogControllerService.getAllTaskLogs>
>;
export type TaskLogControllerServiceGetAllTaskLogsQueryResult<
  TData = TaskLogControllerServiceGetAllTaskLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTaskLogControllerServiceGetAllTaskLogsKey =
  "TaskLogControllerServiceGetAllTaskLogs";
export const UseTaskLogControllerServiceGetAllTaskLogsKeyFn = (
  {
    leadUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    leadUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTaskLogControllerServiceGetAllTaskLogsKey,
  ...(queryKey ?? [
    { leadUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type CrmNewsletterControllerServiceGetNewsletterByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof CrmNewsletterControllerService.getNewsletterByUuid>
  >;
export type CrmNewsletterControllerServiceGetNewsletterByUuidQueryResult<
  TData = CrmNewsletterControllerServiceGetNewsletterByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmNewsletterControllerServiceGetNewsletterByUuidKey =
  "CrmNewsletterControllerServiceGetNewsletterByUuid";
export const UseCrmNewsletterControllerServiceGetNewsletterByUuidKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useCrmNewsletterControllerServiceGetNewsletterByUuidKey,
  ...(queryKey ?? []),
];
export type CrmNewsletterControllerServiceGetAllNewsletterDefaultResponse =
  Awaited<ReturnType<typeof CrmNewsletterControllerService.getAllNewsletter>>;
export type CrmNewsletterControllerServiceGetAllNewsletterQueryResult<
  TData = CrmNewsletterControllerServiceGetAllNewsletterDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmNewsletterControllerServiceGetAllNewsletterKey =
  "CrmNewsletterControllerServiceGetAllNewsletter";
export const UseCrmNewsletterControllerServiceGetAllNewsletterKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCrmNewsletterControllerServiceGetAllNewsletterKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type CrmCampaignControllerServiceGetCampaignByUuidDefaultResponse =
  Awaited<ReturnType<typeof CrmCampaignControllerService.getCampaignByUuid>>;
export type CrmCampaignControllerServiceGetCampaignByUuidQueryResult<
  TData = CrmCampaignControllerServiceGetCampaignByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmCampaignControllerServiceGetCampaignByUuidKey =
  "CrmCampaignControllerServiceGetCampaignByUuid";
export const UseCrmCampaignControllerServiceGetCampaignByUuidKeyFn = (
  {
    campaignUuid,
  }: {
    campaignUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCrmCampaignControllerServiceGetCampaignByUuidKey,
  ...(queryKey ?? [{ campaignUuid }]),
];
export type CrmCampaignControllerServiceGetAllCampaignDefaultResponse = Awaited<
  ReturnType<typeof CrmCampaignControllerService.getAllCampaign>
>;
export type CrmCampaignControllerServiceGetAllCampaignQueryResult<
  TData = CrmCampaignControllerServiceGetAllCampaignDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCrmCampaignControllerServiceGetAllCampaignKey =
  "CrmCampaignControllerServiceGetAllCampaign";
export const UseCrmCampaignControllerServiceGetAllCampaignKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useCrmCampaignControllerServiceGetAllCampaignKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type CallLogsControllerServiceGetCallLogByUuidDefaultResponse = Awaited<
  ReturnType<typeof CallLogsControllerService.getCallLogByUuid>
>;
export type CallLogsControllerServiceGetCallLogByUuidQueryResult<
  TData = CallLogsControllerServiceGetCallLogByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCallLogsControllerServiceGetCallLogByUuidKey =
  "CallLogsControllerServiceGetCallLogByUuid";
export const UseCallLogsControllerServiceGetCallLogByUuidKeyFn = (
  {
    callLogUuid,
  }: {
    callLogUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCallLogsControllerServiceGetCallLogByUuidKey,
  ...(queryKey ?? [{ callLogUuid }]),
];
export type CallLogsControllerServiceGetAllCallLogsDefaultResponse = Awaited<
  ReturnType<typeof CallLogsControllerService.getAllCallLogs>
>;
export type CallLogsControllerServiceGetAllCallLogsQueryResult<
  TData = CallLogsControllerServiceGetAllCallLogsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useCallLogsControllerServiceGetAllCallLogsKey =
  "CallLogsControllerServiceGetAllCallLogs";
export const UseCallLogsControllerServiceGetAllCallLogsKeyFn = (
  {
    leadUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    leadUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useCallLogsControllerServiceGetAllCallLogsKey,
  ...(queryKey ?? [
    { leadUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type TicketMergeControllerServiceGetMergedTicketDefaultResponse =
  Awaited<ReturnType<typeof TicketMergeControllerService.getMergedTicket>>;
export type TicketMergeControllerServiceGetMergedTicketQueryResult<
  TData = TicketMergeControllerServiceGetMergedTicketDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketMergeControllerServiceGetMergedTicketKey =
  "TicketMergeControllerServiceGetMergedTicket";
export const UseTicketMergeControllerServiceGetMergedTicketKeyFn = (
  {
    uuid,
  }: {
    uuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketMergeControllerServiceGetMergedTicketKey,
  ...(queryKey ?? [{ uuid }]),
];
export type TicketMergeControllerServiceGetAllMergedTicketsDefaultResponse =
  Awaited<ReturnType<typeof TicketMergeControllerService.getAllMergedTickets>>;
export type TicketMergeControllerServiceGetAllMergedTicketsQueryResult<
  TData = TicketMergeControllerServiceGetAllMergedTicketsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketMergeControllerServiceGetAllMergedTicketsKey =
  "TicketMergeControllerServiceGetAllMergedTickets";
export const UseTicketMergeControllerServiceGetAllMergedTicketsKeyFn = (
  {
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTicketMergeControllerServiceGetAllMergedTicketsKey,
  ...(queryKey ?? [{ page, pageSize, searchString, sortBy, sortDirection }]),
];
export type TicketLinkedControllerServiceGetLinkedTicketByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketLinkedControllerService.getLinkedTicketByUuid>
  >;
export type TicketLinkedControllerServiceGetLinkedTicketByUuidQueryResult<
  TData = TicketLinkedControllerServiceGetLinkedTicketByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketLinkedControllerServiceGetLinkedTicketByUuidKey =
  "TicketLinkedControllerServiceGetLinkedTicketByUuid";
export const UseTicketLinkedControllerServiceGetLinkedTicketByUuidKeyFn = (
  {
    linkedUuid,
  }: {
    linkedUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketLinkedControllerServiceGetLinkedTicketByUuidKey,
  ...(queryKey ?? [{ linkedUuid }]),
];
export type TicketLinkedControllerServiceGetAllLinkedTicketsDefaultResponse =
  Awaited<ReturnType<typeof TicketLinkedControllerService.getAllLinkedTickets>>;
export type TicketLinkedControllerServiceGetAllLinkedTicketsQueryResult<
  TData = TicketLinkedControllerServiceGetAllLinkedTicketsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketLinkedControllerServiceGetAllLinkedTicketsKey =
  "TicketLinkedControllerServiceGetAllLinkedTickets";
export const UseTicketLinkedControllerServiceGetAllLinkedTicketsKeyFn = (
  {
    mainTicketUuid,
    page,
    pageSize,
    searchString,
    sortBy,
    sortDirection,
  }: {
    mainTicketUuid: string;
    page?: number;
    pageSize?: number;
    searchString?: string;
    sortBy?: string;
    sortDirection?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTicketLinkedControllerServiceGetAllLinkedTicketsKey,
  ...(queryKey ?? [
    { mainTicketUuid, page, pageSize, searchString, sortBy, sortDirection },
  ]),
];
export type TicketConversationControllerServiceGetConversationByUuidDefaultResponse =
  Awaited<
    ReturnType<typeof TicketConversationControllerService.getConversationByUuid>
  >;
export type TicketConversationControllerServiceGetConversationByUuidQueryResult<
  TData =
    TicketConversationControllerServiceGetConversationByUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketConversationControllerServiceGetConversationByUuidKey =
  "TicketConversationControllerServiceGetConversationByUuid";
export const UseTicketConversationControllerServiceGetConversationByUuidKeyFn =
  (
    {
      conversationUuid,
    }: {
      conversationUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useTicketConversationControllerServiceGetConversationByUuidKey,
    ...(queryKey ?? [{ conversationUuid }]),
  ];
export type TicketConversationControllerServiceGetAllConversationsByTicketUuidDefaultResponse =
  Awaited<
    ReturnType<
      typeof TicketConversationControllerService.getAllConversationsByTicketUuid
    >
  >;
export type TicketConversationControllerServiceGetAllConversationsByTicketUuidQueryResult<
  TData =
    TicketConversationControllerServiceGetAllConversationsByTicketUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTicketConversationControllerServiceGetAllConversationsByTicketUuidKey =
  "TicketConversationControllerServiceGetAllConversationsByTicketUuid";
export const UseTicketConversationControllerServiceGetAllConversationsByTicketUuidKeyFn =
  (
    {
      page,
      pageSize,
      searchString,
      sortBy,
      sortDirection,
      ticketUuid,
    }: {
      page?: number;
      pageSize?: number;
      searchString?: string;
      sortBy?: string;
      sortDirection?: string;
      ticketUuid: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useTicketConversationControllerServiceGetAllConversationsByTicketUuidKey,
    ...(queryKey ?? [
      { page, pageSize, searchString, sortBy, sortDirection, ticketUuid },
    ]),
  ];
export type MessageControllerServiceGetUnreadMessageCountByUserUuidDefaultResponse =
  Awaited<
    ReturnType<typeof MessageControllerService.getUnreadMessageCountByUserUuid>
  >;
export type MessageControllerServiceGetUnreadMessageCountByUserUuidQueryResult<
  TData =
    MessageControllerServiceGetUnreadMessageCountByUserUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetUnreadMessageCountByUserUuidKey =
  "MessageControllerServiceGetUnreadMessageCountByUserUuid";
export const UseMessageControllerServiceGetUnreadMessageCountByUserUuidKeyFn = (
  {
    userUuid,
  }: {
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetUnreadMessageCountByUserUuidKey,
  ...(queryKey ?? [{ userUuid }]),
];
export type MessageControllerServiceGetMessageSummariesByUserUuidDefaultResponse =
  Awaited<
    ReturnType<typeof MessageControllerService.getMessageSummariesByUserUuid>
  >;
export type MessageControllerServiceGetMessageSummariesByUserUuidQueryResult<
  TData = MessageControllerServiceGetMessageSummariesByUserUuidDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetMessageSummariesByUserUuidKey =
  "MessageControllerServiceGetMessageSummariesByUserUuid";
export const UseMessageControllerServiceGetMessageSummariesByUserUuidKeyFn = (
  {
    locationUuid,
    providerUuids,
    search,
    userUuid,
  }: {
    locationUuid?: string;
    providerUuids?: string[];
    search?: string;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetMessageSummariesByUserUuidKey,
  ...(queryKey ?? [{ locationUuid, providerUuids, search, userUuid }]),
];
export type MessageControllerServiceGetUrgentUnreadMessagesForUserDefaultResponse =
  Awaited<
    ReturnType<typeof MessageControllerService.getUrgentUnreadMessagesForUser>
  >;
export type MessageControllerServiceGetUrgentUnreadMessagesForUserQueryResult<
  TData = MessageControllerServiceGetUrgentUnreadMessagesForUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetUrgentUnreadMessagesForUserKey =
  "MessageControllerServiceGetUrgentUnreadMessagesForUser";
export const UseMessageControllerServiceGetUrgentUnreadMessagesForUserKeyFn = (
  {
    locationUuid,
    page,
    providerUuids,
    size,
  }: {
    locationUuid?: string;
    page?: number;
    providerUuids?: string[];
    size?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetUrgentUnreadMessagesForUserKey,
  ...(queryKey ?? [{ locationUuid, page, providerUuids, size }]),
];
export type MessageControllerServiceGetUrgentUnreadMessageCountForUserDefaultResponse =
  Awaited<
    ReturnType<
      typeof MessageControllerService.getUrgentUnreadMessageCountForUser
    >
  >;
export type MessageControllerServiceGetUrgentUnreadMessageCountForUserQueryResult<
  TData =
    MessageControllerServiceGetUrgentUnreadMessageCountForUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetUrgentUnreadMessageCountForUserKey =
  "MessageControllerServiceGetUrgentUnreadMessageCountForUser";
export const UseMessageControllerServiceGetUrgentUnreadMessageCountForUserKeyFn =
  (
    {
      locationUuid,
      providerUuids,
    }: {
      locationUuid?: string;
      providerUuids?: string[];
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useMessageControllerServiceGetUrgentUnreadMessageCountForUserKey,
    ...(queryKey ?? [{ locationUuid, providerUuids }]),
  ];
export type MessageControllerServiceGetUnreadMessagesForUserDefaultResponse =
  Awaited<ReturnType<typeof MessageControllerService.getUnreadMessagesForUser>>;
export type MessageControllerServiceGetUnreadMessagesForUserQueryResult<
  TData = MessageControllerServiceGetUnreadMessagesForUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetUnreadMessagesForUserKey =
  "MessageControllerServiceGetUnreadMessagesForUser";
export const UseMessageControllerServiceGetUnreadMessagesForUserKeyFn = (
  {
    page,
    size,
  }: {
    page?: number;
    size?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetUnreadMessagesForUserKey,
  ...(queryKey ?? [{ page, size }]),
];
export type MessageControllerServiceGetUnreadMessageCountForUserDefaultResponse =
  Awaited<
    ReturnType<typeof MessageControllerService.getUnreadMessageCountForUser>
  >;
export type MessageControllerServiceGetUnreadMessageCountForUserQueryResult<
  TData = MessageControllerServiceGetUnreadMessageCountForUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetUnreadMessageCountForUserKey =
  "MessageControllerServiceGetUnreadMessageCountForUser";
export const UseMessageControllerServiceGetUnreadMessageCountForUserKeyFn = (
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetUnreadMessageCountForUserKey,
  ...(queryKey ?? []),
];
export type MessageControllerServiceListMessagesDefaultResponse = Awaited<
  ReturnType<typeof MessageControllerService.listMessages>
>;
export type MessageControllerServiceListMessagesQueryResult<
  TData = MessageControllerServiceListMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceListMessagesKey =
  "MessageControllerServiceListMessages";
export const UseMessageControllerServiceListMessagesKeyFn = (
  {
    filter,
    page,
    search,
    size,
    threadUuid,
  }: {
    filter?: "TEXT" | "IMAGE" | "FILE" | "SYSTEM";
    page?: number;
    search?: string;
    size?: number;
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceListMessagesKey,
  ...(queryKey ?? [{ filter, page, search, size, threadUuid }]),
];
export type MessageControllerServiceGetScheduledMessagesDefaultResponse =
  Awaited<ReturnType<typeof MessageControllerService.getScheduledMessages>>;
export type MessageControllerServiceGetScheduledMessagesQueryResult<
  TData = MessageControllerServiceGetScheduledMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetScheduledMessagesKey =
  "MessageControllerServiceGetScheduledMessages";
export const UseMessageControllerServiceGetScheduledMessagesKeyFn = (
  {
    page,
    size,
    threadUuid,
  }: {
    page?: number;
    size?: number;
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceGetScheduledMessagesKey,
  ...(queryKey ?? [{ page, size, threadUuid }]),
];
export type MessageControllerServiceCountUnreadDefaultResponse = Awaited<
  ReturnType<typeof MessageControllerService.countUnread>
>;
export type MessageControllerServiceCountUnreadQueryResult<
  TData = MessageControllerServiceCountUnreadDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceCountUnreadKey =
  "MessageControllerServiceCountUnread";
export const UseMessageControllerServiceCountUnreadKeyFn = (
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceCountUnreadKey,
  ...(queryKey ?? [{ threadUuid }]),
];
export type MessageControllerServiceCountUnreadForUserDefaultResponse = Awaited<
  ReturnType<typeof MessageControllerService.countUnreadForUser>
>;
export type MessageControllerServiceCountUnreadForUserQueryResult<
  TData = MessageControllerServiceCountUnreadForUserDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceCountUnreadForUserKey =
  "MessageControllerServiceCountUnreadForUser";
export const UseMessageControllerServiceCountUnreadForUserKeyFn = (
  {
    threadUuid,
    userUuid,
  }: {
    threadUuid: string;
    userUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceCountUnreadForUserKey,
  ...(queryKey ?? [{ threadUuid, userUuid }]),
];
export type MessageControllerServiceSearchMessagesDefaultResponse = Awaited<
  ReturnType<typeof MessageControllerService.searchMessages>
>;
export type MessageControllerServiceSearchMessagesQueryResult<
  TData = MessageControllerServiceSearchMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceSearchMessagesKey =
  "MessageControllerServiceSearchMessages";
export const UseMessageControllerServiceSearchMessagesKeyFn = (
  {
    includeAttachments,
    page,
    query,
    size,
    threadUuid,
  }: {
    includeAttachments?: boolean;
    page?: number;
    query: string;
    size?: number;
    threadUuid?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useMessageControllerServiceSearchMessagesKey,
  ...(queryKey ?? [{ includeAttachments, page, query, size, threadUuid }]),
];
export type MessageControllerServiceGetPatientDependentsMessageSummaryDefaultResponse =
  Awaited<
    ReturnType<
      typeof MessageControllerService.getPatientDependentsMessageSummary
    >
  >;
export type MessageControllerServiceGetPatientDependentsMessageSummaryQueryResult<
  TData =
    MessageControllerServiceGetPatientDependentsMessageSummaryDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useMessageControllerServiceGetPatientDependentsMessageSummaryKey =
  "MessageControllerServiceGetPatientDependentsMessageSummary";
export const UseMessageControllerServiceGetPatientDependentsMessageSummaryKeyFn =
  (
    {
      patientUuid,
      search,
    }: {
      patientUuid: string;
      search?: string;
    },
    queryKey?: Array<unknown>,
  ) => [
    useMessageControllerServiceGetPatientDependentsMessageSummaryKey,
    ...(queryKey ?? [{ patientUuid, search }]),
  ];
export type VideoCallControllerServiceGetCallDefaultResponse = Awaited<
  ReturnType<typeof VideoCallControllerService.getCall>
>;
export type VideoCallControllerServiceGetCallQueryResult<
  TData = VideoCallControllerServiceGetCallDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useVideoCallControllerServiceGetCallKey =
  "VideoCallControllerServiceGetCall";
export const UseVideoCallControllerServiceGetCallKeyFn = (
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: Array<unknown>,
) => [useVideoCallControllerServiceGetCallKey, ...(queryKey ?? [{ callUuid }])];
export type TwilioVoiceControllerServiceCallLogDefaultResponse = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.callLog>
>;
export type TwilioVoiceControllerServiceCallLogQueryResult<
  TData = TwilioVoiceControllerServiceCallLogDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioVoiceControllerServiceCallLogKey =
  "TwilioVoiceControllerServiceCallLog";
export const UseTwilioVoiceControllerServiceCallLogKeyFn = (
  {
    direction,
    from,
    fromUserUuid,
    page,
    patientUuid,
    phoneNumber,
    providerUuid,
    size,
    to,
    toUserUuid,
  }: {
    direction?: "UNKNOWN" | "INBOUND" | "OUTBOUND";
    from?: string;
    fromUserUuid?: string;
    page?: number;
    patientUuid?: string;
    phoneNumber?: string;
    providerUuid?: string;
    size?: number;
    to?: string;
    toUserUuid?: string;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useTwilioVoiceControllerServiceCallLogKey,
  ...(queryKey ?? [
    {
      direction,
      from,
      fromUserUuid,
      page,
      patientUuid,
      phoneNumber,
      providerUuid,
      size,
      to,
      toUserUuid,
    },
  ]),
];
export type TwilioVoiceControllerServiceStatusDefaultResponse = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.status>
>;
export type TwilioVoiceControllerServiceStatusQueryResult<
  TData = TwilioVoiceControllerServiceStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioVoiceControllerServiceStatusKey =
  "TwilioVoiceControllerServiceStatus";
export const UseTwilioVoiceControllerServiceStatusKeyFn = (
  queryKey?: Array<unknown>,
) => [useTwilioVoiceControllerServiceStatusKey, ...(queryKey ?? [])];
export type TwilioVoiceControllerServiceGetCall1DefaultResponse = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.getCall1>
>;
export type TwilioVoiceControllerServiceGetCall1QueryResult<
  TData = TwilioVoiceControllerServiceGetCall1DefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioVoiceControllerServiceGetCall1Key =
  "TwilioVoiceControllerServiceGetCall1";
export const UseTwilioVoiceControllerServiceGetCall1KeyFn = (
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTwilioVoiceControllerServiceGetCall1Key,
  ...(queryKey ?? [{ callUuid }]),
];
export type TwilioVoiceControllerServiceReadTranscriptDefaultResponse = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.readTranscript>
>;
export type TwilioVoiceControllerServiceReadTranscriptQueryResult<
  TData = TwilioVoiceControllerServiceReadTranscriptDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioVoiceControllerServiceReadTranscriptKey =
  "TwilioVoiceControllerServiceReadTranscript";
export const UseTwilioVoiceControllerServiceReadTranscriptKeyFn = (
  {
    callUuid,
  }: {
    callUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTwilioVoiceControllerServiceReadTranscriptKey,
  ...(queryKey ?? [{ callUuid }]),
];
export type TwilioVoiceControllerServicePlayRecordingDefaultResponse = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.playRecording>
>;
export type TwilioVoiceControllerServicePlayRecordingQueryResult<
  TData = TwilioVoiceControllerServicePlayRecordingDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioVoiceControllerServicePlayRecordingKey =
  "TwilioVoiceControllerServicePlayRecording";
export const UseTwilioVoiceControllerServicePlayRecordingKeyFn = (
  {
    callUuid,
    range,
  }: {
    callUuid: string;
    range?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useTwilioVoiceControllerServicePlayRecordingKey,
  ...(queryKey ?? [{ callUuid, range }]),
];
export type TwilioControllerServiceGenerateAccessTokenDefaultResponse = Awaited<
  ReturnType<typeof TwilioControllerService.generateAccessToken>
>;
export type TwilioControllerServiceGenerateAccessTokenQueryResult<
  TData = TwilioControllerServiceGenerateAccessTokenDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioControllerServiceGenerateAccessTokenKey =
  "TwilioControllerServiceGenerateAccessToken";
export const UseTwilioControllerServiceGenerateAccessTokenKeyFn = (
  queryKey?: Array<unknown>,
) => [useTwilioControllerServiceGenerateAccessTokenKey, ...(queryKey ?? [])];
export type TwilioControllerServiceGetServiceStatusDefaultResponse = Awaited<
  ReturnType<typeof TwilioControllerService.getServiceStatus>
>;
export type TwilioControllerServiceGetServiceStatusQueryResult<
  TData = TwilioControllerServiceGetServiceStatusDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioControllerServiceGetServiceStatusKey =
  "TwilioControllerServiceGetServiceStatus";
export const UseTwilioControllerServiceGetServiceStatusKeyFn = (
  queryKey?: Array<unknown>,
) => [useTwilioControllerServiceGetServiceStatusKey, ...(queryKey ?? [])];
export type TwilioControllerServiceCheckHealthDefaultResponse = Awaited<
  ReturnType<typeof TwilioControllerService.checkHealth>
>;
export type TwilioControllerServiceCheckHealthQueryResult<
  TData = TwilioControllerServiceCheckHealthDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useTwilioControllerServiceCheckHealthKey =
  "TwilioControllerServiceCheckHealth";
export const UseTwilioControllerServiceCheckHealthKeyFn = (
  queryKey?: Array<unknown>,
) => [useTwilioControllerServiceCheckHealthKey, ...(queryKey ?? [])];
export type ThreadControllerServiceGetThreadByIdDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getThreadById>
>;
export type ThreadControllerServiceGetThreadByIdQueryResult<
  TData = ThreadControllerServiceGetThreadByIdDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetThreadByIdKey =
  "ThreadControllerServiceGetThreadById";
export const UseThreadControllerServiceGetThreadByIdKeyFn = (
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceGetThreadByIdKey,
  ...(queryKey ?? [{ threadUuid }]),
];
export type ThreadControllerServiceGetOpenThreadUsersDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getOpenThreadUsers>
>;
export type ThreadControllerServiceGetOpenThreadUsersQueryResult<
  TData = ThreadControllerServiceGetOpenThreadUsersDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetOpenThreadUsersKey =
  "ThreadControllerServiceGetOpenThreadUsers";
export const UseThreadControllerServiceGetOpenThreadUsersKeyFn = (
  {
    threadUuid,
  }: {
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceGetOpenThreadUsersKey,
  ...(queryKey ?? [{ threadUuid }]),
];
export type ThreadControllerServiceSearchThreadsDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.searchThreads>
>;
export type ThreadControllerServiceSearchThreadsQueryResult<
  TData = ThreadControllerServiceSearchThreadsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceSearchThreadsKey =
  "ThreadControllerServiceSearchThreads";
export const UseThreadControllerServiceSearchThreadsKeyFn = (
  {
    categories,
    page,
    patientUuid,
    size,
    subject,
    urgentOnly,
  }: {
    categories?: string[];
    page?: number;
    patientUuid?: string;
    size?: number;
    subject?: string;
    urgentOnly?: boolean;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceSearchThreadsKey,
  ...(queryKey ?? [
    { categories, page, patientUuid, size, subject, urgentOnly },
  ]),
];
export type ThreadControllerServiceGetThreadsByPatientDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getThreadsByPatient>
>;
export type ThreadControllerServiceGetThreadsByPatientQueryResult<
  TData = ThreadControllerServiceGetThreadsByPatientDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetThreadsByPatientKey =
  "ThreadControllerServiceGetThreadsByPatient";
export const UseThreadControllerServiceGetThreadsByPatientKeyFn = (
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid: string;
    size?: number;
  },
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceGetThreadsByPatientKey,
  ...(queryKey ?? [{ page, patientUuid, size }]),
];
export type ThreadControllerServiceGetThreadsListDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getThreadsList>
>;
export type ThreadControllerServiceGetThreadsListQueryResult<
  TData = ThreadControllerServiceGetThreadsListDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetThreadsListKey =
  "ThreadControllerServiceGetThreadsList";
export const UseThreadControllerServiceGetThreadsListKeyFn = (
  {
    excludeResolved,
    filter,
    page,
    patientUuid,
    search,
    size,
    userUuid,
  }: {
    excludeResolved?: boolean;
    filter?: string;
    page?: number;
    patientUuid: string;
    search?: string;
    size?: number;
    userUuid?: string;
  },
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceGetThreadsListKey,
  ...(queryKey ?? [
    { excludeResolved, filter, page, patientUuid, search, size, userUuid },
  ]),
];
export type ThreadControllerServiceGetMyThreadsDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getMyThreads>
>;
export type ThreadControllerServiceGetMyThreadsQueryResult<
  TData = ThreadControllerServiceGetMyThreadsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetMyThreadsKey =
  "ThreadControllerServiceGetMyThreads";
export const UseThreadControllerServiceGetMyThreadsKeyFn = (
  {
    page,
    providerUuids,
    size,
  }: {
    page?: number;
    providerUuids?: string[];
    size?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useThreadControllerServiceGetMyThreadsKey,
  ...(queryKey ?? [{ page, providerUuids, size }]),
];
export type ThreadControllerServiceGetThreadCategoriesDefaultResponse = Awaited<
  ReturnType<typeof ThreadControllerService.getThreadCategories>
>;
export type ThreadControllerServiceGetThreadCategoriesQueryResult<
  TData = ThreadControllerServiceGetThreadCategoriesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useThreadControllerServiceGetThreadCategoriesKey =
  "ThreadControllerServiceGetThreadCategories";
export const UseThreadControllerServiceGetThreadCategoriesKeyFn = (
  queryKey?: Array<unknown>,
) => [useThreadControllerServiceGetThreadCategoriesKey, ...(queryKey ?? [])];
export type BookmarkControllerServiceGetBookmarkedThreadsDefaultResponse =
  Awaited<ReturnType<typeof BookmarkControllerService.getBookmarkedThreads>>;
export type BookmarkControllerServiceGetBookmarkedThreadsQueryResult<
  TData = BookmarkControllerServiceGetBookmarkedThreadsDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBookmarkControllerServiceGetBookmarkedThreadsKey =
  "BookmarkControllerServiceGetBookmarkedThreads";
export const UseBookmarkControllerServiceGetBookmarkedThreadsKeyFn = (
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useBookmarkControllerServiceGetBookmarkedThreadsKey,
  ...(queryKey ?? [{ page, patientUuid, size }]),
];
export type BookmarkControllerServiceGetBookmarkedMessagesDefaultResponse =
  Awaited<ReturnType<typeof BookmarkControllerService.getBookmarkedMessages>>;
export type BookmarkControllerServiceGetBookmarkedMessagesQueryResult<
  TData = BookmarkControllerServiceGetBookmarkedMessagesDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBookmarkControllerServiceGetBookmarkedMessagesKey =
  "BookmarkControllerServiceGetBookmarkedMessages";
export const UseBookmarkControllerServiceGetBookmarkedMessagesKeyFn = (
  {
    page,
    patientUuid,
    size,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
  } = {},
  queryKey?: Array<unknown>,
) => [
  useBookmarkControllerServiceGetBookmarkedMessagesKey,
  ...(queryKey ?? [{ page, patientUuid, size }]),
];
export type BookmarkControllerServiceGetMessagePositionInThreadDefaultResponse =
  Awaited<
    ReturnType<typeof BookmarkControllerService.getMessagePositionInThread>
  >;
export type BookmarkControllerServiceGetMessagePositionInThreadQueryResult<
  TData = BookmarkControllerServiceGetMessagePositionInThreadDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBookmarkControllerServiceGetMessagePositionInThreadKey =
  "BookmarkControllerServiceGetMessagePositionInThread";
export const UseBookmarkControllerServiceGetMessagePositionInThreadKeyFn = (
  {
    messageUuid,
    threadUuid,
  }: {
    messageUuid: string;
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useBookmarkControllerServiceGetMessagePositionInThreadKey,
  ...(queryKey ?? [{ messageUuid, threadUuid }]),
];
export type BookmarkControllerServiceGetBookmarkedMessagesByThreadDefaultResponse =
  Awaited<
    ReturnType<typeof BookmarkControllerService.getBookmarkedMessagesByThread>
  >;
export type BookmarkControllerServiceGetBookmarkedMessagesByThreadQueryResult<
  TData = BookmarkControllerServiceGetBookmarkedMessagesByThreadDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useBookmarkControllerServiceGetBookmarkedMessagesByThreadKey =
  "BookmarkControllerServiceGetBookmarkedMessagesByThread";
export const UseBookmarkControllerServiceGetBookmarkedMessagesByThreadKeyFn = (
  {
    page,
    patientUuid,
    size,
    threadUuid,
  }: {
    page?: number;
    patientUuid?: string;
    size?: number;
    threadUuid: string;
  },
  queryKey?: Array<unknown>,
) => [
  useBookmarkControllerServiceGetBookmarkedMessagesByThreadKey,
  ...(queryKey ?? [{ page, patientUuid, size, threadUuid }]),
];
export type UserControllerServiceAddUserMutationResult = Awaited<
  ReturnType<typeof UserControllerService.addUser>
>;
export type UserControllerServiceHandleStripeWebhookMutationResult = Awaited<
  ReturnType<typeof UserControllerService.handleStripeWebhook>
>;
export type UserControllerServiceRegisterUsersOnKeycloakMutationResult =
  Awaited<ReturnType<typeof UserControllerService.registerUsersOnKeycloak>>;
export type UserControllerServiceSendInviteMutationResult = Awaited<
  ReturnType<typeof UserControllerService.sendInvite>
>;
export type UserControllerServiceRegisterUserWithUuidMutationResult = Awaited<
  ReturnType<typeof UserControllerService.registerUserWithUuid>
>;
export type EmployeeUploadControllerServiceUploadFileMutationResult = Awaited<
  ReturnType<typeof EmployeeUploadControllerService.uploadFile>
>;
export type StripeControllerServiceCreatePromotionalCouponMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.createPromotionalCoupon>>;
export type StripeControllerServiceHandleStripeWebhook1MutationResult = Awaited<
  ReturnType<typeof StripeControllerService.handleStripeWebhook1>
>;
export type StripeControllerServiceCreateSubscriptionMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createSubscription>
>;
export type StripeControllerServiceCreateSubscriptionWithPaymentMutationResult =
  Awaited<
    ReturnType<typeof StripeControllerService.createSubscriptionWithPayment>
  >;
export type StripeControllerServiceCompleteSubscriptionMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.completeSubscription>
>;
export type StripeControllerServiceCreateSetupIntentMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createSetupIntent>
>;
export type StripeControllerServiceCreateSetupIntentWithCustomerMutationResult =
  Awaited<
    ReturnType<typeof StripeControllerService.createSetupIntentWithCustomer>
  >;
export type StripeControllerServiceSetDefaultPaymentMethodMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.setDefaultPaymentMethod>>;
export type StripeControllerServiceSaveCardToCustomerWithChargingMutationResult =
  Awaited<
    ReturnType<typeof StripeControllerService.saveCardToCustomerWithCharging>
  >;
export type StripeControllerServiceSaveCardToCustomerMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.saveCardToCustomer>
>;
export type StripeControllerServiceRefundAmountMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.refundAmount>
>;
export type StripeControllerServiceCreateProductMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createProduct>
>;
export type StripeControllerServiceCreatePriceForProductMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.createPriceForProduct>>;
export type StripeControllerServiceCreateProductAndPriceMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.createProductAndPrice>>;
export type StripeControllerServiceCreateFlexiblePaymentMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.createFlexiblePayment>>;
export type StripeControllerServiceCreatePaymentIntentWithProductPriceMutationResult =
  Awaited<
    ReturnType<
      typeof StripeControllerService.createPaymentIntentWithProductPrice
    >
  >;
export type StripeControllerServiceCreatePaymentIntentMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createPaymentIntent>
>;
export type StripeControllerServiceCreateCustomerMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createCustomer>
>;
export type StripeControllerServiceCreateCoupon1MutationResult = Awaited<
  ReturnType<typeof StripeControllerService.createCoupon1>
>;
export type StripeControllerServiceAddSaveCardToCustomerMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.addSaveCardToCustomer>>;
export type ScriptSureControllerServiceCreateScriptSurePatientMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.createScriptSurePatient>
  >;
export type ScriptSureControllerServiceVendorLoginMutationResult = Awaited<
  ReturnType<typeof ScriptSureControllerService.vendorLogin>
>;
export type ScriptSureControllerServiceRegisterProviderToScriptSureMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.registerProviderToScriptSure>
  >;
export type ScriptSureControllerServiceRegisterNurseStaffToScriptSureMutationResult =
  Awaited<
    ReturnType<
      typeof ScriptSureControllerService.registerNurseStaffToScriptSure
    >
  >;
export type ScriptSureControllerServiceRegisterLocationToScriptSureMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.registerLocationToScriptSure>
  >;
export type ScriptSureControllerServiceSaveMedicationPrescriptionMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.saveMedicationPrescription>
  >;
export type ScriptSureControllerServiceGetPatientMedicationsMutationResult =
  Awaited<ReturnType<typeof ScriptSureControllerService.getPatientMedications>>;
export type ScriptSureControllerServiceGetPatientPharmacyMutationResult =
  Awaited<ReturnType<typeof ScriptSureControllerService.getPatientPharmacy>>;
export type ScriptSureControllerServiceSaveAllergyMutationResult = Awaited<
  ReturnType<typeof ScriptSureControllerService.saveAllergy>
>;
export type ScriptSureControllerServiceSaveNoKnownAllergyMutationResult =
  Awaited<ReturnType<typeof ScriptSureControllerService.saveNoKnownAllergy>>;
export type ScriptSureControllerServiceGetPatientAllergiesMutationResult =
  Awaited<ReturnType<typeof ScriptSureControllerService.getPatientAllergies>>;
export type SavedCardControllerServiceSetDefaultSavedCardByUuidMutationResult =
  Awaited<
    ReturnType<typeof SavedCardControllerService.setDefaultSavedCardByUuid>
  >;
export type SavedBankControllerServiceSetDefaultSavedBankByUuidMutationResult =
  Awaited<
    ReturnType<typeof SavedBankControllerService.setDefaultSavedBankByUuid>
  >;
export type SavedBankControllerServiceCreateSetupIntent1MutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.createSetupIntent1>>;
export type SavedBankControllerServiceConfirmBankAccountMutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.confirmBankAccount>>;
export type SavedBankControllerServiceCreateSetupIntent11MutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.createSetupIntent11>>;
export type SavedBankControllerServiceConfirmBankAccount1MutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.confirmBankAccount1>>;
export type SalesTaxProfileControllerServiceSaveSalesTaxProfileMutationResult =
  Awaited<
    ReturnType<typeof SalesTaxProfileControllerService.saveSalesTaxProfile>
  >;
export type SalesTaxJurisdictionControllerServiceSaveSalesTaxJurisdictionMutationResult =
  Awaited<
    ReturnType<
      typeof SalesTaxJurisdictionControllerService.saveSalesTaxJurisdiction
    >
  >;
export type RolesAndPermissionControllerServiceCreateRoleMutationResult =
  Awaited<ReturnType<typeof RolesAndPermissionControllerService.createRole>>;
export type RoleTypeManagementControllerServiceCreateRoleTypeMutationResult =
  Awaited<
    ReturnType<typeof RoleTypeManagementControllerService.createRoleType>
  >;
export type RoleTypeFeatureManagementControllerServiceCreateRoleTypeFeatureMutationResult =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.createRoleTypeFeature
    >
  >;
export type ProviderControllerServiceAddProviderMutationResult = Awaited<
  ReturnType<typeof ProviderControllerService.addProvider>
>;
export type PlanControllerServiceCreatePlanMutationResult = Awaited<
  ReturnType<typeof PlanControllerService.createPlan>
>;
export type PaymentTransactionControllerServiceCreatePaymentTransactionMutationResult =
  Awaited<
    ReturnType<
      typeof PaymentTransactionControllerService.createPaymentTransaction
    >
  >;
export type PatientControllerServiceAddPatientMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.addPatient>
>;
export type PatientControllerServiceMarkPatientViewedMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.markPatientViewed>
>;
export type PatientControllerServiceSyncPatientWithScriptSureMutationResult =
  Awaited<
    ReturnType<typeof PatientControllerService.syncPatientWithScriptSure>
  >;
export type PatientControllerServiceSendNotificationMailForBasicPaymentDetailsMutationResult =
  Awaited<
    ReturnType<
      typeof PatientControllerService.sendNotificationMailForBasicPaymentDetails
    >
  >;
export type PatientControllerServiceGeneratePatientChartPdfMutationResult =
  Awaited<ReturnType<typeof PatientControllerService.generatePatientChartPdf>>;
export type PatientControllerServiceUpdateEngagedPatientEmployerMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof PatientControllerService.updateEngagedPatientEmployerMembershipInvoice
    >
  >;
export type PatientControllerServiceCheckPatientCredentialsMutationResult =
  Awaited<ReturnType<typeof PatientControllerService.checkPatientCredentials>>;
export type PatientControllerServiceCancelPlanChangeMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.cancelPlanChange>
>;
export type PatientControllerServiceEvictPatientCachesMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.evictPatientCaches>
>;
export type PatientControllerServiceUpdateEngagedPatientBrokerFirmMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof PatientControllerService.updateEngagedPatientBrokerFirmMembershipInvoice
    >
  >;
export type PatientControllerServiceUpdateEngagedPatientAffiliateFirmMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof PatientControllerService.updateEngagedPatientAffiliateFirmMembershipInvoice
    >
  >;
export type PatientControllerServiceAddPatientToStripeMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.addPatientToStripe>
>;
export type PatientControllerServiceAddMembershipMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.addMembership>
>;
export type PatientModuleControllerServiceCreateMutationResult = Awaited<
  ReturnType<typeof PatientModuleControllerService.create>
>;
export type PatientModuleAccessControllerServiceCreate1MutationResult = Awaited<
  ReturnType<typeof PatientModuleAccessControllerService.create1>
>;
export type PatientInformationControllerServiceCreate2MutationResult = Awaited<
  ReturnType<typeof PatientInformationControllerService.create2>
>;
export type NurseStaffProviderControllerServiceAddNurseStaffProviderMutationResult =
  Awaited<
    ReturnType<typeof NurseStaffProviderControllerService.addNurseStaffProvider>
  >;
export type LeadControllerServiceCreateLeadMutationResult = Awaited<
  ReturnType<typeof LeadControllerService.createLead>
>;
export type LeadControllerServiceCreateSubscriptionAfterPaymentMutationResult =
  Awaited<
    ReturnType<typeof LeadControllerService.createSubscriptionAfterPayment>
  >;
export type InvoiceSettingControllerServiceCreateInvoiceSettingMutationResult =
  Awaited<
    ReturnType<typeof InvoiceSettingControllerService.createInvoiceSetting>
  >;
export type FeatureManagementControllerServiceCreateFeatureMutationResult =
  Awaited<ReturnType<typeof FeatureManagementControllerService.createFeature>>;
export type FaxControllerServiceUpdateFaxStatusMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.updateFaxStatus>
>;
export type FaxControllerServiceSendFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendFax>
>;
export type FaxControllerServiceSendWorkNoteByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendWorkNoteByFax>
>;
export type FaxControllerServiceSendWorkNoteByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendWorkNoteByEmail>
>;
export type FaxControllerServiceSendSoapNoteByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendSoapNoteByFax>
>;
export type FaxControllerServiceSendSoapNoteByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendSoapNoteByEmail>
>;
export type FaxControllerServiceSendReferralByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendReferralByFax>
>;
export type FaxControllerServiceSendReferralByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendReferralByEmail>
>;
export type FaxControllerServiceSendPocByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendPocByFax>
>;
export type FaxControllerServiceSendPocByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendPocByEmail>
>;
export type FaxControllerServiceSendPatientInformationByFaxMutationResult =
  Awaited<ReturnType<typeof FaxControllerService.sendPatientInformationByFax>>;
export type FaxControllerServiceSendPatientInformationByEmailMutationResult =
  Awaited<
    ReturnType<typeof FaxControllerService.sendPatientInformationByEmail>
  >;
export type FaxControllerServiceSendLabResultBySmsMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendLabResultBySms>
>;
export type FaxControllerServiceGetFaxDetailServiceMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.getFaxDetailService>
>;
export type FaxControllerServiceSendImagingByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendImagingByFax>
>;
export type FaxControllerServiceSendImagingByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendImagingByEmail>
>;
export type FaxControllerServiceSendHandpNoteByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendHandpNoteByFax>
>;
export type FaxControllerServiceSendHandpNoteByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendHandpNoteByEmail>
>;
export type FaxControllerServiceSendDocumentByFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendDocumentByFax>
>;
export type FaxControllerServiceSendDocumentByEmailMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendDocumentByEmail>
>;
export type FaxControllerServiceSendFaxToRefferalMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendFaxToRefferal>
>;
export type FaxControllerServiceSendQuestionnaireFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendQuestionnaireFax>
>;
export type FaxControllerServiceSendFaxToLabOrderMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendFaxToLabOrder>
>;
export type FaxControllerServiceSendFaxToImagingMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendFaxToImaging>
>;
export type FaxControllerServiceSendFaxToLabOrder1MutationResult = Awaited<
  ReturnType<typeof FaxControllerService.sendFaxToLabOrder1>
>;
export type FaxControllerServiceCancelEfaxFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.cancelEfaxFax>
>;
export type FaxControllerServiceAttachDocumentMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.attachDocument>
>;
export type EmployerControllerServiceAddEmployerMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.addEmployer>
>;
export type EmployerControllerServiceUpdateInvoiceSetting1MutationResult =
  Awaited<ReturnType<typeof EmployerControllerService.updateInvoiceSetting1>>;
export type EmployerPageControllerServiceCreateEmployerPageMutationResult =
  Awaited<ReturnType<typeof EmployerPageControllerService.createEmployerPage>>;
export type EmployerDivisionControllerServiceCreateEmployerDivisionMutationResult =
  Awaited<
    ReturnType<typeof EmployerDivisionControllerService.createEmployerDivision>
  >;
export type EmployerAdministratorControllerServiceCreateEmployerAdministratorMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerAdministratorControllerService.createEmployerAdministrator
    >
  >;
export type CreditControllerServiceAddCreditMutationResult = Awaited<
  ReturnType<typeof CreditControllerService.addCredit>
>;
export type CoverageRuleControllerServiceCreateCoverageRuleMutationResult =
  Awaited<ReturnType<typeof CoverageRuleControllerService.createCoverageRule>>;
export type CoveragePlanControllerServiceCreateCoveragePlanMutationResult =
  Awaited<ReturnType<typeof CoveragePlanControllerService.createCoveragePlan>>;
export type CouponControllerServiceCreateCouponMutationResult = Awaited<
  ReturnType<typeof CouponControllerService.createCoupon>
>;
export type ChargeItemControllerServiceUploadCsvMutationResult = Awaited<
  ReturnType<typeof ChargeItemControllerService.uploadCsv>
>;
export type ChargeItemControllerServiceUpdatePricesFromCsvMutationResult =
  Awaited<ReturnType<typeof ChargeItemControllerService.updatePricesFromCsv>>;
export type ChargeItemControllerServiceSaveChargeItemMutationResult = Awaited<
  ReturnType<typeof ChargeItemControllerService.saveChargeItem>
>;
export type ChargeCategoryControllerServiceSaveChargeCategoryMutationResult =
  Awaited<
    ReturnType<typeof ChargeCategoryControllerService.saveChargeCategory>
  >;
export type CancellationControllerServiceSaveCancellationMutationResult =
  Awaited<ReturnType<typeof CancellationControllerService.saveCancellation>>;
export type BrokerControllerServiceCreateBrokerMutationResult = Awaited<
  ReturnType<typeof BrokerControllerService.createBroker>
>;
export type BreakGlassControllerServiceCreate3MutationResult = Awaited<
  ReturnType<typeof BreakGlassControllerService.create3>
>;
export type AncillaryServiceChargesControllerServiceUpdatePlanRenewalDatesForActiveRetailPatientsMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updatePlanRenewalDatesForActiveRetailPatients
    >
  >;
export type AncillaryServiceChargesControllerServiceSyncEmployerInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.syncEmployerInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceScheduledPaymentProcessingMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.scheduledPaymentProcessing
    >
  >;
export type AncillaryServiceChargesControllerServiceScheduledPaymentMutationResult =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.scheduledPayment>
  >;
export type AncillaryServiceChargesControllerServiceUpdateExistingRetailPatientMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updateExistingRetailPatientMembershipInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceRefundAmount1MutationResult =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.refundAmount1>
  >;
export type AncillaryServiceChargesControllerServiceReactiveEmployerMembershipMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.reactiveEmployerMembership
    >
  >;
export type AncillaryServiceChargesControllerServiceProcessOverdueInvoicesAndGeneratePdfsMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.processOverdueInvoicesAndGeneratePdfs
    >
  >;
export type AncillaryServiceChargesControllerServiceSaveMiscellaneousServiceChargeMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.saveMiscellaneousServiceCharge
    >
  >;
export type AncillaryServiceChargesControllerServiceMakePaymentMutationResult =
  Awaited<
    ReturnType<typeof AncillaryServiceChargesControllerService.makePayment>
  >;
export type AncillaryServiceChargesControllerServiceLinkChargeItemsToPatientMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.linkChargeItemsToPatient
    >
  >;
export type AncillaryServiceChargesControllerServiceMarkLabOrderAsDrawnMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.markLabOrderAsDrawn
    >
  >;
export type AncillaryServiceChargesControllerServiceInvoiceLabOrderNowMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.invoiceLabOrderNow
    >
  >;
export type AncillaryServiceChargesControllerServiceSendLabInvoicePaymentRemindersMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.sendLabInvoicePaymentReminders
    >
  >;
export type AncillaryServiceChargesControllerServiceLabInvoiceAutopayProcessingMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.labInvoiceAutopayProcessing
    >
  >;
export type AncillaryServiceChargesControllerServiceCreateRetailMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.createRetailMembershipInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceRetailPatientAutopayProcessingMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.retailPatientAutopayProcessing
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateMonthlyEmployerInvoicesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateMonthlyEmployerInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateMonthlyBrokerFirmInvoicesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateMonthlyBrokerFirmInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateMonthlyAffiliateFirmInvoicesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateMonthlyAffiliateFirmInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateLabOrderInvoicesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateLabOrderInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateInvoiceOfAncillaryForUserMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateInvoiceOfAncillaryForUser
    >
  >;
export type AncillaryServiceChargesControllerServiceGenerateInvoiceEmployerMembershipMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.generateInvoiceEmployerMembership
    >
  >;
export type AncillaryServiceChargesControllerServiceEmployerInvoiceSettingMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.employerInvoiceSetting
    >
  >;
export type AncillaryServiceChargesControllerServiceDeactivateRetailPatientsWithUnpaidInvoicesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.deactivateRetailPatientsWithUnpaidInvoices
    >
  >;
export type AncillaryServiceChargesControllerServiceProcessEmployerDeactivationMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.processEmployerDeactivation
    >
  >;
export type AncillaryServiceChargesControllerServiceCreateChargeItemAndInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.createChargeItemAndInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceSaveAncillaryServiceChargesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.saveAncillaryServiceCharges
    >
  >;
export type AncillaryServiceChargesControllerServiceConvertPatientMembershipMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.convertPatientMembership
    >
  >;
export type AncillaryServiceChargesControllerServiceCheckChargeCoverageMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.checkChargeCoverage
    >
  >;
export type AncillaryServiceChargesControllerServiceChangeInvoiceStatusMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.changeInvoiceStatus
    >
  >;
export type AncillaryServiceChargesControllerServiceUpdateExistingAffiliateFirmMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updateExistingAffiliateFirmMembershipInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceUpdateExistingBrokerFirmMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updateExistingBrokerFirmMembershipInvoice
    >
  >;
export type AncillaryServiceChargesControllerServiceActivatePendingEmployeePatientsMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.activatePendingEmployeePatients
    >
  >;
export type AgentFirmControllerServiceCreateAgentFirmMutationResult = Awaited<
  ReturnType<typeof AgentFirmControllerService.createAgentFirm>
>;
export type AgentDealControllerServiceCreateAgentDealMutationResult = Awaited<
  ReturnType<typeof AgentDealControllerService.createAgentDeal>
>;
export type AffiliateGroupControllerServiceAddAffiliateMutationResult = Awaited<
  ReturnType<typeof AffiliateGroupControllerService.addAffiliate>
>;
export type AffiliateGroupControllerServiceAddAffiliateUserMutationResult =
  Awaited<ReturnType<typeof AffiliateGroupControllerService.addAffiliateUser>>;
export type AdminUserControllerServiceResetUserMfaMutationResult = Awaited<
  ReturnType<typeof AdminUserControllerService.resetUserMfa>
>;
export type AdminUserControllerServiceGenerateGuestTokenMutationResult =
  Awaited<ReturnType<typeof AdminUserControllerService.generateGuestToken>>;
export type AdminUserControllerServiceResendLinkMutationResult = Awaited<
  ReturnType<typeof AdminUserControllerService.resendLink>
>;
export type AdminUserControllerServiceSaveAdminUserMutationResult = Awaited<
  ReturnType<typeof AdminUserControllerService.saveAdminUser>
>;
export type SupervisingProviderRequestControllerServiceSendRequestsMutationResult =
  Awaited<
    ReturnType<typeof SupervisingProviderRequestControllerService.sendRequests>
  >;
export type ShareCardControllerServiceShareCardMutationResult = Awaited<
  ReturnType<typeof ShareCardControllerService.shareCard>
>;
export type ShareCardControllerServiceShareCard1MutationResult = Awaited<
  ReturnType<typeof ShareCardControllerService.shareCard1>
>;
export type ShareCardControllerServiceAddMetadataMutationResult = Awaited<
  ReturnType<typeof ShareCardControllerService.addMetadata>
>;
export type ShareBankControllerServiceShareBankMutationResult = Awaited<
  ReturnType<typeof ShareBankControllerService.shareBank>
>;
export type ProviderCoverageControllerServiceCreateRequestMutationResult =
  Awaited<ReturnType<typeof ProviderCoverageControllerService.createRequest>>;
export type ProviderCoverageControllerServiceResyncScriptSureMutationResult =
  Awaited<
    ReturnType<typeof ProviderCoverageControllerService.resyncScriptSure>
  >;
export type PdfControllerServiceUploadSoapNotePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadSoapNotePdf>
>;
export type PdfControllerServiceUploadSingleLabOrderPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadSingleLabOrderPdf>
>;
export type PdfControllerServiceUploadPocPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadPocPdf>
>;
export type PdfControllerServiceUploadPatientInformationPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.uploadPatientInformationPdf>>;
export type PdfControllerServiceUploadLabResultPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadLabResultPdf>
>;
export type PdfControllerServiceUploadImagingResultPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadImagingResultPdf>
>;
export type PdfControllerServiceUploadHandpNotePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.uploadHandpNotePdf>
>;
export type PdfControllerServiceSignExistingPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.signExistingPdf>
>;
export type PdfControllerServiceGeneratePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generatePdf>
>;
export type PdfControllerServiceGenerateWorkNotePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateWorkNotePdf>
>;
export type PdfControllerServiceGenerateExportStatementPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateExportStatementPdf>>;
export type PdfControllerServiceGenerateSpecimenLabelMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateSpecimenLabel>
>;
export type PdfControllerServiceGenerateSoapNotePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateSoapNotePdf>
>;
export type PdfControllerServiceGenerateSingleLabOrderPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateSingleLabOrderPdf>>;
export type PdfControllerServiceGenerateReturnLetterPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateReturnLetterPdf>
>;
export type PdfControllerServiceGenerateReferralPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateReferralPdf>
>;
export type PdfControllerServiceGenerateProviderAppointmentsPdfMutationResult =
  Awaited<
    ReturnType<typeof PdfControllerService.generateProviderAppointmentsPdf>
  >;
export type PdfControllerServiceGeneratePocPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generatePocPdf>
>;
export type PdfControllerServiceGeneratePatientInformationPdfMutationResult =
  Awaited<
    ReturnType<typeof PdfControllerService.generatePatientInformationPdf>
  >;
export type PdfControllerServiceGenerateMedicationsPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateMedicationsPdf>
>;
export type PdfControllerServiceGenerateLabResultPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateLabResultPdf>
>;
export type PdfControllerServiceGenerateLabResultPdfByUuidMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateLabResultPdfByUuid>>;
export type PdfControllerServiceGenerateLabOrdersPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateLabOrdersPdf>
>;
export type PdfControllerServiceGenerateInventoryOrderPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateInventoryOrderPdf>>;
export type PdfControllerServiceGenerateInventoryDetailPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateInventoryDetailPdf>>;
export type PdfControllerServiceGenerateImmunizationsPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateImmunizationsPdf>>;
export type PdfControllerServiceGenerateImagingResultPdfMutationResult =
  Awaited<ReturnType<typeof PdfControllerService.generateImagingResultPdf>>;
export type PdfControllerServiceGenerateHandpNotePdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateHandpNotePdf>
>;
export type PdfControllerServiceGenerateFacesheetPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateFacesheetPdf>
>;
export type PdfControllerServiceGenerateDiagnosisPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateDiagnosisPdf>
>;
export type PdfControllerServiceGenerateAuditLogPdfMutationResult = Awaited<
  ReturnType<typeof PdfControllerService.generateAuditLogPdf>
>;
export type AgentPayoutServiceMakePayoutMutationResult = Awaited<
  ReturnType<typeof AgentPayoutService.makePayout>
>;
export type AgentPayoutServiceAddPayoutBankAccountMutationResult = Awaited<
  ReturnType<typeof AgentPayoutService.addPayoutBankAccount>
>;
export type AgentPayoutServiceVerifyPayoutBankAccountMutationResult = Awaited<
  ReturnType<typeof AgentPayoutService.verifyPayoutBankAccount>
>;
export type InventoryOrderControllerServiceAddToInventoryMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.addToInventory>>;
export type InventoryOrderControllerServicePollShipmentsMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.pollShipments>>;
export type InventoryOrderControllerServicePlaceOrderOnNorthWindMutationResult =
  Awaited<
    ReturnType<typeof InventoryOrderControllerService.placeOrderOnNorthWind>
  >;
export type InventoryOrderControllerServiceTransferInventoryMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.transferInventory>>;
export type InventoryOrderControllerServiceAddInventoryQuantityMutationResult =
  Awaited<
    ReturnType<typeof InventoryOrderControllerService.addInventoryQuantity>
  >;
export type GoogleMapsControllerServiceUploadPatientAddressesCsvMutationResult =
  Awaited<
    ReturnType<typeof GoogleMapsControllerService.uploadPatientAddressesCsv>
  >;
export type GoogleMapsControllerServiceGenerateShareLinkMutationResult =
  Awaited<ReturnType<typeof GoogleMapsControllerService.generateShareLink>>;
export type FutureBillingControllerServiceRegenerateInvoiceWithCurrentRenewalDateMutationResult =
  Awaited<
    ReturnType<
      typeof FutureBillingControllerService.regenerateInvoiceWithCurrentRenewalDate
    >
  >;
export type FutureBillingControllerServiceRegenerateEmployerMembershipInvoiceMutationResult =
  Awaited<
    ReturnType<
      typeof FutureBillingControllerService.regenerateEmployerMembershipInvoice
    >
  >;
export type CsvControllerServiceUploadEmployeeUploadTemplateMutationResult =
  Awaited<ReturnType<typeof CsvControllerService.uploadEmployeeUploadTemplate>>;
export type CartControllerServicePlaceOrderMutationResult = Awaited<
  ReturnType<typeof CartControllerService.placeOrder>
>;
export type CartControllerServiceAddToCartMutationResult = Awaited<
  ReturnType<typeof CartControllerService.addToCart>
>;
export type MobileAuthControllerServiceRefreshMutationResult = Awaited<
  ReturnType<typeof MobileAuthControllerService.refresh>
>;
export type MobileAuthControllerServiceConfirmEnrollmentMutationResult =
  Awaited<ReturnType<typeof MobileAuthControllerService.confirmEnrollment>>;
export type MobileAuthControllerServiceLogoutMutationResult = Awaited<
  ReturnType<typeof MobileAuthControllerService.logout>
>;
export type MobileAuthControllerServiceLoginMutationResult = Awaited<
  ReturnType<typeof MobileAuthControllerService.login>
>;
export type MobileAuthControllerServiceVerifyOtpMutationResult = Awaited<
  ReturnType<typeof MobileAuthControllerService.verifyOtp>
>;
export type MobileAuthControllerServiceForgotPasswordMutationResult = Awaited<
  ReturnType<typeof MobileAuthControllerService.forgotPassword>
>;
export type DashboardControllerServiceMarkReviewResultMutationResult = Awaited<
  ReturnType<typeof DashboardControllerService.markReviewResult>
>;
export type WorkNoteControllerServiceAddWorkNoteMutationResult = Awaited<
  ReturnType<typeof WorkNoteControllerService.addWorkNote>
>;
export type VitalControllerServiceAddVitalMutationResult = Awaited<
  ReturnType<typeof VitalControllerService.addVital>
>;
export type VitalControllerServiceRecalculateGrowthPercentilesMutationResult =
  Awaited<
    ReturnType<typeof VitalControllerService.recalculateGrowthPercentiles>
  >;
export type VaccineControllerServiceCreateVaccineMutationResult = Awaited<
  ReturnType<typeof VaccineControllerService.createVaccine>
>;
export type TaskControllerServiceAddTaskMutationResult = Awaited<
  ReturnType<typeof TaskControllerService.addTask>
>;
export type TaskControllerServiceResolveTasksForThreadMutationResult = Awaited<
  ReturnType<typeof TaskControllerService.resolveTasksForThread>
>;
export type TaskControllerServiceProcessTaskRemindersMutationResult = Awaited<
  ReturnType<typeof TaskControllerService.processTaskReminders>
>;
export type StatusConfigurationControllerServiceCreateStatusConfigurationMutationResult =
  Awaited<
    ReturnType<
      typeof StatusConfigurationControllerService.createStatusConfiguration
    >
  >;
export type SocialHistoryControllerServiceCreate1MutationResult = Awaited<
  ReturnType<typeof SocialHistoryControllerService.create1>
>;
export type SoapNoteControllerServiceAddSoapNoteMutationResult = Awaited<
  ReturnType<typeof SoapNoteControllerService.addSoapNote>
>;
export type SoapNoteTemplateControllerServiceAddSoapNoteTemplateMutationResult =
  Awaited<
    ReturnType<typeof SoapNoteTemplateControllerService.addSoapNoteTemplate>
  >;
export type ScreenHistoryControllerServiceCreate11MutationResult = Awaited<
  ReturnType<typeof ScreenHistoryControllerService.create11>
>;
export type ReviewOfSystemTemplateControllerServiceAddReviewOfSystemTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof ReviewOfSystemTemplateControllerService.addReviewOfSystemTemplate
    >
  >;
export type ReviewOfSystemControllerServiceAddReviewOfSystemMutationResult =
  Awaited<ReturnType<typeof ReviewOfSystemControllerService.addReviewOfSystem>>;
export type ReferralControllerServiceSaveReferralMutationResult = Awaited<
  ReturnType<typeof ReferralControllerService.saveReferral>
>;
export type ProviderDirectoryControllerServiceUploadCsv1MutationResult =
  Awaited<ReturnType<typeof ProviderDirectoryControllerService.uploadCsv1>>;
export type ProviderDirectoryControllerServiceTriggerNppesImportMutationResult =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.triggerNppesImport>
  >;
export type ProviderDirectoryControllerServiceTriggerNppesFileImportMutationResult =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.triggerNppesFileImport>
  >;
export type ProviderDirectoryControllerServiceSaveProviderDirectoryMutationResult =
  Awaited<
    ReturnType<typeof ProviderDirectoryControllerService.saveProviderDirectory>
  >;
export type PointsOfCareLabControllerServiceCreatePointOfCareLabMutationResult =
  Awaited<
    ReturnType<typeof PointsOfCareLabControllerService.createPointOfCareLab>
  >;
export type PocLabTestControllerServiceAddPocLabTestMutationResult = Awaited<
  ReturnType<typeof PocLabTestControllerService.addPocLabTest>
>;
export type PocLabResultControllerServiceAddPocLabResultMutationResult =
  Awaited<ReturnType<typeof PocLabResultControllerService.addPocLabResult>>;
export type PhysicalExamTemplateControllerServiceAddPhysicalExamTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.addPhysicalExamTemplate
    >
  >;
export type PhysicalExamControllerServiceAddPhysicalExamMutationResult =
  Awaited<ReturnType<typeof PhysicalExamControllerService.addPhysicalExam>>;
export type PharmacyControllerServiceAddPharmacyMutationResult = Awaited<
  ReturnType<typeof PharmacyControllerService.addPharmacy>
>;
export type PatientVaccinationControllerServiceCreatePatientVaccinationMutationResult =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.createPatientVaccination
    >
  >;
export type PatientFlagControllerServiceAddPatientFlagMutationResult = Awaited<
  ReturnType<typeof PatientFlagControllerService.addPatientFlag>
>;
export type PastSurgicalHistoryControllerServiceAddPastSurgicalHistoryMutationResult =
  Awaited<
    ReturnType<
      typeof PastSurgicalHistoryControllerService.addPastSurgicalHistory
    >
  >;
export type PastMedicalHistoryControllerServiceAddPastMedicalHistoryMutationResult =
  Awaited<
    ReturnType<typeof PastMedicalHistoryControllerService.addPastMedicalHistory>
  >;
export type NoteControllerServiceSaveThreadToChartMutationResult = Awaited<
  ReturnType<typeof NoteControllerService.saveThreadToChart>
>;
export type NoteControllerServiceSaveNoteMutationResult = Awaited<
  ReturnType<typeof NoteControllerService.saveNote>
>;
export type MedicationControllerServiceUploadMedicationsMutationResult =
  Awaited<ReturnType<typeof MedicationControllerService.uploadMedications>>;
export type MedicationControllerServiceSaveMedicationMutationResult = Awaited<
  ReturnType<typeof MedicationControllerService.saveMedication>
>;
export type MacroControllerServiceAddMacroMutationResult = Awaited<
  ReturnType<typeof MacroControllerService.addMacro>
>;
export type LocationControllerServiceAddLocationMutationResult = Awaited<
  ReturnType<typeof LocationControllerService.addLocation>
>;
export type LocationGroupControllerServiceAddLocationGroupMutationResult =
  Awaited<ReturnType<typeof LocationGroupControllerService.addLocationGroup>>;
export type LocationAvailabilityControllerServiceCreate21MutationResult =
  Awaited<ReturnType<typeof LocationAvailabilityControllerService.create21>>;
export type PatientLinkPharmacyControllerServiceLinkPharmacyMutationResult =
  Awaited<ReturnType<typeof PatientLinkPharmacyControllerService.linkPharmacy>>;
export type LabTestControllerServiceCreateLabTestMutationResult = Awaited<
  ReturnType<typeof LabTestControllerService.createLabTest>
>;
export type LabResultControllerServiceProccesResultMutationResult = Awaited<
  ReturnType<typeof LabResultControllerService.proccesResult>
>;
export type LabResultControllerServiceAddLabResultByOrderUuidMutationResult =
  Awaited<
    ReturnType<typeof LabResultControllerService.addLabResultByOrderUuid>
  >;
export type LabResultControllerServiceAddLabResultMutationResult = Awaited<
  ReturnType<typeof LabResultControllerService.addLabResult>
>;
export type LabOrderControllerServiceCreateLabOrderMutationResult = Awaited<
  ReturnType<typeof LabOrderControllerService.createLabOrder>
>;
export type LabOrderControllerServiceCalculatePriceMutationResult = Awaited<
  ReturnType<typeof LabOrderControllerService.calculatePrice>
>;
export type LabOrderSetControllerServiceCreateLabOrderSetMutationResult =
  Awaited<ReturnType<typeof LabOrderSetControllerService.createLabOrderSet>>;
export type InvoiceControllerServiceSaveInvoiceStatementMutationResult =
  Awaited<ReturnType<typeof InvoiceControllerService.saveInvoiceStatement>>;
export type InvoiceControllerServiceSaveInvoiceMutationResult = Awaited<
  ReturnType<typeof InvoiceControllerService.saveInvoice>
>;
export type InsuranceControllerServiceCreateInsuranceMutationResult = Awaited<
  ReturnType<typeof InsuranceControllerService.createInsurance>
>;
export type ImagingResultControllerServiceSaveImagingResultMutationResult =
  Awaited<ReturnType<typeof ImagingResultControllerService.saveImagingResult>>;
export type ImagingOrderControllerServiceSaveImagingOrderMutationResult =
  Awaited<ReturnType<typeof ImagingOrderControllerService.saveImagingOrder>>;
export type IcdCodeControllerServiceCreateIcdCodeMutationResult = Awaited<
  ReturnType<typeof IcdCodeControllerService.createIcdCode>
>;
export type HAndPNoteControllerServiceAddHandPnoteMutationResult = Awaited<
  ReturnType<typeof HAndPNoteControllerService.addHandPnote>
>;
export type HabitsControllerServiceCreate31MutationResult = Awaited<
  ReturnType<typeof HabitsControllerService.create31>
>;
export type GlobalHolidayControllerServiceAddGlobalHolidayMutationResult =
  Awaited<ReturnType<typeof GlobalHolidayControllerService.addGlobalHoliday>>;
export type FormTemplateControllerServiceCreateFormTemplateMutationResult =
  Awaited<ReturnType<typeof FormTemplateControllerService.createFormTemplate>>;
export type FormTemplateControllerServiceDuplicateFormTemplateMutationResult =
  Awaited<
    ReturnType<typeof FormTemplateControllerService.duplicateFormTemplate>
  >;
export type FormTemplateControllerServiceCreateFormTemplateWithPdfMutationResult =
  Awaited<
    ReturnType<typeof FormTemplateControllerService.createFormTemplateWithPdf>
  >;
export type FdbMedicationsControllerServiceCreate4MutationResult = Awaited<
  ReturnType<typeof FdbMedicationsControllerService.create4>
>;
export type FamilyHistoryControllerServiceAddFamilyHistoryMutationResult =
  Awaited<ReturnType<typeof FamilyHistoryControllerService.addFamilyHistory>>;
export type EducationalMaterialControllerServiceCreateEducationalMaterialMutationResult =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.createEducationalMaterial
    >
  >;
export type EducationalMaterialControllerServiceSetPatientsForMaterialMutationResult =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.setPatientsForMaterial
    >
  >;
export type DrugIntoleranceControllerServiceAddDrugIntoleranceMutationResult =
  Awaited<
    ReturnType<typeof DrugIntoleranceControllerService.addDrugIntolerance>
  >;
export type DocumentTypeControllerServiceSaveDocumentTypeMutationResult =
  Awaited<ReturnType<typeof DocumentTypeControllerService.saveDocumentType>>;
export type DiagnosisControllerServiceAddDiagnosisMutationResult = Awaited<
  ReturnType<typeof DiagnosisControllerService.addDiagnosis>
>;
export type CptCodeControllerServiceAddCptCodeMutationResult = Awaited<
  ReturnType<typeof CptCodeControllerService.addCptCode>
>;
export type CommentControllerServiceAddMessageMutationResult = Awaited<
  ReturnType<typeof CommentControllerService.addMessage>
>;
export type CarePlanControllerServiceSaveCarePlanMutationResult = Awaited<
  ReturnType<typeof CarePlanControllerService.saveCarePlan>
>;
export type AvailabilityControllerServiceAddAvailabilityMutationResult =
  Awaited<ReturnType<typeof AvailabilityControllerService.addAvailability>>;
export type AvailabilityControllerServiceCreateBlockSlotMutationResult =
  Awaited<ReturnType<typeof AvailabilityControllerService.createBlockSlot>>;
export type AppointmentControllerServiceCreateAppointmentMutationResult =
  Awaited<ReturnType<typeof AppointmentControllerService.createAppointment>>;
export type AppointmentControllerServiceSubmitVideoConsentMutationResult =
  Awaited<ReturnType<typeof AppointmentControllerService.submitVideoConsent>>;
export type AppointmentControllerServiceConfirmAppointmentFromSmsMutationResult =
  Awaited<
    ReturnType<typeof AppointmentControllerService.confirmAppointmentFromSms>
  >;
export type AppointmentControllerServiceGenerateCalendarSyncUrlMutationResult =
  Awaited<
    ReturnType<typeof AppointmentControllerService.generateCalendarSyncUrl>
  >;
export type AppointmentTypeControllerServiceCreateAppointmentTypeMutationResult =
  Awaited<
    ReturnType<typeof AppointmentTypeControllerService.createAppointmentType>
  >;
export type AnnotableImageControllerServiceAddAnnotableImageMutationResult =
  Awaited<ReturnType<typeof AnnotableImageControllerService.addAnnotableImage>>;
export type AnnotableImageTemplateControllerServiceAddAnnotableImageTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.addAnnotableImageTemplate
    >
  >;
export type AnnotableImagePinControllerServiceAddAnnotableImagePinMutationResult =
  Awaited<
    ReturnType<typeof AnnotableImagePinControllerService.addAnnotableImagePin>
  >;
export type AllergyControllerServiceAddAllergyMutationResult = Awaited<
  ReturnType<typeof AllergyControllerService.addAllergy>
>;
export type QuestionnaireControllerServiceSubmitQuestionnaireMultipartMutationResult =
  Awaited<
    ReturnType<
      typeof QuestionnaireControllerService.submitQuestionnaireMultipart
    >
  >;
export type QuestionnaireControllerServiceSendQuestionnaireReminderMutationResult =
  Awaited<
    ReturnType<typeof QuestionnaireControllerService.sendQuestionnaireReminder>
  >;
export type QuestionnaireControllerServiceSendQuestionnaireFax1MutationResult =
  Awaited<
    ReturnType<typeof QuestionnaireControllerService.sendQuestionnaireFax1>
  >;
export type QuestionnaireControllerServiceUploadPdfMutationResult = Awaited<
  ReturnType<typeof QuestionnaireControllerService.uploadPdf>
>;
export type QuestResultPushControllerServiceReceiveQuestResultMutationResult =
  Awaited<
    ReturnType<typeof QuestResultPushControllerService.receiveQuestResult>
  >;
export type QuestControllerServiceGetOrderDocumentMutationResult = Awaited<
  ReturnType<typeof QuestControllerService.getOrderDocument>
>;
export type Hl7ControllerServiceUpdateCompadiumMutationResult = Awaited<
  ReturnType<typeof Hl7ControllerService.updateCompadium>
>;
export type Hl7ControllerServiceSendOrderMutationResult = Awaited<
  ReturnType<typeof Hl7ControllerService.sendOrder>
>;
export type Hl7ControllerServiceSubmitToQuestMutationResult = Awaited<
  ReturnType<typeof Hl7ControllerService.submitToQuest>
>;
export type Hl7ControllerServiceTestOrderQuestMutationResult = Awaited<
  ReturnType<typeof Hl7ControllerService.testOrderQuest>
>;
export type Hl7ControllerServiceGetResultsMutationResult = Awaited<
  ReturnType<typeof Hl7ControllerService.getResults>
>;
export type PatientFormControllerServiceSendFormToPatientMutationResult =
  Awaited<ReturnType<typeof PatientFormControllerService.sendFormToPatient>>;
export type PatientFormControllerServiceSendMultipleFormsToPatientMutationResult =
  Awaited<
    ReturnType<typeof PatientFormControllerService.sendMultipleFormsToPatient>
  >;
export type PatientFormControllerServiceSendFormToBulkPatientsMutationResult =
  Awaited<
    ReturnType<typeof PatientFormControllerService.sendFormToBulkPatients>
  >;
export type DocumentControllerServiceUploadDocumentMutationResult = Awaited<
  ReturnType<typeof DocumentControllerService.uploadDocument>
>;
export type DocumentControllerServiceSaveDocumentMutationResult = Awaited<
  ReturnType<typeof DocumentControllerService.saveDocument>
>;
export type ContactDirectoryControllerServiceSaveContactDirectoryMutationResult =
  Awaited<
    ReturnType<typeof ContactDirectoryControllerService.saveContactDirectory>
  >;
export type AwsControllerServiceUploadImageAsMultipartMutationResult = Awaited<
  ReturnType<typeof AwsControllerService.uploadImageAsMultipart>
>;
export type AwsControllerServiceUploadImageAsBase64MutationResult = Awaited<
  ReturnType<typeof AwsControllerService.uploadImageAsBase64>
>;
export type AwsControllerServiceUploadDocumentAsMultipartMutationResult =
  Awaited<ReturnType<typeof AwsControllerService.uploadDocumentAsMultipart>>;
export type AwsControllerServiceUploadDocumentAsBase64MutationResult = Awaited<
  ReturnType<typeof AwsControllerService.uploadDocumentAsBase64>
>;
export type AgreementControllerServiceSubmitAgreementMultipartMutationResult =
  Awaited<
    ReturnType<typeof AgreementControllerService.submitAgreementMultipart>
  >;
export type AgreementControllerServiceCreateAffiliateAgreementMutationResult =
  Awaited<
    ReturnType<typeof AgreementControllerService.createAffiliateAgreement>
  >;
export type AgreementControllerServiceCreateMultipleAffiliateAgreementsMutationResult =
  Awaited<
    ReturnType<
      typeof AgreementControllerService.createMultipleAffiliateAgreements
    >
  >;
export type NotificationControllerServiceCreateNotificationMutationResult =
  Awaited<ReturnType<typeof NotificationControllerService.createNotification>>;
export type NotificationPreferenceControllerServiceAddNotificationPreferenceMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationPreferenceControllerService.addNotificationPreference
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS32MutationResult =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.uploadEmailStructureAndTemplateToS32
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceUpdateStatusMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.updateStatus
    >
  >;
export type PushNotificationControllerServiceSendFcmNotificationMutationResult =
  Awaited<
    ReturnType<typeof PushNotificationControllerService.sendFcmNotification>
  >;
export type PushNotificationControllerServiceSendFcmBulkNotificationMutationResult =
  Awaited<
    ReturnType<typeof PushNotificationControllerService.sendFcmBulkNotification>
  >;
export type NotificationSettingControllerServiceUpdateCustomNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.updateCustomNotification
    >
  >;
export type NotificationSettingControllerServiceSendEmailForSetPasswordMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForSetPassword
    >
  >;
export type NotificationSettingControllerServiceUploadEmailTemplateToS3MutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.uploadEmailTemplateToS3
    >
  >;
export type NotificationSettingControllerServiceUploadEmailStructureAndTemplateToS3MutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.uploadEmailStructureAndTemplateToS3
    >
  >;
export type NotificationSettingControllerServiceSendEmailForMutationResult =
  Awaited<ReturnType<typeof NotificationSettingControllerService.sendEmailFor>>;
export type NotificationSettingControllerServiceSendEmailForAddPaymentToPatientMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForAddPaymentToPatient
    >
  >;
export type NotificationSettingControllerServiceSendAddressChangeMailToPhpMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendAddressChangeMailToPhp
    >
  >;
export type NotificationSettingControllerServiceSendEmailForProviderSignupMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForProviderSignup
    >
  >;
export type NotificationSettingControllerServiceSendAppointmentJoinNotificationToPatientMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendAppointmentJoinNotificationToPatient
    >
  >;
export type NotificationSettingControllerServiceSendLabResultToPatientMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendLabResultToPatient
    >
  >;
export type NotificationSettingControllerServiceSendRetailEnrollmentNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendRetailEnrollmentNotification
    >
  >;
export type NotificationSettingControllerServiceSendRefundEmailMutationResult =
  Awaited<
    ReturnType<typeof NotificationSettingControllerService.sendRefundEmail>
  >;
export type NotificationSettingControllerServiceSendEmailForPatientBirthdayMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForPatientBirthday
    >
  >;
export type NotificationSettingControllerServiceSendUpcomingInvoiceNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendUpcomingInvoiceNotification
    >
  >;
export type NotificationSettingControllerServiceSendPatientNotificationEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendPatientNotificationEmail
    >
  >;
export type NotificationSettingControllerServiceSendPatientEnrollmentRequestNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendPatientEnrollmentRequestNotification
    >
  >;
export type NotificationSettingControllerServiceSendMultipleFormsEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendMultipleFormsEmail
    >
  >;
export type NotificationSettingControllerServiceSendMembershipPaidEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendMembershipPaidEmail
    >
  >;
export type NotificationSettingControllerServiceSendMembershipCreatedEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendMembershipCreatedEmail
    >
  >;
export type NotificationSettingControllerServiceSendLabResultReadyNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendLabResultReadyNotification
    >
  >;
export type NotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopayDisabledMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForInvoiceNotificationAutopayDisabled
    >
  >;
export type NotificationSettingControllerServiceSendEmailForInvoiceNotificationAutopayMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForInvoiceNotificationAutopay
    >
  >;
export type NotificationSettingControllerServiceSendEmailForInvoiceMutationResult =
  Awaited<
    ReturnType<typeof NotificationSettingControllerService.sendEmailForInvoice>
  >;
export type NotificationSettingControllerServiceSendEmailsForInvoiceNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailsForInvoiceNotification
    >
  >;
export type NotificationSettingControllerServiceSendFailedPaymentSummaryToAdminMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendFailedPaymentSummaryToAdmin
    >
  >;
export type NotificationSettingControllerServiceSendUpcomingInvoiceNotificationToEmployerMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendUpcomingInvoiceNotificationToEmployer
    >
  >;
export type NotificationSettingControllerServiceSendPatientPaidNotificationToEmployerMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendPatientPaidNotificationToEmployer
    >
  >;
export type NotificationSettingControllerServiceSendInvoiceIssuedNotificationToEmployerMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendInvoiceIssuedNotificationToEmployer
    >
  >;
export type NotificationSettingControllerServiceSendCreatedInvoiceNotificationToEmployerMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendCreatedInvoiceNotificationToEmployer
    >
  >;
export type NotificationSettingControllerServiceSendAutopayProcessedNotificationToEmployerMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendAutopayProcessedNotificationToEmployer
    >
  >;
export type NotificationSettingControllerServiceSendEmployerInvoiceCreationReminderNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmployerInvoiceCreationReminderNotification
    >
  >;
export type NotificationSettingControllerServiceSendEmailForChargePaidMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForChargePaid
    >
  >;
export type NotificationSettingControllerServiceSendEmailForCardExpiringSoonMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForCardExpiringSoon
    >
  >;
export type NotificationSettingControllerServiceSendCardSharedEmailMutationResult =
  Awaited<
    ReturnType<typeof NotificationSettingControllerService.sendCardSharedEmail>
  >;
export type NotificationSettingControllerServiceSendEmailForRemovalOfCardMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForRemovalOfCard
    >
  >;
export type NotificationSettingControllerServiceSendCardReceivedEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendCardReceivedEmail
    >
  >;
export type NotificationSettingControllerServiceSendCallInvitationNotificationMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendCallInvitationNotification
    >
  >;
export type NotificationSettingControllerServiceSendSignBrokerMutationResult =
  Awaited<
    ReturnType<typeof NotificationSettingControllerService.sendSignBroker>
  >;
export type NotificationSettingControllerServiceSendEmailForRemovalOfBankMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendEmailForRemovalOfBank
    >
  >;
export type NotificationSettingControllerServiceSendAppointmentEmailMutationResult =
  Awaited<
    ReturnType<typeof NotificationSettingControllerService.sendAppointmentEmail>
  >;
export type NotificationSettingControllerServiceSendAgentFirmAgreementCreatedEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendAgentFirmAgreementCreatedEmail
    >
  >;
export type NotificationSettingControllerServiceSendAffiliateAgreementCreatedEmailMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationSettingControllerService.sendAffiliateAgreementCreatedEmail
    >
  >;
export type SnsWebHookControllerServiceHandleSnsNotificationMutationResult =
  Awaited<ReturnType<typeof SnsWebHookControllerService.handleSnsNotification>>;
export type EmployerNotificationSettingControllerServiceUploadEmailStructureAndTemplateToS31MutationResult =
  Awaited<
    ReturnType<
      typeof EmployerNotificationSettingControllerService.uploadEmailStructureAndTemplateToS31
    >
  >;
export type EmailControllerServiceSendReferralEmailMutationResult = Awaited<
  ReturnType<typeof EmailControllerService.sendReferralEmail>
>;
export type EmailControllerServiceSendReferralEmailWithLinkMutationResult =
  Awaited<ReturnType<typeof EmailControllerService.sendReferralEmailWithLink>>;
export type EmailControllerServiceSendProviderReassignmentEmailsMutationResult =
  Awaited<
    ReturnType<typeof EmailControllerService.sendProviderReassignmentEmails>
  >;
export type EmailControllerServiceSendFormTemplateMutationResult = Awaited<
  ReturnType<typeof EmailControllerService.sendFormTemplate>
>;
export type EmailControllerServiceSendBulkEmailMutationResult = Awaited<
  ReturnType<typeof EmailControllerService.sendBulkEmail>
>;
export type EmailControllerServiceSendInvitationEmailMutationResult = Awaited<
  ReturnType<typeof EmailControllerService.sendInvitationEmail>
>;
export type StripControllerServiceCreatePromotionalCoupon1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.createPromotionalCoupon1>>;
export type StripControllerServiceHandleStripeWebhook1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.handleStripeWebhook1>
>;
export type StripControllerServiceCreateSubscription1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createSubscription1>
>;
export type StripControllerServiceCreateSubscriptionWithPayment1MutationResult =
  Awaited<
    ReturnType<typeof StripControllerService.createSubscriptionWithPayment1>
  >;
export type StripControllerServiceCreateSetupIntent1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createSetupIntent1>
>;
export type StripControllerServiceCreateSetupIntentWithCustomer1MutationResult =
  Awaited<
    ReturnType<typeof StripControllerService.createSetupIntentWithCustomer1>
  >;
export type StripControllerServiceSetDefaultPaymentMethod1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.setDefaultPaymentMethod1>>;
export type StripControllerServiceSaveCardToCustomerWithCharging1MutationResult =
  Awaited<
    ReturnType<typeof StripControllerService.saveCardToCustomerWithCharging1>
  >;
export type StripControllerServiceSaveCardToCustomer1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.saveCardToCustomer1>
>;
export type StripControllerServiceCreateProduct1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createProduct1>
>;
export type StripControllerServiceCreatePriceForProduct1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.createPriceForProduct1>>;
export type StripControllerServiceCreateProductAndPrice1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.createProductAndPrice1>>;
export type StripControllerServiceCreatePaymentIntent1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createPaymentIntent1>
>;
export type StripControllerServiceCreateCustomer1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createCustomer1>
>;
export type StripControllerServiceCreateCoupon1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.createCoupon1>
>;
export type TicketControllerServiceCreateTicketMutationResult = Awaited<
  ReturnType<typeof TicketControllerService.createTicket>
>;
export type TicketTaskControllerServiceCreateTicketTaskMutationResult = Awaited<
  ReturnType<typeof TicketTaskControllerService.createTicketTask>
>;
export type TicketNotesControllerServiceCreateTicketNotesMutationResult =
  Awaited<ReturnType<typeof TicketNotesControllerService.createTicketNotes>>;
export type TicketAttachmentControllerServiceAddAttachmentMutationResult =
  Awaited<ReturnType<typeof TicketAttachmentControllerService.addAttachment>>;
export type CrmTemplateControllerServiceAddTemplateMutationResult = Awaited<
  ReturnType<typeof CrmTemplateControllerService.addTemplate>
>;
export type CrmTaskControllerServiceCreateTaskMutationResult = Awaited<
  ReturnType<typeof CrmTaskControllerService.createTask>
>;
export type TaskLogControllerServiceCreateTaskLogMutationResult = Awaited<
  ReturnType<typeof TaskLogControllerService.createTaskLog>
>;
export type CrmNewsletterControllerServiceCreateNewsletterMutationResult =
  Awaited<ReturnType<typeof CrmNewsletterControllerService.createNewsletter>>;
export type CrmCampaignControllerServiceCreateCampaignMutationResult = Awaited<
  ReturnType<typeof CrmCampaignControllerService.createCampaign>
>;
export type CallLogsControllerServiceCreateCallLogMutationResult = Awaited<
  ReturnType<typeof CallLogsControllerService.createCallLog>
>;
export type TicketMergeControllerServiceMergeTicketMutationResult = Awaited<
  ReturnType<typeof TicketMergeControllerService.mergeTicket>
>;
export type TicketLinkedControllerServiceLinkTicketMutationResult = Awaited<
  ReturnType<typeof TicketLinkedControllerService.linkTicket>
>;
export type TicketConversationControllerServiceCreateConversationMutationResult =
  Awaited<
    ReturnType<typeof TicketConversationControllerService.createConversation>
  >;
export type MessageControllerServiceSendMessageMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.sendMessage>
>;
export type MessageControllerServiceSendScheduledMessageNowMutationResult =
  Awaited<ReturnType<typeof MessageControllerService.sendScheduledMessageNow>>;
export type MessageControllerServiceRemoveAttacmentMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.removeAttacment>
>;
export type VideoCallControllerServiceEndCallMutationResult = Awaited<
  ReturnType<typeof VideoCallControllerService.endCall>
>;
export type VideoCallControllerServiceDeclineCallMutationResult = Awaited<
  ReturnType<typeof VideoCallControllerService.declineCall>
>;
export type VideoCallControllerServiceCancelCallMutationResult = Awaited<
  ReturnType<typeof VideoCallControllerService.cancelCall>
>;
export type VideoCallControllerServiceAcceptCallMutationResult = Awaited<
  ReturnType<typeof VideoCallControllerService.acceptCall>
>;
export type VideoCallControllerServiceStartCallMutationResult = Awaited<
  ReturnType<typeof VideoCallControllerService.startCall>
>;
export type TwilioVoiceWebhookControllerServiceOutboundDialMutationResult =
  Awaited<ReturnType<typeof TwilioVoiceWebhookControllerService.outboundDial>>;
export type TwilioVoiceWebhookControllerServiceInboundCallMutationResult =
  Awaited<ReturnType<typeof TwilioVoiceWebhookControllerService.inboundCall>>;
export type TwilioVoiceWebhookControllerServiceDialActionMutationResult =
  Awaited<ReturnType<typeof TwilioVoiceWebhookControllerService.dialAction>>;
export type TwilioVoiceWebhookControllerServiceAppDialMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceWebhookControllerService.appDial>
>;
export type TwilioVoiceWebhookControllerServiceRecordingsMutationResult =
  Awaited<ReturnType<typeof TwilioVoiceWebhookControllerService.recordings>>;
export type TwilioVoiceWebhookControllerServiceEventsMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceWebhookControllerService.events>
>;
export type TwilioVoiceControllerServiceIssueTokenMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.issueToken>
>;
export type TwilioVoiceControllerServicePlaceCallMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.placeCall>
>;
export type TwilioVoiceControllerServiceHangUpMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.hangUp>
>;
export type TwilioControllerServiceInboundSmsMutationResult = Awaited<
  ReturnType<typeof TwilioControllerService.inboundSms>
>;
export type TwilioControllerServiceSendSmsMutationResult = Awaited<
  ReturnType<typeof TwilioControllerService.sendSms>
>;
export type TwilioControllerServiceSendGenericSmsMutationResult = Awaited<
  ReturnType<typeof TwilioControllerService.sendGenericSms>
>;
export type ThreadControllerServiceCreateThreadMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.createThread>
>;
export type ThreadControllerServiceResumeThreadMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.resumeThread>
>;
export type ThreadControllerServiceBroadcastThreadListUpdateMutationResult =
  Awaited<ReturnType<typeof ThreadControllerService.broadcastThreadListUpdate>>;
export type ThreadControllerServiceBroadcastThreadSummariesMutationResult =
  Awaited<ReturnType<typeof ThreadControllerService.broadcastThreadSummaries>>;
export type ThreadControllerServiceRouteThreadMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.routeThread>
>;
export type ThreadControllerServiceCreateOpenThreadMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.createOpenThread>
>;
export type RealtimeControllerServiceBroadcastMutationResult = Awaited<
  ReturnType<typeof RealtimeControllerService.broadcast>
>;
export type BookmarkControllerServiceBookmarkThreadMutationResult = Awaited<
  ReturnType<typeof BookmarkControllerService.bookmarkThread>
>;
export type BookmarkControllerServiceBookmarkMessageMutationResult = Awaited<
  ReturnType<typeof BookmarkControllerService.bookmarkMessage>
>;
export type UserControllerServiceUpdateUserArchiveStatusMutationResult =
  Awaited<ReturnType<typeof UserControllerService.updateUserArchiveStatus>>;
export type UserControllerServiceBulkUpdateUserStatusMutationResult = Awaited<
  ReturnType<typeof UserControllerService.bulkUpdateUserStatus>
>;
export type UserControllerServiceUpdateUserMutationResult = Awaited<
  ReturnType<typeof UserControllerService.updateUser>
>;
export type UserControllerServiceUpdateUserStatusMutationResult = Awaited<
  ReturnType<typeof UserControllerService.updateUserStatus>
>;
export type UserControllerServiceSyncDeviceTokenMutationResult = Awaited<
  ReturnType<typeof UserControllerService.syncDeviceToken>
>;
export type UserControllerServiceRevokeDeviceTokenMutationResult = Awaited<
  ReturnType<typeof UserControllerService.revokeDeviceToken>
>;
export type UserControllerServiceResetPasswordMutationResult = Awaited<
  ReturnType<typeof UserControllerService.resetPassword>
>;
export type UserControllerServiceSwitchLastLoggedInLocationMutationResult =
  Awaited<ReturnType<typeof UserControllerService.switchLastLoggedInLocation>>;
export type UserControllerServiceUpdateProfileDetailsOfUserMutationResult =
  Awaited<ReturnType<typeof UserControllerService.updateProfileDetailsOfUser>>;
export type UserControllerServiceCheckUsernameMutationResult = Awaited<
  ReturnType<typeof UserControllerService.checkUsername>
>;
export type EmployeeUploadControllerServiceProcessUploadMutationResult =
  Awaited<ReturnType<typeof EmployeeUploadControllerService.processUpload>>;
export type StripeControllerServiceUpdateSubscriptionMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.updateSubscription>
>;
export type StripeControllerServiceChangePlanMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.changePlan>
>;
export type StripeControllerServiceChangePlanWithProrationMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.changePlanWithProration>>;
export type StripeControllerServiceUpdatePromotionalCouponMutationResult =
  Awaited<ReturnType<typeof StripeControllerService.updatePromotionalCoupon>>;
export type ScriptSureControllerServiceUpdateScriptSurePatientMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.updateScriptSurePatient>
  >;
export type ScriptSureControllerServiceUpdateAllergyMutationResult = Awaited<
  ReturnType<typeof ScriptSureControllerService.updateAllergy>
>;
export type ScriptSureControllerServiceArchiveAllergyMutationResult = Awaited<
  ReturnType<typeof ScriptSureControllerService.archiveAllergy>
>;
export type SavedCardControllerServiceUpdateSavedCardByUuidMutationResult =
  Awaited<ReturnType<typeof SavedCardControllerService.updateSavedCardByUuid>>;
export type SavedCardControllerServiceSetAutopaySavedCardByUuidMutationResult =
  Awaited<
    ReturnType<typeof SavedCardControllerService.setAutopaySavedCardByUuid>
  >;
export type SavedBankControllerServiceSetAutopaySavedBankByUuidMutationResult =
  Awaited<
    ReturnType<typeof SavedBankControllerService.setAutopaySavedBankByUuid>
  >;
export type SalesTaxProfileControllerServiceUpdateSalesTaxProfileByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof SalesTaxProfileControllerService.updateSalesTaxProfileByUuid
    >
  >;
export type SalesTaxJurisdictionControllerServiceUpdateSalesTaxJurisdictionByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof SalesTaxJurisdictionControllerService.updateSalesTaxJurisdictionByUuid
    >
  >;
export type RolesAndPermissionControllerServiceUpdatePermissionsOfRoleMutationResult =
  Awaited<
    ReturnType<
      typeof RolesAndPermissionControllerService.updatePermissionsOfRole
    >
  >;
export type RoleTypeManagementControllerServiceUpdateRoleTypeMutationResult =
  Awaited<
    ReturnType<typeof RoleTypeManagementControllerService.updateRoleType>
  >;
export type RoleTypeFeatureManagementControllerServiceUpdateRoleTypeFeatureMutationResult =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.updateRoleTypeFeature
    >
  >;
export type ProviderControllerServiceUpdateProviderMutationResult = Awaited<
  ReturnType<typeof ProviderControllerService.updateProvider>
>;
export type ProviderControllerServiceAssignedNewProviderMutationResult =
  Awaited<ReturnType<typeof ProviderControllerService.assignedNewProvider>>;
export type PlanControllerServiceUpdatePlanMutationResult = Awaited<
  ReturnType<typeof PlanControllerService.updatePlan>
>;
export type PlanControllerServiceUpdatePlanDetailsMutationResult = Awaited<
  ReturnType<typeof PlanControllerService.updatePlanDetails>
>;
export type PaymentTransactionControllerServiceUpdatePaymentTransactionMutationResult =
  Awaited<
    ReturnType<
      typeof PaymentTransactionControllerService.updatePaymentTransaction
    >
  >;
export type PatientControllerServiceUpdatePatientMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.updatePatient>
>;
export type PatientControllerServiceUnEnrollPatientMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.unEnrollPatient>
>;
export type PatientControllerServicePatientCreateUpdateMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.patientCreateUpdate>
>;
export type PatientControllerServiceEndMembershipForPatientAndDependentsMutationResult =
  Awaited<
    ReturnType<
      typeof PatientControllerService.endMembershipForPatientAndDependents
    >
  >;
export type PatientControllerServiceEditDependentMembershipDetailsMutationResult =
  Awaited<
    ReturnType<typeof PatientControllerService.editDependentMembershipDetails>
  >;
export type PatientControllerServiceCreateUpdatePatientMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.createUpdatePatient>
>;
export type PatientModuleControllerServiceUpdateMutationResult = Awaited<
  ReturnType<typeof PatientModuleControllerService.update>
>;
export type PatientModuleAccessControllerServiceUpdate1MutationResult = Awaited<
  ReturnType<typeof PatientModuleAccessControllerService.update1>
>;
export type PatientInformationControllerServiceUpdate2MutationResult = Awaited<
  ReturnType<typeof PatientInformationControllerService.update2>
>;
export type NurseStaffProviderControllerServiceUpdateNurseStaffProviderMutationResult =
  Awaited<
    ReturnType<
      typeof NurseStaffProviderControllerService.updateNurseStaffProvider
    >
  >;
export type LeadControllerServiceUpdateLeadMutationResult = Awaited<
  ReturnType<typeof LeadControllerService.updateLead>
>;
export type LeadControllerServiceCreateUpdateLeadMutationResult = Awaited<
  ReturnType<typeof LeadControllerService.createUpdateLead>
>;
export type InvoiceSettingControllerServiceUpdateInvoiceSettingMutationResult =
  Awaited<
    ReturnType<typeof InvoiceSettingControllerService.updateInvoiceSetting>
  >;
export type InvoiceSettingControllerServiceToggleEmailNotificationMutationResult =
  Awaited<
    ReturnType<typeof InvoiceSettingControllerService.toggleEmailNotification>
  >;
export type FeatureManagementControllerServiceUpdateFeatureMutationResult =
  Awaited<ReturnType<typeof FeatureManagementControllerService.updateFeature>>;
export type FaxControllerServiceUpdateFaxDocumentMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.updateFaxDocument>
>;
export type FaceSheetLayoutControllerServiceSaveLayoutMutationResult = Awaited<
  ReturnType<typeof FaceSheetLayoutControllerService.saveLayout>
>;
export type EmployerControllerServiceUpdateEmployerMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.updateEmployer>
>;
export type EmployerControllerServiceSavePricingDetailsMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.savePricingDetails>
>;
export type EmployerControllerServiceSaveOnlineSignUpMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.saveOnlineSignUp>
>;
export type EmployerControllerServiceSaveAccountDetailsMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.saveAccountDetails>
>;
export type EmployerPageControllerServiceUpdateEmployerPageMutationResult =
  Awaited<ReturnType<typeof EmployerPageControllerService.updateEmployerPage>>;
export type EmployerDivisionControllerServiceUpdateEmployerDivisionMutationResult =
  Awaited<
    ReturnType<typeof EmployerDivisionControllerService.updateEmployerDivision>
  >;
export type EmployerAdministratorControllerServiceUpdateEmployerAdministratorMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerAdministratorControllerService.updateEmployerAdministrator
    >
  >;
export type CreditControllerServiceUpdateCreditMutationResult = Awaited<
  ReturnType<typeof CreditControllerService.updateCredit>
>;
export type CoverageRuleControllerServiceUpdateCoverageRuleMutationResult =
  Awaited<ReturnType<typeof CoverageRuleControllerService.updateCoverageRule>>;
export type CoveragePlanControllerServiceUpdateCoveragePlanMutationResult =
  Awaited<ReturnType<typeof CoveragePlanControllerService.updateCoveragePlan>>;
export type CouponControllerServiceUpdateCouponMutationResult = Awaited<
  ReturnType<typeof CouponControllerService.updateCoupon>
>;
export type ChargeItemControllerServiceUpdateChargeItemByUuidMutationResult =
  Awaited<
    ReturnType<typeof ChargeItemControllerService.updateChargeItemByUuid>
  >;
export type ChargeCategoryControllerServiceUpdateChargeCategoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof ChargeCategoryControllerService.updateChargeCategoryByUuid
    >
  >;
export type CancellationControllerServiceUpdateCancellationMutationResult =
  Awaited<ReturnType<typeof CancellationControllerService.updateCancellation>>;
export type CancellationControllerServiceArchiveAndUnarchiveCancellationByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof CancellationControllerService.archiveAndUnarchiveCancellationByUuid
    >
  >;
export type BrokerControllerServiceUpdateBrokerMutationResult = Awaited<
  ReturnType<typeof BrokerControllerService.updateBroker>
>;
export type BreakGlassControllerServiceUpdate3MutationResult = Awaited<
  ReturnType<typeof BreakGlassControllerService.update3>
>;
export type AncillaryServiceChargesControllerServiceUpdateAncillaryServiceChargesMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updateAncillaryServiceCharges
    >
  >;
export type AncillaryServiceChargesControllerServiceUpdateMiscellaneousServiceChargeByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.updateMiscellaneousServiceChargeByUuid
    >
  >;
export type AgentFirmControllerServiceUpdateAgentFirmMutationResult = Awaited<
  ReturnType<typeof AgentFirmControllerService.updateAgentFirm>
>;
export type AgentDealControllerServiceUpdateAgentDealMutationResult = Awaited<
  ReturnType<typeof AgentDealControllerService.updateAgentDeal>
>;
export type AffiliateGroupControllerServiceUpdateAffiliateMutationResult =
  Awaited<ReturnType<typeof AffiliateGroupControllerService.updateAffiliate>>;
export type AffiliateGroupControllerServiceUpdateAffiliateUserMutationResult =
  Awaited<
    ReturnType<typeof AffiliateGroupControllerService.updateAffiliateUser>
  >;
export type AffiliateGroupControllerServiceMarkAffiliateUserAsPrimaryMutationResult =
  Awaited<
    ReturnType<
      typeof AffiliateGroupControllerService.markAffiliateUserAsPrimary
    >
  >;
export type AdminUserControllerServiceUpdateAdminUserByUuidMutationResult =
  Awaited<ReturnType<typeof AdminUserControllerService.updateAdminUserByUuid>>;
export type AdminUserControllerServiceActiveAdminUserByUuidMutationResult =
  Awaited<ReturnType<typeof AdminUserControllerService.activeAdminUserByUuid>>;
export type WorkNoteControllerServiceUpdateWorkNoteMutationResult = Awaited<
  ReturnType<typeof WorkNoteControllerService.updateWorkNote>
>;
export type VitalControllerServiceUpdateVitalMutationResult = Awaited<
  ReturnType<typeof VitalControllerService.updateVital>
>;
export type VaccineControllerServiceUpdateVaccineMutationResult = Awaited<
  ReturnType<typeof VaccineControllerService.updateVaccine>
>;
export type TaskControllerServiceUpdateTaskMutationResult = Awaited<
  ReturnType<typeof TaskControllerService.updateTask>
>;
export type StatusConfigurationControllerServiceUpdateStatusConfigurationMutationResult =
  Awaited<
    ReturnType<
      typeof StatusConfigurationControllerService.updateStatusConfiguration
    >
  >;
export type SocialHistoryControllerServiceUpdateSocialHistoryMutationResult =
  Awaited<
    ReturnType<typeof SocialHistoryControllerService.updateSocialHistory>
  >;
export type SoapNoteControllerServiceUpdateSoapNoteMutationResult = Awaited<
  ReturnType<typeof SoapNoteControllerService.updateSoapNote>
>;
export type SoapNoteTemplateControllerServiceUpdateSoapNoteTemplateMutationResult =
  Awaited<
    ReturnType<typeof SoapNoteTemplateControllerService.updateSoapNoteTemplate>
  >;
export type ScreenHistoryControllerServiceUpdateScreenHistoryMutationResult =
  Awaited<
    ReturnType<typeof ScreenHistoryControllerService.updateScreenHistory>
  >;
export type ReviewOfSystemTemplateControllerServiceUpdateReviewOfSystemTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof ReviewOfSystemTemplateControllerService.updateReviewOfSystemTemplate
    >
  >;
export type ReviewOfSystemControllerServiceUpdateReviewOfSystemMutationResult =
  Awaited<
    ReturnType<typeof ReviewOfSystemControllerService.updateReviewOfSystem>
  >;
export type ReferralControllerServiceUpdateReferralByUuidMutationResult =
  Awaited<ReturnType<typeof ReferralControllerService.updateReferralByUuid>>;
export type ProviderDirectoryControllerServiceUpdateProviderDirectoryMutationResult =
  Awaited<
    ReturnType<
      typeof ProviderDirectoryControllerService.updateProviderDirectory
    >
  >;
export type PointsOfCareLabControllerServiceUpdatePointOfCareLabMutationResult =
  Awaited<
    ReturnType<typeof PointsOfCareLabControllerService.updatePointOfCareLab>
  >;
export type PocLabTestControllerServiceUpdatePocLabTestMutationResult = Awaited<
  ReturnType<typeof PocLabTestControllerService.updatePocLabTest>
>;
export type PocLabResultControllerServiceUpdatePocLabResultMutationResult =
  Awaited<ReturnType<typeof PocLabResultControllerService.updatePocLabResult>>;
export type PhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.updatePhysicalExamTemplate
    >
  >;
export type PhysicalExamControllerServiceUpdatePhysicalExamMutationResult =
  Awaited<ReturnType<typeof PhysicalExamControllerService.updatePhysicalExam>>;
export type PharmacyControllerServiceUpdatePharmacyMutationResult = Awaited<
  ReturnType<typeof PharmacyControllerService.updatePharmacy>
>;
export type PatientVaccinationControllerServiceUpdatePatientVaccinationMutationResult =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.updatePatientVaccination
    >
  >;
export type PatientFlagControllerServiceUpdatePatientFlagMutationResult =
  Awaited<ReturnType<typeof PatientFlagControllerService.updatePatientFlag>>;
export type PastSurgicalHistoryControllerServiceUpdatePastSurgicalHistoryMutationResult =
  Awaited<
    ReturnType<
      typeof PastSurgicalHistoryControllerService.updatePastSurgicalHistory
    >
  >;
export type PastMedicalHistoryControllerServiceUpdatePastMedicalHistoryMutationResult =
  Awaited<
    ReturnType<
      typeof PastMedicalHistoryControllerService.updatePastMedicalHistory
    >
  >;
export type NoteControllerServiceUpdateNoteByUuidMutationResult = Awaited<
  ReturnType<typeof NoteControllerService.updateNoteByUuid>
>;
export type MedicationControllerServiceUpdateMedicationByUuidMutationResult =
  Awaited<
    ReturnType<typeof MedicationControllerService.updateMedicationByUuid>
  >;
export type MacroControllerServiceUpdateMacroMutationResult = Awaited<
  ReturnType<typeof MacroControllerService.updateMacro>
>;
export type LocationControllerServiceUpdateLocationMutationResult = Awaited<
  ReturnType<typeof LocationControllerService.updateLocation>
>;
export type LocationShareableSettingControllerServiceUpdateSingleToggleMutationResult =
  Awaited<
    ReturnType<
      typeof LocationShareableSettingControllerService.updateSingleToggle
    >
  >;
export type LocationGroupControllerServiceUpdateLocationGroupMutationResult =
  Awaited<
    ReturnType<typeof LocationGroupControllerService.updateLocationGroup>
  >;
export type LocationAvailabilityControllerServiceUpdateLocationAvailabilityMutationResult =
  Awaited<
    ReturnType<
      typeof LocationAvailabilityControllerService.updateLocationAvailability
    >
  >;
export type PatientLinkPharmacyControllerServiceSetDefaultPharmacyMutationResult =
  Awaited<
    ReturnType<typeof PatientLinkPharmacyControllerService.setDefaultPharmacy>
  >;
export type LabTestControllerServiceUpdateLabTestMutationResult = Awaited<
  ReturnType<typeof LabTestControllerService.updateLabTest>
>;
export type LabResultControllerServiceApproveLabResultMutationResult = Awaited<
  ReturnType<typeof LabResultControllerService.approveLabResult>
>;
export type LabOrderControllerServiceUpdateLabOrderMutationResult = Awaited<
  ReturnType<typeof LabOrderControllerService.updateLabOrder>
>;
export type LabOrderSetControllerServiceUpdateLabOrderSetMutationResult =
  Awaited<ReturnType<typeof LabOrderSetControllerService.updateLabOrderSet>>;
export type InvoiceControllerServiceUpdateInvoiceByUuidMutationResult = Awaited<
  ReturnType<typeof InvoiceControllerService.updateInvoiceByUuid>
>;
export type InsuranceControllerServiceUpdateInsuranceMutationResult = Awaited<
  ReturnType<typeof InsuranceControllerService.updateInsurance>
>;
export type ImagingResultControllerServiceUpdateImagingResultMutationResult =
  Awaited<
    ReturnType<typeof ImagingResultControllerService.updateImagingResult>
  >;
export type ImagingOrderControllerServiceUpdateImagingOrderMutationResult =
  Awaited<ReturnType<typeof ImagingOrderControllerService.updateImagingOrder>>;
export type IcdCodeControllerServiceUpdateIcdCodeMutationResult = Awaited<
  ReturnType<typeof IcdCodeControllerService.updateIcdCode>
>;
export type HAndPNoteControllerServiceUpdateHandPnoteMutationResult = Awaited<
  ReturnType<typeof HAndPNoteControllerService.updateHandPnote>
>;
export type HabitsControllerServiceUpdateHabitsMutationResult = Awaited<
  ReturnType<typeof HabitsControllerService.updateHabits>
>;
export type GlobalHolidayControllerServiceUpdateGlobalHolidayMutationResult =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.updateGlobalHoliday>
  >;
export type FormTemplateControllerServiceUpdateFormTemplateMutationResult =
  Awaited<ReturnType<typeof FormTemplateControllerService.updateFormTemplate>>;
export type FormTemplateControllerServiceSetFormAsDefaultMutationResult =
  Awaited<ReturnType<typeof FormTemplateControllerService.setFormAsDefault>>;
export type FormTemplateControllerServiceUpdateFormTemplateWithPdfMutationResult =
  Awaited<
    ReturnType<typeof FormTemplateControllerService.updateFormTemplateWithPdf>
  >;
export type FdbMedicationsControllerServiceUpdateFdbMedicationMutationResult =
  Awaited<
    ReturnType<typeof FdbMedicationsControllerService.updateFdbMedication>
  >;
export type FamilyHistoryControllerServiceUpdateFamilyHistoryMutationResult =
  Awaited<
    ReturnType<typeof FamilyHistoryControllerService.updateFamilyHistory>
  >;
export type EducationalMaterialControllerServiceUpdateEducationalMaterialMutationResult =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.updateEducationalMaterial
    >
  >;
export type DrugIntoleranceControllerServiceUpdateDrugIntoleranceMutationResult =
  Awaited<
    ReturnType<typeof DrugIntoleranceControllerService.updateDrugIntolerance>
  >;
export type DocumentTypeControllerServiceUpdateDocumentTypeMutationResult =
  Awaited<ReturnType<typeof DocumentTypeControllerService.updateDocumentType>>;
export type DiagnosisControllerServiceUpdateDiagnosisMutationResult = Awaited<
  ReturnType<typeof DiagnosisControllerService.updateDiagnosis>
>;
export type CptCodeControllerServiceUpdateIcdCode1MutationResult = Awaited<
  ReturnType<typeof CptCodeControllerService.updateIcdCode1>
>;
export type CommentControllerServiceUpdateMessageMutationResult = Awaited<
  ReturnType<typeof CommentControllerService.updateMessage>
>;
export type CarePlanControllerServiceUpdateCarePlanByUuidMutationResult =
  Awaited<ReturnType<typeof CarePlanControllerService.updateCarePlanByUuid>>;
export type AvailabilityControllerServiceUpdateAvailabilityMutationResult =
  Awaited<ReturnType<typeof AvailabilityControllerService.updateAvailability>>;
export type AvailabilityControllerServiceCreateAvailabilityForDateMutationResult =
  Awaited<
    ReturnType<typeof AvailabilityControllerService.createAvailabilityForDate>
  >;
export type AppointmentControllerServiceUpdateAppointmentMutationResult =
  Awaited<ReturnType<typeof AppointmentControllerService.updateAppointment>>;
export type AppointmentControllerServiceCancelAppointmentByUuidMutationResult =
  Awaited<
    ReturnType<typeof AppointmentControllerService.cancelAppointmentByUuid>
  >;
export type AppointmentTypeControllerServiceUpdateAppointmentTypeMutationResult =
  Awaited<
    ReturnType<typeof AppointmentTypeControllerService.updateAppointmentType>
  >;
export type AnnotableImageControllerServiceUpdateAnnotableImageMutationResult =
  Awaited<
    ReturnType<typeof AnnotableImageControllerService.updateAnnotableImage>
  >;
export type AnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.updateAnnotableImageTemplate
    >
  >;
export type AnnotableImagePinControllerServiceUpdateAnnotableImagePinMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImagePinControllerService.updateAnnotableImagePin
    >
  >;
export type AllergyControllerServiceUpdateAllergy1MutationResult = Awaited<
  ReturnType<typeof AllergyControllerService.updateAllergy1>
>;
export type NotificationControllerServiceMarkAsReadMutationResult = Awaited<
  ReturnType<typeof NotificationControllerService.markAsRead>
>;
export type NotificationPreferenceControllerServiceUpdateNotificationPreferenceMutationResult =
  Awaited<
    ReturnType<
      typeof NotificationPreferenceControllerService.updateNotificationPreference
    >
  >;
export type EmployerManagementNotificationSettingControllerServiceUpdateSingleToggle1MutationResult =
  Awaited<
    ReturnType<
      typeof EmployerManagementNotificationSettingControllerService.updateSingleToggle1
    >
  >;
export type StripControllerServiceUpdateSubscription1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.updateSubscription1>
>;
export type StripControllerServiceChangePlan1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.changePlan1>
>;
export type StripControllerServiceChangePlanWithProration1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.changePlanWithProration1>>;
export type StripControllerServiceUpdatePromotionalCoupon1MutationResult =
  Awaited<ReturnType<typeof StripControllerService.updatePromotionalCoupon1>>;
export type TicketControllerServiceUpdateTicketMutationResult = Awaited<
  ReturnType<typeof TicketControllerService.updateTicket>
>;
export type TicketControllerServiceUpdateTicketPriorityMutationResult = Awaited<
  ReturnType<typeof TicketControllerService.updateTicketPriority>
>;
export type TicketControllerServiceUpdateTicketStatusMutationResult = Awaited<
  ReturnType<typeof TicketControllerService.updateTicketStatus>
>;
export type TicketTaskControllerServiceUpdateTicketTaskMutationResult = Awaited<
  ReturnType<typeof TicketTaskControllerService.updateTicketTask>
>;
export type TicketTaskControllerServiceUpdateTicketTaskStatusMutationResult =
  Awaited<
    ReturnType<typeof TicketTaskControllerService.updateTicketTaskStatus>
  >;
export type TicketTaskControllerServiceUpdateTicketTaskPriorityMutationResult =
  Awaited<
    ReturnType<typeof TicketTaskControllerService.updateTicketTaskPriority>
  >;
export type TicketTaskControllerServiceUpdateTicketTaskAssigneeMutationResult =
  Awaited<
    ReturnType<typeof TicketTaskControllerService.updateTicketTaskAssignee>
  >;
export type TicketNotesControllerServiceUpdateTicketNotesMutationResult =
  Awaited<ReturnType<typeof TicketNotesControllerService.updateTicketNotes>>;
export type TicketAttachmentControllerServiceUpdateAttachmentMutationResult =
  Awaited<
    ReturnType<typeof TicketAttachmentControllerService.updateAttachment>
  >;
export type CrmTemplateControllerServiceUpdateTemplateMutationResult = Awaited<
  ReturnType<typeof CrmTemplateControllerService.updateTemplate>
>;
export type CrmTaskControllerServiceUpdateCrmTaskMutationResult = Awaited<
  ReturnType<typeof CrmTaskControllerService.updateCrmTask>
>;
export type CrmTaskControllerServiceUpdateTaskPriorityMutationResult = Awaited<
  ReturnType<typeof CrmTaskControllerService.updateTaskPriority>
>;
export type TaskLogControllerServiceUpdateTaskLogMutationResult = Awaited<
  ReturnType<typeof TaskLogControllerService.updateTaskLog>
>;
export type CrmNewsletterControllerServiceUpdateNewsletterMutationResult =
  Awaited<ReturnType<typeof CrmNewsletterControllerService.updateNewsletter>>;
export type CrmCampaignControllerServiceUpdateCampaignMutationResult = Awaited<
  ReturnType<typeof CrmCampaignControllerService.updateCampaign>
>;
export type CallLogsControllerServiceUpdateCallLogMutationResult = Awaited<
  ReturnType<typeof CallLogsControllerService.updateCallLog>
>;
export type MessageControllerServiceMarkMessageUrgentMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.markMessageUrgent>
>;
export type MessageControllerServiceMarkMessageReadByUserMutationResult =
  Awaited<ReturnType<typeof MessageControllerService.markMessageReadByUser>>;
export type MessageControllerServiceCancelScheduledMessageMutationResult =
  Awaited<ReturnType<typeof MessageControllerService.cancelScheduledMessage>>;
export type MessageControllerServiceMarkAllMessagesReadInThreadMutationResult =
  Awaited<
    ReturnType<typeof MessageControllerService.markAllMessagesReadInThread>
  >;
export type MessageControllerServiceMarkAllMessagesReadInThreadForUserMutationResult =
  Awaited<
    ReturnType<
      typeof MessageControllerService.markAllMessagesReadInThreadForUser
    >
  >;
export type MessageControllerServiceRescheduleMessageMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.rescheduleMessage>
>;
export type MessageControllerServiceEditScheduledMessageMutationResult =
  Awaited<ReturnType<typeof MessageControllerService.editScheduledMessage>>;
export type MessageControllerServiceRemoveMessageUrgentMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.removeMessageUrgent>
>;
export type EmployeeUploadControllerServiceSetReviewedMutationResult = Awaited<
  ReturnType<typeof EmployeeUploadControllerService.setReviewed>
>;
export type EmployeeUploadControllerServiceUpdateMuteStatusMutationResult =
  Awaited<ReturnType<typeof EmployeeUploadControllerService.updateMuteStatus>>;
export type SavedBankControllerServiceUpdateAutopaySavedBankMutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.updateAutopaySavedBank>>;
export type RolesAndPermissionControllerServiceUpdateRoleNameMutationResult =
  Awaited<
    ReturnType<typeof RolesAndPermissionControllerService.updateRoleName>
  >;
export type ProviderControllerServiceUpdatePatientEntrollmentByProviderUuidMutationResult =
  Awaited<
    ReturnType<
      typeof ProviderControllerService.updatePatientEntrollmentByProviderUuid
    >
  >;
export type ProviderControllerServiceUpdateProviderStatusMutationResult =
  Awaited<ReturnType<typeof ProviderControllerService.updateProviderStatus>>;
export type PatientControllerServiceSetPatientPortalAccessMutationResult =
  Awaited<ReturnType<typeof PatientControllerService.setPatientPortalAccess>>;
export type PatientControllerServiceUpdatePatientStatusMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.updatePatientStatus>
>;
export type PatientControllerServiceMakePrimaryMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.makePrimary>
>;
export type PatientControllerServiceSetPatientPrimaryProviderMutationResult =
  Awaited<
    ReturnType<typeof PatientControllerService.setPatientPrimaryProvider>
  >;
export type PatientControllerServiceSetSendSmsMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.setSendSms>
>;
export type PatientControllerServiceRemovePreEngageMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.removePreEngage>
>;
export type PatientControllerServiceSetReEnrollmentMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.setReEnrollment>
>;
export type PatientControllerServiceAddExistingPatientAsDependentMutationResult =
  Awaited<
    ReturnType<typeof PatientControllerService.addExistingPatientAsDependent>
  >;
export type PatientControllerServiceChangeBillingDateMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.changeBillingDate>
>;
export type NurseStaffProviderControllerServiceUpdateNurseStaffProviderStatusMutationResult =
  Awaited<
    ReturnType<
      typeof NurseStaffProviderControllerService.updateNurseStaffProviderStatus
    >
  >;
export type EmployerControllerServiceUpdateEmployerStatusMutationResult =
  Awaited<ReturnType<typeof EmployerControllerService.updateEmployerStatus>>;
export type BrokerControllerServiceUpdateBrokerStatusMutationResult = Awaited<
  ReturnType<typeof BrokerControllerService.updateBrokerStatus>
>;
export type AgentDealControllerServiceEndAgentDealMutationResult = Awaited<
  ReturnType<typeof AgentDealControllerService.endAgentDeal>
>;
export type AgentDealControllerServiceEndAllDealsByAgentFirmMutationResult =
  Awaited<ReturnType<typeof AgentDealControllerService.endAllDealsByAgentFirm>>;
export type SupervisingProviderRequestControllerServiceDenyMutationResult =
  Awaited<ReturnType<typeof SupervisingProviderRequestControllerService.deny>>;
export type SupervisingProviderRequestControllerServiceApproveMutationResult =
  Awaited<
    ReturnType<typeof SupervisingProviderRequestControllerService.approve>
  >;
export type ProviderCoverageControllerServiceRevokeMutationResult = Awaited<
  ReturnType<typeof ProviderCoverageControllerService.revoke>
>;
export type ProviderCoverageControllerServiceDeny1MutationResult = Awaited<
  ReturnType<typeof ProviderCoverageControllerService.deny1>
>;
export type ProviderCoverageControllerServiceApprove1MutationResult = Awaited<
  ReturnType<typeof ProviderCoverageControllerService.approve1>
>;
export type ProviderCoverageControllerServiceUpdateUrgentMessageAlertMutationResult =
  Awaited<
    ReturnType<
      typeof ProviderCoverageControllerService.updateUrgentMessageAlert
    >
  >;
export type ProviderCoverageControllerServiceExpireEndedCoveragesMutationResult =
  Awaited<
    ReturnType<typeof ProviderCoverageControllerService.expireEndedCoverages>
  >;
export type InventoryOrderControllerServiceUpdateInventoryMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.updateInventory>>;
export type InventoryOrderControllerServiceUpdateFormularyMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.updateFormulary>>;
export type InventoryOrderControllerServiceUpdateAutoShipMutationResult =
  Awaited<ReturnType<typeof InventoryOrderControllerService.updateAutoShip>>;
export type GoogleMapsControllerServiceUpdateShareLinkMutationResult = Awaited<
  ReturnType<typeof GoogleMapsControllerService.updateShareLink>
>;
export type CartControllerServiceUpdateQuantityMutationResult = Awaited<
  ReturnType<typeof CartControllerService.updateQuantity>
>;
export type SoapNoteControllerServiceUpdatePreEngagedStatusMutationResult =
  Awaited<ReturnType<typeof SoapNoteControllerService.updatePreEngagedStatus>>;
export type SoapNoteTemplateControllerServiceUpdateSoapNoteTemplateBookmarkMutationResult =
  Awaited<
    ReturnType<
      typeof SoapNoteTemplateControllerService.updateSoapNoteTemplateBookmark
    >
  >;
export type ReviewOfSystemTemplateControllerServiceUpdateRosBookmarkMutationResult =
  Awaited<
    ReturnType<typeof ReviewOfSystemTemplateControllerService.updateRosBookmark>
  >;
export type PhysicalExamTemplateControllerServiceUpdatePhysicalExamTemplateBookmarkMutationResult =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.updatePhysicalExamTemplateBookmark
    >
  >;
export type NoteControllerServiceUpdateNoteFlagMutationResult = Awaited<
  ReturnType<typeof NoteControllerService.updateNoteFlag>
>;
export type MacroControllerServiceUpdateMacroBookmarkMutationResult = Awaited<
  ReturnType<typeof MacroControllerService.updateMacroBookmark>
>;
export type LabOrderControllerServiceMarkAsCompleteMutationResult = Awaited<
  ReturnType<typeof LabOrderControllerService.markAsComplete>
>;
export type LabOrderControllerServiceArchiveLabOrderByUuidMutationResult =
  Awaited<ReturnType<typeof LabOrderControllerService.archiveLabOrderByUuid>>;
export type GlobalHolidayControllerServiceToggleGlobalHolidayMutationResult =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.toggleGlobalHoliday>
  >;
export type EducationalMaterialControllerServiceUpdatePatientMaterialBookmarkMutationResult =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.updatePatientMaterialBookmark
    >
  >;
export type EducationalMaterialControllerServiceUpdateBookmarkMutationResult =
  Awaited<
    ReturnType<typeof EducationalMaterialControllerService.updateBookmark>
  >;
export type DiagnosisControllerServiceResolvedDiagnosisMutationResult = Awaited<
  ReturnType<typeof DiagnosisControllerService.resolvedDiagnosis>
>;
export type AppointmentControllerServiceUpdateAppointmentStatusMutationResult =
  Awaited<
    ReturnType<typeof AppointmentControllerService.updateAppointmentStatus>
  >;
export type AnnotableImageTemplateControllerServiceUpdateAnnotableImageTemplateBookmarkMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.updateAnnotableImageTemplateBookmark
    >
  >;
export type QuestionnaireControllerServiceMarkAsReviewedMutationResult =
  Awaited<ReturnType<typeof QuestionnaireControllerService.markAsReviewed>>;
export type DocumentControllerServiceUnshareDocumentWithPatientMutationResult =
  Awaited<
    ReturnType<typeof DocumentControllerService.unshareDocumentWithPatient>
  >;
export type DocumentControllerServiceShareDocumentWithPatientMutationResult =
  Awaited<
    ReturnType<typeof DocumentControllerService.shareDocumentWithPatient>
  >;
export type DocumentControllerServiceUpdateReviewRequiredMutationResult =
  Awaited<ReturnType<typeof DocumentControllerService.updateReviewRequired>>;
export type DocumentControllerServiceExpireDocumentMutationResult = Awaited<
  ReturnType<typeof DocumentControllerService.expireDocument>
>;
export type ThreadControllerServiceMarkThreadUrgentMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.markThreadUrgent>
>;
export type ThreadControllerServiceUpdateThreadStatusMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.updateThreadStatus>
>;
export type ThreadControllerServiceUpdateOpenThreadMutationResult = Awaited<
  ReturnType<typeof ThreadControllerService.updateOpenThread>
>;
export type StripeControllerServiceCancelSubscriptionMutationResult = Awaited<
  ReturnType<typeof StripeControllerService.cancelSubscription>
>;
export type ScriptSureControllerServiceDeleteScriptSurePatientMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.deleteScriptSurePatient>
  >;
export type ScriptSureControllerServiceDeletePreferredPharmacyMutationResult =
  Awaited<
    ReturnType<typeof ScriptSureControllerService.deletePreferredPharmacy>
  >;
export type SavedCardControllerServiceDeleteSavedCardByUuidMutationResult =
  Awaited<ReturnType<typeof SavedCardControllerService.deleteSavedCardByUuid>>;
export type SavedBankControllerServiceDeleteSavedBankByUuidMutationResult =
  Awaited<ReturnType<typeof SavedBankControllerService.deleteSavedBankByUuid>>;
export type SalesTaxProfileControllerServiceDeleteSalesTaxProfileByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof SalesTaxProfileControllerService.deleteSalesTaxProfileByUuid
    >
  >;
export type SalesTaxJurisdictionControllerServiceDeleteSalesTaxJurisdictionByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof SalesTaxJurisdictionControllerService.deleteSalesTaxJurisdictionByUuid
    >
  >;
export type RoleTypeManagementControllerServiceDeleteRoleTypeMutationResult =
  Awaited<
    ReturnType<typeof RoleTypeManagementControllerService.deleteRoleType>
  >;
export type RoleTypeFeatureManagementControllerServiceDeleteRoleTypeFeatureMutationResult =
  Awaited<
    ReturnType<
      typeof RoleTypeFeatureManagementControllerService.deleteRoleTypeFeature
    >
  >;
export type ProviderControllerServiceDeleteProviderByUuidMutationResult =
  Awaited<ReturnType<typeof ProviderControllerService.deleteProviderByUuid>>;
export type PlanControllerServiceDeletePlanByUuidMutationResult = Awaited<
  ReturnType<typeof PlanControllerService.deletePlanByUuid>
>;
export type PaymentTransactionControllerServiceDeletePaymentTransactionMutationResult =
  Awaited<
    ReturnType<
      typeof PaymentTransactionControllerService.deletePaymentTransaction
    >
  >;
export type PatientControllerServiceDeletePatientByUuidMutationResult = Awaited<
  ReturnType<typeof PatientControllerService.deletePatientByUuid>
>;
export type PatientModuleControllerServiceDelete1MutationResult = Awaited<
  ReturnType<typeof PatientModuleControllerService.delete1>
>;
export type PatientModuleAccessControllerServiceDelete2MutationResult = Awaited<
  ReturnType<typeof PatientModuleAccessControllerService.delete2>
>;
export type PatientInformationControllerServiceDeleteMutationResult = Awaited<
  ReturnType<typeof PatientInformationControllerService.delete>
>;
export type NurseStaffProviderControllerServiceDeleteNurseStaffProviderMutationResult =
  Awaited<
    ReturnType<
      typeof NurseStaffProviderControllerService.deleteNurseStaffProvider
    >
  >;
export type LeadControllerServiceDeleteLeadByUuidMutationResult = Awaited<
  ReturnType<typeof LeadControllerService.deleteLeadByUuid>
>;
export type InvoiceSettingControllerServiceDeleteInvoiceSettingByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof InvoiceSettingControllerService.deleteInvoiceSettingByUuid
    >
  >;
export type FeatureManagementControllerServiceDeleteFeatureMutationResult =
  Awaited<ReturnType<typeof FeatureManagementControllerService.deleteFeature>>;
export type FaxControllerServiceDeleteEfaxFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.deleteEfaxFax>
>;
export type FaxControllerServiceDeleteFaxMutationResult = Awaited<
  ReturnType<typeof FaxControllerService.deleteFax>
>;
export type FaceSheetLayoutControllerServiceResetLayoutMutationResult = Awaited<
  ReturnType<typeof FaceSheetLayoutControllerService.resetLayout>
>;
export type EmployerControllerServiceDeleteEmployerMutationResult = Awaited<
  ReturnType<typeof EmployerControllerService.deleteEmployer>
>;
export type EmployerControllerServiceArchiveEmployerPlanMutationResult =
  Awaited<ReturnType<typeof EmployerControllerService.archiveEmployerPlan>>;
export type EmployerPageControllerServiceDeleteEmployerPageByUuidMutationResult =
  Awaited<
    ReturnType<typeof EmployerPageControllerService.deleteEmployerPageByUuid>
  >;
export type EmployerDivisionControllerServiceDeleteEmployerDivisionByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerDivisionControllerService.deleteEmployerDivisionByUuid
    >
  >;
export type EmployerAdministratorControllerServiceDeleteEmployerAdministratorByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof EmployerAdministratorControllerService.deleteEmployerAdministratorByUuid
    >
  >;
export type CreditControllerServiceDeleteCreditMutationResult = Awaited<
  ReturnType<typeof CreditControllerService.deleteCredit>
>;
export type CoverageRuleControllerServiceDeleteCoverageRuleByUuidMutationResult =
  Awaited<
    ReturnType<typeof CoverageRuleControllerService.deleteCoverageRuleByUuid>
  >;
export type CoveragePlanControllerServiceDeleteCoveragePlanByUuidMutationResult =
  Awaited<
    ReturnType<typeof CoveragePlanControllerService.deleteCoveragePlanByUuid>
  >;
export type CoveragePlanControllerServiceDeleteCoveragePlanEmployerByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof CoveragePlanControllerService.deleteCoveragePlanEmployerByUuid
    >
  >;
export type CouponControllerServiceDeleteCouponByUuidMutationResult = Awaited<
  ReturnType<typeof CouponControllerService.deleteCouponByUuid>
>;
export type ChargeItemControllerServiceDeleteChargeItemByUuidMutationResult =
  Awaited<
    ReturnType<typeof ChargeItemControllerService.deleteChargeItemByUuid>
  >;
export type ChargeItemControllerServiceDeleteChargeItemsByUuidsMutationResult =
  Awaited<
    ReturnType<typeof ChargeItemControllerService.deleteChargeItemsByUuids>
  >;
export type ChargeCategoryControllerServiceDeleteChargeCategoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof ChargeCategoryControllerService.deleteChargeCategoryByUuid
    >
  >;
export type CancellationControllerServiceDeleteCancellationByUuidMutationResult =
  Awaited<
    ReturnType<typeof CancellationControllerService.deleteCancellationByUuid>
  >;
export type BrokerControllerServiceDeleteBrokerByUuidMutationResult = Awaited<
  ReturnType<typeof BrokerControllerService.deleteBrokerByUuid>
>;
export type BreakGlassControllerServiceDelete3MutationResult = Awaited<
  ReturnType<typeof BreakGlassControllerService.delete3>
>;
export type AncillaryServiceChargesControllerServiceDeleteMiscellaneousServiceChargeByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.deleteMiscellaneousServiceChargeByUuid
    >
  >;
export type AncillaryServiceChargesControllerServiceDeleteAncillaryServiceChargesByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof AncillaryServiceChargesControllerService.deleteAncillaryServiceChargesByUuid
    >
  >;
export type AgentFirmControllerServiceDeleteAgentFirmByUuidMutationResult =
  Awaited<ReturnType<typeof AgentFirmControllerService.deleteAgentFirmByUuid>>;
export type AgentDealControllerServiceDeleteAgentDealByUuidMutationResult =
  Awaited<ReturnType<typeof AgentDealControllerService.deleteAgentDealByUuid>>;
export type AffiliateGroupControllerServiceDeleteAffiliateMutationResult =
  Awaited<ReturnType<typeof AffiliateGroupControllerService.deleteAffiliate>>;
export type AdminUserControllerServiceDeleteAdminUserByUuidMutationResult =
  Awaited<ReturnType<typeof AdminUserControllerService.deleteAdminUserByUuid>>;
export type ShareCardControllerServiceDeleteShareCardMutationResult = Awaited<
  ReturnType<typeof ShareCardControllerService.deleteShareCard>
>;
export type ShareBankControllerServiceDeleteSharedBankAccountMutationResult =
  Awaited<
    ReturnType<typeof ShareBankControllerService.deleteSharedBankAccount>
  >;
export type GoogleMapsControllerServiceDeleteShareLinkMutationResult = Awaited<
  ReturnType<typeof GoogleMapsControllerService.deleteShareLink>
>;
export type CartControllerServiceDeleteCartByUuidMutationResult = Awaited<
  ReturnType<typeof CartControllerService.deleteCartByUuid>
>;
export type WorkNoteControllerServiceDeleteWorkNoteByUuidMutationResult =
  Awaited<ReturnType<typeof WorkNoteControllerService.deleteWorkNoteByUuid>>;
export type VitalControllerServiceDeleteVitalMutationResult = Awaited<
  ReturnType<typeof VitalControllerService.deleteVital>
>;
export type VaccineControllerServiceDeleteVaccineByUuidMutationResult = Awaited<
  ReturnType<typeof VaccineControllerService.deleteVaccineByUuid>
>;
export type TaskControllerServiceDeleteTaskMutationResult = Awaited<
  ReturnType<typeof TaskControllerService.deleteTask>
>;
export type StatusConfigurationControllerServiceDeleteStatusConfigurationByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof StatusConfigurationControllerService.deleteStatusConfigurationByUuid
    >
  >;
export type SocialHistoryControllerServiceDeleteSocialHistoryByUuidMutationResult =
  Awaited<
    ReturnType<typeof SocialHistoryControllerService.deleteSocialHistoryByUuid>
  >;
export type SoapNoteControllerServiceDeleteSoapNoteMutationResult = Awaited<
  ReturnType<typeof SoapNoteControllerService.deleteSoapNote>
>;
export type SoapNoteTemplateControllerServiceDeleteSoapNoteTemplateByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof SoapNoteTemplateControllerService.deleteSoapNoteTemplateByUuid
    >
  >;
export type ScreenHistoryControllerServiceDeleteScreenHistoryByUuidMutationResult =
  Awaited<
    ReturnType<typeof ScreenHistoryControllerService.deleteScreenHistoryByUuid>
  >;
export type ReviewOfSystemTemplateControllerServiceDeleteReviewOfSystemTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof ReviewOfSystemTemplateControllerService.deleteReviewOfSystemTemplate
    >
  >;
export type ReviewOfSystemControllerServiceDeleteReviewOfSystemMutationResult =
  Awaited<
    ReturnType<typeof ReviewOfSystemControllerService.deleteReviewOfSystem>
  >;
export type ReferralControllerServiceDeleteReferralByUuidMutationResult =
  Awaited<ReturnType<typeof ReferralControllerService.deleteReferralByUuid>>;
export type ProviderDirectoryControllerServiceDeleteProviderDirectoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof ProviderDirectoryControllerService.deleteProviderDirectoryByUuid
    >
  >;
export type PointsOfCareLabControllerServiceDeletePointOfCareLabByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof PointsOfCareLabControllerService.deletePointOfCareLabByUuid
    >
  >;
export type PocLabTestControllerServiceDeletePocLabTestMutationResult = Awaited<
  ReturnType<typeof PocLabTestControllerService.deletePocLabTest>
>;
export type PocLabTestControllerServiceDeletePocTestFieldsMutationResult =
  Awaited<ReturnType<typeof PocLabTestControllerService.deletePocTestFields>>;
export type PocLabResultControllerServiceDeletePocLabResultMutationResult =
  Awaited<ReturnType<typeof PocLabResultControllerService.deletePocLabResult>>;
export type PhysicalExamTemplateControllerServiceDeletePhysicalExamTemplateByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof PhysicalExamTemplateControllerService.deletePhysicalExamTemplateByUuid
    >
  >;
export type PhysicalExamControllerServiceDeletePhysicalExamByUuidMutationResult =
  Awaited<
    ReturnType<typeof PhysicalExamControllerService.deletePhysicalExamByUuid>
  >;
export type PharmacyControllerServiceDeletePharmacyMutationResult = Awaited<
  ReturnType<typeof PharmacyControllerService.deletePharmacy>
>;
export type PatientVaccinationControllerServiceDeletePatientVaccinationMutationResult =
  Awaited<
    ReturnType<
      typeof PatientVaccinationControllerService.deletePatientVaccination
    >
  >;
export type PatientFlagControllerServiceDeletePatientFlagMutationResult =
  Awaited<ReturnType<typeof PatientFlagControllerService.deletePatientFlag>>;
export type PastSurgicalHistoryControllerServiceDeletePastSurgicalHistoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof PastSurgicalHistoryControllerService.deletePastSurgicalHistoryByUuid
    >
  >;
export type PastMedicalHistoryControllerServiceDeletePastMedicalHistoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof PastMedicalHistoryControllerService.deletePastMedicalHistoryByUuid
    >
  >;
export type NoteControllerServiceDeleteNoteByUuidMutationResult = Awaited<
  ReturnType<typeof NoteControllerService.deleteNoteByUuid>
>;
export type MedicationControllerServiceDeleteMedicationByUuidMutationResult =
  Awaited<
    ReturnType<typeof MedicationControllerService.deleteMedicationByUuid>
  >;
export type MacroControllerServiceDeleteMacroMutationResult = Awaited<
  ReturnType<typeof MacroControllerService.deleteMacro>
>;
export type LocationControllerServiceDeleteLocationByUuidMutationResult =
  Awaited<ReturnType<typeof LocationControllerService.deleteLocationByUuid>>;
export type LocationGroupControllerServiceDeleteLocationGroupByUuidMutationResult =
  Awaited<
    ReturnType<typeof LocationGroupControllerService.deleteLocationGroupByUuid>
  >;
export type LocationAvailabilityControllerServiceDeleteLocationAvailabilityByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof LocationAvailabilityControllerService.deleteLocationAvailabilityByUuid
    >
  >;
export type PatientLinkPharmacyControllerServiceDeletePharmacyForPatientByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof PatientLinkPharmacyControllerService.deletePharmacyForPatientByUuid
    >
  >;
export type LabTestControllerServiceDeleteLabTestByUuidMutationResult = Awaited<
  ReturnType<typeof LabTestControllerService.deleteLabTestByUuid>
>;
export type LabResultControllerServiceArchiveLabResultMutationResult = Awaited<
  ReturnType<typeof LabResultControllerService.archiveLabResult>
>;
export type LabOrderControllerServiceDeleteLabOrderByUuidMutationResult =
  Awaited<ReturnType<typeof LabOrderControllerService.deleteLabOrderByUuid>>;
export type LabOrderSetControllerServiceDeleteLabOrderSetByUuidMutationResult =
  Awaited<
    ReturnType<typeof LabOrderSetControllerService.deleteLabOrderSetByUuid>
  >;
export type InvoiceControllerServiceDeleteInvoiceByUuidMutationResult = Awaited<
  ReturnType<typeof InvoiceControllerService.deleteInvoiceByUuid>
>;
export type InsuranceControllerServiceDeleteInsuranceByUuidMutationResult =
  Awaited<ReturnType<typeof InsuranceControllerService.deleteInsuranceByUuid>>;
export type ImagingResultControllerServiceDeleteImagingResultByUuidMutationResult =
  Awaited<
    ReturnType<typeof ImagingResultControllerService.deleteImagingResultByUuid>
  >;
export type ImagingOrderControllerServiceDeleteImagingOrderByUuidMutationResult =
  Awaited<
    ReturnType<typeof ImagingOrderControllerService.deleteImagingOrderByUuid>
  >;
export type IcdCodeControllerServiceDeleteIcdCodeByUuidMutationResult = Awaited<
  ReturnType<typeof IcdCodeControllerService.deleteIcdCodeByUuid>
>;
export type HAndPNoteControllerServiceDeleteHandPnoteMutationResult = Awaited<
  ReturnType<typeof HAndPNoteControllerService.deleteHandPnote>
>;
export type HabitsControllerServiceDeleteHabitsByUuidMutationResult = Awaited<
  ReturnType<typeof HabitsControllerService.deleteHabitsByUuid>
>;
export type GlobalHolidayControllerServiceDeleteGlobalHolidayByUuidMutationResult =
  Awaited<
    ReturnType<typeof GlobalHolidayControllerService.deleteGlobalHolidayByUuid>
  >;
export type FormTemplateControllerServiceDeleteFormTemplateMutationResult =
  Awaited<ReturnType<typeof FormTemplateControllerService.deleteFormTemplate>>;
export type FdbMedicationsControllerServiceDeleteFdbMedicationByUuidMutationResult =
  Awaited<
    ReturnType<typeof FdbMedicationsControllerService.deleteFdbMedicationByUuid>
  >;
export type FamilyHistoryControllerServiceDeleteFamilyHistoryByUuidMutationResult =
  Awaited<
    ReturnType<typeof FamilyHistoryControllerService.deleteFamilyHistoryByUuid>
  >;
export type EducationalMaterialControllerServiceDeleteEducationalMaterialMutationResult =
  Awaited<
    ReturnType<
      typeof EducationalMaterialControllerService.deleteEducationalMaterial
    >
  >;
export type DrugIntoleranceControllerServiceDeleteDrugIntoleranceByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof DrugIntoleranceControllerService.deleteDrugIntoleranceByUuid
    >
  >;
export type DocumentTypeControllerServiceDeleteDocumentTypeByUuidMutationResult =
  Awaited<
    ReturnType<typeof DocumentTypeControllerService.deleteDocumentTypeByUuid>
  >;
export type DiagnosisControllerServiceDeleteDiagnosisMutationResult = Awaited<
  ReturnType<typeof DiagnosisControllerService.deleteDiagnosis>
>;
export type CptCodeControllerServiceDeleteIcdCodeByUuid1MutationResult =
  Awaited<ReturnType<typeof CptCodeControllerService.deleteIcdCodeByUuid1>>;
export type CommentControllerServiceDeleteMessageMutationResult = Awaited<
  ReturnType<typeof CommentControllerService.deleteMessage>
>;
export type CarePlanControllerServiceDeleteCarePlanMutationResult = Awaited<
  ReturnType<typeof CarePlanControllerService.deleteCarePlan>
>;
export type AvailabilityControllerServiceDeleteAvailabilityByUuidMutationResult =
  Awaited<
    ReturnType<typeof AvailabilityControllerService.deleteAvailabilityByUuid>
  >;
export type AppointmentControllerServiceDeleteAppointmentByUuidMutationResult =
  Awaited<
    ReturnType<typeof AppointmentControllerService.deleteAppointmentByUuid>
  >;
export type AppointmentTypeControllerServiceDeleteAppointmentTypeByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof AppointmentTypeControllerService.deleteAppointmentTypeByUuid
    >
  >;
export type AnnotableImageControllerServiceDeleteAnnotableImageMutationResult =
  Awaited<
    ReturnType<typeof AnnotableImageControllerService.deleteAnnotableImage>
  >;
export type AnnotableImageTemplateControllerServiceDeleteAnnotableImageTemplateMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImageTemplateControllerService.deleteAnnotableImageTemplate
    >
  >;
export type AnnotableImagePinControllerServiceDeleteAnnotableImagePinMutationResult =
  Awaited<
    ReturnType<
      typeof AnnotableImagePinControllerService.deleteAnnotableImagePin
    >
  >;
export type AllergyControllerServiceDeleteAllergyByUuIdMutationResult = Awaited<
  ReturnType<typeof AllergyControllerService.deleteAllergyByUuId>
>;
export type QuestionnaireControllerServiceDeleteQuestionnaireMutationResult =
  Awaited<
    ReturnType<typeof QuestionnaireControllerService.deleteQuestionnaire>
  >;
export type DocumentControllerServiceDeleteDocumentByUuidMutationResult =
  Awaited<ReturnType<typeof DocumentControllerService.deleteDocumentByUuid>>;
export type ContactDirectoryControllerServiceDeleteContactDirectoryByUuidMutationResult =
  Awaited<
    ReturnType<
      typeof ContactDirectoryControllerService.deleteContactDirectoryByUuid
    >
  >;
export type AgreementControllerServiceDeleteAgreementMutationResult = Awaited<
  ReturnType<typeof AgreementControllerService.deleteAgreement>
>;
export type NotificationControllerServiceDeleteNotificationMutationResult =
  Awaited<ReturnType<typeof NotificationControllerService.deleteNotification>>;
export type StripControllerServiceCancelSubscription1MutationResult = Awaited<
  ReturnType<typeof StripControllerService.cancelSubscription1>
>;
export type TicketControllerServiceDeleteTicketMutationResult = Awaited<
  ReturnType<typeof TicketControllerService.deleteTicket>
>;
export type TicketTaskControllerServiceDeleteTicketTaskMutationResult = Awaited<
  ReturnType<typeof TicketTaskControllerService.deleteTicketTask>
>;
export type TicketNotesControllerServiceDeleteTicketNotesMutationResult =
  Awaited<ReturnType<typeof TicketNotesControllerService.deleteTicketNotes>>;
export type TicketAttachmentControllerServiceDeleteAttachmentMutationResult =
  Awaited<
    ReturnType<typeof TicketAttachmentControllerService.deleteAttachment>
  >;
export type CrmTemplateControllerServiceDeleteTemplateMutationResult = Awaited<
  ReturnType<typeof CrmTemplateControllerService.deleteTemplate>
>;
export type CrmTaskControllerServiceDeleteCrmTaskMutationResult = Awaited<
  ReturnType<typeof CrmTaskControllerService.deleteCrmTask>
>;
export type TaskLogControllerServiceDeleteTaskLogMutationResult = Awaited<
  ReturnType<typeof TaskLogControllerService.deleteTaskLog>
>;
export type CrmNewsletterControllerServiceDeleteNewsletterMutationResult =
  Awaited<ReturnType<typeof CrmNewsletterControllerService.deleteNewsletter>>;
export type CrmCampaignControllerServiceDeleteCampaignMutationResult = Awaited<
  ReturnType<typeof CrmCampaignControllerService.deleteCampaign>
>;
export type CallLogsControllerServiceDeleteCallLogMutationResult = Awaited<
  ReturnType<typeof CallLogsControllerService.deleteCallLog>
>;
export type TicketLinkedControllerServiceUnlinkTicketMutationResult = Awaited<
  ReturnType<typeof TicketLinkedControllerService.unlinkTicket>
>;
export type MessageControllerServiceDeleteMessageByUuidMutationResult = Awaited<
  ReturnType<typeof MessageControllerService.deleteMessageByUuid>
>;
export type MessageControllerServiceDeleteScheduledMessageMutationResult =
  Awaited<ReturnType<typeof MessageControllerService.deleteScheduledMessage>>;
export type TwilioVoiceControllerServiceUnregisterMutationResult = Awaited<
  ReturnType<typeof TwilioVoiceControllerService.unregister>
>;
export type BookmarkControllerServiceUnbookmarkThreadMutationResult = Awaited<
  ReturnType<typeof BookmarkControllerService.unbookmarkThread>
>;
export type BookmarkControllerServiceUnbookmarkMessageMutationResult = Awaited<
  ReturnType<typeof BookmarkControllerService.unbookmarkMessage>
>;
export type BookmarkControllerServiceUnbookmarkMessagesByThreadMutationResult =
  Awaited<
    ReturnType<typeof BookmarkControllerService.unbookmarkMessagesByThread>
  >;
